var app = {

	settings: {
		duration: 0.3,
		easeOut: Power3.easeOut,
		easeInOut: Power3.easeInOut,
	},

	vars: {
		initialized: false,
		browser: undefined,
		browserVersion: undefined,
		os: undefined,
		media: undefined,
		isLocalPage: false,
		lang: $('html').attr('lang'),
		urlParam: {},
		context: 'context',
		$win: $(window),
		$doc: $(document),
		$html: $('html'),
		$body: $('body'),
		utm: {
			cookie_name: 'cookie_utm',
		},
		searchbar: {
			cookie: {
				name: 'cookie_searchbar',
				expire: 365,
			}
		},
		translations: (typeof translations !== 'undefined') ? translations : {},
	},

	states: {
		isActive: 'is-active',
		isOpen: 'is-open',
		isAnimated: 'is-animated',
		isDisabled: 'is-disabled',
		isHidden: 'is-hidden',
		isSelected: 'is-selected',
		isHover: 'is-hover',
		isLast: 'is-last',
		isDefault: 'is-default',
		isHiding: 'is-hiding',
		isChange: 'is-change',
	},

	init: function () {
		this.urlParams();
		this.isTouchScreen();
		this.isLocalPage();
		this.initGlobalExtensions();
		this.initLocalExtensions($('body'));
	},

	parse: function ($context) {
		if (!$context.jQuery) $context = $($context)
		this.initLocalExtensions($context);
		$('[data-bg]:not(.lazy-loaded),[data-src]:not(.lazy-loaded)', $context).lazyLoadXT({ checkDuplicates: false });
	},

	initGlobalExtensions: function () {
		var t = this;
		for (var globalExt in t.globalExt) {
			if (!app.obj[globalExt]) {
				app.obj[globalExt] = new t.globalExt[globalExt]();
			}
		}
	},

	initLocalExtensions: function ($context) {
		var t = this;
		for (var ext in t.ext) {
			var $els = $context.findOrSelf('.js-' + ext);
			$els.each(function () {
				var fn = new t.ext[ext]($(this));
				if (app.obj[ext] === undefined) app.obj[ext] = [];
				if ($(this).data('objectName')) {
					app.obj[ext][$(this).data('objectName')] = fn;
				} else {
					app.obj[ext].push(fn);
				}
			});
		}
	},

	urlParams: function () {
		var search = document.location.search;
		app.vars.urlParam = {};
		if (search.length > 0) {
			$.each(document.location.search.substr(1).split('&'), function (c, q) {
				var i = q.split('=');
				app.vars.urlParam[i[0].toString()] = i[1] ? i[1].toString() : true;
			});
		}
	},

	getParam: function (name, url) {
		var string = url || location.href;
		var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(string); //window.location.href
		if (results == null) {
			return null;
		} else {
			return results[1] || 0;
		}
	},

	tl: function (val) {
		if (typeof app.vars.translations[val] !== 'undefined') {
			return app.vars.translations[val];
		} else {
			return val;
		}
	},

	isTouchScreen: function () {
		var deviceAgent = navigator.userAgent.toLowerCase();
		var touchEnabled = 'ontouchstart' in window || navigator.maxTouchPoints;
		var $html = $('html');
		var no = 'screen--no-touch';
		var is = 'screen--is-touch';
		var no_touch = $html.hasClass(no);
		var is_touch = $html.hasClass(is);

		if ((deviceAgent.match(/(iphone|ipod|ipad)/) ||
			deviceAgent.match(/(android)/) ||
			deviceAgent.match(/(iemobile)/) ||
			deviceAgent.match(/iphone/i) ||
			deviceAgent.match(/ipad/i) ||
			deviceAgent.match(/ipod/i) ||
			deviceAgent.match(/blackberry/i) ||
			deviceAgent.match(/bada/i)) &&
			touchEnabled

		) {
			if (!is_touch) $html.addClass(is);
		} else if (!no_touch) {
			$html.addClass(no);
		}
	},

	isLocalPage: function () {
		app.vars.isLocalPage = $('html').hasClass('is-local-page');
	},

	ext: {},
	globalExt: {},
	obj: {},
};

$(function () {
	// Gridle.on('update', function() {
	if (!app.vars.initialized) {
		app.init();
		app.vars.initialized = true;
	}
	// });
});

$.fn.findOrSelf = function (selector) {
	return this.find(selector).add(this.filter(selector));
};

app.globalExt['site'] = function() {
	var api = {
		breakPoints: {
			mobile:				320,
			mobileLandscape:	480,
			tablet:				740,
			desktopAd:			810,
			tabletLandscape:	906,
			desktop:			980,
			desktopEx:			1025,
			wide:				1200,
			full:				1480,
			design:				1600,
			hd:					1800,
		},
		scrollTop: 0,
		scrollDiff: 0,
		overlayOpen: false,
		winWidth: 0,
	};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	// var typeform_interval_counter = 0;
	// var typeform_interval;

	var init = function() {
		// REQUEST ANIMATION FRAME
		if (!window.requestAnimationFrame) {
			window.requestAnimationFrame = (function() {

				return window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(/* function FrameRequestCallback */ callback, /* DOMElement Element */ element) {
					window.setTimeout(callback, 1000 / 60);
				};
			})();
		}

		// HEADER HEIGHT
		api.setHeaderHeight();
		$win.on('resize orientationchange', function() {
			api.setHeaderHeight();
		});

		// MQ
		if (location.href.indexOf('.devlocal') >= 0 && location.search.indexOf('mq') >= 0) {
		// 	api.site_dev = true;
		$html.addClass('showDebug');
	}

		// MOBILE DEBUGGER
		if (location.href.indexOf('.xip.io') > 0 && location.search.indexOf('debug') >= 0 && typeof eruda !== 'undefined') {
			eruda.init();
		}

		// SCROLLMAGICK
		if (!$('html.lt-ie9').length) {
			api.scrollController = new ScrollMagic.Controller();
			$win.on('resize orientationchange', function() {
				if (typeof api.scrollController.update !== 'undefined') {
					api.scrollController.update(true);
				}
			});
			api.scrollController.scrollTo(function(newScrollPos, options) {
				var callback;
				var duration = 1.3;
				var target;
				var $nav_sub = $('.site-main .subnav__trigger:eq(0)');

				if (options) {
					callback = options.callback ? options.callback : false;
					duration = options.duration ? options.duration : duration;
					target = options.target ? options.target : false;
				}
				if (target) {
					newScrollPos = target.offset ? target.offset().top : target;
				} else {
					newScrollPos -= ($('html.until-desktopEx').length ? api.headerHeight : ($nav_sub.length ? $nav_sub.outerHeight() : api.headerHeight));
				}
				//app.modules.smoothScroll.enabled = false;
				TweenMax.to(window, duration, {scrollTo: {y: newScrollPos, autoKill: false}, ease: Power3.easeInOut, onComplete: callback});
				//setTimeout(function(){app.modules.smoothScroll.enabled = true;}, 1000);
			});
		}

		var scrolling;
		api.scrollTop = $win.scrollTop();

		$win.on('scroll', function() {
			var y = $win.scrollTop();
			var navOpen = $html.filter('.nav-main--open, .nav-download--open').length;

			if (!api.overlayOpen && !navOpen){
				api.scrollDiff = api.scrollTop - y;
				api.scrollTop = y;
				$html.addClass('page--scroll');

				if (api.scrollTop < 30) {
					$html.removeClass('scroll--nav');
				} else {
					$html.addClass('scroll--nav');
				}
				if(api.scrollTop == 0){
					$html.addClass('scroll--top').removeClass('scroll--bottom');
				}else{
					$html.removeClass('scroll--top');
					if(api.scrollTop + $win.height() == $doc.height()) {
						$html.addClass('scroll--bottom');
					}else{
						$html.removeClass('scroll--bottom');
					}
				}
			}
			clearTimeout(scrolling);
			scrolling = setTimeout(function() {
				$html.removeClass('page--scroll');
			}, 350);
		});

		// PREVENT ANCHOR SCROLLING BY DEFAULT
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}

		// MODERNIZR
		var htmlParams = function () {
			for (var bp in api.breakPoints) {
				var b = api.breakPoints[bp];
				var from = 'from-' + bp;
				var until = 'until-' + bp;

				if (Modernizr.mq('(max-width: ' + (b - 1) + 'px)')) { $html.addClass(until); } else { $html.removeClass(until); }
				if (Modernizr.mq('(min-width: ' + b + 'px)')) { $html.addClass(from); } else { $html.removeClass(from); }
			}

			if (Modernizr.mq('(max-width: ' + (api.breakPoints.desktop - 1) + 'px)')) { $html.addClass('touch-test').removeClass('no-touch-test'); } else { $html.removeClass('touch-test').addClass('no-touch-test'); }
		};
		htmlParams();

		var timer_resize;
		$win.on('resize orientationchange', function() {
			var w = $win.innerWidth();
			if (api.winWidth != w){
				htmlParams();
				api.winWidth = w;
			}
			clearTimeout(timer_resize);
			if ($html.hasClass('site--initialized')) $html.addClass('page--resize');
			timer_resize = setTimeout(function() {
				$html.removeClass('page--resize');
			}, 100);
		});

		var is_home = $('.header.is-animated').length;

		// TRIGGER
		setTimeout(function() {
			$win.trigger('resize');
			$win.trigger('scroll');
		}, is_home ? 1500 : 100);

		// INITIALIZED
		setTimeout(function() {
			$html.addClass('site--initialized');
		}, is_home ? 700 : 150);

		//typeform_interval = setInterval(checkTypeform, 5);

	};

	// function checkTypeform() {
	// 	// WRAP TYPEFORM
	// 	var typeform = $('body > a[role=button]');

	// 	if(typeform.length){
	// 		typeform.addClass('typeform__button');
	// 		typeform.prev().addClass('typeform__article');
	// 		clearInterval(typeform_interval);
	// 	}

	// 	typeform_interval_counter++;

	// 	if(typeform_interval_counter > 30){
	// 		clearInterval(typeform_interval);
	// 	}

	// }

	api.setHeaderHeight = function() {
		api.headerHeight = $('.js-ui-site-header').outerHeight();
	};


	init();	return api;
};


// LAZYLOAD
//$.lazyLoadXT.autoInit=false;
$.extend($.lazyLoadXT, {
	//autoInit: false,
	//visibleOnly: false,
	edgeY: $(window).innerHeight(),
	oninit: {addClass: 'lazy'},
	onload: {removeClass: 'lazy', addClass: 'lazy-loaded'},
	//updateEvent: 'load orientationchange resize scroll touchMove'
});

var options = $.lazyLoadXT,
bgAttr = options.bgAttr || 'data-bg';

options.selector += ',[' + bgAttr + ']';

$(document).on('lazyshow', function(e) {
	var $this = $(e.target);

	if (!$this.data('lazyshow')) {
		$this.data('lazyshow', true);

		// BACKGROUND
		if ($this.is('[' + bgAttr + ']')) {
			$this
			.css('background-image', "url('" + $this.attr(bgAttr) + "')");
			//.removeAttr(bgAttr);

			var $header = $this.parents('.header:not(.header--loaded)');

			if ($header.length) {
				//$this.parent().addClass('header__img--loaded');
				$header.addClass('header--loaded');
			}
		}

	}
});
$(document).on('lazyload', function(e) {
	var $this = $(e.target);
});
$('img[data-src]').each(function(i) {
	var img = $(this);
	if (img.attr('width') && img.attr('height')) {
		img.css('padding-bottom', (img.attr('height') / img.attr('width') * 100 - 0) + '%');
	}
});

app.globalExt['detect-browser'] = function () {
	var $win = app.vars.$win;
	var $doc = app.vars.$doc;
	var $html = app.vars.$html;
	var $body = app.vars.$body;

	var dataBrowser = [
		{ string: navigator.userAgent, subString: 'Edge', identity: 'edge' },
		{ string: navigator.userAgent, subString: 'MSIE', identity: 'explorer' },
		{ string: navigator.userAgent, subString: 'Trident', identity: 'explorer' },
		{ string: navigator.userAgent, subString: 'Firefox', identity: 'firefox' },
		{ string: navigator.userAgent, subString: 'Opera', identity: 'opera' },
		{ string: navigator.userAgent, subString: 'OPR', identity: 'opera' },
		{ string: navigator.userAgent, subString: 'Chrome', identity: 'chrome' },
		{ string: navigator.userAgent, subString: 'Safari', identity: 'safari' },
	];

	var init = function () {
		app.vars.browser = searchString(dataBrowser) || 'other';
		app.vars.browserVersion = searchVersion(navigator.userAgent) || searchVersion(navigator.appVersion) || 'unknown';
		app.vars.os = getOs();
		app.vars.media = getMedia();
		$html.addClass(app.vars.browser).addClass(app.vars.browser + '-' + app.vars.browserVersion).addClass(app.vars.os).addClass('media-' + app.vars.media);
		console.log(app.vars.browser)
	};

	var searchString = function (data) {
		for (var i = 0; i < data.length; i++) {
			var dataString = data[i].string;
			this.versionSearchString = data[i].subString;
			if (dataString.indexOf(data[i].subString) !== -1) {
				return data[i].identity;
			}
		}
	};

	var searchVersion = function (dataString) {
		var index = dataString.indexOf(this.versionSearchString);
		if (index === -1) {
			return;
		}
		var rv = dataString.indexOf('rv:');
		if (this.versionSearchString === 'Trident' && rv !== -1) {
			return parseFloat(dataString.substring(rv + 3));
		} else {
			return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
		}
	};

	var getOs = function () {
		var OSName = 'unknown-os';
		var appVersion = navigator.appVersion;
		if (appVersion.indexOf('Win') !== -1) OSName = 'windows';
		else if (appVersion.indexOf('Mac') !== -1) OSName = 'macos';
		else if (appVersion.indexOf('X11') !== -1) OSName = 'unix';
		else if (appVersion.indexOf('Linux') !== -1) OSName = 'linux';
		return OSName;
	};

	var getMedia = function () {
		var media = 'desktop';
		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			media = 'mobile';
		}
		return media;
	};

	init();
};

app.globalExt['downloads'] = function() {
	var api = {};

	var $win     = app.vars.$win;
	var $doc     = app.vars.$doc;
	var $html    = app.vars.$html;
	var $body    = app.vars.$body;
	var tl       = app.tl;

	var settings = {
		cookieName: 'borealis_downloads',
		cookieExpire: 1, // days
	};

	var classes = {
		trigger       : '.js-downloads-add-trigger, .js-downloads-trigger, .downloads__img, .downloads__item.js-more-options .downloads__title, .downloads__info, a.circle-icon--download',
		add           : '.js-downloads-add .circle-icon--add, .js-downloads-add .circle-icon--download',
		list          : '.js-downloads-list',
		downloads     : '.downloads',
		nav           : '.nav-download',
		qty           : '.nav-download__qty',
		remove        : '.js-downloads-remove',
		removeAll     : '.js-downloads-remove-all',
		item          : '.js-downloads-item',
		total         : '.downloads__total',
		totalFilesize : '.js-downloads-total-filesize',
		getAll        : '.js-downloads-get-all',
		body          : 'body',
		groupLabel    : '.dropdown__group__label',
	};

	var templates = {
		filter: {
			item:	'<div class="dropdown-lg js-filters">\
		<div class="filters__button  dropdown  js-dropdown  is-active  js-filters-group">\
		<div class="dropdown__content  js-dropdown-content  form">\
		<div class="dropdown__title  dropdown__title--close  open  js-dropdown-close">' + tl('Language') + '</div>\
		<div class="dropdown__search">\
		<input type="text" class="dropdown__search__field  js-filters-search" placeholder="Search">\
		<div class="dropdown__search__reset  js-filters-search-reset"></div>\
		</div>\
		<div class="dropdown__main  js-dropdown-main">\
		<div class="dropdown__items"></div>\
		</div>\
		<div class="dropdown__button  button  button--full  button--empty  button--small  button--blue-medium  js-dropdown-close">' + tl('Select') + '</div>\
		</div>\
		</div>\
		</div>',

			option:	'<div class="form__row  js-filters-item">\
		<input type="checkbox" id="" name="" class="form__checkbox">\
		<label for="" class="form__checkbox-label"></label>\
		</div>',

			group:	'<div class="dropdown__group  js-filters-group">\
		<div class="dropdown__group__label  js-filters-group-label"></div>\
		<div class="dropdown__group__content  js-filters-group-content"></div>\
		</div>',
		},
	};

	var downloadsMessages = $('#downloads-messages').data();
	var search_borouge = $('.site-main').children().length < 1;
	var $iframe = $("<iframe>").hide().appendTo("body");

	var texts = {
		infoMessageTitle: downloadsMessages['infoTitle'],
		infoMessageContent: downloadsMessages['infoContent'],
	};

	var addDownloadsTimeout;
	var getAllAjaxCall;

	var init = function() {
		addListeners();
		updateList();
	};

	var addListeners = function() {
		$doc.on('click.downloads_add',         classes.add+','+classes.trigger,  addClickHandler);
		$doc.on('click.downloads_list',        classes.list,                     listClickHandler);
		$doc.on('click.downloads_body',        classes.body,                     bodyClickHandler);
		$doc.on('click.downloads_group_label', classes.groupLabel,               groupLabelClickHandler);
		$doc.on('click.downloads_remove',      classes.remove,                   removeClickHandler);
		$doc.on('click.downloads_remove_all',  classes.removeAll,                removeAllClickHandler);
		$doc.on('click.downloads_get_all',     classes.getAll,                   getAllClickHandler);
	};

	var addClickHandler = function(event) {
		var $this = $(event.currentTarget);
		//if(!$this.parents('a').length){
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
			var $downloads = $this.find('[data-downloads]').length ? $this.find('[data-downloads]') : ($this.closest('[data-downloads]').length ? $this.closest('[data-downloads]') : $('[data-downloads]', $this.parents('.downloads__item:eq(0)')));
			var trigger = $this.filter(classes.trigger).length;
			var directdownload = !!$this.hasClass('circle-icon--download') || trigger;
			var force = !!$this.hasClass('downloads__icon--force');

			if ($downloads.length) {
				downloadSelect($downloads, directdownload, force, trigger);

			// Download List
			}else if(!$downloads.length){
				var $trigger = $this.closest('[data-id][data-url]');
				if($trigger.length){
					var id = $trigger.data('id');
					var url = $trigger.data('url');
					tracking('Download', {'url': url});
					downloadFiles($trigger, [id], [url], true);
				}
			}
		//}
	};

	var listClickHandler = function(event) {
		var $this = $(this);
		var $a = $(classes.nav+' a')
		event.preventDefault();
		event.stopPropagation();
		$a.toggleClass('is-hover');

		if (!api.overlayIsOpen && $(classes.nav).attr('data-qty') > 0) {
			$a.addClass('is-loading');
			overlayOpen($a.attr('href'));
		} else {
			api.overlayClose();
		}
	};

	var bodyClickHandler = function(event) {
		$(classes.list).removeClass('is-hover');
	};

	var groupLabelClickHandler = function(event) {
		var $group = $(this).closest('.dropdown__group');
		toggleGroup($group);
	};

	var removeClickHandler = function(event) {
		var $this = $(this);
		var $item = $this.closest(classes.item);
		removeItem($item);
	};

	var removeAllClickHandler = function(event) {
		var $this = $(this);
		var $items = $(classes.item, $this.closest(classes.downloads));
		$items.each(function(){
			removeItem($(this));
		});
	};

	var getAllClickHandler = function(event) {
		var $this = $(this);
		var url = $this.data('url');
		var $items = $(classes.item, $this.closest(classes.downloads));
		$items.each(function(){
			var _url = $(this).data('url');
			if(_url){
				tracking('Download', {'url': _url});
			}
		});
		downloadAllFiles(url);
	};

	var overlayOpen = function(url) {
		api.overlayIsOpen = true;
		$.ajax({
			xhr: function() {
				var xhr = new window.XMLHttpRequest();
				app.obj['preloader'].showPreloader(xhr);
				return xhr;
			},
			url: url,
			method: 'POST',
			data: {
				'CRAFT_CSRF_TOKEN' : window.csrfTokenValue,
			},
		})
		.done(function(response) {
			if (api.overlayIsOpen) {
				var $overlay = $('<div class="nav-download__overlay"></div>').append($('.site-content', $(response)).children());
				app.obj['preloader'].hidePreloader();

				var y = $win.scrollTop();
				var $freeze = $('.site__wrapper');
				$freeze.data('y', y);
				$freeze.css('top', -y + $freeze.position().top);
				$win.scrollTop(0);

				if ($html.hasClass('search--open')) {
					$('.nav-search a').trigger('click');
				}
				app.obj['nav-main'].close();

				$('.nav-download__overlay').remove();
				$body.append($overlay);
				$overlay.append($('.site__wrapper > .site-footer').clone());
				app.obj.site.overlayOpen = true;
				app.parse($overlay);

				setTimeout(function() {
					$html.addClass('nav-download--open overlay--open');
					$(classes.list).removeClass('is-loading');
				}, 30);
			}
		});
	};

	api.overlayClose = function() {
		if (api.overlayIsOpen) {

			var s = $win.scrollTop();
			var $freeze = $('.site__wrapper');
			var y = $freeze.data('y');

			$html.removeClass('nav-download--open overlay--open');
			app.obj.site.overlayOpen = false;
			$win.scrollTop(y);
			$freeze.removeAttr('style');

			setTimeout(function() {
				if (!api.overlayIsOpen) $('.nav-download__overlay').remove();
			}, 500);
		}
		api.overlayIsOpen = false;
	};

	var downloadSelect = function($holder, directdownload, force, trigger) {

		if (typeof directdownload === 'undefined') {
			directdownload = false;
		}
		if (typeof force === 'undefined') {
			force = false;
		}

		var downloads		= $holder.data('downloads');
		var downloadGroups	= $holder.data('downloadGroups');
		var title			= $holder.data('downloads-title');
		var button_title	= $holder.data('downloads-button');
		var ids = [];
		var urls = [];

		if (downloads.length > 1 && !force && !trigger) {
			var $filter		= $(templates.filter.item);
			var $options	= $('.dropdown__items', $filter);
			var $search		= $('.dropdown__search', $filter);
			var $title		= $('.dropdown__title', $filter);
			var $button		= $('.dropdown__button', $filter);

			if (title)			$title.text(title);
			if (button_title)	$button.text(button_title);

			if ($.isArray(downloadGroups)) {
				$.each(downloadGroups, function(index, group) {
					var $group		= $(templates.filter.group);
					$group.attr('id', group.id);
					$('.dropdown__group__label', $group).text(group.label);
					$options.append($group);
				});
			}

			if (downloads.length < 4 || downloadGroups !== undefined) $search.remove();

			$.each(downloads, function(index, download) {
				var $option		= $(templates.filter.option);
				var id			= 'lg-' + download.id;

				$('label', $option).attr('for', id).text(download.lg);
				$('input', $option).attr('id', id).attr('name', id);
				if (download.group !== undefined) {
					var $groupContent = $('.dropdown__group', $options).filter('#' + download.group).find('.dropdown__group__content');
					$groupContent.append($option);
				} else {
					$options.append($option);
				}
			});

			$body.append($filter);
			$filter.data('buttons', $holder);
			downloadSelectPosition($filter);

			setTimeout(function() {
				$win.on('resize.dropdown orientationchange.dropdown', function() {
					downloadSelectPosition($filter);
				});
			}, 30);

			app.parse($filter);

			//$('.filters__button', $filter).trigger('click').off();
			$('.js-dropdown', $filter).data('dropdown').showDropdown();
			$filter.off('change', 'input[type="checkbox"]');
			$filter.on('click', '.dropdown__button', function(e) {
				$('input[type="checkbox"]:checked', $filter).each(function(i, e) {
					var $button = $('<div></div>');
					var download = downloads[$('input[type="checkbox"]', $filter).index($(this))];
					ids.push(download.id);
					//urls.push(download.url);

					for (var d in download) {
						$button.data(d, download[d]);
					}
					if (!directdownload) {
						addDownloadItem($button);
					}else{
						tracking('Download', $button.data());
					}
				});

				if (directdownload) {
					downloadFiles($holder, ids, urls, trigger);
				}else{
					showInfoMessage(ids.length);
				}
			});
		} else {
			var certificates = $holder.parents('.certificates').length;
			var all = certificates ? [] : downloads;
			var $button = $('<div></div>');

			// CERTIFICATES
			var $filter_lg = $('input[name="language"]:checked');
			var lg_default = 'English';

			// GET CURRENT DOWNLOAD LIST ITEMS
			var $downloads__all = $holder.closest('.downloads__all');
			var $tabs = $holder.closest('.js-tabs-container');
			if($downloads__all.length && $tabs.length && !certificates){
				var all_list = [];
				$('.downloads__item [data-downloads]', $tabs).each(function(i, e) {
					var _downloads = $(this).data('downloads');
					for(d in _downloads) {
						all_list.push(_downloads[d]);
					}
				});
				//console.log(all_list);
				all = all_list;
			}

			for (var download in downloads) {
					if (downloads.hasOwnProperty(download)) {
							var eq = false, download_en = false;

							// CERTIFICATES
							if(certificates){
								if ($filter_lg.length < 1) {
									if (!downloads[download].lg || downloads[download].lg == lg_default || downloads.length<2) {
										all.push(downloads[download]);
									}
								} else {
									$filter_lg.each(function(i, e) {
										var $input = $(this);
										var $label = $('[for="' + $input.attr('id') + '"]', $input.parent());
										if (downloads[download].lg == $label.text()) {
											eq = true;
											all.push(downloads[download]);
										} else if (downloads[download].lg == lg_default) {
											download_en = downloads[download];
										}
									});
									if (!eq && download_en) {
										all.push(download_en);
									}
								}
							}
							// CERTIFICATES END

							urls.push(downloads[download].url);
					}
			}

			var ids_new = "|";

			for (var a in all) {
				var download = all[a];
				ids.push(download.id);

				if(ids_new.indexOf('|'+download.id+'|')<0){
					ids_new += download.id+'|';
				}

				for (var d in download) {
					$button.data(d, download[d]);
				}
				if (!directdownload) {
					addDownloadItem($button);
				}else if(all.length<2 || (force && $button.data('url'))){
					tracking('Download', $button.data());
				}
			}

			if (directdownload) {
				downloadFiles($holder, ids, urls, trigger);
			}else{
				showInfoMessage(ids_new.split('|').length-2);
			}
		}
	};

	var downloadSelectPosition = function($filter) {
		var $buttons		= $filter.data('buttons');
		var $content		= $('.dropdown__content', $filter);
		var pos				= $buttons.offset();
		var top_scroll		= $win.scrollTop();
		var w_win			= $win.innerWidth();
		var h_win			= $win.innerHeight();
		var w				= $content.outerWidth();
		var h				= $content.outerHeight();
		var x				= Math.max(30, Math.min(w_win - w - 30, pos.left - w / 2 + 30));
		var y				= Math.max(30 + top_scroll, Math.min(top_scroll + h_win - h - 30, pos.top - h / 2 + 50));

		$filter.css('right', 'auto').css('bottom', 'auto').css('left', x + 'px').css('top', y + 'px');
	};

	var addDownloadItem = function($button) {
		var buttonData = $button.data();
		var fullCookieData;

		var currentDownloadId = buttonData['id'];
		var currentCookieData = {
			url: buttonData['url'],
			title: buttonData['title'],
			image: buttonData['image'],
			lg: buttonData['lg'],
		};

		var existingCookie = Cookies.get(settings.cookieName);

		console.log(currentCookieData);

		if (existingCookie === undefined) {
			fullCookieData = {};
		} else {
			existingCookie = JSON.parse(existingCookie);
			fullCookieData = existingCookie;
		}

		for(var val in fullCookieData){
			fullCookieData[val] = 1;
		}

		//fullCookieData[currentDownloadId] = currentCookieData;
		fullCookieData[currentDownloadId] = 1; // reduce cookie date

		console.log(fullCookieData);

		Cookies.set(settings.cookieName, fullCookieData, { expires: settings.cookieExpire, path: '/' });

		//showInfoMessage();

		updateList();

		tracking('Download Add', buttonData);
	};

	// TRACKING
	var tracking = function(event, buttonData){
		app.obj.tracking.track({
			'event': 'downloads',
			'category': 'Downloads',
			'action': event,
			'label': buttonData['url'],
			//'value': buttonData['title'],
			//'lg': buttonData['lg']
		});
	};

	var updateList = function() {
		var cookie = Cookies.get(settings.cookieName);

		if (cookie) {
			var qty = Object.keys(JSON.parse(cookie)).length;

			$(classes.nav).attr('data-qty', qty);
			$(classes.qty).attr('title', qty);
		}
	};

	var clearDownloads = function() {
		Cookies.remove(settings.cookieName);
	};

	var toggleGroup = function($group) {
		$group.toggleClass(app.states.isOpen);
		$win.trigger('scrollRefresh');
	};

	var showInfoMessage = function(nr) {
		if (addDownloadsTimeout !== undefined) {
			clearTimeout(addDownloadsTimeout);
		}
		addDownloadsTimeout = setTimeout(function() {
			var infoSettings = {
				type: 'success, corner',
				autoHide: true,
				title: texts.infoMessageTitle,
				message: texts.infoMessageContent.split('###nr###').join(nr),
			};
			app.obj['info'].showInfo(infoSettings);
		}, 100);
	};

	var removeItem = function($item) {
		if(!$item.hasClass('is-removed')){
			var id = $item.data('id');
			var filesize = $item.data('filesize');
			subtractFilesize(filesize);
			removeItemFromCookie(id);
			$item.addClass('is-removed').fadeOut(function() {
				$item.remove();
			});
			if($(classes.item+':not(.is-removed)').length<1){
				$(classes.total).fadeOut(function() {});

				api.overlayClose();
			}
		}
	};

	var subtractFilesize = function(filesize) {
		$totalFilesize = $(classes.totalFilesize);
		if (!$totalFilesize.length) return false;

		var totalFilesize = parseFloat($totalFilesize.text());
		filesize = parseFloat(filesize);

		totalFilesize = Math.max(0, totalFilesize - filesize).toFixed(1);
		$totalFilesize.text(totalFilesize);
	};

	var removeItemFromCookie = function(id) {
		var existingCookie = Cookies.get(settings.cookieName);

		if (existingCookie === undefined) return false;

		existingCookie = JSON.parse(existingCookie);
		if (existingCookie[id] !== undefined) {
			delete existingCookie[id];
		}

		Cookies.set(settings.cookieName, existingCookie, { expires: settings.cookieExpire, path: '/' });

		updateList();
	};

	var downloadFiles = function($holder, ids, urls, trigger) {
		if(ids.length>0){
			if(!trigger){
				var url = window.location .protocol + '//' + window.location.host + '/download?ids=' + ids.join(',');

				downloadUrl(url);

			} else if (urls.length > 1) {
				var $circle = $('.circle-icon--download', $holder);
				if ($circle.length) {
					$circle.trigger('click.downloads_add');
				} else {
					downloadSelect($holder, true, false, false);
				}
			}else{
				var win = window.open(urls[0], '_blank', 'noopener,noreferrer');

				win.opener = null;

				// tracking
				/*app.obj.tracking.track({
					'event': 'downloadsView',
					'category': 'Downloads View',
					'action': 'Download View',
					'label': urls[0],
					//'value': buttonData['title'],
					//'lg': buttonData['lg']
				});*/
			}
		}
	};

	var downloadAllFiles = function(url) {
		if (getAllAjaxCall !== undefined) {
			return false;
		}

		downloadUrl(url);

 //    getAllAjaxCall = $.ajax({
 //      xhr: function() {
 //        var xhr = new window.XMLHttpRequest();
 //        app.obj['preloader'].showPreloader(xhr);
 //        return xhr;
 //      },
 //      url: url,
 //      method: 'POST',
 //      data: {
 //        'CRAFT_CSRF_TOKEN' : window.csrfTokenValue,
 //      },
 //    })
	// .done(function(response) {
 //  app.obj['preloader'].hidePreloader();
 //  getAllAjaxCall = undefined;
 // });
	};

	var downloadUrl = function(url){
		//location.href = url;
		if($('html.screen--is-touch').length || ($html.hasClass('explorer') && search_borouge)){
			window.open(url, '_blank');
		}else{
			$iframe.attr('src', url);
		}
	}

	init();	return api;
};

app.globalExt['fixed-bottom'] = function() {
	var api = {};

	var $win     = app.vars.$win;
	var $doc     = app.vars.$doc;
    var win_w    = 0;
    var len      = 0;

	var classes = {
        el       : ['#consent_blackbar', '.js-fixed-bottom'],
        trigger  : '#consent_blackbar button',
        fixed    : '.js-fixed-bottom',
        close    : '.js-fixed-bottom-close',
        cookie   : '[data-cookie]',
	};

	var init = function() {
		addListeners();
        updateElements();
        setTimeout(function () {
            cookies();
        }, 3000);
	};

	var addListeners = function() {
        $win.on('resize.fixed-bottom orientationchange.fixed-bottom', addResizeHandler);
        $doc.on('click.fixed-bottom', classes.trigger, addClickHandler);
        $doc.on('click.fixed-bottom-close', classes.close, addCloseHandler);
    };
    
    var addClickHandler = function (e) {
        console.log('addClickHandler');
        setTimeout(function(){
            updateElements();
        }, 1000);
    };

    var addCloseHandler = function (e) {
        console.log('addCloseHandler');
        var $target = $(e.target).closest(classes.cookie);
        Cookies.set($target.data('cookie'), '1', { expires: 365 });
        $target.remove();
        setTimeout(function () {
            updateElements();
        }, 1000);
    };

    var addResizeHandler = function (e) {
        var w = $win.innerWidth();
        var l = $(classes.el.join(',')).length;

        //console.log('width: ' + w + ', len: ' + l);
        if (win_w != w || len != l){
            updateElements();
            win_w = w;
        }
    };

    var updateElements = function () {
        var h = 0;
        var $el_parent;

        //console.log('updateElements');
        for(var i = 0; i < classes.el.length; i++){
            var $el = $(classes.el[i]);

            if($el.length){
                if ($el_parent && $el_parent.length){
                    $el.css('bottom', $el_parent.outerHeight());
                } else {
                    $el.removeAttr('style');
                }
                $el_parent = $el;
                h += $el.outerHeight();
            }
        }

        $('.site-footer').css('margin-bottom', h);
    };

    var cookies = function () {
        $(classes.fixed).filter(classes.cookie).each(function () {
            var $el = $(this);

            if (Cookies.get($el.data('cookie')) === '1') {
                $el.remove();
            } else {
                $el.addClass('is-visible');
                updateElements();
            }
        });
    };

	init();	return api;
};

app.globalExt['freeze'] = function() {
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var init = function() {
	};

	//var $wrapper = $('.site__wrapper');
	//var $search = $('.search.search--global');

	api.enable = function($target){
		var top = $win.scrollTop();
		var $wrapper = $('.site__wrapper');
		var $search = $('.search.search--global');
		//var $freeze = $target || (!$('html.search--open').length ? $wrapper : $search);
		var $freeze = $target || $wrapper;
		var y = $freeze.data('y');
		var frozen = $freeze.data('frozen');
		var search_open = $('html.search--open').length;

		if(!frozen){
			var y_diff = (-top + $freeze.position().top);
			$freeze.data('y', top);
			$freeze.css('transform','translateY('+ y_diff +'px)');
			$html.addClass('site--lockscroll').attr('data-scroll-nav', (y_diff <= -30 ? 1 : 0));
		}

		$win.scrollTop(0);

		$freeze.data('frozen', true);

		if(!search_open){
			$search.removeAttr('style');
			y = -top;
		}else{
			y = -y;
		}

		//console.log('FREEZE:'+y+', top:'+top);

		$('.nav-main__sub__inner').removeAttr('style');
		if(top>0 || search_open){
			$('.nav-main__append .nav-main__sub__inner[style]').removeAttr('style');
			$('.nav-main__append.open .nav-main__sub__inner').css('transform', 'translateY('+(y)+'px)');
		}

		return top;
	};

	api.disable = function($target){
		var top = $win.scrollTop();
		var $wrapper = $('.site__wrapper');
		var $search = $('.search.search--global');
		//var $freeze = $target || (!$('html.search--open').length ? $wrapper : $search);
		var $freeze = $target || $wrapper;
		var y = $freeze.data('y');

		//console.log('UNFREEZE:'+y+','+top);

		$freeze.removeAttr('style');
		$html.removeClass('site--lockscroll').removeAttr('data-scroll-nav');
		$win.scrollTop(y);

		$freeze.data('frozen','');
		$freeze.data('y',top);

		if($('html.search--open').length){
			$search.css('top', (y - top) + 'px');

			console.log('UNFREEZE SEARCH:'+y);

			setTimeout(function() {
				$search.removeAttr('style');
			}, 500);
		}

		$('.nav-main__append .nav-main__sub__inner[style]').removeAttr('style');
		$('.nav-main__append.open .nav-main__sub__inner').css('transform', 'translateY('+(y-top)+'px)');

		return y;
	};

	init();	return api;
};

app.globalExt['module-name'] = function() {
	var api = {};

	var init = function() {
		
	};

	init();	return api;
};

app.globalExt["grid-layout"] = function () {
  var api = {};

  var init = function () {
    gridLayout("grid=1");
  };

  var gridLayout = function (param) {
    var url = window.location.href;

    if (url.replace("?", "&").indexOf("&" + param) >= 0) {
      var layout = document.createElement("div");
      var outer = document.createElement("div");
      var inner = document.createElement("div");
      var columns = 12;
      var i = "";

      for (i = 0; i < columns; i++) {
        inner.appendChild(document.createElement("div"));
      }

      layout.setAttribute("class", "grid-layout");
      layout.prepend(outer);
      outer.prepend(inner);
      document.body.prepend(layout);
    }
  };

  init();
  return api;
};

app.globalExt['info'] = function() {
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var settings = {
		duration: 0.4,
		distance: 10,
		timeoutDuration: 5,
	};

	var templates = {
		info: '<div class="info  js-info">\
		<p><strong>{{title}}</strong></p>\
		<p>{{message}}</p>\
		</div>',
		closeButton: '<div class="info__close  js-info-close"></div>',
	};

	var classes = {
		info: '.js-info',
		closeButton: '.js-info-close',
	};

	var init = function() {
		addListeners();
	};

	var addListeners = function() {
		$doc.on('click', classes.closeButton, closeButtonClickHandler);
	};

	var closeButtonClickHandler = function() {
		var $info = $(this).closest(classes.info);
		api.hideInfo($info);
	};

	api.showInfo = function(infoSettings) {
		var template = templates.info;

		var types = infoSettings.type.replace(/ /g, '');
		types = types.split(',');
		template = template.replace('{{title}}', infoSettings.title);
		template = template.replace('{{message}}', infoSettings.message);
		
		var $info = $(template).hide();
		$.each(types, function(index, type) {
			$info.addClass('info--' + type);
		});

		if (infoSettings.closeButton === true) {
			$info.prepend(templates.closeButton);
		}

		$body.append($info);

		TweenLite.fromTo(
			$info, 
			settings.duration, 
			{opacity: 0, y: settings.distance}, 
			{opacity: 1, y: 0, display: 'block', ease: app.settings.easeOut,
			onComplete: function() {
			},
		});

		if (infoSettings.autoHide === true) {
			setTimeout(function() {
				api.hideInfo($info);
			}, settings.timeoutDuration * 1000);
		}
	};

	api.hideInfo = function($info) {
		TweenLite.to(
			$info, 
			settings.duration, 
			{opacity: 0, y: settings.distance, display: 'none', ease: app.settings.easeOut,
			onComplete: function() {
				$info.remove();
			},
		});
	};

	init();	return api;
};

app.globalExt["media"] = function () {
  var api = {};

  var $win = app.vars.$win;
  var $doc = app.vars.$doc;
  var $html = app.vars.$html;
  var $body = app.vars.$body;

  var settings = {};

  var classes = {
    media: ".media",
    close: ".button-close",
    items: ".media__items",
    item: ".js-media-item",
    item_text: ".media__item__desc__text",
  };

  var templates = {
    media:
      '<div class="media media--overlay">\
						<div class="media__outer">\
							<div class="media__inner">\
								<div class="media__items" data-component=\'{ "component": "slider" }\' data-slider-settings=\'{ "navigation": true, "autoHeight": true, "spaceBetween": 90, "slidesPerView": 1, "initialSlide": %initialSlideIndex% }\'></div>\
								<div class="button-close"><i></i></div>\
							</div>\
						</div>\
					</div>',
    item: '<div class="media__item" data-id="###id###">\
						<div class="media__item__img"></div>\
						<div class="media__item__desc">\
							<div class="media__item__desc__inner">\
								<div class="media__item__desc__text">\
									<div class="media__item__desc__text__inner"></div>\
								</div>\
							</div>\
						</div>\
					</div>',
    downloads:
      '<div class="downloads__item  js-more-options">\
						<div class="downloads__item__section  js-downloads-add">\
							<div class="downloads__icon  circle-icon  circle-icon--download" title="Download"></div>\
						</div>\
					</div>',
  };

  var media_param = "id-media-single";
  var media_param_search = "id-media-search";

  var init = function () {
    addListeners();

    $(classes.media + "--inline").each(function () {
      $media = $(this);
      $media.addClass("media--items-" + $(".media__item", $media).length);
      //console.log($media);
      // mediaSwiper($media, 0);
      //iScrollUpdate($media);
    });

    $win.on("popstate.media", mediaHistoryCheck);
    mediaHistoryCheck();
  };

  var addListeners = function () {
    $doc.on("click.media_item", classes.item, openClickHandler);
    $doc.on(
      "click.media_item_text",
      ".media--overlay " + classes.item_text,
      textClickHandler
    );
  };

  var openClickHandler = function (event) {
    if (!$(event.target).hasClass("circle-icon")) {
      event.preventDefault();
      //event.stopPropagation();
      //event.stopImmediatePropagation();
      api.mediaOpen($(this));
    }
  };
  var closeClickHandler = function (event) {
    api.mediaClose();
  };

  api.mediaOpen = function ($el, $container) {
    $container = $container || $body;

    if ($container.children(classes.media).length) return false;

    var $items = $(classes.item, $el.parent());
    var index = $items.index($el);
    var mediaTemplate = templates.media;
    mediaTemplate = mediaTemplate.replace("%initialSlideIndex%", index);
    var $media = $(mediaTemplate);
    var param =
      $el.parent().data("param-media") ||
      ($el.parents(".search").length ? media_param_search : media_param);

    //console.log('--param:'+param);

    if (param) {
      $media.data("param-media", param);
    }

    $items.each(function (i) {
      var $self = $(this);
      var $data = $self.data("media-title")
        ? $self.data()
        : $("[data-media-title]:eq(0)", $(this)).data();

      var id = $data["id"];
      var img = $data["mediaImg"];
      var title = $data["mediaTitle"];
      var copy = $data["mediaCopy"];
      var desc = $data["mediaDesc"];

      var $item = $(templates.item.split("###id###").join(id || ""));
      var $img = $(".media__item__img", $item);
      var vid_id = $data["videoId"];
      var vid_type = $data["type"];
      var autoplay = $self[0] == $el[0] ? ' data-autoplay="true"' : "";

      $(".media__item__desc__text__inner", $item)
        .append($('<h5 class="h5">' + title + "</h5>"))
        .append($('<p class="media__item__copy">' + copy + "</p>"))
        .append($('<p class="media__item__text">' + desc + "</p>"));

      if (vid_id) {
        $img.append(
          $('<div class="video-inline__img" data-bg="' + img + '"></div>')
        );
        $img.append($('<div class="h5 video-inline__duration"></div>'));
        $img.append(
          $(
            '<a href="javascript:;" class="video-button"><span><i></i><span></span></span></a>'
          )
        );
        $img.append(
          $(
            '<div class="video-inline__video"><div class="js-video-player" data-target="inline" ' +
              autoplay +
              ' data-type="' +
              vid_type +
              '" data-video-id="' +
              vid_id +
              '"></div></div>'
          )
        );
        $img.wrapInner('<div class="video-inline"></div>');
      } else {
        $img.append($('<img data-src="' + img + '" />'));

        var image = $("img", $img)[0];
        var $downloads = $(templates.downloads);
        var downloads_attr = $("[data-downloads]", $self).length
          ? $("[data-downloads]", $self).attr("data-downloads")
          : $self.attr("data-downloads");

        if (downloads_attr) {
          $(".js-downloads-add", $downloads).attr(
            "data-downloads",
            downloads_attr
          );
          $(".media__item__desc__inner", $item).append($downloads);
        }

        /*image.onload = function (e) {
					if((e.target.width / e.target.height) < 1) {
						$item.addClass('media__item--vertical');
					}
				};
				image.src = img;*/
      }

      $(classes.items, $media).append($item);
    });

    $container.append($media);

    // Create Swiper
    // mediaSwiper($media, index);
    window.parseNewComponents($media[0]);

    // Parse
    app.parse($media);

    // Close Handler
    $($media).on("click", classes.close, closeClickHandler);

    setTimeout(function () {
      $html.addClass("media--open");
      lockScroll(true);
    }, 30);
  };

  // var mediaSwiper = function($media, index) {

  // 	if ($media.hasClass('no-swiper')) return false;

  // 	$('> *:first-child', $('.media__inner', $media)).addClass('swiper-wrapper');
  // 	$('> *:first-child > *', $('.media__inner', $media)).addClass('swiper-slide');

  // 	var pagination = false;

  // 	if($('.swiper-pagination', $media).length){
  // 		pagination = {
  // 			el: $('.swiper-pagination', $media)[0],
  // 			type: 'bullets', // fraction
  // 			clickable: true,
  // 		};
  // 	}

  // 	var swiper = new Swiper($('.media__inner', $media)[0], {
  // 		pagination:		pagination,
  // 		navigation:		{
  // 							prevEl: $('.media__nav > *:first-child', $media)[0],
  // 							nextEl: $('.media__nav > *:last-child', $media)[0],
  // 						},
  // 		initialSlide:	index,
  // 		autoHeight:		$media.hasClass('media--inline'),
  // 		spaceBetween:	90,
  // 		//speed:		300,

  // 		on: {
  // 			init: function() {
  // 				var $container = $(this.wrapperEl);
  // 				videoVis($container);
  // 				lazy($container);
  // 				updateVisibleSlides(this);
  // 				setTimeout(function() {
  // 					lazy($container);
  // 				}, 1000);
  // 			},
  // 			touchStart: function() {
  // 				$(this.wrapperEl).addClass('swiper--move');
  // 			},
  // 			sliderMove: function() {
  // 				$media.addClass('media--swipe');
  // 			},
  // 			touchEnd: function() {
  // 				$media.removeClass('media--swipe');
  // 				$(this.wrapperEl).removeClass('swiper--move');
  // 			},
  // 			transitionStart: function() {
  // 				updateVisibleSlides(this);
  // 				$media.addClass('media--swipe');
  // 			},
  // 			transitionEnd: function() {
  // 				var $container = $(this.wrapperEl);
  // 				$('.slide--hidden .video-playing .js-video-player', $container).each(function() {
  // 					$(this).data('video-player').videoPause();
  // 				});
  // 				videoVis($container);
  // 				$media.removeClass('media--swipe');
  // 				iScrollUpdate($media);
  // 				lazy($container);
  // 			},
  // 		},
  // 	});

  // 	$media.data('swiper', swiper);

  // 	setTimeout(function() {
  // 		iScrollUpdate($media);
  // 		//$('[data-bg],[data-src]', $media).lazyLoadXT({checkDuplicates: false});

  // 		$win.on('resize orientationchange', function() {
  // 			iScrollUpdate($media);
  // 		});
  // 	}, 300);
  // };

  var mediaHistoryCheck = function () {
    var id = app.getParam(media_param) || app.getParam(media_param_search);

    console.log("mediaHistoryCheck:" + id);

    if (id) {
      var $slide = $(classes.media + ' .swiper-slide[data-id="' + id + '"]');
      if ($slide.length && $slide.parents(classes.media).data("swiper")) {
        $slide.parents(classes.media).data("swiper").slideTo($slide.index());
      } else {
        setTimeout(function () {
          $(classes.item + '[data-id="' + id + '"]')
            .eq(0)
            .trigger("click");
        }, 500);
      }
    } else if (!id) {
      api.mediaClose();
    }
  };

  var mediaHistoryID = function (id, swiper) {
    var url = location.href
      .split("&" + media_param_search + "=")[0]
      .split("?" + media_param_search + "=")[0]
      .split("&" + media_param + "=")[0]
      .split("?" + media_param + "=")[0];

    console.log("mediaHistoryID:" + url);

    if (id && id != "") {
      var param = mediaParam(id);
      //console.log('param:'+param);
      if (swiper) {
        param = $(swiper.wrapperEl).closest(".media").data("param-media");
        //console.log('param swiper:'+param);
      }
      if (param) {
        url += (url.indexOf("?") < 0 ? "?" : "&") + param + "=" + id;
      }
      //console.log('url:'+url);
      if (!history.state || history.state.media_id != id) {
        history.pushState({ type: "media", media_id: id }, document.title, url);
      }
    } else if (app.getParam(media_param) || app.getParam(media_param_search)) {
      history.pushState({ type: "media", media_id: "" }, document.title, url);
    }
  };

  var mediaParam = function (id) {
    var id = app.getParam(media_param);
    var id_search = app.getParam(media_param_search);

    return id ? media_param : id_search ? media_param_search : false;
  };

  var videoVis = function ($container) {
    var $video = $(".swiper-slide-active .js-video-player", $container);
    if ($video.length && $video[0].videoVis) $video[0].videoVis();
  };

  var lazy = function ($container) {
    $(
      ".swiper-slide-active [data-bg]:not(.lazy-loaded),[data-src]:not(.lazy-loaded)",
      $container
    ).lazyLoadXT({ checkDuplicates: false });
  };

  var textClickHandler = function (event) {
    var $target = $(event.currentTarget);
    var $inner = $target.children();

    if (!$target.hasClass("is-open")) {
      $target.addClass("is-open");
      $inner.trigger("destroy");
      var h = $inner.prop("scrollHeight");
      $inner.css("height", h);
    } else {
      $target.removeClass("is-open");
      $inner.removeAttr("style");
      setTimeout(function () {
        //$inner.data('dots').dots();
        dots($inner);
      }, 500);
    }
  };

  var updateVisibleSlides = function (swiper) {
    console.log("updateVisibleSlides");
    var $container = $(swiper.wrapperEl);
    var $items = $(".swiper-slide", $container);
    var slidesPerView = swiper.params.slidesPerView;
    var visibleItems = $items.filter(function (index) {
      return (
        index >= swiper.activeIndex &&
        index < swiper.activeIndex + slidesPerView
      );
    });
    var $active = $(".swiper-slide-active", $container);
    var id = $active.data("id");

    $container.attr("data-length", swiper.slides.length);
    $items.not(visibleItems).addClass("slide--hidden");
    visibleItems.removeClass("slide--hidden");

    if (id) mediaHistoryID(id, swiper);
  };

  var dots = function ($text) {
    var dots = $text.dotdotdot({
      ellipsis: "...",
      watch: "window",
      callback: function (isTruncated, orgContent) {
        if (!isTruncated) {
          $text.addClass("no-height");
        }
      },
    });
    //$text.data('dots', dots);
    setTimeout(function () {
      $text.trigger("update");
    }, 30);
  };

  var iScrollUpdate = function ($media) {
    $(
      ".media__item.swiper-slide-active",
      $media.filter(":not(.media--inline)")
    ).each(function () {
      var $item = $(this);
      var scroller = $item.data("scroller");

      if ($("html.until-tablet").length) {
        var $text = $(".media__item__desc__text__inner", $item);

        //if(!$text.hasClass('is-truncated') && $text.data('dots')) {
        if (!$text.hasClass("is-truncated")) {
          $text.removeAttr("style").parent().removeClass("is-open");
          //$text.data('dots').dots();
          dots($text);
        }
      } else {
        $(".media__item__desc__text__inner.is-truncated", $item)
          .trigger("destroy")
          .removeAttr("style")
          .parent()
          .removeClass("is-open");
      }

      if ($("html.until-tablet").length && scroller) {
        scroller.destroy();
        scroller = null;
        $item.data("scroller", null);
        $(".media__item__desc__inner", $item).removeAttr("style");
      } else if (!$("html.until-tablet").length && !scroller) {
        scroller = new IScroll($(".media__item__desc", $item)[0], {
          scrollbars: true,
          mouseWheel: true,
          fadeScrollbars: true,
          interactiveScrollbars: true,
          useTransition: true,
          momentum: true,
          bounce: true,
          click: false,
          preventDefaultException: { "*": /.*/ },
        });
        $item.data("scroller", scroller);
      }
    });
  };

  api.mediaClose = function ($container) {
    $container = $container || $body;

    var $media = $container.find(classes.media).first();

    $html.removeClass("media--open");
    $(".video-player", $container).each(function () {
      delete $(this)[0].player;
    });

    $(".media__holder--hidden").remove();

    mediaHistoryID();

    lockScroll(false);

    setTimeout(function () {
      /*if(scroller){
				scroller.destroy();
				scroller = null;
			}*/
      $media.remove();
    }, 1000);
  };

  var lockScroll = function (lock) {
    var $target = $win;
    console.log("lockScroll Media:" + lock);

    if (lock) {
      var lockedPosition = $target.scrollTop();
      $target.on("scroll.lockScroll", function () {
        $target.scrollTop(lockedPosition);
      });
    } else {
      $target.off("scroll.lockScroll");
    }
  };

  init();
  return api;
};

app.globalExt["nav-main"] = function () {
  var api = {};

  var $win = app.vars.$win;
  var $doc = app.vars.$doc;
  var $html = app.vars.$html;
  var $body = app.vars.$body;

  var $desktop;
  var $mobile;

  var $search;
  var $header;
  var $nav;
  var $icon;
  var $selected;
  var $items;
  var $close;
  var nav_open;
  var local;
  var initialized;

  var nav_enter_timer;
  var nav_change_timer;
  var nav_close_sub_timer;
  var nav_appended;
  var resize_timer;

  var init = function () {
    $search = $(".search--global");
    $header = $(".site-header");
    $nav = $(".nav-main");
    $icon = $(".nav-main-icon");
    $selected = $(".nav-main-selected span");
    $items = $("ul li a:not(.teaser-button, .more)", $nav);
    $close = $(".nav-main__sub__close");
    header = $(".site-header__item", $header).length;
    local = $(".site-header--local").length;
    nav_open = $html.hasClass("nav-main--open");

    if ($nav.length && !initialized) {
      initialized = true;

      addListeners();

      if (!header) $html.addClass("site-header--none");

      // CRAFT CMS PPERFORMANCE ISSUE
      $(".nav-contact").appendTo($("> ul", $nav));

      // hashURL();
    }
  };
  api.init = function () {
    init();
  };

  // var hashURL = function () {
  //   var hash = location.hash;

  //   if (hash) {
  //     var $target = $header.find('[data-target="' + hash + '"]');

  //     if ($target.length) {
  //       var $trigger = $target.closest("li.is-hidden").find("> a");

  //       setTimeout(function () {
  //         $target.trigger("click");
  //         $trigger.trigger("click");
  //       }, 2000);
  //     }
  //   }
  // };

  var addListeners = function () {
    // CLICK - MOBILE, MOUSEENTER - DESKTOP
    $doc
      .on(
        "click.nav-mobile",
        ".screen--is-touch .nav-main ul li a:not(.teaser-button, .more), .screen--is-touch .nav-main__append ul li a:not(.teaser-button, .more)",
        navClick
      )
      /*// HOVER - DESKTOP
			.on('mouseenter.nav',	'.screen--no-touch .nav-main > ul > li > a', function(e){
				clearTimeout(nav_enter_timer);
				//navClick(e);
				if(!$(e.currentTarget).closest('.open').length) {
					navClick(e);
				}else{
					navHover(e);
				}
			})
			// MOVE OUTSIDE
			.on('mouseleave.close', '.nav-main__sub__inner', function (e) {
				nav_enter_timer = setTimeout(function () {
					$close.trigger('click.close_sub');
				}, 100);
			})*/
      // CLICK - DESKTOP
      .on(
        "click.nav",
        ".screen--no-touch .nav-main > ul > li > a",
        function (e) {
          navClick(e);
        }
      )
      // MOUSELEAVE - DESKTOP
      .on(
        "mouseleave.nav",
        ".screen--no-touch .nav-main > ul > li.open > a, .screen--no-touch .nav-main__append, .screen--no-touch .nav-main > ul > li .nav-main__sub",
        function (e) {
          /*nav_enter_timer = setTimeout(function(){
					api.close();
				}, 100);*/
        }
      )
      // APPEND - MOUSEENTER - DESKTOP
      .on(
        "mouseenter.nav-append",
        ".screen--no-touch .nav-main__append, .screen--no-touch .nav-main__sub, .nav-main__sub__close",
        function (e) {
          clearTimeout(nav_enter_timer);
        }
      )
      // CLICK CLOSE
      .on("click.close", ".nav-main-icon", function (e) {
        api.closeSub();

        if (!nav_open) {
          if ($html.hasClass("search--open")) {
            app.obj["search"][0].close();
          }
          lockScroll(true);
          $html.addClass("nav-main--open");
          nav_open = true;
        } else {
          $html.removeClass("nav-main--open nav-main--open-full");
          nav_open = false;
          lockScroll(false);
        }
      });

    $selected.on("click.close", function (e) {
      api.closeSub();
    });
    $close.on("click.close_sub", function (e) {
      api.close();
    });

    $(".nav-main__sub__innernav li").on("click", function (e) {
      var $target = $(e.currentTarget);
      var $ul = $target.parent();
      var $targets = $ul.next().children();

      $("li", $ul).removeClass("is-active");
      $target.addClass("is-active");

      $targets
        .removeClass("is-active")
        .eq($("li", $ul).index($target))
        .addClass("is-active");
    });

    $win.on("scroll.navscroll", function (e) {
      api.navScroll();
    });

    //$win.on('mousewheel.navscroll', wheelScroll);

    $win.on("resize.navscroll", function (e) {
      $desktop = $("html.from-tabletLandscape");
      $mobile = $("html.until-tabletLandscape");
      scrollTop_tmp = 0;
      api.navScroll();

      if ($mobile.length) {
        subnavRestore();
      } else {
        subnavAppend();
      }
    });

    clearTimeout(resize_timer);
    resize_timer = setTimeout(function () {
      //api.navScroll();
      $win.trigger("scroll.navscroll");
    }, 30);
  };

  var navHover = function (e) {
    if (nav_open && nav_appended) {
      var $target = $(e.currentTarget).parent();
      var append = $target.data("append");
      var $append = append || $target;
      $target.removeClass("change");
      $append.removeClass("change");
    }
  };

  var navClick = function (e) {
    if (nav_appended) {
      var $target = $(e.currentTarget).parent();
      var quick = $target.hasClass("is-hidden");
      var append = $target.data("append");
      var $append = append || $target;

      if ($append.find("ul").length || quick) {
        var open;
        var $appended = $target.closest(".nav-main__append");
        var $sub = $append.find(".nav-main__sub__sub");
        var $sub2 = $append.find("> .nav-main__sub__sub__sub");
        var subs = $append.find("> .nav-main__sub .nav-main__sub__sub").length;
        var subs2 =
          subs &&
          $append.find("> .nav-main__sub__sub .nav-main__sub__sub__sub").length;
        var topnav = !$appended.length && $target.parents("ul").length < 2;

        e.preventDefault();

        //$win.trigger('headerNavLinkClick');

        // if ($search.data("search").isOpen) {
        //   $search.data("search").close();
        // }
        app.obj["downloads"].overlayClose();

        $target.toggleClass("open");
        //navChange();

        if (subs && $mobile.length) {
          $target.addClass("open");
        }
        if (topnav) {
          $html.removeClass("nav-main--open-sub-sub");
        }

        open = nav_open = $target.hasClass("open");

        $html.removeClass("nav-main--change");

        if (open) {
          if (!$appended.length && !local) {
            //lockScroll(false);
            lockScroll(true);
          }

          $html
            .removeClass("nav-main--open-full")
            .addClass(
              "nav-main--open-sub nav-main--open" +
                (!local || quick ? " nav-main--open-full" : "")
            );
          $target.removeClass("change").siblings().removeClass("open");
          $(
            "li",
            $target.parents(".nav-main__sub__sub").parent().siblings()
          ).removeClass("open");
          $("ul li.open", $target).removeClass("open");

          $("body > .nav-main__append").removeClass("open");
          if (append) {
            $append.addClass("open").removeClass("change");
            $("ul li.open", $append).removeClass("open");
          } else if ($appended.length) {
            $appended.addClass("open");
          }

          /*var $sub_nav = $desktop.find('li.open .nav-main__sub');

					if ($sub_nav.length & !$sub_nav.data('scroller')) {
						var scroller = new IScroll($sub_nav[0], {
							scrollbars: true,
							mouseWheel: true,
							//fadeScrollbars: true,
							interactiveScrollbars: true,
							useTransition: true,
							momentum: true,
							bounce: true,
							click: false,
							preventDefaultException: {'*':/.*\/},
						});
						$sub_nav.data('scroller', scroller);
					}
					scrollStart($sub_nav);*/

          if (append) {
            $append.addClass("open");
          }

          if ($mobile.length) {
            if (subs || $sub.length) {
              $mobile.find(".nav-main__sub__sub").slideUp();
            }
            $(".nav-main__sub__sub__sub").slideUp();
            $selected.text($("> ul > li.open > a", $nav).text());
          }

          if ((append && quick) || $mobile.length) {
            $win.trigger("scroll");
          }
        } else if ((subs || append) && $desktop.length) {
          $html.removeClass(
            "nav-main--open-sub nav-main--open-sub-sub nav-main--open nav-main--open-full"
          );
          nav_open = false;

          nav_enter_timer = setTimeout(function () {
            lockScroll(false);
          }, 500);
          ///////
          //scrollStop();
          //lockScroll(false);

          ///////
          //scrollStop();
          /*if(!small_tmp || lock_scroll) {
						lockScroll(false);
					}*/
          ///////
          if (append) {
            $append.removeClass("open");
          }
        }

        if (!topnav && !subs && !subs2 && $("ul", $target).length) {
          if (open) {
            $html.addClass("nav-main--open-sub-sub");
          } else {
            $html.removeClass("nav-main--open-sub-sub");
          }
        }

        if (!subs || $sub2.length) {
          if (open) {
            $sub.slideDown();
            if ($sub2.length) {
              $sub2.slideDown();
            }
          } else {
            if ($sub2.length) {
              $sub2.slideUp();
            } else {
              $sub.slideUp();
            }
          }
        } else {
          //$target.addClass('open');
          $sub.parents(".nav-main__sub").scrollTop(0);
        }
      } else if (nav_open) {
        //api.close();
        $html.addClass("nav-main--change");
        $(".nav-main__item, .nav-main__append.open").addClass("change");
        nav_enter_timer = setTimeout(function () {
          api.close();
        }, 500);
      }
    }
  };

  var subnavAppend = function ($sub_nav) {
    $(
      !local
        ? "> ul > li .nav-main__sub"
        : "> ul > li.is-hidden .nav-main__sub",
      $nav
    ).each(function (i) {
      var $sub_nav = $(this);
      var $parent = $sub_nav.parent();
      var $append = $("<div></div>")
        .attr("class", ($parent.attr("class") || "") + " nav-main__append")
        .append($sub_nav);

      $parent.data("append", $append);
      $append.appendTo($body);
    });
    nav_appended = true;
  };

  var subnavRestore = function () {
    $("> ul > li", $nav).each(function () {
      var $li = $(this),
        $append = $li.data("append");
      if ($append) {
        $li.append($(".nav-main__sub", $append)).data("append", "");
      }
    });
    $("body > .nav-main__append").remove();
    nav_appended = true;
  };

  api.closeSub = function () {
    if ($html.hasClass("nav-main--open-sub")) {
      //scrollStop();
      navChange();
      $html.removeClass("nav-main--open-sub nav-main--open-sub-sub");
      clearTimeout(nav_close_sub_timer);
      nav_close_sub_timer = setTimeout(
        function () {
          $("ul li.open", $nav).removeClass("open");
        },
        $desktop.length ? 0 : 500
      );
    }
  };

  api.close = function () {
    if (nav_open) {
      nav_open = false;
      if ($mobile.length) {
        $html.removeClass("nav-main--open nav-main--open-full");
        api.closeSub();
      } else {
        $html.removeClass(
          "nav-main--open nav-main--open-full nav-main--open-sub nav-main--open-sub-sub"
        );
        $("ul li.open", $nav).removeClass("open");
        //setTimeout(function() {
        $(".nav-main__append.open").removeClass("open");
        //}, 500);
        //subnavRestore();
      }
      //scrollStop();
      lockScroll(false);
      navChange();
      //$win.trigger('headerNavCloseClick');
    }
  };

  /*var $scroller, scroller;
	var scrollStart = function($sub_nav){
		$scroller = $sub_nav;
		scroller = $scroller.data('scroller');
		scrollStop();
		scrollUpdate();
		$win.on('resize.nav-main-scroll orientationchange.nav-main-scroll', scrollResize);
	};
	var scrollStop = function(){
		$('.scrollbar--enabled').removeClass('scrollbar--enabled');
		$win.off('resize.nav-main-scroll orientationchange.nav-main-scroll');
	};
	var scrollUpdate = function(){
		if(!$('.iScrollIndicator:visible', $scroller).length){
			$scroller.removeClass('scrollbar--enabled');
		}else{
			$scroller.addClass('scrollbar--enabled');
		}
	};
	var scrollResize = function(){
		if(scroller && !scroller.enabled){
			scroller.enable();
		}
		setTimeout(function(){
			scrollUpdate();
		}, 300);
	};*/

  var navChange = function () {
    $html.addClass("nav-main--change");
    clearTimeout(nav_change_timer);
    nav_change_timer = setTimeout(
      function () {
        $html.removeClass("nav-main--change");
      },
      $desktop.length ? 0 : 500
    );
  };

  var scrollTop_tmp = -1;
  var scrollDiff = 0;
  var top = 0;

  api.navScroll = function (unstick) {
    if (!nav_open) {
      if (app.obj.site) {
        top = app.obj.site.scrollTop;
        var $pusher = $("html.search--open").length
          ? $(".search .subnav:eq(0):visible")
          : $(".site-main .subnav:eq(0):not(.filters):visible");

        if (!unstick) {
          scrollDiff = scrollTop_tmp - top;
        }

        // if (!app.obj.site.overlayOpen && $pusher.length) {
        // 	var $el			= $pusher.parent();
        // 	var $subnav		= $('.subnav:eq(1)', $el);
        // 	var $content	= $('.overview', $el.parent());

        // 	/*if($el.hasClass('is_stuck') && $el.data('unstick')){
        // 		$el.data('unstick','');
        // 		$el.data('top',0);
        // 		console.log('--');
        // 	}*/
        // 	if (scrollDiff && $el.hasClass('is_stuck')) {
        // 		/*var h = $subnav.height();
        // 		var y = Math.max(-h, Math.min(0, $el.data('top') + scrollDiff));
        // 		$el.css('top', y + 'px');
        // 		$el.data('top', y);*/
        // 	} else {
        // 		//$el.data('top',0);
        // 	}
        // 	/*else if(!$el.data('unstick')){
        // 		$el.data('unstick',1);
        // 		$el.data('top',y);
        // 	}*/

        // 	/*if (scrollDiff && $el.hasClass('is_stuck')) {
        // 		$html.addClass('subnav--up');
        // 	} else {
        // 		$html.removeClass('subnav--up');
        // 	}*/
        // 	if (scrollDiff<-3 && $el.hasClass('is_stuck')){
        // 		if($pusher.next().hasClass('subnav')) {
        // 			$html.addClass('subnav--up');
        // 		}
        // 	} else if(!$el.hasClass('is_stuck')){
        // 		$html.removeClass('subnav--up');
        // 	}
        // 	//console.log(scrollDiff);
        // 	if (!unstick) {
        // 		if (scrollDiff<-3) {
        // 			$html.addClass('scroll--down');
        // 		}else if (scrollDiff>0) {
        // 			$html.removeClass('scroll--down');
        // 		}
        // 	}

        // 	if ($content.length) {
        // 		var content_y	= $content.offset().top;
        // 		var $content_inner	= $('> *', $content);
        // 		var inner_y		= $content_inner.position().top;

        // 		/*if (y > -h) {
        // 			$html.addClass('side--slide-down');
        // 		} else {
        // 			$html.removeClass('side--slide-down');
        // 		}
        // 		if (content_y > top + $el.height() - inner_y) {
        // 			$html.addClass('side--slide-up');
        // 		} else {
        // 			$html.removeClass('side--slide-up');
        // 		}*/
        // 	}
        // 	clearTimeout(resize_timer);
        // 	resize_timer = setTimeout(function () {
        // 		var hh = $header.height();
        // 		var sy = $pusher.offset().top - top + (header ? 0 : 10);

        // 		if (sy < hh) {
        // 			$html.addClass('site-header--up');
        // 		} else {
        // 			$html.removeClass('site-header--up');
        // 		}
        // 	}, 30);
        // }else{
        // 	$html.removeClass('site-header--up');
        // }
      }
      scrollTop_tmp = top;
    }
  };

  var wheelScroll = function (e) {
    if (e.deltaY < 0) {
      $html.addClass("scroll--wheel-down");
    } else if (e.deltaY > 0) {
      $html.removeClass("scroll--wheel-down");
    }
  };

  var lockScrollTimer;
  var lockScroll = function (lock) {
    //var $wrapper = $('.site__wrapper');
    //var $target = $win;
    //var top = $target.scrollTop();
    var quick_open = $(".is-hidden.open").length;
    var y;

    if (lock && (!local || quick_open)) {
      y = app.obj.freeze.enable();
    } else if (!local) {
      y = app.obj.freeze.disable();
    }

    /*if($wrapper.data('frozen')) {
			y = -top;
		}else{
			y = y-top;
		}

		//console.log('FREEZE:'+lock+', top:'+top+', y:'+y);

		$('.nav-main__append .nav-main__sub__inner[style]').removeAttr('style');
		$('.nav-main__append.open .nav-main__sub__inner').css('transform', 'translateY('+y+'px)');*/
    //$('.search--global').css('top', (y) + 'px');
  };

  init();
  return api;
};

app.globalExt['overlay'] = function() {
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var overlayOpen = false;
	var overlayOpening = false;
	var basePageUrl;
	var basePageTitle = document.title;

	var $overlayBgPageContainer = $('#overlay-bg-page');

	var init = function() {
		addListeners();
		// basePageUrl = getBasePageUrl();
		basePageUrl = window.location.href;
		loadBgPage();
	};

	var addListeners = function() {
		$body.on('click.overlay, click.standard', 'a[target="_top"], .js-overlay-legacy', linkClickHandler);
		$body.on('click.overlayClose', '.overlay .button-close', closeClickHandler);
		$doc.on('mousedown.overlay touchstart.overlay', documentClickHandler);
		$win.on('popstate.overlay', popstateHandler);
	};

	var linkClickHandler = function(e) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();

		var $link = $(this);
		var url = $link.attr('href');
		openOverlay(url, true);
	};

	var closeClickHandler = function(e) {
		e.preventDefault();
		close($(this), true);
	};

	var documentClickHandler = function(e) {
		if ($(e.target).hasClass('overlay')) {
			e.preventDefault();
			close(undefined, true);
		}
	};

	var popstateHandler = function(e) {

		if (history.state == null) {
			// Fallback if history is empty
			//window.location.href = window.location.href;
		}else if(history.state){
			var stateType = history.state.type;

			if (stateType === 'overlay') {
				var url = window.location.href;
				openOverlay(url);
			} else if (stateType === 'background' || stateType === null) {
				if (overlayOpen) {
					close();
				}
			}
		}

	};

	var openOverlay = function(url, triggered) {
		triggered = triggered || false;
		if (triggered) {
			basePageUrl = window.location.href;
			if (!$html.hasClass('search--open')) {
				goToOverlayUrl(url);
			}
		}
		if (overlayOpening !== true && !overlayOpen) {
			overlayOpening = true;
			overlayOpen = true;
			jQuery.ajax({
				context: this,
				url: url,
				type: 'GET',
				data: {
					'ajaxCall': true,
				},
				cache: false,
				success: function(data) {
					var $overlay = $(data);
					var y = $win.scrollTop();

					$body.append($overlay);
					app.parse($overlay);
					$('[data-bg],[data-src]', $overlay).lazyLoadXT();

					// TRACKING
					/*app.obj.tracking.track({
						'event':'page-overlay',
						'attributes': {
							'url': url,
							'title' : $('h1', $overlay).text()
						}
					});*/
					if (app.obj.tracking) {
						app.obj.tracking.track({
							'event': 'overlay',
							'category': 'Overlays',
							'action': 'Open',
							'label': url,
							'attributes': {
								'url': url,
								'title' : $('h1', $overlay).length ? $('h1', $overlay).text() : ''
							}
						});
					}

					setTimeout(function() {
						if (app.obj['sticky-top']) {
							$.each(app.obj['sticky-top'], function(index, object) {
								object.freezeStickyKit();
							});
						}
						var $freeze = !$('html.search--open').length ? $('.site__wrapper') : $('.search');
						$freeze.data('y', y);
						$freeze.css('top', -y + $freeze.position().top);
						$html.addClass('overlay--open');
						app.obj.site.overlayOpen = true;
						$win.scrollTop(0);
					}, 100);
				},
				error: function (data) {
					overlayOpening = false;
					overlayOpen = false;
				},
			}).done(function() {
				overlayOpening = false;
			});
		}

	};

	var loadBgPage = function() {

		if (!$overlayBgPageContainer.length) {
			return false;
		}

		var url = $overlayBgPageContainer.data('url');
		var href = basePageUrl.split('?')[0];

		//basePageUrl = href.indexOf(url)<0 ? url : location.protocol + '//' + location.hostname;
		basePageUrl = href.indexOf(url)<0 ? url : location.protocol + '//' + location.hostname + (href.indexOf('/product/')>=0 ? '/search' : (href.indexOf('.devlocal')>=0  ? '/search.php' : ''));

		overlayOpen = true;

		var overlayPageBgCall = $.ajax({
			url: basePageUrl,
			method: 'GET',
			data: {'ajaxBgCall': true},
		})
		.done(function(msg) {
			var $msg = $(msg);
			$overlayBgPageContainer.html($msg);
			//$('body > .nav-contact').appendTo($('> ul', $('.nav-main')));
			app.parse($overlayBgPageContainer);
			//$overlayBgPageContainer.children().prependTo($body);
			app.obj['nav-main'].init();
			setTimeout(function() {
				$('[data-bg],[data-src]', $msg).lazyLoadXT();
				app.obj['site'].setHeaderHeight();
			}, 100);
		});
	};

	var close = function($close, triggered) {
		triggered = triggered || false;
		console.log('triggered:' + triggered);
		if (triggered) {
			goToBgPage();
		}
		var s = $win.scrollTop();
		var $overlay = $('.overlay');
		var $outer = $('.overlay__outer');
		var remove	= !$overlay.data('overlay-no-remove');

		var $freeze = !$('html.search--open').length ? $('.site__wrapper') : $('.search');
		//var y = Math.abs(parseInt($('.site__wrapper').css('top')));
		var y = $freeze.data('y');

		overlayOpen = false;

		$html.removeClass('overlay--open');
		app.obj.site.overlayOpen = false;
		$win.scrollTop(y);
		$freeze.removeAttr('style');
		$outer.css('top', (y - s + parseInt($outer.css('top'))) + 'px');


		if (remove && $close !== undefined) $close.off('click.close');
		setTimeout(function() {
			$overlay.addClass('overlay--closed');
			if (remove) $overlay.remove();

			if (app.obj['sticky-top']) {
				$.each(app.obj['sticky-top'], function(index, object) {
					object.unfreezeStickyKit();
				});
			}
		}, 500);
	};


	//////////
	// Helpers

	var getBasePageUrl = function() {
		var currentUrl = window.location.href;
		var basecurrentUrl = currentUrl.split('?');
		return basecurrentUrl[0];
	};

	var goToBgPage = function() {
		//if($overlayBgPageContainer.length)
			history.pushState({ type: 'background' }, basePageTitle, basePageUrl);
	};

	var goToOverlayUrl = function(url) {
		history.pushState({ type: 'overlay' }, basePageTitle, url);
	};


	init();	return api;
};

app.globalExt['preloader'] = function() {
    var api = {};

    var $win    = app.vars.$win;
    var $doc    = app.vars.$doc;
    var $html   = app.vars.$html;
    var $body   = app.vars.$body;

    var classes = {
        preloader: '.preloader',
    };

    var templates = {
        preloader: '<div class="preloader"></div>',
    };

    api.showPreloader = function(xhr, $container) {
        $container = $container || $body;

        // if ($container.children(classes.preloader).length) return false;
        $container.find(classes.preloader).remove();

        var $preloader = $(templates.preloader);
        $container.append($preloader);

        xhr.addEventListener('progress', function(evt) {
            if (evt.lengthComputable) {
                var percentComplete = (evt.loaded / evt.total) * 100;
                $preloader.css('width', percentComplete + '%');
                TweenLite.to($preloader, 0.3, {
                    width: percentComplete + '%',
                    onComplete: function() {},
                });
            }
        }, false);
    };

    api.hidePreloader = function($container, type) {
        $container = $container || $body;
        type = type || 'move';
        var $preloader = $container.find(classes.preloader).first();
        if ($preloader.length) {

            if (type === 'move') {
                TweenLite.to($preloader, 0.3, {
                    y: '-100%',
                    onComplete: function() {
                        $preloader.remove();
                    },
                });
            } else if (type === 'fade') {
                TweenLite.to($preloader, 0.3, {
                    opacity: 0,
                    onComplete: function() {
                        $preloader.remove();
                    },
                });
            }

        }
    };

    return api;
};

app.globalExt['scroll-to-anchor'] = function () {
	var api = {};

	var $doc = app.vars.$doc;

	var classes = {
		anchor_link: 'a[href^="#"]',
	};

	var init = function () {
		var initialized;
		Gridle.on('update', function () {
			if (!initialized) {
				initialized = true;
				scrollToAnchor();
			}
		});
		addListeners();
		setTimeout(function () {
			if (!initialized) {
				initialized = true;
				scrollToAnchor();
			}
		}, 30);
	};

	var addListeners = function () {
		$doc.on('click.scroll-to-anchor', classes.anchor_link, function (e) {
			var hash = $(e.currentTarget).attr('href');
			var $target = $(hash);

			if ($target.length) {
				var y = $target.offset().top;
				var offset = app.obj['site'].headerHeight + 30;
				e.preventDefault();
				var tracked = tracking(hash, 'click');
				if (tracked) {
					app.obj.site.scrollController.scrollTo(y - offset, {
						callback: function () {
							if (typeof app.obj.site.scrollController.update !== 'undefined') app.obj.site.scrollController.update(true);
						}
					});
				}
			}
		});
	};

	var scrollToAnchor = function () {
		var href = location.href;
		if (href.indexOf('#') > -1) {
			var hash = href.split('#')[1];
			scrollToElement('#' + hash);
		}
	};

	var scrollToElement = function (hash) {
		var offset = app.obj['site'].headerHeight + 30;
		var $el = $(hash);
		if ($el.length) {
			var tracked = tracking(hash, 'load');
			if (tracked) {
				TweenLite.to(window, 0, { scrollTo: { y: hash, offsetY: offset }, ease: Power3.easeInOut });
			}
		}
	};

	var locationHref = function() {
		var href = location.href;
		return href.split('#').shift();
	};

	var tracking = function (hash, event) {
		var $el = $(hash);
		var url = locationHref() + hash;

		if (hash != '#quick-global') {

			history.pushState({ type: 'anchor-link' }, document.title, url);

			if ($el.length) {
				var $headline = $el.parent().find('h1, h2, h3, h4');
				app.obj.tracking.track({
					'event': 'anchor-links',
					'category': 'Anchor Links',
					'action': event,
					'label': url,
					'attributes': {
						'url': url,
						'title': $headline.length ? $headline.eq(0).text() : ''
					}
				});
			}
			return true;
		} else {
			return false;
		}
	};

	init(); return api;
};

app.globalExt['sections'] = function() {
  var $html = app.vars.$html;
  
  var init = function() {
    var $last_bg = $('.site-main > :last-child.section--bg-grey-light, .site-main > .site-content >:last-child.section--bg-grey-light, .site-main > .section:not(.section--bg-grey-light) + :last-child.subnav--light, .site-main > .site-content > .section:not(.section--bg-grey-light) + :last-child.subnav--light');

    if($last_bg.length){
      $html.addClass('site-sections--last-bg');
    }
  };

  init();
};

app.globalExt['smoothscroll'] = function() {
	var api = {
		enabled: true,
	};

	var init = function() {
		// smoothScroll(); 
	};

	var smoothScroll = function() {
		//https://github.com/galambalazs/smoothscroll-for-websites/blob/master/SmoothScroll.js

		// Scroll Variables (tweakable)
		var defaultOptions = {

			// Scrolling Core
			frameRate: 150,	// 150 [Hz]
			animationTime: 400,	// 400 [ms]
			stepSize: 100,	// 100 [px]

			// Pulse (less tweakable)
			// ratio of "tail" to "acceleration"
			pulseAlgorithm: true,	// true
			pulseScale: 4,	// 4
			pulseNormalize: 1,	// 1

			// Acceleration
			accelerationDelta: 50,	// 50
			accelerationMax: 3,	// 3

			// Keyboard Settings
			keyboardSupport: true,	// option
			arrowScroll: 50,	// [px]

			// Other
			touchpadSupport: false,	// ignore touchpad by default
			fixedBackground: true,
			excluded: '',
		};

		var options = defaultOptions;


		// Other Variables
		var isExcluded = false;
		var isFrame = false;
		var direction = { x: 0, y: 0 };
		var initDone = false;
		var root = document.documentElement;
		var activeElement;
		var observer;
		var refreshSize;
		var deltaBuffer = [];
		var isMac = /^Mac/.test(navigator.platform);

		var key = { left: 37, up: 38, right: 39, down: 40, spacebar: 32, 
					pageup: 33, pagedown: 34, end: 35, home: 36 };
		var arrowKeys = { 37: 1, 38: 1, 39: 1, 40: 1 };

		/***********************************************
		 * INITIALIZE
		 ***********************************************/

		/**
		 * Tests if smooth scrolling is allowed. Shuts down everything if not.
		 */
		function initTest() {
			if (options.keyboardSupport) {
				addEvent('keydown', keydown);
			}
		}

		/**
		 * Sets up scrolls array, determines if frames are involved.
		 */
		function init() {
			
			if (initDone || !document.body) return;

			initDone = true;

			var body = document.body;
			var html = document.documentElement;
			var windowHeight = window.innerHeight; 
			var scrollHeight = body.scrollHeight;
			
			// check compat mode for root element
			root = (document.compatMode.indexOf('CSS') >= 0) ? html : body;
			activeElement = body;
			
			initTest();

			// Checks if this script is running in a frame
			if (top != self) {
				isFrame = true;
			}

			/**
			 * Please duplicate this radar for a Safari fix! 
			 * rdar://22376037
			 * https://openradar.appspot.com/radar?id=4965070979203072
			 * 
			 * Only applies to Safari now, Chrome fixed it in v45:
			 * This fixes a bug where the areas left and right to 
			 * the content does not trigger the onmousewheel event
			 * on some pages. e.g.: html, body { height: 100% }
			 */
			else if (scrollHeight > windowHeight &&
					(body.offsetHeight <= windowHeight || 
					 html.offsetHeight <= windowHeight)) {

				var fullPageElem = document.createElement('div');
				fullPageElem.style.cssText = 'position:absolute; z-index:-10000; ' +
											 'top:0; left:0; right:0; height:' + 
												root.scrollHeight + 'px';
				document.body.appendChild(fullPageElem);
				
				// DOM changed (throttled) to fix height
				var pendingRefresh;
				refreshSize = function() {
					if (pendingRefresh) return; // could also be: clearTimeout(pendingRefresh);
					pendingRefresh = setTimeout(function() {
						if (isExcluded) return; // could be running after cleanup
						fullPageElem.style.height = '0';
						fullPageElem.style.height = root.scrollHeight + 'px';
						pendingRefresh = null;
					}, 500); // act rarely to stay fast
				};
			
				setTimeout(refreshSize, 10);

				addEvent('resize', refreshSize);

				// TODO: attributeFilter?
				var config = {
					attributes: true, 
					childList: true, 
					characterData: false, 
					// subtree: true
				};

				observer = new MutationObserver(refreshSize);
				observer.observe(body, config);

				if (root.offsetHeight <= windowHeight) {
					var clearfix = document.createElement('div');	 
					clearfix.style.clear = 'both';
					body.appendChild(clearfix);
				}
			}

			// disable fixed background
			if (!options.fixedBackground && !isExcluded) {
				body.style.backgroundAttachment = 'scroll';
				html.style.backgroundAttachment = 'scroll';
			}
		}

		/**
		 * Removes event listeners and other traces left on the page.
		 */
		function cleanup() {
			observer && observer.disconnect();
			removeEvent(wheelEvent, wheel);
			removeEvent('mousedown', mousedown);
			removeEvent('keydown', keydown);
			removeEvent('resize', refreshSize);
			removeEvent('load', init);
		}


		/************************************************
		 * SCROLLING 
		 ************************************************/
		 
		var que = [];
		var pending = false;
		var lastScroll = Date.now();

		/**
		 * Pushes scroll actions to the scrolling queue.
		 */
		function scrollArray(elem, left, top) {
			
			directionCheck(left, top);

			if (options.accelerationMax != 1) {
				var now = Date.now();
				var elapsed = now - lastScroll;
				if (elapsed < options.accelerationDelta) {
					var factor = (1 + (50 / elapsed)) / 2;
					if (factor > 1) {
						factor = Math.min(factor, options.accelerationMax);
						left *= factor;
						top	*= factor;
					}
				}
				lastScroll = Date.now();
			}		
			
			// push a scroll command
			que.push({
				x: left, 
				y: top, 
				lastX: (left < 0) ? 0.99 : -0.99,
				lastY: (top	< 0) ? 0.99 : -0.99, 
				start: Date.now(),
			});
				
			// don't act if there's a pending queue
			if (pending) {
				return;
			}	

			var scrollWindow = (elem === document.body);
			
			var step = function(time) {
				
				var now = Date.now();
				var scrollX = 0;
				var scrollY = 0; 
			
				for (var i = 0; i < que.length; i++) {
					
					var item = que[i];
					var elapsed	= now - item.start;
					var finished = (elapsed >= options.animationTime);
					
					// scroll position: [0, 1]
					var position = (finished) ? 1 : elapsed / options.animationTime;
					
					// easing [optional]
					if (options.pulseAlgorithm) {
						position = pulse(position);
					}
					
					// only need the difference
					var x = (item.x * position - item.lastX) >> 0;
					var y = (item.y * position - item.lastY) >> 0;
					
					// add this to the total scrolling
					scrollX += x;
					scrollY += y;			
					
					// update last values
					item.lastX += x;
					item.lastY += y;
				
					// delete and step back if it's over
					if (finished) {
						que.splice(i, 1); i--;
					}		 
				}

				// scroll left and top
				if (scrollWindow) {
					if (api.enabled) window.scrollBy(scrollX, scrollY);
				} 				else {
					if (scrollX) elem.scrollLeft += scrollX;
					if (scrollY) elem.scrollTop	+= scrollY;				
				}

				api.update();
				
				// clean up if there's nothing left to do
				if (!left && !top) {
					que = [];
				}
				
				if (que.length) { 
					requestFrame(step, elem, (1000 / options.frameRate + 1)); 
				} else { 
					pending = false;
				}
			};
			
			// start a new queue of actions
			requestFrame(step, elem, 0);
			pending = true;
		}


		/***********************************************
		 * EVENTS
		 ***********************************************/

		/**
		 * Mouse wheel handler.
		 * @param {Object} event
		 */
		function wheel(event) {

			if (!initDone) {
				init();
			}
			
			var target = event.target;
			var overflowing = overflowingAncestor(target);

			// use default if there's no overflowing
			// element or default action is prevented	 
			// or it's a zooming event with CTRL 
			if (!overflowing || event.defaultPrevented || event.ctrlKey) {
				return true;
			}
			
			// leave embedded content alone (flash & pdf)
			if (isNodeName(activeElement, 'embed') || 
				 (isNodeName(target, 'embed') && /\.pdf/i.test(target.src)) ||
				isNodeName(activeElement, 'object') ||
				target.shadowRoot) {
				return true;
			}

			var deltaX = -event.wheelDeltaX || event.deltaX || 0;
			var deltaY = -event.wheelDeltaY || event.deltaY || 0;
			
			if (isMac) {
				if (event.wheelDeltaX && isDivisible(event.wheelDeltaX, 120)) {
					deltaX = -120 * (event.wheelDeltaX / Math.abs(event.wheelDeltaX));
				}
				if (event.wheelDeltaY && isDivisible(event.wheelDeltaY, 120)) {
					deltaY = -120 * (event.wheelDeltaY / Math.abs(event.wheelDeltaY));
				}
			}
			
			// use wheelDelta if deltaX/Y is not available
			if (!deltaX && !deltaY) {
				deltaY = -event.wheelDelta || 0;
			}

			// line based scrolling (Firefox mostly)
			if (event.deltaMode === 1) {
				deltaX *= 40;
				deltaY *= 40;
			}
			
			// check if it's a touchpad scroll that should be ignored
			if (!options.touchpadSupport && isTouchpad(deltaY)) {
				return true;
			}

			// scale by step size
			// delta is 120 most of the time
			// synaptics seems to send 1 sometimes
			if (Math.abs(deltaX) > 1.2) {
				deltaX *= options.stepSize / 120;
			}
			if (Math.abs(deltaY) > 1.2) {
				deltaY *= options.stepSize / 120;
			}
			
			scrollArray(overflowing, deltaX, deltaY);
			event.preventDefault();
			scheduleClearCache();
		}

		/**
		 * Keydown event handler.
		 * @param {Object} event
		 */
		function keydown(event) {

			var target	 = event.target;
			var modifier = event.ctrlKey || event.altKey || event.metaKey || 
							(event.shiftKey && event.keyCode !== key.spacebar);
			
			// our own tracked active element could've been removed from the DOM
			if (!document.body.contains(activeElement)) {
				activeElement = document.activeElement;
			}

			// do nothing if user is editing text
			// or using a modifier key (except shift)
			// or in a dropdown
			// or inside interactive elements
			var inputNodeNames = /^(textarea|select|embed|object)$/i;
			var buttonTypes = /^(button|submit|radio|checkbox|file|color|image)$/i;
			if (event.defaultPrevented ||
				 inputNodeNames.test(target.nodeName) ||
				 isNodeName(target, 'input') && !buttonTypes.test(target.type) ||
				 isNodeName(activeElement, 'video') ||
				 isInsideYoutubeVideo(event) ||
				 target.isContentEditable || 
				 modifier) {
				return true;
			}

			// [spacebar] should trigger button press, leave it alone
			if ((isNodeName(target, 'button') ||
				 isNodeName(target, 'input') && buttonTypes.test(target.type)) &&
				event.keyCode === key.spacebar) {
				return true;
			}

			// [arrwow keys] on radio buttons should be left alone
			if (isNodeName(target, 'input') && target.type == 'radio' &&
				arrowKeys[event.keyCode])	{
				return true;
			}
			
			var shift, x = 0, y = 0;
			var elem = overflowingAncestor(activeElement);
			var clientHeight = elem.clientHeight;

			if (elem == document.body) {
				clientHeight = window.innerHeight;
			}

			switch (event.keyCode) {
				case key.up:
					y = -options.arrowScroll;
					break;
				case key.down:
					y = options.arrowScroll;
					break;			
				case key.spacebar: // (+ shift)
					shift = event.shiftKey ? 1 : -1;
					y = -shift * clientHeight * 0.9;
					break;
				case key.pageup:
					y = -clientHeight * 0.9;
					break;
				case key.pagedown:
					y = clientHeight * 0.9;
					break;
				case key.home:
					y = -elem.scrollTop;
					break;
				case key.end:
					var damt = elem.scrollHeight - elem.scrollTop - clientHeight;
					y = (damt > 0) ? damt + 10 : 0;
					break;
				case key.left:
					x = -options.arrowScroll;
					break;
				case key.right:
					x = options.arrowScroll;
					break;			
				default:
					return true; // a key we don't care about
			}

			scrollArray(elem, x, y);
			event.preventDefault();
			scheduleClearCache();
		}

		/**
		 * Mousedown event only for updating activeElement
		 */
		function mousedown(event) {
			activeElement = event.target;
		}


		/***********************************************
		 * OVERFLOW
		 ***********************************************/

		var uniqueID = (function() {
			var i = 0;
			return function(el) {
				return el.uniqueID || (el.uniqueID = i++);
			};
		})();

		var cache = {}; // cleared out after a scrolling session
		var clearCacheTimer;

		//setInterval(function () { cache = {}; }, 10 * 1000);

		function scheduleClearCache() {
			clearTimeout(clearCacheTimer);
			clearCacheTimer = setInterval(function() { cache = {}; }, 1 * 1000);
		}

		function setCache(elems, overflowing) {
			for (var i = elems.length; i--;)
				cache[uniqueID(elems[i])] = overflowing;
			return overflowing;
		}

		//	(body)			 (root)
		//			| hidden | visible | scroll |	auto	|
		// hidden	|	 no	 |		no	 |	 YES	|	 YES	|
		// visible |	 no	 |	 YES	 |	 YES	|	 YES	|
		// scroll	|	 no	 |	 YES	 |	 YES	|	 YES	|
		// auto		|	 no	 |	 YES	 |	 YES	|	 YES	|

		function overflowingAncestor(el) {
			var elems = [];
			var body = document.body;
			var rootScrollHeight = root.scrollHeight;
			do {
				var cached = cache[uniqueID(el)];
				if (cached) {
					return setCache(elems, cached);
				}
				elems.push(el);
				if (rootScrollHeight === el.scrollHeight) {
					var topOverflowsNotHidden = overflowNotHidden(root) && overflowNotHidden(body);
					var isOverflowCSS = topOverflowsNotHidden || overflowAutoOrScroll(root);
					if (isFrame && isContentOverflowing(root) || 
						 !isFrame && isOverflowCSS) {
						return setCache(elems, getScrollRoot()); 
					}
				} else if (isContentOverflowing(el) && overflowAutoOrScroll(el)) {
					return setCache(elems, el);
				}
			} while (el = el.parentElement);
		}

		function isContentOverflowing(el) {
			return (el.clientHeight + 10 < el.scrollHeight);
		}

		// typically for <body> and <html>
		function overflowNotHidden(el) {
			var overflow = getComputedStyle(el, '').getPropertyValue('overflow-y');
			return (overflow !== 'hidden');
		}

		// for all other elements
		function overflowAutoOrScroll(el) {
			var overflow = getComputedStyle(el, '').getPropertyValue('overflow-y');
			return (overflow === 'scroll' || overflow === 'auto');
		}


		/***********************************************
		 * HELPERS
		 ***********************************************/

		function addEvent(type, fn) {
			window.addEventListener(type, fn, false);
		}

		function removeEvent(type, fn) {
			window.removeEventListener(type, fn, false);	
		}

		function isNodeName(el, tag) {
			return (el.nodeName || '').toLowerCase() === tag.toLowerCase();
		}

		function directionCheck(x, y) {
			x = (x > 0) ? 1 : -1;
			y = (y > 0) ? 1 : -1;
			if (direction.x !== x || direction.y !== y) {
				direction.x = x;
				direction.y = y;
				que = [];
				lastScroll = 0;
			}
		}

		var deltaBufferTimer;

		if (window.localStorage && localStorage.SS_deltaBuffer) {
			deltaBuffer = localStorage.SS_deltaBuffer.split(',');
		}

		function isTouchpad(deltaY) {
			if (!deltaY) return;
			if (!deltaBuffer.length) {
				deltaBuffer = [deltaY, deltaY, deltaY];
			}
			deltaY = Math.abs(deltaY);
			deltaBuffer.push(deltaY);
			deltaBuffer.shift();
			clearTimeout(deltaBufferTimer);
			deltaBufferTimer = setTimeout(function() {
				if (window.localStorage) {
					localStorage.SS_deltaBuffer = deltaBuffer.join(',');
				}
			}, 1000);
			return !allDeltasDivisableBy(120) && !allDeltasDivisableBy(100);
		} 

		function isDivisible(n, divisor) {
			return (Math.floor(n / divisor) == n / divisor);
		}

		function allDeltasDivisableBy(divisor) {
			return (isDivisible(deltaBuffer[0], divisor) &&
					isDivisible(deltaBuffer[1], divisor) &&
					isDivisible(deltaBuffer[2], divisor));
		}

		function isInsideYoutubeVideo(event) {
			var elem = event.target;
			var isControl = false;
			if (document.URL.indexOf('www.youtube.com/watch') != -1) {
				do {
					isControl = (elem.classList && 
								 elem.classList.contains('html5-video-controls'));
					if (isControl) break;
				} while (elem = elem.parentNode);
			}
			return isControl;
		}

		var requestFrame = (function() {
				return (window.requestAnimationFrame		|| 
						window.webkitRequestAnimationFrame || 
						window.mozRequestAnimationFrame		||
						function(callback, element, delay) {
						 window.setTimeout(callback, delay || (1000 / 60));
					 });
		})();

		var MutationObserver = (window.MutationObserver || 
								window.WebKitMutationObserver ||
								window.MozMutationObserver);	

		var getScrollRoot = (function() {
			var SCROLL_ROOT;
			return function() {
			if (!SCROLL_ROOT) {
				var dummy = document.createElement('div');
				dummy.style.cssText = 'height:10000px;width:1px;';
				document.body.appendChild(dummy);
				var bodyScrollTop	= document.body.scrollTop;
				var docElScrollTop = document.documentElement.scrollTop;
				window.scrollBy(0, 3);
				if (document.body.scrollTop != bodyScrollTop)
				(SCROLL_ROOT = document.body);
				else 
				(SCROLL_ROOT = document.documentElement);
				window.scrollBy(0, -3);
				document.body.removeChild(dummy);
			}
			return SCROLL_ROOT;
			};
		})();


		/***********************************************
		 * PULSE (by Michael Herf)
		 ***********************************************/
		 
		/**
		 * Viscous fluid with a pulse for part and decay for the rest.
		 * - Applies a fixed force over an interval (a damped acceleration), and
		 * - Lets the exponential bleed away the velocity over a longer interval
		 * - Michael Herf, http://stereopsis.com/stopping/
		 */
		function pulse_(x) {
			var val, start, expx;
			// test
			x = x * options.pulseScale;
			if (x < 1) { // acceleartion
				val = x - (1 - Math.exp(-x));
			} else {	// tail
				// the previous animation ended here:
				start = Math.exp(-1);
				// simple viscous drag
				x -= 1;
				expx = 1 - Math.exp(-x);
				val = start + (expx * (1 - start));
			}
			return val * options.pulseNormalize;
		}

		function pulse(x) {
			if (x >= 1) return 1;
			if (x <= 0) return 0;

			if (options.pulseNormalize == 1) {
				options.pulseNormalize /= pulse_(1);
			}
			return pulse_(x);
		}


		/***********************************************
		 * FIRST RUN
		 ***********************************************/

		var userAgent = window.navigator.userAgent;
		var isEdge		= /Edge/.test(userAgent); // thank you MS
		var isChrome	= /chrome/i.test(userAgent) && !isEdge; 
		var isSafari	= /safari/i.test(userAgent) && !isEdge; 
		var isMobile	= /mobile/i.test(userAgent);
		var isIEWin7	= /Windows NT 6.1/i.test(userAgent) && /rv:11/i.test(userAgent);
		var isMac		= $('html.mac').length;
		var isTouch		= $('html.screen--is-touch').length;

		//var isEnabledForBrowser = (isChrome || isSafari || isIEWin7) && !isMobile;
		var isEnabledForBrowser = (!isMac && !isTouch);

		var wheelEvent;
		if ('onwheel' in document.createElement('div'))
			wheelEvent = 'wheel';
		else if ('onmousewheel' in document.createElement('div'))
			wheelEvent = 'mousewheel';

		if (wheelEvent && isEnabledForBrowser) {
			addEvent(wheelEvent, wheel);
			addEvent('mousedown', mousedown);
			addEvent('load', init);
		}


		/***********************************************
		 * PUBLIC INTERFACE
		 ***********************************************/

		function SmoothScroll(optionsToSet) {
			for (var key in optionsToSet)
				if (defaultOptions.hasOwnProperty(key)) 
					options[key] = optionsToSet[key];
		}
		SmoothScroll.destroy = cleanup;

		if (window.SmoothScrollOptions) // async API
			SmoothScroll(window.SmoothScrollOptions);

		if (typeof define === 'function' && define.amd)
			define(function() {
				return SmoothScroll;
			});
		else if (typeof exports === 'object')
			module.exports = SmoothScroll;
		else
			window.SmoothScroll = SmoothScroll;
	};

	api.update = function() {
		$('.js-sticky-top').trigger('sticky_kit:tick');
		/*for(var i=0; i<app.obj['sticky-top'].length; i++){
			app.obj['sticky-top'][i].update();
		}*/
	};

	init();	return api;
};

/*
	Smooth Zoom Pan - jQuery Image Viewer
 	Copyright (c) 2011-12 Ramesh Kumar
	http://codecanyon.net/user/VF
	
	Version:	1.6.9
	RELEASE:	09 SEP 2011
	UPDATE:		27 FEB 2013
	
	Built using:
	jQuery 		version:1.9.1	http://jquery.com/
	Modernizr 	version:2.5.3	http://www.modernizr.com/
	MouseWheel	version:3.0.6	http://brandonaaron.net/code/mousewheel/docs
	
*/

app.globalExt['smoothZoom'] = function() {
	var api = {};

	var init = function() {
		
//(function ($, window, document) {
	
	/*****************************************************************************
		Default settings:
		For detailed description of individual parameters, see the help document
	******************************************************************************/
	var defaults = {
		
		width: '',									//Width of the view area [480, '480px', '100%']
		height: '',									//Height of the view area [480, '480px', '100%']

		initial_ZOOM: '',							//Initial zoom level to start with (in percentage) [100]
		initial_POSITION: '',						//Initial location to be focused in pixel value [150,150 or 150 150]

		animation_SMOOTHNESS: 5.5,					//Ease or smoothness of all movements [Any number from 0]				
		animation_SPEED_ZOOM: 5.5,					//Speed of zoom movements [Any number from 0] 
		animation_SPEED_PAN: 5.5,					//Speed of pan movements [Any number from 0] 

		zoom_MAX: 800,								//Maximum limit for zooming (in percentage)
		zoom_MIN: '',								//Minimum limit for zooming (in percentage)
		zoom_SINGLE_STEP: false,					//To reach maximum and minimum zoom levels in single click 
		zoom_OUT_TO_FIT: true,						//To allow image to be zoomed out with whitespace on sides
		zoom_BUTTONS_SHOW: true,					//To enable/disable the + and - buttons

		pan_BUTTONS_SHOW: true,						//To enable/disable the arrow and reset buttons
		pan_LIMIT_BOUNDARY: true,					//To allow/restrict moving the image beyond boundaries
		pan_REVERSE: false,
		
		reset_ALIGN_TO: 'center center', 			//Image can be aligned to desired position on reset. Example: 'Top Left'
		reset_TO_ZOOM_MIN: true,					//How it should behave if zoom_MIN value set and while clicking reset button, 

		button_HOLDER: false,						//Buttons parent element
		button_SIZE: 18,							//Button width and height (in pixels)
		button_SIZE_TOUCH_DEVICE: 30,				//Button width and height (in pixels) on touch devices
		button_COLOR: '#FFFFFF',					//Button color in hexadecimal
		button_BG_COLOR: '#000000',					//Button set's background color in hexadecimal
		button_BG_TRANSPARENCY: 55,					//Background transparency (in percentage)
		button_AUTO_HIDE: false,					//To hide the button set when mouse moved outside the view area
		button_AUTO_HIDE_DELAY: 1,					//Auto hide delay time in seconds
		button_ALIGN: 'bottom right',				//Button set can be aligned to any side or center
		button_MARGIN: 10,							//Space between button set and view port's edge
		button_ROUND_CORNERS: true,					//To enable disable roundness of button corner
		
		touch_DRAG: true,							//Enable/disable the dragability of image (touch)
		mouse_DRAG: true,							//Enable/disable the dragability of image (mouse)
		mouse_WHEEL: true,							//Enable/disable mousewheel zoom
		mouse_WHEEL_CURSOR_POS: true,				//Enable/disable position sensitive mousewheel zoom
		mouse_DOUBLE_CLICK: true,					//Enable/disable zoom action with double click

		background_COLOR: '#FFFFFF',				//Background colour of image container
		border_SIZE: 1,								//Border size of view area
		border_COLOR: '#000000',					//Border color of view area
		border_TRANSPARENCY: 10,					//Border transparency of view area
		
		image_url: '',								//Set url or image to be zoomed
		image_original_width: '',					//Original width of main image
		image_original_height: '',					//Original height of main image
		container: '',								//Set container element of image (id of container)
		
		on_IMAGE_LOAD: '',							//To Call external function immediatly after image loaded
		on_ZOOM_PAN_UPDATE: '',						//To Call external function for each zoom, pan animation frame
		on_ZOOM_PAN_COMPLETE: '',					//To Call external function whenever zoom, pan animation completes
		on_LANDMARK_STATE_CHANGE: '',				//To Call external function whenever the zoom leval crosses global "data-show-at-zoom" value
		
		use_3D_Transform: true,						//To enable / disable Hardware acceleration on webkit browsers
		
		responsive: false,							//To enable / disable Responsive / fluid layout
		responsive_maintain_ratio: true,			//To maintain view area width/height ratio or not
		max_WIDTH: '',								//Maximum allowed width of view area (helpful when 'width' parameter set with % and need limit)
		max_HEIGHT: '',								//Maximum allowed height of view area (helpful when 'height' parameter set with % and need limit)
	};

	function Zoomer($elem, params) {
		
		var self = this;
		this.$elem = $elem;
		this.$map = $elem.parent();
		var op = $.extend({}, defaults, params);

		/**********************************************************
		Option values verified and formated if needed
		**********************************************************/
		this.sW = op.width;
		this.sH = op.height;

		this.init_zoom = op.initial_ZOOM / 100;
		this.init_pos = op.initial_POSITION.replace(/,/g, ' ').replace(/\s{2,}/g, ' ').split(' ');

		this.zoom_max_initial = op.zoom_MAX / 100;
		this.zoom_max = op.zoom_MAX / 100;
		this.zoom_min = op.zoom_MIN / 100;
		
		this.zoom_single = checkBoolean(op.zoom_SINGLE_STEP);
		this.zoom_fit = checkBoolean(op.zoom_OUT_TO_FIT);		
		this.zoom_speed = 1 + (((op.animation_SPEED === 0 || op.animation_SPEED ? op.animation_SPEED : op.animation_SPEED_ZOOM) + 1) / 20);
		this.zoom_show = checkBoolean(op.zoom_BUTTONS_SHOW);

		this.pan_speed_o = (op.animation_SPEED === 0 || op.animation_SPEED ? op.animation_SPEED : op.animation_SPEED_PAN);
		this.pan_show = checkBoolean(op.pan_BUTTONS_SHOW);
		this.pan_limit = checkBoolean(op.pan_LIMIT_BOUNDARY);	
		this.pan_rev = checkBoolean(op.pan_REVERSE);		
		
		this.reset_align = op.reset_ALIGN_TO.toLowerCase().split(' ');	
		this.reset_to_zmin = checkBoolean(op.reset_TO_ZOOM_MIN);
		
		if (supportsTouch) {
			this.bu_size = parseInt(op.button_SIZE_TOUCH_DEVICE / 2) * 2;
		} else {
			this.bu_size = parseInt(op.button_SIZE / 2) * 2;
		}	
		this.bu_color = op.button_COLOR;
		this.bu_bg = op.button_BG_COLOR;
		this.bu_bg_alpha = op.button_BG_TRANSPARENCY / 100;
		this.bu_icon = op.button_ICON_IMAGE;
		this.bu_auto = checkBoolean(op.button_AUTO_HIDE);

		this.bu_delay = op.button_AUTO_HIDE_DELAY * 1000;
		this.bu_align = op.button_ALIGN.toLowerCase().split(' ');
		this.bu_margin = op.button_MARGIN;
		this.bu_round = checkBoolean(op.button_ROUND_CORNERS);

		this.touch_drag = checkBoolean(op.touch_DRAG);
		this.mouse_drag = checkBoolean(op.mouse_DRAG);
		this.mouse_wheel = checkBoolean(op.mouse_WHEEL);
		this.mouse_wheel_cur = checkBoolean(op.mouse_WHEEL_CURSOR_POS);
		this.mouse_dbl_click = checkBoolean(op.mouse_DOUBLE_CLICK);

		this.ani_smooth =  Math.max(1, (op.animation_SMOOTHNESS + 1) / 1.45);
		
		this.bg_color = op.background_COLOR;
		this.bord_size = op.border_SIZE;
		this.bord_color = op.border_COLOR;
		this.bord_alpha = op.border_TRANSPARENCY / 100;

		this.container = op.container;
		this.image_url = op.image_url;
		this.image_width = op.image_original_width;
		this.image_height = op.image_original_height;
		
		this.responsive = checkBoolean(op.responsive);
		this.maintain_ratio = checkBoolean(op.responsive_maintain_ratio);
		this.w_max = op.max_WIDTH;
		this.h_max = op.max_HEIGHT;
		
		this.onLOAD = op.on_IMAGE_LOAD;
		this.onUPDATE = op.on_ZOOM_PAN_UPDATE;
		this.onZOOM_PAN = op.on_ZOOM_PAN_COMPLETE;
		this.onLANDMARK = op.on_LANDMARK_STATE_CHANGE;

		/***********************************************************
		Variables for inner operation.	
		x, y, width, height and scale value of image
		***********************************************************/
		this._x;
		this._y;
		this._w;
		this._h;
		this._sc = 0;		
		
		this.rA = 1;
		this.rF = 1;
		this.rR = 1;
		this.iW = 0;
		this.iH = 0;
		this.tX = 0;
		this.tY = 0;
		this.oX = 0;
		this.oY = 0;
		this.fX = 0;
		this.fY = 0;
		this.dX = 0;
		this.dY = 0;
		this.cX = 0;
		this.cY = 0;

		this.transOffX = 0;
		this.transOffY = 0;
		this.focusOffX = 0;
		this.focusOffY = 0;
		this.offX = 0;
		this.offY = 0;
		
		/***********************************************************
		Flags that convey current states and events 
		***********************************************************/
		this._playing = false;
		this._dragging = false;
		this._onfocus = false;
		this._moveCursor = false;
		this._wheel = false;
		this._recent = 'zoomOut';
		this._pinching = false;
		this._landmark = false;
		this._rA;
		this._centx;
		this._centy;
		this._onButton = false;
		this._onHitArea = false;		
		this.cFlag = {
			_zi: false,
			_zo: false,
			_ml: false,
			_mr: false,
			_mu: false,
			_md: false,
			_rs: false,
			_nd: false,
		};
		
		/***********************************************************
		Elements and arrays that references elements
		***********************************************************/
		this.$holder;
		this.$buttons = op.button_HOLDER;
		this.$hitArea;
		this.$controls;
		this.$loc_cont;		
		this.map_coordinates = [];
		this.locations = [];
		this.buttons = [];
		this.border = [];
		
		/***********************************************************
		miscellaneous
		***********************************************************/
		this.buttons_total = 7;
		this.cButtId = 0;
		this.pan_speed;
		this.auto_timer;
		this.ani_timer;
		this.wheel_timer;
		this.ani_end;
		this.focusSpeed = this.reduction = 0.5;
		this.orig_style;		
		this.mapAreas;
		this.icons;		
		this.show_at_zoom;		
		this.assetsLoaded = false;	
		this.zStep = 0;	
		this.sRed = 300;
		this.use3D = op.use_3D_Transform && supportsTrans3D;
		
		if (supportsTouch) {
			this.event_down = 'touchstart.sz';
			this.event_up 	= 'touchend.sz';
			this.event_move = 'touchmove.sz';
		} else {
			this.event_down = 'mousedown.sz';
			this.event_up 	= 'mouseup.sz';
			this.event_move = 'mousemove.sz';
		}	
	
		//Case 1: Image specificed (possibly) through img tag:
		if (this.image_url == '') {
			this.$image = $elem;
			this.id = this.$image.attr('id');
		
		//Case 2: Image url specificed through parameter:
		} else {
			var img = new Image();
			if (this.image_width) {
				img.width = this.image_width;
			}
			if (this.image_height) {
				img.height = this.image_height;
			}
			img.src = this.image_url;			
			this.$image = $(img).appendTo($elem);
		}		
		
		
		//Prepare container div (Basically the element that masks image with overflow hidden)
		this.setContainer();	
		
		//Get button icon image's url
		var testOb;
		if (!this.bu_icon) {
			var regx = /url\(["']?([^'")]+)['"]?\)/;
			testOb = $('<div class="smooth_zoom_icons"></div>');
			this.$holder.append(testOb);
			this.bu_icon = testOb.css('background-image').replace(regx, '$1');
			if (this.bu_icon == 'none') {
				this.bu_icon = 'zoom_assets/icons.png';
			}
			testOb.remove();
		}		
		
		//Firefox feature checkup
		if (this.$image.css('-moz-transform') && prop_transform) {
			testOb = $('<div style="-moz-transform: translate(1px, 1px)"></div>');
			this.$holder.append(testOb);
			this.fixMoz = testOb.position().left !== 1;
			testOb.remove();	
		} else {
			this.fixMoz = false;
		}		
		
		//Preload icons and main image.	
		/*this.$image.hide();	
		this.imgList = [
			{loaded: false, src: this.bu_icon || 'zoom_assets/icons.png'}, //Icon image
			{loaded: false, src: this.image_url == ''? this.$image.attr('src') : this.image_url} // Main image
		];
		
		$.each(this.imgList, function (i){
			var _img = new Image();	
			$(_img) .on('load', {id:i, self: self}, self.loadComplete)
					.on('error', {id:i, self: self}, self.loadComplete); //Allow initiation even if image is not there :(
			_img.src = self.imgList[i].src;	
		});*/
		
		// SKIP IMAGE PRELOADER
		self.assetsLoaded = true;				
		if (self.onLOAD !== '') self.onLOAD();
		self.init();
		
	}

	Zoomer.prototype = {
		
		/*Preload the icon and main image
		*********************************************************************************************************************/
		loadComplete: function(e) {
			var self = e.data.self,
				complete = true;
			
			self.imgList[e.data.id].loaded = true;					
			for (var j = 0; j < self.imgList.length; j++) {				
				if (!self.imgList[j].loaded) {
					complete = false;
				}
			}
			if (complete) {
				self.assetsLoaded = true;				
				if (self.onLOAD !== '') {
					self.onLOAD();
				}
										
				//Assets loaded, initiate plugin
				self.init();
			}
		},	

		
		/*Initiate after assets loaded
		***********************************************************************************************************************/
		init: function() {
			var self = this,
				$image = self.$image,
				sW = self.sW,
				sH = self.sH,
				container = self.container,	
				cBW, cBH, pan_show = self.pan_show,
				zoom_show = self.zoom_show,
				$controls = self.$controls,
				buttons = self.buttons,
				cFlag = self.cFlag,
				bu_align = self.bu_align,
				bu_margin = self.bu_margin,
				$holder = self.$holder,
				$buttons = self.$buttons ? self.$buttons : self.$holder;

			//Store the default image properties so that it can be reverted back when plugin needs to be destroyed
			self.orig_style = self.getStyle();

			//IE 6 Image tool bar disabled
			$image.attr('galleryimg', 'no');
			
			if (!navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/)) {
				$image.removeAttr('width');
				$image.removeAttr('height');
			}		

			//In case parent element's display property set to 'none', we need to first set them 'block', measure the width and height and then set them back to 'none'
			var temp = $image,
			dispArray = [];
			for (var i = 0; i < 5; i++) {				
				if (temp && temp[0].tagName !== 'BODY' && temp[0].tagName !== 'HTML') {									
					if (temp.css('display') == 'none') {
						temp.css('display', 'block');
						dispArray.push(temp);		
					}
					temp = temp.parent();
				} else {
					break;
				}
			}	

			self.iW = $image.width();
			self.iH = $image.height();
			
			for (var i = 0; i < dispArray.length; i++) {
				dispArray[i].css('display', 'none');
			}

			//Initially the image needs to be resized to fit container. To do so, first measure the scaledown ratio	
			self.rF = self.rR = self.checkRatio(sW, sH, self.iW, self.iH, self.zoom_fit);

			//If NO Minimum zoom value set
			if (self.zoom_min == 0 || self.init_zoom != 0) {			
				if (self.init_zoom != '') {
					self.rA = self._sc = self.init_zoom;
				} else {
					self.rA = self._sc = self.rF;
				}	
				if (self.zoom_min != 0) {
					self.rF = self.zoom_min;
					if (self.reset_to_zmin) {
						self.rR = self.zoom_min;											
					}
				}
				
			//If Minimum zoom value set
			} else {				
				if (self.rF < self.zoom_min) {
					self.rF = self.zoom_min;
					if (self.reset_to_zmin) {
						self.rR = self.zoom_min;											
					}
					self.rA = self._sc = self.zoom_min;				
				} else {
					self.rA = self._sc = self.rR;
				}				
			}

			//Width and Height to be applied to the image
			self._w = self._sc * self.iW;
			self._h = self._sc * self.iH;

			//Resize the image and position it centered inside the wrapper
			if (self.init_pos == '') {
				self._x = self.tX = (sW - self._w) / 2;
				self._y = self.tY = (sH - self._h) / 2;
			} else {
				self._x = self.tX = (sW / 2) - parseInt(self.init_pos[0]) * self._sc;
				self._y = self.tY = (sH / 2) - parseInt(self.init_pos[1]) * self._sc;
				self.oX = (self.tX - ((sW - self._w) / 2)) / (self._w / sW);
				self.oY = (self.tY - ((sH - self._h) / 2)) / (self._h / sH);
			}

			if ((!self.pan_limit || self._moveCursor || self.init_zoom != self.rF) && self.mouse_drag) {				
				 $image.css('cursor', 'move');
				 self.$hitArea.css('cursor', 'move');
			}
			
			
			if (prop_transform) {	
				self.$image.css(prop_origin, '0 0');
			}
			if (self.use3D) {
				$image.css({				
					'-webkit-backface-visibility': 'hidden',
					'-webkit-perspective': 1000,
				});
			}	
			
			//Start displaying the image		
			$image.css({
					position: 'absolute',
					'z-index': 2,
					left: '0px',
					top: '0px',
					'-webkit-box-shadow': '1px 1px rgba(0,0,0,0)',
				})
				.hide()
				.fadeIn(500, function() {
					$holder.css('background-image', 'none');					
				});
			
			//Create Control buttons and events				
			var self = self,
				bs = self.bu_size,
				iSize = 50,
				sDiff = 2,
				bSpace = 3,
				mSize = Math.ceil(self.bu_size / 4),
				iconOff = bs < 16 ? 50 : 0,
				bsDiff = bs - sDiff;

			//Show all buttons		
			if (pan_show) {
				if (zoom_show) {
					cBW = parseInt(bs + (bs * 0.85) + (bsDiff * 3) + (bSpace * 2) + (mSize * 2));
				} else {
					cBW = parseInt((bsDiff * 3) + (bSpace * 2) + (mSize * 2));
				}
				cBH = parseInt((bsDiff * 3) + (bSpace * 2) + (mSize * 2));

				//Show zoom buttons only		
			} else {
				if (zoom_show) {
					cBW = parseInt(bs + mSize * 2);
					cBH = parseInt(bs * 2 + mSize * 3);
					cBW = parseInt(cBW / 2) * 2;
					cBH = parseInt(cBH / 2) * 2;
				} else {
					cBW = 0;
					cBH = 0;
				}
			}

			var pOff = (iSize - bs) / 2,
				resetCenterX = cBW - ((bs - (pan_show ? sDiff : 0)) * 2) - mSize - bSpace,
				resetCenterY = (cBH / 2) - ((bs - (pan_show ? sDiff : 0)) / 2);

			var hProp, vProp, hVal, vVal;
			//Align button set as per settings
			if (bu_align[0] == 'top') {
				vProp = 'top';
				vVal = bu_margin;
			} else if (bu_align[0] == 'center') {
				vProp = 'top';
				vVal = parseInt((sH - cBH) / 2);
			} else {
				vProp = 'bottom';
				vVal = bu_margin;
			}
			if (bu_align[1] == 'right') {
				hProp = 'right';
				hVal = bu_margin;
			} else if (bu_align[1] == 'center') {
				hProp = 'right';
				hVal = parseInt((sW - cBW) / 2);
			} else {
				hProp = 'left';
				hVal = bu_margin;
			}

			//Buttons Container		
			$controls = $(
				'<div style="position: absolute; ' + hProp + ':' + hVal + 'px; ' + vProp + ': ' + vVal + 'px; width: ' + cBW + 'px; height: ' + cBH + 'px; z-index: 20;" class="noSel;">\
					<div class="noSel controlsBg" style="position: relative; width: 100%; height: 100%; z-index: 1;">\
					</div>\
				</div>'
			);
			
			$buttons.append($controls);
			var $controlsBg = $controls.find('.controlsBg');
			
			//Make the corners rounded
			if (self.bu_round) {
				if (prop_radius) {					
					$controlsBg
						.css(prop_radius, (iconOff > 0 ? 4 : 5) + 'px')
						.css('background-color', self.bu_bg);
				} else {				
					self.roundBG(
						$controlsBg,
						'cBg',
						cBW,
						cBH,
						iconOff > 0 ? 4 : 5,
						375,
						self.bu_bg,
						self.bu_icon,
						1, 
						iconOff ? 50 : 0
					);
				}
			} else {
				$controlsBg.css('background-color', self.bu_bg);
			}
			
			$controlsBg.css('opacity', self.bu_bg_alpha);
			
			//Generating Button properties	(7 buttons)			
			buttons[0] = {
				_var: '_zi',
				l: mSize,
				t: pan_show ? (cBH - (bs * 2) - (bSpace * 2) + 2) / 2 : mSize,
				w: bs,
				h: bs,
				bx: -pOff,
				by: -pOff - iconOff,
			};

			buttons[1] = {
				_var: '_zo',
				l: mSize,
				t: pan_show ? ((cBH - (bs * 2) - (bSpace * 2) + 2) / 2) + bs + (bSpace * 2) - 2 : cBH - bs - mSize,
				w: bs,
				h: bs,
				bx: -iSize - pOff,
				by: -pOff - iconOff,
			};

			buttons[2] = {
				_var: self.pan_rev ? '_ml' : '_mr',
				l: resetCenterX - bsDiff - bSpace,
				t: resetCenterY,
				w: bsDiff,
				h: bsDiff,
				bx: -(sDiff / 2) - iSize * 2 - pOff,
				by: -(sDiff / 2) - pOff - iconOff,
			};

			buttons[3] = {
				_var: self.pan_rev ? '_mr' : '_ml',
				l: resetCenterX + bsDiff + bSpace,
				t: resetCenterY,
				w: bsDiff,
				h: bsDiff,
				bx: -(sDiff / 2) - iSize * 3 - pOff,
				by: -(sDiff / 2) - pOff - iconOff,
			};

			buttons[4] = {
				_var: self.pan_rev ? '_md' : '_mu',
				l: resetCenterX,
				t: resetCenterY + bsDiff + bSpace,
				w: bsDiff,
				h: bsDiff,
				bx: -(sDiff / 2) - iSize * 4 - pOff,
				by: -(sDiff / 2) - pOff - iconOff,
			};

			buttons[5] = {
				_var: self.pan_rev ? '_mu' : '_md',
				l: resetCenterX,
				t: resetCenterY - bsDiff - bSpace,
				w: bsDiff,
				h: bsDiff,
				bx: -(sDiff / 2) - iSize * 5 - pOff,
				by: -(sDiff / 2) - pOff - iconOff,
			};

			buttons[6] = {
				_var: '_rs',
				l: resetCenterX,
				t: resetCenterY,
				w: bsDiff,
				h: bsDiff,
				bx: -(sDiff / 2) - iSize * 6 - pOff,
				by: -(sDiff / 2) - pOff - iconOff,
			};

			for (var i = 0; i < 7; i++) {
				buttons[i].$ob = $(
						'<div style="position: absolute; display: ' + (i < 2 ? zoom_show ? 'block' : 'none' : pan_show ? 'block' : 'none') + '; left: ' + (buttons[i].l - 1) + 'px; top: ' + (buttons[i].t - 1) + 'px; width: ' + (buttons[i].w + 2) + 'px; height: ' + (buttons[i].h + 2) + 'px; z-index:' + (i + 1) + ';" class="noSel">\
						</div>'
					)
				.css('opacity', 0.7)
				.on((supportsTouch ? '' : 'mouseover.sz mouseout.sz ') + self.event_down, {
					id: i,
					
				}, function(e) {
					self._onfocus = false;
					$this = $(this);
					
					//Button over 
					if (e.type == 'mouseover') {
						if ($this.css('opacity') > 0.5) {
							 $this.css('opacity', 1);
						}
					
					//Button out 
					} else if (e.type == 'mouseout') {
						if ($this.css('opacity') > 0.5) {
							$this.css('opacity', 0.7);
						}
					
					//Button press/down
					} else if (e.type == 'mousedown' || e.type == 'touchstart') {
						self.cButtId = e.data.id;
						self._onButton = true;
						self._wheel = false;	
						
						//If NOT already down..
						if ($this.css('opacity') > 0.5) {
							$this.css('opacity', 1);
							$holder.find('#' + buttons[self.cButtId]._var + 'norm').hide();
							$holder.find('#' + buttons[self.cButtId]._var + 'over').show();
							
							//CASE 1: If zoomIn pressed and single step zoom enabled
							if (self.cButtId <= 1 && self.zoom_single) {								
								if (!cFlag[buttons[self.cButtId]._var]) {									
									self.sRed = 300;
									cFlag[buttons[self.cButtId]._var] = true;
								}
								
							//CASE 2: If any button except RESET pressed
							} else if (self.cButtId < 6) {
								cFlag[buttons[self.cButtId]._var] = true;
								
							//CASE 3: RESET pressed							
							} else {
								cFlag._rs = true;
								self.rA = self.rR;							
								if (self.reset_align[0] == 'top') {
									self.fY = (self.sH / 2) * (self.rA / 2);
								} else if (self.reset_align[0] == 'bottom') {
									self.fY = -(self.sH / 2) * (self.rA / 2);
								} else {
									self.fY = 0;
								}							
								if (self.reset_align[1] == 'left') {
									self.fX = (self.sW / 2) * (self.rA / 2);
								} else if (self.reset_align[1] == 'right') {
									self.fX = -(self.sW / 2) * (self.rA / 2);
								} else {
									self.fX = 0;
								}							
							}
							
							self.focusOffX = self.focusOffY = 0;
							self.changeOffset(true, true);
							if (!self._playing) {
								self.setMaxZoom();
								self.Animate();
							}
						}
						e.preventDefault();
						e.stopPropagation();						
					}
				});

				//Make 2 BGs for Button Normal and Over state
				//Button BG normal
				var tpm = $(
					'<div id="' + buttons[i]._var + 'norm" style="position: absolute; left: 1px; top: 1px; width: ' + buttons[i].w + 'px; height: ' + buttons[i].h + 'px; ' + (prop_radius || !self.bu_round ? 'background:' + self.bu_color : '') + '">\
					</div>'
				);

				//Button BG hover
				var tpmo = $(
					'<div id="' + buttons[i]._var + 'over" style="position: absolute; left: 0px; top: 0px; width: ' + (buttons[i].w + 2) + 'px; height: ' + (buttons[i].h + 2) + 'px; display: none; ' + (prop_radius || !self.bu_round ? 'background:' + self.bu_color : '') + '">\
					</div>'
				);

				//Add the button icons
				var cont = $(
					'<div id="' + buttons[i]._var + '_icon" style="position: absolute; left: 1px; top: 1px; width: ' + buttons[i].w + 'px; height: ' + buttons[i].h + 'px; background: transparent url(' + self.bu_icon + ') ' + buttons[i].bx + 'px ' + buttons[i].by + 'px no-repeat;" >\
					</div>'
				);
				
				buttons[i].$ob.append(tpm, tpmo, cont);
				$controls.append(buttons[i].$ob);

				//Apply corner radius
				if (self.bu_round) {
					if (prop_radius) {						
						tpm.css(prop_radius, '2px');				
						tpmo.css(prop_radius, '2px');						
					} else {
						self.roundBG(
							tpm,
							buttons[i]._var + 'norm',
							buttons[i].w,
							buttons[i].h,
							2,
							425,
							self.bu_color,
							self.bu_icon,
							i + 1,
							iconOff ? 50 : 0
						);
						self.roundBG(
							tpmo,
							buttons[i]._var + 'over',
							buttons[i].w + 2,
							buttons[i].h + 2,
							2,
							425,
							self.bu_color,
							self.bu_icon,
							i + 1,
							iconOff ? 50 : 0
						);
					}
				}
			}

			//Add Events for mouse drag / touch swipe action
			$(document).on(self.event_up + self.id, {self: self}, self.mouseUp);
			
			if ((self.mouse_drag && !supportsTouch) || (self.touch_drag && supportsTouch)) {			
				self.$holder.on(self.event_down, {self: self}, self.mouseDown);
				if (supportsTouch) {
					$(document).on(self.event_move + self.id, {self: self}, self.mouseDrag);
				}				
			}		

			//Add Double click / Double tap zoom
			if (self.mouse_dbl_click) {
				var dClickedX,
					dClickedY,
					dbl_click_dir = 1;
					
				self.$holder.on('dblclick.sz', function(e) {					
					self.focusOffX = e.pageX - $holder.offset().left - (self.sW / 2);
					self.focusOffY = e.pageY - $holder.offset().top - (self.sH / 2);
					self.changeOffset(true, true);
					self._wheel = false;

					if (!window.doubleClick || window.doubleClick < 1) {
					
						if (self.rA < self.zoom_max && dbl_click_dir == -1 && dClickedX != self.focusOffX && dClickedY != self.focusOffY) {
							dbl_click_dir = 1;
						}
						
						dClickedX = self.focusOffX;
						dClickedY = self.focusOffY;

						self.setMaxZoom();

						if (self.rA >= self.zoom_max && dbl_click_dir == 1) {
							dbl_click_dir = -1;
						}					
						if (self.rA <= self.rF && dbl_click_dir == -1) {
							dbl_click_dir = 1;
						}
						if (dbl_click_dir > 0) {
							self.rA *= 2;
							self.rA = self.rA > self.zoom_max ?  self.zoom_max : self.rA;
							cFlag._zi = true;
							clearTimeout(self.ani_timer);
							self._playing = true;
							self.Animate();
							cFlag._zi = false;

						} else {
							self.rA /= 2;
							self.rA =  self.rA < self.rF ? self.rF : self.rA;
							cFlag._zo = true;
							clearTimeout(self.ani_timer);
							self._playing = true;
							self.Animate();
							cFlag._zo = false;
						}
						e.preventDefault();		
						e.stopPropagation();

					}
				});
			}

			//Add mouse wheel event if enabled
			if (self.mouse_wheel) {
				 $holder.parent().on('mousewheel.sz', {self: this}, self.mouseWheel);
			}

			//Auto Hide the control buttons if enabled
			if (self.bu_auto) {
				$holder.on('mouseleave.sz', {self: this}, self.autoHide);
			}

			//Prevent Controls Bg from start dragging image
			$controls.on(self.event_down, function(e) {
				e.preventDefault();
				e.stopPropagation();				
			});

			//Prevent Controls Bg from double click zoom
			if (self.mouse_dbl_click) {
				$controls.on('dblclick.sz', function(e) {
					e.preventDefault();
					e.stopPropagation();					
				});
			}

			//Prevent text selection for smoother dragging and button focus
			$('.noSel').each(function() {
				this.onselectstart = function() {
					return false;
				};
			});

			self.$holder = $holder;
			self.$controls = $controls;
			self.sW = sW;
			self.sH = sH;
			self.cBW = cBW;
			self.cBH = cBH;

			//Apply initial transformation
			self.setMaxZoom();
			self.Animate();
		},
		
		
		/*Prepare the container (holder) element and get landmarks if available
		***********************************************************************************************************************/
		setContainer: function() {			
			var self = this,
				$image = self.$image,
				bord_size = self.bord_size,
				border = self.border,
				$holder = self.$holder;

			//Wrap a container for image or get the container if specified through options:
			if (self.container == '' && self.image_url == '') {
				$holder = self.$image.wrap(
					'<div class="noSel smooth_zoom_preloader">\
					</div>'
				).parent();
				
			} else {
				if (self.image_url == '') {
					$holder = $('#' + self.container);
				} else {
					$holder = self.$elem;
				}
				$holder.addClass('noSel smooth_zoom_preloader');
				self.locations = [];
				self.$loc_cont = $holder.find('.landmarks');
				if (self.$loc_cont[0]) {
					var locs = self.$loc_cont.children('.item');
					self.loc_clone = self.$loc_cont.clone();
					self.show_at_zoom = parseInt(self.$loc_cont.data('show-at-zoom'), 10) / 100;
					self.allow_scale = checkBoolean(self.$loc_cont.data('allow-scale'));
					self.allow_drag = checkBoolean(self.$loc_cont.data('allow-drag'));					
					locs.each(function() {	
						self.setLocation($(this));			
					});
				}
			}
						
			$holder.css({
				'position': 'relative',
				'overflow': 'hidden',
				'text-align': 'left',
				'-moz-user-select': 'none',
				'-khtml-user-select': 'none',
				'-webkit-user-select': 'none',
				'user-select': 'none',					
				'-webkit-touch-callout': 'none',
				'-webkit-tap-highlight-color': 'rgba(255, 255, 255, 0)', 
				'background-color': self.bg_color,
				'background-position': 'center center',
				'background-repeat': 'no-repeat',
			});

			self.$hitArea = $('<div style="position: absolute; z-index: 1; top: 0px; left: 0px; width: 100%; height: 100%;" ></div>').appendTo($holder);
			
			self.getContainerSize(self.sW, self.sH, $holder, self.w_max, self.h_max);	
								
			if (self.responsive) {
				$(window).on('orientationchange.sz' + self.id + ' resize.sz' + self.id, {self: self}, self.resize);
			}
			var sW = self.sW;
			var sH = self.sH;	

			//Add Image container properties			
			$holder.css({
				'width': sW,
				'height': sH,
			});

			//Add border if needed
			if (bord_size > 0) {
				border[0] = $('<div style="position: absolute;	width: ' + bord_size + 'px; height: ' + sH + 'px;	top: 0px; left: 0px; z-index: 3; background-color: ' + self.bord_color + ';"></div>').css('opacity', self.bord_alpha);
				border[1] = $('<div style="position: absolute;	width: ' + bord_size + 'px; height: ' + sH + 'px;	top: 0px; left: ' + (sW - bord_size) + 'px; z-index: 4; background-color: ' + self.bord_color + ';"></div>').css('opacity', self.bord_alpha);
				border[2] = $('<div style="position: absolute;	width: ' + (sW - (bord_size * 2)) + 'px; height: ' + bord_size + 'px; top: 0px; left: ' + bord_size + 'px; z-index: 5; background-color: ' + self.bord_color + '; line-height: 1px;"></div>').css('opacity', self.bord_alpha);
				border[3] = $('<div style="position: absolute;	width: ' + (sW - (bord_size * 2)) + 'px; height: ' + bord_size + 'px; top: ' + (sH - bord_size) + 'px; left: ' + bord_size + 'px; z-index: 6; background-color: ' + self.bord_color + '; line-height: 1px;"></div>').css('opacity', self.bord_alpha);
				$holder.append(border[0], border[1], border[2], border[3]);
			}

			//Get Image maps if exists
			if ($image.attr('usemap') != undefined) {
				self.mapAreas = $("map[name='" + ($image.attr('usemap').split('#').join('')) + "']").children('area');
				self.mapAreas.each(function(i) {					
					var area = $(this);
					area.css('cursor', 'pointer');
					if (self.mouse_drag) {
						area.on(self.event_down, {self: self}, self.mouseDown);
					}
					if (self.mouse_wheel) {
						area.on('mousewheel.sz', {self: self}, self.mouseWheel);
					}
					self.map_coordinates.push(area.attr('coords').split(','));
				});
			}	
			
			self.$holder = $holder;
			self.sW = sW;
			self.sH = sH;
		},
		
		getContainerSize: function(sW, sH, $holder, w_max, h_max) {
			if (sW === '' || sW === 0) {				
				if (this.image_url == '') {					
					sW = Math.max($holder.parent().width(), 100);
				} else {									
					sW = Math.max($holder.width(), 100);
				}				
				
			} else if (!isNaN(sW) || String(sW).indexOf('px') > -1) {
				sW = this.oW = parseInt(sW);
				if (this.responsive) {
					sW = Math.min($holder.parent().width(), sW);
				}
			} else if (String(sW).indexOf('%') > -1) {
				sW = $holder.parent().width() * (sW.split('%')[0] / 100);			
			} else {
				sW = 100;
			}
			if (w_max !== 0 && w_max !== '') {
				sW = Math.min(sW, w_max);
			}
			if (sH === '' || sH === 0) {
				if (this.image_url == '') {				
					sH = Math.max($holder.parent().height(), 100);
				} else {					
					sH = Math.max($holder.height(), 100);
				}				
			} else if (!isNaN(sH) || String(sH).indexOf('px') > -1) {
				sH = this.oH = parseInt(sH);
		
			} else if (String(sH).indexOf('%') > -1) {
				sH = $holder.parent().height() * (sH.split('%')[0] / 100);				
			} else {
				sH = 100;
			}
			if (h_max !== 0 && h_max !== '') {
				sH = Math.min(sH, h_max);
			}

			if (this.oW && sW !== this.oW) {				
				if (this.oH && this.maintain_ratio) {				
					sH = sW / (this.oW / this.oH);
				}
			}			
			
			this.sW = sW;
			this.sH = sH;
		},
		
		
		/*Each landmark / location / lable initiated here
		***********************************************************************************************************************/
		setLocation: function(lc) {
			var self = this,
				ob = lc,
				w2, h2, pos, sc;
			
			if (prop_origin) {
				ob.css(prop_origin, '0 0');
			}
			
			ob.css({
				'display': 'block',
				'z-index': 2,					
			});				
			if (self.use3D) {
				ob.css({			
					'-webkit-backface-visibility': 'hidden',
					'-webkit-perspective': 1000,
				});
			}
					
			w2 = ob.outerWidth() / 2;
			h2 = ob.outerHeight() / 2;
			pos = ob.data('position').split(',');	
			sc = ob.data('allow-scale');
			if (sc == undefined) {
				sc = self.allow_scale;				
			} else {
				sc = checkBoolean(sc);
			}
			
			if (ob.hasClass('mark')) {
				var imgw = ob.find('img').css('vertical-align', 'bottom').width();
				$(ob.children()[0]).css({
					'position': 'absolute',
					'left': (-ob.width() / 2),
					'bottom': parseInt(ob.css('padding-bottom')) * 2,
				});	
				var txt = ob.find('.text');					
				self.locations.push({
					ob: ob,
					x: parseInt(pos[0]),
					y: parseInt(pos[1]),
					w2: w2,
					h2: h2,
					w2pad: w2 + (txt[0] ? parseInt(txt.css('padding-left')) : 0),
					vis: false,
					lab: false,
					lpx: '0',
					lpy: '0',
					showAt: isNaN(ob.data('show-at-zoom')) ? self.show_at_zoom : parseInt(ob.data('show-at-zoom'), 10) / 100,
					scale: sc,
				});				
				
			} else if (ob.hasClass('lable')) {
				var bg = ob.data('bg-color'),
					opacity = ob.data('bg-opacity'),						
					cont = $(ob.eq(0).children()[0])
							.css({
							'position': 'absolute',
							'z-index': 2,
							left: -w2, 
							top: -h2,
						});		
							
				self.locations.push({
					ob: ob,
					x: parseInt(pos[0]),
					y: parseInt(pos[1]),
					w2: w2,
					h2: h2,
					w2pad: w2,
					vis: false,
					lab: true,
					lpx: '0',
					lpy: '0',
					showAt: isNaN(ob.data('show-at-zoom')) ? self.show_at_zoom : parseInt(ob.data('show-at-zoom'), 10) / 100,
					scale: sc,
				});

				if (bg !== '') {
					if (!bg) {
						bg = '#000000';
						opacity = 0.7;
					}							
					var bgob = $('<div style="position: absolute; left: ' + (-w2) + 'px; top: ' + (-h2) + 'px; width: ' + ((w2 - parseInt(cont.css('padding-left'))) * 2) + 'px; height:' + ((h2 - parseInt(cont.css('padding-top'))) * 2) + 'px; background-color: ' + bg + ';"></div>').appendTo(ob);
					if (opacity) {
						bgob.css('opacity', opacity);
					}
				}
			}
			ob.hide();
			if (prop_transform) {
				ob.css('opacity', 0);
			}	
			if (!self.allow_drag) {
				ob.on(self.event_down, function(e) {				
					//e.preventDefault();
					e.stopPropagation();					
				});				
			}
		},

		/*Storing the original style of image (needed only when destroying)
		***********************************************************************************************************************/
		getStyle: function() {
			var el = this.$image;
			return {
				prop_origin: [prop_origin, prop_origin !== false && prop_origin !== undefined ? el.css(prop_origin) : null],
				prop_transform: [prop_transform, prop_transform !== false && prop_transform !== undefined ? el.css(prop_transform) : null],
				'position': ['position', el.css('position')],
				'z-index': ['z-index', el.css('z-index')],
				'cursor': ['cursor', el.css('cursor')],
				'left': ['left', el.css('left')],
				'top': ['top', el.css('top')],
				'width': ['width', el.css('width')],
				'height': ['height', el.css('height')],
			};
		},

		/*Find the scale ratios
		***********************************************************************************************************************/
		checkRatio: function(sW, sH, iW, iH, zoom_fit) {
			var rF;
			if (iW == sW && iH == sH) {
				rF = 1;				
			} else if (iW < sW && iH < sH) {
				rF = sW / iW;				
				if (zoom_fit) {
					if (rF * iH > sH) {
						rF = sH / iH;
					}
				} else {
					if (rF * iH < sH) {
						rF = sH / iH;
					}
					if (sW / iW !== sH / iH && this.mouse_drag) {
						this._moveCursor = true;
						this.$image.css('cursor', 'move');
						this.$hitArea.css('cursor', 'move');
					}
				}
			} else {
				
				rF = sW / iW;
				if (zoom_fit) {
					if (rF * iH > sH) {
						rF = sH / iH;
					}
					if (rF < this.init_zoom && this.mouse_drag) {
						this._moveCursor = true;
						this.$image.css('cursor', 'move');
						this.$hitArea.css('cursor', 'move');
					}
				} else {
					if (rF * iH < sH) {
						rF = sH / iH;
					}
					if (sW / iW !== sH / iH && this.mouse_drag) {
						this._moveCursor = true;
						this.$image.css('cursor', 'move');
						this.$hitArea.css('cursor', 'move');
					}
				}
			}
			return rF;
		},
		
		
		/*Returns distance between 2 points (used for touch gesture)
		***********************************************************************************************************************/
		getDistance: function(x1, y1, x2, y2) {
			return Math.sqrt(Math.abs(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1))));
		},
		

		/*Image Events for Dragging and Mouse Wheel
		***********************************************************************************************************************/
		mouseDown: function(e) {
			var self = e.data.self;
			self._onfocus = self._dragging = false;		
			if (self.cFlag._nd) {
				if (self.fixMoz) {
					self.correctTransValue();
				}
				self.samePointRelease = false;
				if (e.type == 'mousedown') {			
					self.stX = e.pageX;
					self.stY = e.pageY;		
					self.offX = e.pageX - self.$holder.offset().left - self.$image.position().left;
					self.offY = e.pageY - self.$holder.offset().top - self.$image.position().top;					
					$(document).on(self.event_move + self.id, {self: self}, self.mouseDrag);	
				} else {
					//OVERRIDE
					e.preventDefault();
					var te = e.originalEvent;						
					if (te.targetTouches.length > 1) {
						self._pinching = true;	
						self._rA = self.rA;	
						self.dStart = self.getDistance(te.touches[0].pageX, te.touches[0].pageY, te.touches[1].pageX, te.touches[1].pageY);
					} else {
						self.offX = te.touches[0].pageX - self.$holder.offset().left - self.$image.position().left;
						self.offY = te.touches[0].pageY - self.$holder.offset().top - self.$image.position().top;
						self.setDraggedPos(te.touches[0].pageX - self.$holder.offset().left - self.offX, te.touches[0].pageY - self.$holder.offset().top - self.offY, self._sc);
						self._recent = 'drag';
						self._dragging = true;
					}
				}				
				self._onHitArea = true;								
			}
			if (e.type == 'mousedown') {
				e.preventDefault();
			}		
		},
		
		
		/*Mouse Drag / Touch swipe operations handled here
		***********************************************************************************************************************/
		mouseDrag: function(e) {
			var self = e.data.self;
			// OVERRIDE
			//e.preventDefault();

			//Mouse
			if (e.type == 'mousemove') {
				self.setDraggedPos(e.pageX - self.$holder.offset().left - self.offX, e.pageY - self.$holder.offset().top - self.offY, self._sc);				
				self._recent = 'drag';
				self._dragging = true;
				if (!self._playing) {
					self.Animate();
				}
				return false;

				//Touch				
			} else {
				if (self._dragging || self._pinching) {
					e.preventDefault();		
				}
				if (self._onHitArea) {
					var touches = e.originalEvent.touches;					
					if (self._pinching || touches.length > 1) {
						if (!self._pinching) {
							self._pinching = true;
							self._rA = self.rA;	
							if (touches.length > 1) {
								self.dStart = self.getDistance(touches[0].pageX, touches[0].pageY, touches[1].pageX, touches[1].pageY);		
							}
						}	
						if (touches.length > 1) {					
							self._centx = (touches[0].pageX + touches[1].pageX) / 2;
							self._centy = (touches[0].pageY + touches[1].pageY) / 2;
							self.focusOffX = self._centx - self.$holder.offset().left - (self.sW / 2);
							self.focusOffY = self._centy - self.$holder.offset().top - (self.sH / 2);
							self.changeOffset(true, true);
							self._wheel = true;
							self._dragging = false;
							if (self.zoom_single) {													
								self.sRed = 300;
																					
							} else {
								self.dEnd = self.getDistance(touches[0].pageX, touches[0].pageY, touches[1].pageX, touches[1].pageY);
								self.rA = self._rA * (self.dEnd / self.dStart);
								self.rA = self.rA > self.zoom_max ? self.zoom_max : self.rA;
								self.rA = self.rA < self.rF ? self.rF : self.rA;
							}
							if (self._sc < self.rA) {
								self.cFlag._zo = false;
								self.cFlag._zi = true;
							} else {
								self.cFlag._zi = false;
								self.cFlag._zo = true;
							}
							if (!self._playing) {
								self.Animate();
							}
						}

					} else if (self._dragging && touches.length < 2) {
						self.setDraggedPos(touches[0].pageX - self.$holder.offset().left - self.offX, touches[0].pageY - self.$holder.offset().top - self.offY, self._sc);
						self._recent = 'drag';
						if (!self._playing) {
							self.Animate();
						}
					}
				}
			}
		},
		
		
		/*Global Mouse Up / Touch End
		***********************************************************************************************************************/
		mouseUp: function(e) {
			var self = e.data.self;
			
			//If one of the buttons released
			if (self._onButton) {
				self.$holder.find('#' + self.buttons[self.cButtId]._var + 'norm').show();
				self.$holder.find('#' + self.buttons[self.cButtId]._var + 'over').hide();
				if (self.cButtId !== 6) {
					self.cFlag[self.buttons[self.cButtId]._var] = false;
				}
				if (e.type == 'touchend' && self.buttons[self.cButtId].$ob.css('opacity') > 0.5) {
					self.buttons[self.cButtId].$ob.css('opacity', 0.7);
				}
				self._onButton = false;
				e.stopPropagation();
				return false;
				
			//If the mouse drag or touch swipe completed
			} else if (self._onHitArea) {
				if (self.mouse_drag || self.touch_drag) {
					//Mouse					
					if (e.type == 'mouseup') {
						$(document).off(self.event_move + self.id);						
						if (self.stX ==  e.pageX && self.stY == e.pageY) {
							self.samePointRelease = true;
						}						
						self._recent = 'drag';
						self._dragging = false;
						if (!self._playing) {
							self.Animate();
						}
						self._onHitArea = false;

					//Touch
					} else {
						e.preventDefault();
						self._dragging = false;
						if (self._pinching) {
							self._pinching = false;
							self._wheel = false;
							self.cFlag._nd = true;
							self.cFlag._zi = false;
							self.cFlag._zo = false;
						} else {
							self._recent = 'drag';
							if (!self._playing) {
								self.Animate();
							}
						}						
						self._onHitArea = false;
					}
				}
			}
		},
		
		
		/*Mouse wheel zoom in-out
		***********************************************************************************************************************/
		mouseWheel: function(e, delta) {
			if (e.deltaY && e.deltaY % 1 !== 0) {
				e.preventDefault();
			}
			var self = e.data.self;
			self._onfocus = self._dragging = false;
			if (self.mouse_wheel_cur) {
				self.focusOffX = e.pageX - self.$holder.offset().left - (self.sW / 2);
				self.focusOffY = e.pageY - self.$holder.offset().top - (self.sH / 2);
				self.changeOffset(true, true);
			}

			self.setMaxZoom();
			
			self._dragging = false;
			if (delta > 0) {
				if (self.rA != self.zoom_max) {
					if (self.zoom_single) {													
						if (!self._wheel) {
							self.sRed = 300;	
						}
					} else {				
						self.rA *= delta < 1 ? 1 + (0.3 * delta) : 1.3;
						self.rA = self.rA > self.zoom_max ? self.zoom_max : self.rA;						
					}
					self._wheel = true;
					self.cFlag._zi = true;
					clearTimeout(self.ani_timer);
					self._playing = true;
					self.Animate();
					self.cFlag._zi = false;
				}
			} else {
				if (self.rA != self.rF) {
					if (self.zoom_single) {													
						if (!self._wheel) {
							self.sRed = 300;
						}
					} else {	
						self.rA /= delta > -1 ? 1 + (0.3 * -delta) : 1.3;
						self.rA = self.rA < self.rF ? self.rF : self.rA;
					}
					self._wheel = true;
					self.cFlag._zo = true;
					clearTimeout(self.ani_timer);
					self._playing = true;
					self.Animate();
					self.cFlag._zo = false;
				}
			}

			self.$map.addClass('map--wheel');
			clearTimeout(self.wheel_timer);
			self.wheel_timer = setTimeout(function() {
				self.$map.removeClass('map--wheel');
			}, 200);

			return false;
		},
		

		/*Control buttons Auto hide
		***********************************************************************************************************************/
		autoHide: function(e) {
			var self = e.data.self;

			clearTimeout(self.auto_timer);
			self.auto_timer = setTimeout(function() {
				self.$controls.fadeOut(600);
			}, self.bu_delay);

			self.$holder.on('mouseenter.sz', function(e) {
				clearTimeout(self.auto_timer);
				self.$controls.fadeIn(300);
			});
		},
		

		/*Mozilla works differently than others when getting translated positions. So this correction needed
		***********************************************************************************************************************/
		correctTransValue: function() {
			var v = this.$image.css('-moz-transform').toString().replace(')', '').split(',');
			this.transOffX = parseInt(v[4]);
			this.transOffY = parseInt(v[5]);
		},


		/*Make sure the dragged position obeying limits
		***********************************************************************************************************************/
		setDraggedPos: function(xp, yp, s, resize) {
			var self = this;
			
			if (xp !== '') {
				self.dX = xp + self.transOffX;
				if (self.pan_limit) {
					self.dX = self.dX + (s * self.iW) < self.sW ? self.sW - (s * self.iW) : self.dX;
					self.dX = self.dX > 0 ? 0 : self.dX;
					if ((s * self.iW) < self.sW) {
						self.dX = (self.sW - (s * self.iW)) / 2;
					}
				} else {
					self.dX = self.dX + (s * self.iW) < self.sW / 2 ? (self.sW / 2) - (s * self.iW) : self.dX;
					self.dX = self.dX > self.sW / 2 ? self.sW / 2 : self.dX;
				}
			}
			if (yp !== '') {
				self.dY = yp + self.transOffY;
				if (self.pan_limit) {
					self.dY = self.dY + (s * self.iH) < self.sH ? self.sH - (s * self.iH) : self.dY;
					self.dY = self.dY > 0 ? 0 : self.dY;
					if ((s * self.iH) < self.sH) {
						self.dY = (self.sH - (s * self.iH)) / 2;
					}
				} else {
					self.dY = self.dY + (s * self.iH) < self.sH / 2 ? (self.sH / 2) - (s * self.iH) : self.dY;
					self.dY = self.dY > self.sH / 2 ? self.sH / 2 : self.dY;
				}
			}
			/*if(!resize){
				//console.log(self.x_diff+' === '+xp);
				self.x_diff = xp;
				self.y_diff = yp;
				self.img_w = self.$image.outerWidth();
				self.img_h = self.$image.outerHeight();
			}*/
		},

		setMaxZoom: function() {
			// OVERRIDE ZOOM MAX VALUE
			var self = this;
			self.zoom_max = self.image_width / self.img_w * self.zoom_max_initial;
			//console.log('setMaxZoom')
		},

		/*Called to animate image transformation whenever the navigation events occur
		***********************************************************************************************************************/
		Animate: function() {

			var self = this;
			var pixTol = 0.5;

			self.cFlag._nd = true;
			self.ani_end = false;
			
			//Zoom In
			if (self.cFlag._zi) {
				if (!self._wheel && !self.zoom_single) {
					self.rA *= self.zoom_speed;
				}
				if (self.rA > self.zoom_max) {
					self.rA = self.zoom_max;
				}
				self.cFlag._nd = false;
				self.cFlag._rs = false;
				self._recent = 'zoomIn';
				self._onfocus = self._dragging = false;
			}

			//Zoom Out
			if (self.cFlag._zo) {
				if (!self._wheel && !self.zoom_single) {
					self.rA /= self.zoom_speed;
				}
				if (self.zoom_min != 0) {
					if (self.rA < self.zoom_min) {
						self.rA = self.zoom_min;
					}					
				} else {					
					if (self.rA < self.rF) {
						self.rA = self.rF;
					}
				}
				
				self.cFlag._nd = false;
				self.cFlag._rs = false;
				self._recent = 'zoomOut';
				self._onfocus = self._dragging = false;
			}
			
			//Zoom In or Out - Single Step
			if (self.zoom_single && !self.cFlag._rs) {
				if (self._recent == 'zoomIn') {
					self.sRed += (10 - self.sRed) / 6;
					self.rA += (self.zoom_max - self.rA) / (((1 / (self.pan_speed_o + 1)) * self.sRed) + 1);

				} else if (self._recent == 'zoomOut') {
					self.sRed += (3 - self.sRed) / 3;
					self.rA += (self.rF - self.rA) / (((1 / self.pan_speed_o + 1) * self.sRed) + 1);
				}
			}
			
			//Pan speed needs to adjust according to application dimension and zoom level
			self.pan_speed = (Math.max(1, 1 + ((self.sW + self.sH) / 500)) + (self.pan_speed_o * self.pan_speed_o / 4)) / Math.max(1, self.rA / 2);

			//Move Left
			if (self.cFlag._ml) {
				self.oX -= self.pan_speed;
				self.cFlag._nd = false;
				self.cFlag._rs = false;
				self._recent = 'left';
				self._onfocus = self._dragging = false;
			}

			//Move Right
			if (self.cFlag._mr) {
				self.oX += self.pan_speed;
				self.cFlag._nd = false;
				self.cFlag._rs = false;
				self._recent = 'right';
				self._onfocus = self._dragging = false;
			}

			//Move Up
			if (self.cFlag._mu) {
				self.oY -= self.pan_speed;
				self.cFlag._nd = false;
				self.cFlag._rs = false;
				self._recent = 'up';
				self._onfocus = self._dragging = false;
			}

			//Move Down
			if (self.cFlag._md) {
				self.oY += self.pan_speed;
				self.cFlag._nd = false;
				self.cFlag._rs = false;
				self._recent = 'down';
				self._onfocus = self._dragging = false;
			}

			//Reset
			if (self.cFlag._rs) {				
				self.oX += (self.fX - self.oX) / 8;
				self.oY += (self.fY - self.oY) / 8;				
				self.cFlag._nd = false;
				self._recent = 'reset';
				self._onfocus = self._dragging = false;
			}

			//Find scale value, width and height
			//Case 1: Single Step Zoom
			if (self.zoom_single && (self._recent !== 'reset')) {
				if (self._onfocus) {
					self._sc += (self.rA - self._sc) / self.reduction;
				} else {
					self._sc = self.rA;
				}
			
			//Case 2: Normal Zoom
			} else {
				self._sc += (self.rA - self._sc) / (self.ani_smooth / (self._onfocus ? self.reduction : 1));
			}
			
			self._w = self._sc * self.iW;
			self._h = self._sc * self.iH;

			//Dragging
			if (self._dragging) {
				self.tX = self.dX;
				self.tY = self.dY;
				self.changeOffset(true, true);
			}

			//Check if Zoom In completed
			if (self._recent == 'zoomIn') {
				if (self._w > (self.rA * self.iW) - pixTol && !self.zoom_single) {
					if (self.cFlag._nd) {
						self.ani_end = true;
					}
					self._sc = self.rA;					
				} else if (self._w > (self.zoom_max * self.iW) - pixTol && self.zoom_single) {
					if (self.cFlag._nd) {
						self.ani_end = true;
					}
					self._sc = self.rA = self.zoom_max;					
				}
				if (self.ani_end) {
					self._w = self._sc * self.iW;
					self._h = self._sc * self.iH;
				}

			//Check if Zoom Out completed
			} else if (self._recent == 'zoomOut') {
				if (self._w < (self.rA * self.iW) + pixTol  && !self.zoom_single) {
					if (self.cFlag._nd) {
						self.ani_end = true;
					}
					self._sc = self.rA;					
				} else if (self._w < (self.rF * self.iW) + pixTol  && self.zoom_single) {
					if (self.cFlag._nd) {
						self.ani_end = true;
					}
					self._sc = self.rA = self.rF;					
				}
				if (self.ani_end) {
					self._w = self._sc * self.iW;
					self._h = self._sc * self.iH;
				}
			}

			//Move image according to boundary limits
			self.limitX = (((self._w - self.sW) / (self._w / self.sW)) / 2);
			self.limitY = (((self._h - self.sH) / (self._h / self.sH)) / 2);

			if (!self._dragging) {
				if (self.pan_limit) {
					if (self.oX < -self.limitX - self.focusOffX) {
						self.oX = -self.limitX - self.focusOffX;
					}
					if (self.oX > self.limitX - self.focusOffX) {
						self.oX = self.limitX - self.focusOffX;
					}
					if (self._w < self.sW) {
						self.tX = (self.sW - self._w) / 2;
						self.changeOffset(true, false);
					}
					if (self.oY < -self.limitY - self.focusOffY) {
						self.oY = -self.limitY - self.focusOffY;
					}
					if (self.oY > self.limitY - self.focusOffY) {
						self.oY = self.limitY - self.focusOffY;
					}
					if (self._h < self.sH) {
						self.tY = (self.sH - self._h) / 2;
						self.changeOffset(false, true);
					}
				} else {
					if (self.oX < -self.limitX - (self.focusOffX / self._w * self.sW) - ((self.sW / 2) / (self._w / self.sW))) {
						self.oX = -self.limitX - (self.focusOffX / self._w * self.sW) - ((self.sW / 2) / (self._w / self.sW));
					}

					if (self.oX > self.limitX - (self.focusOffX / self._w * self.sW) + ((self.sW / 2) / (self._w / self.sW))) {
						self.oX = self.limitX - (self.focusOffX / self._w * self.sW) + ((self.sW / 2) / (self._w / self.sW));
					}

					if (self.oY < -self.limitY - (self.focusOffY / self._h * self.sH) - (self.sH / (self._h / self.sH * 2))) {
						self.oY = -self.limitY - (self.focusOffY / self._h * self.sH) - (self.sH / (self._h / self.sH * 2));
					}

					if (self.oY > self.limitY - (self.focusOffY / self._h * self.sH) + (self.sH / (self._h / self.sH * 2))) {
						self.oY = self.limitY - (self.focusOffY / self._h * self.sH) + (self.sH / (self._h / self.sH * 2));
					}
				}
			}
			if (!self._dragging && self._recent != 'drag') {
				self.tX = ((self.sW - self._w) / 2) + self.focusOffX + (self.oX * (self._w / self.sW));
				self.tY = ((self.sH - self._h) / 2) + self.focusOffY + (self.oY * (self._h / self.sH));							
				if (self.ani_smooth === 1) {
					self.cFlag._nd = true;
					self.ani_end = true;
				}
			}
			if (self._recent == 'zoomIn' || self._recent == 'zoomOut' || self.cFlag._rs) {				
				self._x = self.tX;
				self._y = self.tY;
			} else {
				self._x += (self.tX - self._x) / (self.ani_smooth / (self._onfocus ? self.reduction : 1));
				self._y += (self.tY - self._y) / (self.ani_smooth / (self._onfocus ? self.reduction : 1));
			}
			
			//Check if Left movement completed
			if (self._recent == 'left') {
				if (self._x < self.tX + pixTol || self.ani_smooth === 1) {
					self.cFlag._nd ? self.ani_end = true : '';
					self._recent = '';
					self._x = self.tX;
				}

			//Check if Right  movement completed
			} else if (self._recent == 'right') {
				if (self._x > self.tX - pixTol || self.ani_smooth === 1) {
					self.cFlag._nd ? self.ani_end = true : '';
					self._recent = '';
					self._x = self.tX;
				}

				//Check if Up movement completed
			} else if (self._recent == 'up') {
				if (self._y < self.tY + pixTol || self.ani_smooth === 1) {
					self.cFlag._nd ? self.ani_end = true : '';
					self._recent = '';
					self._y = self.tY;
				}

				//Check if Down movement completed
			} else if (self._recent == 'down') {
				if (self._y > self.tY - pixTol || self.ani_smooth === 1) {
					self.cFlag._nd ? self.ani_end = true : '';
					self._recent = '';
					self._y = self.tY;
				}

				//Check if Dragging completed
			} else if (self._recent == 'drag') {
				if (self._x + pixTol >= self.tX && self._x - pixTol <= self.tX && self._y + pixTol >= self.tY && self._y - pixTol <= self.tY || self.ani_smooth === 1) {
					if (self._onfocus) {
						self._dragging = false;
					}
					self.cFlag._nd ? self.ani_end = true : '';
					self._recent = '';
					self._x = self.tX;
					self._y = self.tY;
				}
			}

			//Check if Reset completed
			if (self.cFlag._rs && self._w + pixTol >= (self.rA * self.iW) && self._w - pixTol <= (self.rA * self.iW) && self.oX <= self.fX + pixTol && self.oX >= self.fX - pixTol && self.oY <= self.fY + pixTol && self.oY >= self.fY - pixTol) {
				self.ani_end = true;
				self._recent = '';
				self.cFlag._rs = false;
				self.cFlag._nd = true;
				self._x = self.tX;
				self._y = self.tY;
				self._sc = self.rA;
				self._w = self._sc * self.iW;
				self._h = self._sc * self.iH;
			}

			//When the image fits exactly to container size, disable the pan, zoom out and reset buttons
			if (self.rA == self.rF && self.iW * self.rA <= self.sW && self.iH * self.rA <= self.sH) {
				if (self.buttons[1].$ob.css('opacity') > 0.5) {
					if (self.rA >= self.rF && (self.init_zoom == '' || self.rA < self.init_zoom) && (self.zoom_min == '' || self.rA < self.zoom_min)) {
						if (self.pan_limit && self._moveCursor && !self._moveCursor) {
							self.$image.css('cursor', 'default');
							self.$hitArea.css('cursor', 'default');
						}
						for (var bEn = 1; bEn < (self.pan_limit && !self._moveCursor ? self.buttons_total : 2); bEn++) {
							self.buttons[bEn].$ob.css({
								'opacity': 0.4,
							});
							self._wheel = false;
							self.$holder.find('#' + self.buttons[bEn]._var + 'norm').show();
							self.$holder.find('#' + self.buttons[bEn]._var + 'over').hide();
						}
					}
				}

			} else {
				if (self.buttons[1].$ob.css('opacity') < 0.5) {
					if (self._moveCursor && self.mouse_drag) {
						self.$image.css('cursor', 'move');
						self.$hitArea.css('cursor', 'move');
					}
					for (var bEn = 1; bEn < self.buttons_total; bEn++) {
						self.buttons[bEn].$ob.css('opacity', 0.7);
					}
				}
			}

			//When the image reaches max zoom, disable the zoom button
			if (self.rA == self.zoom_max) {
				if (self.buttons[0].$ob.css('opacity') > 0.5) {
					self.buttons[0].$ob.css('opacity', 0.4);
					self._wheel = false;
					self.$holder.find('#' + self.buttons[0]._var + 'norm').show();
					self.$holder.find('#' + self.buttons[0]._var + 'over').hide();
				}

			} else {
				if (self.buttons[0].$ob.css('opacity') < 0.5) {
					self.buttons[0].$ob.css('opacity', 0.7);
				}
			}
			
			//Apply Scale and position to the image:
			if (prop_transform) {
				self.$image.css(prop_transform, 'translate(' + self._x.toFixed(14) + 'px,' + self._y.toFixed(14) + 'px) scale(' + self._sc + ')');
				//self.$image.css(prop_transform, 'translate3d(' + self._x.toFixed(14) + 'px,' + self._y.toFixed(14) + 'px, 0) scale(' + self._sc + ') translateZ(0)');
			} else {
				self.$image.css({
					left: self._x,
					top: self._y,
					width: self._w,
					height: self._h,
				});
			}

			if (self.$loc_cont) {
				self.updateLocations(self._x, self._y, self._sc, self.locations);
			}

			//In case image Maps used, update them
			if (!prop_transform && self.map_coordinates.length > 0) {
				 self.updateMap();
			}	
			//If the animation completed, stop running; else continue	
			if (self.ani_end && !self._dragging && self._recent != 'drag') {				
				self._playing = false;				
				self._recent = '';
				self.cX = (-self._x + (self.sW / 2)) / self.rA;
				self.cY = (-self._y + (self.sH / 2)) / self.rA;
				if (self.onUPDATE) {
					self.onUPDATE(self.getZoomData(), false);
				}
				if (self.onZOOM_PAN) {
					self.onZOOM_PAN(self.getZoomData());
				}
				clearTimeout(self.ani_timer);

				//Set new window resize values
				self.x_diff = self._x.toFixed(14);
				self.y_diff = self._y.toFixed(14);
				self.img_w = self.$image.outerWidth();
				self.img_h = self.$image.outerHeight();
			} else {				
				self._playing = true;
				if (self.onUPDATE) {
					self.onUPDATE(self.getZoomData(), true);
				}
				self.ani_timer = setTimeout(function() {
					self.Animate();
				}, 28);
			}
		},
		
		
		/*Relocate the landmarks according to main image's position
		***********************************************************************************************************************/
		updateLocations: function(_x, _y, _sc, loc) {	
		
			if (this.onLANDMARK !== '') {
				if (_sc >= this.show_at_zoom) {
					if (!this._landmark) {
						this._landmark = true;
						this.onLANDMARK(true);	
					}
				} else {
					if (this._landmark) {
						this._landmark = false;
						this.onLANDMARK(false);
					}
				}
			}
								
			for (var p = 0; p < loc.length; p++) {
				var wScaled,
					hScaled,
					lpx = (loc[p].x * _sc) + _x,
					lpy = (loc[p].y * _sc) + _y;
					
				if (_sc >= loc[p].showAt) {	
					if (loc[p].scale && prop_transform) {
						wScaled = loc[p].w2pad * this._sc;
						hScaled = loc[p].h2 * this._sc;
					} else {
						wScaled = loc[p].w2pad;
						hScaled = loc[p].h2;
					}
					if (lpx > -wScaled && lpx < this.sW + wScaled && ((lpy > -hScaled && lpy < this.sH + hScaled && loc[p].lab) || (lpy > 0 && lpy < this.sH + (hScaled * 2) && !loc[p].lab))) {
						if (!loc[p].vis) {
							loc[p].vis = true;							
							if (prop_transform) {											
								loc[p].ob.stop()
									.css('display', 'block')
									.animate({
										opacity: 1,
									}, 300);
							} else {
								loc[p].ob.show();
							}
						}
					} else {
						if (loc[p].vis) {
							loc[p].vis = false;
							if (prop_transform) {
								loc[p].ob.stop()
									.animate({
										opacity: 0,
									}, 200, function() {
										$(this).hide();
									});
							} else {
								loc[p].ob.hide();								
							}
						}
					}			
				} else {					
					if (loc[p].vis) {	
						loc[p].vis = false;
						if (prop_transform) {
							loc[p].ob.stop()
								.animate({
									opacity: 0,
								}, 200, function() {
									$(this).hide();
								});
						} else {
							loc[p].ob.hide();								
						}
					}	
				}
				if (lpx !== loc[p].lpx || lpy !== loc[p].lpy && loc[p].vis) {					
					if (prop_transform) {
						loc[p].ob.css(prop_transform, 'translate(' + lpx.toFixed(14) + 'px,' + lpy.toFixed(14) + 'px)' + (loc[p].scale ? ' scale(' + this._sc + ')' : ''));						
					} else {						
						loc[p].ob.css({
							left: lpx,
							top: lpy,						
						});
					}
				}
				loc[p].lpx = lpx;
				loc[p].lpy = lpy;
			}
		},
		

		/*If the broswer doesn't supports css border radius, we need to go with old school png image for rounded corner
		***********************************************************************************************************************/
		roundBG: function(el, _name, _w, _h, _r, _p, _c, _i, _z, _yoff) {
			var w = 50 / 2;
			
			el.append($(
				'<div class="bgi' + _name + '" style="background-position:' + (-(_p - _r)) + 'px ' + (-(w - _r) - _yoff) + 'px"></div>\
				<div class="bgh' + _name + '"></div>\
				<div class="bgi' + _name + '" style="background-position:' + (-_p) + 'px ' + (-(w - _r) - _yoff) + 'px; left:' + (_w - _r) + 'px"></div>\
				<div class="bgi' + _name + '" style="background-position:' + (-(_p - _r)) + 'px ' + (-w - _yoff) + 'px; top:' + (_h - _r) + 'px"></div>\
				<div class="bgh' + _name + '" style = "top:' + (_h - _r) + 'px; left:' + _r + 'px"></div>\
				<div class="bgi' + _name + '" style="background-position:' + (-_p) + 'px ' + (-w - _yoff) + 'px; top:' + (_h - _r) + 'px; left:' + (_w - _r) + 'px"></div>\
				<div class="bgc' + _name + '"></div>'	
			));
			$('.bgi' + _name).css({
				position: 'absolute',
				width: _r,
				height: _r,
				'background-image': 'url(' + _i + ')',
				'background-repeat': 'no-repeat',
				'-ms-filter': 'progid:DXImageTransform.Microsoft.gradient(startColorstr=#00FFFFFF,endColorstr=#00FFFFFF)',
				'filter': 'progid:DXImageTransform.Microsoft.gradient(startColorstr=#00FFFFFF,endColorstr=#00FFFFFF)',
				'zoom': 1,
			});
			$('.bgh' + _name).css({
				position: 'absolute',
				width: _w - _r * 2,
				height: _r,
				'background-color': _c,
				left: _r,
			});
			$('.bgc' + _name).css({
				position: 'absolute',
				width: _w,
				height: _h - _r * 2,
				'background-color': _c,
				top: _r,
				left: 0,
			});
		},
		
		
		/*To calibrate position offset when navigation events supposed to be overlapped 
		***********************************************************************************************************************/
		changeOffset: function(x, y) {
			if (x) this.oX = (this.tX - ((this.sW - this._w) / 2) - this.focusOffX) / (this._w / this.sW);
			if (y) this.oY = (this.tY - ((this.sH - this._h) / 2) - this.focusOffY) / (this._h / this.sH);
		},
		

		/*Transform Image Maps (hot spots) if any
		***********************************************************************************************************************/
		updateMap: function() {
			var self = this,
				mapId = 0;
				
			self.mapAreas.each(function() {
				var new_vals = [];
				for (var i = 0; i < self.map_coordinates[mapId].length; i++) {
					new_vals[i] = self.map_coordinates[mapId][i] * self._sc;
				}
				new_vals = new_vals.join(',');
				$(this).attr('coords', new_vals);
				mapId++;
			});
		},
		

		/*To stop the timer loops immediatly
		***********************************************************************************************************************/
		haltAnimation: function() {
			clearTimeout(this.ani_timer);
			this._playing = false;
			this._recent = '';
		},


		/*Method to Remove the plugin instance
		***********************************************************************************************************************/
		destroy: function() {
			var self = this;
			
			if (self.assetsLoaded) {
				self.haltAnimation();
				for (prop in self.orig_style) {
					if (self.orig_style[prop][0] !== false && self.orig_style[prop][0] !== undefined) {
						if (self.orig_style[prop][0] === 'width' || self.orig_style[prop][0] === 'height') {
							if (parseInt(self.orig_style[prop][1]) !== 0) {
								self.$image.css(self.orig_style[prop][0], self.orig_style[prop][1]);
							}
						} else {
							self.$image.css(self.orig_style[prop][0], self.orig_style[prop][1]);
						}
					}
				}
				clearTimeout(self.auto_timer);
				$(document).off('.sz' + self.id);
				$(window).off('.sz' + self.id);
				self.$holder.off('.sz');
				self.$controls = undefined;
			} else {
				self.$image.show();
			}		
				
			if (self.container == '') {
				if (self.image_url == '') {
					self.$image.insertBefore(self.$holder);
					if (self.$holder !== undefined) {
						self.$holder.remove();
					}
				} else {
					self.$elem.empty();
					if (self.$loc_cont[0]) {
						self.$elem.append(self.loc_clone);
					}
				}
			} else {
				self.$image.insertBefore(self.$holder);	
				self.$holder.empty();								
				self.$image.wrap(self.$holder);
				if (self.$loc_cont[0]) {
					self.$holder.append(self.loc_clone);
				}
			}
			self.$elem.removeData('smoothZoom');
			self.$holder = undefined;
			self.Buttons = undefined;
			self.op = undefined;
			self.$image = undefined;
		},
	
	
		/*Method to change focus point and level
		***********************************************************************************************************************/
		focusTo: function(params) {
			var self = this;

			self.setMaxZoom();

			// OVERRIDE MAX ZOOM VALUE
			if(params.zoom_max) self.zoom_max = params.zoom_max;
			
			if (self.assetsLoaded) {			
				if (params.zoom === undefined || params.zoom === '' || params.zoom == 0) {
					params.zoom = self.rA;
				} else {
					params.zoom /= 100;
				}
				self._onfocus = true;
				if (params.zoom > self.rA && self.rA != self.zoom_max) {
					self.rA = params.zoom;
					self.rA = self.rA > self.zoom_max ? self.zoom_max : self.rA;
				} else if (params.zoom < self.rA && self.rA != self.rF) {
					self.rA = params.zoom;
					self.rA = self.rA < self.rF ? self.rF : self.rA;
				}
				self.transOffX = self.transOffY = 0;
				self.setDraggedPos(params.x === undefined || params.x === '' ? '' : (-params.x * self.rA) + (self.sW / 2), params.y === undefined || params.y === '' ? '' : (-params.y * self.rA) + (self.sH / 2), self.rA);
				self.reduction =  params.speed ? params.speed / 10 : self.focusSpeed;
				self._recent = 'drag';
				self._dragging = true;
				if (!self._playing) {
					self.Animate();
				}
			}
		},		

		zoomIn: function(params) {
			this.buttons[0].$ob.trigger(this.event_down, {
				id: 0,
			});
		},

		zoomOut: function(params) {
			this.buttons[1].$ob.trigger(this.event_down, {
				id: 1,
			});
		},

		moveRight: function(params) {
			this.buttons[2].$ob.trigger(this.event_down, {
				id: 2,
			});
		},

		moveLeft: function(params) {
			this.buttons[3].$ob.trigger(this.event_down, {
				id: 3,
			});
		},

		moveUp: function(params) {
			this.buttons[4].$ob.trigger(this.event_down, {
				id: 4,
			});
		},

		moveDown: function(params) {
			this.buttons[5].$ob.trigger(this.event_down, {
				id: 5,
			});
		},

		Reset: function(params) {
			this.buttons[6].$ob.trigger(this.event_down, {
				id: 6,
			});
		},				

		getZoomData: function(params) {
			return {
				//x offset (without scale ratio multiplied)
				normX: (-this._x / this.rA).toFixed(14),				
				
				//y offset (without scale ratio multiplied)
				normY: (-this._y / this.rA).toFixed(14),
				
				//Original image Width
				normWidth: this.iW,
				
				//Original image height
				normHeight: this.iH,
				
				//x offset (with scale ratio multiplied)
				scaledX: -this._x.toFixed(14),
				
				//y offset (with scale ratio multiplied)
				scaledY: -this._y.toFixed(14),
				
				//Scaled image width
				scaledWidth: this._w,
				
				//Scaled image height
				scaledHeight: this._h,
							
				//The X location on image which is currently on center of canvas 
				centerX: (-this._x.toFixed(14) + (this.sW / 2)) / this.rA,
				
				//The Y location on image which is currently on center of canvas 
				centerY: (-this._y.toFixed(14) + (this.sH / 2)) / this.rA,
				
				//Scale ratio
				ratio: this.rA, 
			};
		},
		
		addLandmark: function(loc) {
			if (this.$loc_cont) {				
				var total = loc.length;
				
				for (var i = 0; i < total; i++) {
					var $loc = $(loc[i]);
					this.$loc_cont.append($loc);
					this.setLocation($loc);						
				}	
							
				if (total > 0) {
					this.updateLocations(this._x, this._y, this._sc, this.locations);	
				}
			}
		},
		
		attachLandmark: function(loc) {
			if (this.$loc_cont) {				
				var total = loc.length;				
				for (var i = 0; i < total; i++) {					
					this.setLocation(loc[i] instanceof jQuery ? loc[i] : $('#' + loc[i]));		
				}
				if (total > 0) {
					this.updateLocations(this._x, this._y, this._sc, this.locations);
				}
			}			
		},
		
		removeLandmark: function(loc) {
			if (this.$loc_cont) {				
				if (loc) {			
					var total = loc.length;					
					for (var i = 0; i < total; i++) {
						for (var j = 0; j < this.locations.length; j++) {
							if ((loc[i] instanceof jQuery && this.locations[j].ob[0] == loc[i][0]) || (!(loc[i] instanceof jQuery) && this.locations[j].ob.attr('id') == loc[i])) {							
								this.locations[j].ob.remove();
								this.locations.splice(j, 1);
								j--;						
							} 
						}
					}
				} else {
					if (this.locations.length > 0) {
						this.locations[this.locations.length - 1].ob.remove();
						this.locations.pop();
					}
				}
				if (total > 0) {
					this.updateLocations(this._x, this._y, this._sc, this.locations);
				}
			}			
		},
		
		refreshAllLandmarks: function() {
			var self = this;
			var locs = self.$loc_cont.children('.item');
			self.show_at_zoom = parseInt(self.$loc_cont.data('show-at-zoom'), 10) / 100;
			self.allow_scale = checkBoolean(self.$loc_cont.data('allow-scale'));
			self.allow_drag = checkBoolean(self.$loc_cont.data('allow-drag'));
				
			//Step 1: Remove records for which the elements no longer exist
			for (var i = 0; i < self.locations.length; i++) {					
				var exists = false;					
				locs.each(function() {
					if (self.locations[i].ob[0] == $(this)[0]) {
						exists = true;	
					}
				});					
				if (!exists) {
					self.locations.splice(i, 1);
					i--;
				}
			}	
			
			//Step 2: Add new elements to record
			locs.each(function() {
				var exists = false;		
				for (var i = 0; i < self.locations.length; i++) {					
					if (self.locations[i].ob[0] == $(this)[0]) {
						exists = true;	
						break;
					}
				}
				if (!exists) {
					self.setLocation($(this));	
				}
	
			});					
			this.updateLocations(this._x, this._y, this._sc, this.locations);
		},
		
		
		/*On windows resize, adjust some defaults
		***********************************************************************************************************************/
		resize: function(e) {	
			var self;
			
			if (e.data) {	
				e.preventDefault();			
				self = e.data.self;			
				var pw = self.$holder.parent().width();	
				var ph = self.$holder.parent().height();	
										
				if (self.oW) {
					pw = Math.min(pw, self.oW);												
				}				
				self.sW = pw;
				
				if (self.oH) {
					if (self.oW && self.maintain_ratio) {
						self.sH = pw / (self.oW / self.oH);			
					}					
				} else {
					self.sH = ph;
				}
						
				
			}  else {
				self = this;
				if (e.width) {
					self.sW = e.width;
				}
				if (e.height) {
					self.sH = e.height;
				}
				if (e.max_WIDTH) {
					self.w_max = e.max_WIDTH;
				}
				if (e.max_HEIGHT) {
					self.h_max = e.max_HEIGHT;
				}
			}			
			if (self.w_max !== 0 && self.w_max !== '') {
				self.sW = Math.min(self.sW, self.w_max);
			}
			if (self.h_max !== 0 && self.h_max !== '') {
				self.sH = Math.min(self.sH, self.h_max);
			}
			self.$holder.css({
				'width': self.sW,
				'height': self.sH,
			});

			self.setMaxZoom();

			if (self.bord_size > 0) {
				self.border[0].height(self.sH);
				self.border[1].css({
					height: self.sH,
					left: self.sW - self.bord_size,
				});
				self.border[2].width(self.sW - (self.bord_size * 2));
				self.border[3].css({
					width: self.sW - (self.bord_size * 2),
					top: self.sH - self.bord_size,
				});
			}			
			if (self.bu_align[1] == 'center') {
				self.$controls.css('left', parseInt((self.sW - self.cBW) / 2));
			}
			if (self.bu_align[0] == 'center') {
				self.$controls.css('top', parseInt((self.sH - self.cBH) / 2));
			}
			self.rF = self.rR = self.checkRatio(self.sW, self.sH, self.iW, self.iH, self.zoom_fit);
			if (self.zoom_min == 0) {				
				if (self.rA < self.rF) {
					self.rA = self.rF;
				}
			}

			//Set values to keep center focused

			var img_p = self.$image.position();
			var img_w = self.$image.outerWidth();
			var img_h = self.$image.outerHeight();

			var img_x = (parseFloat(self.x_diff || img_p.left) / (self.img_w || img_w) * img_w);
			var img_y = (parseFloat(self.y_diff || img_p.top) / (self.img_h || img_h) * img_h);

			if(self.resizeInit){
				self.setDraggedPos(img_x, img_y, self._sc, true);
				self._recent = 'drag';
				self._dragging = true;
				if (!self._playing) {
					self.Animate();
				}
			}else{
				//clearTimeout(self.ani_timer);
				self.resizeInit = true;
				self.img_w = img_w;
				self.img_h = img_h;
				self.x_diff = img_p.left;
				self.y_diff = img_p.top;
			}

			clearTimeout(self.resizeTimer);
			self.resizeTimer = setTimeout(function(){
				//self._playing = false;
				self._dragging = false;
			},100);
			
			/*self.focusTo({
				x: self.cX,
				y: self.cY,
				zoom:'',
				speed: 10,
			});*/			
		},
	};


	$.fn.smoothZoom = function(params) {		
		var self = this;		
		var l = self.length;
		
		//For single or more than one plugin instance
		for (var i = 0; i < l; i++) {
			var $elem = $(self[i]);
			var instance = $elem.data('smoothZoom');
			
			// Case 1: Initiate the plugin if not already have an instance
			if (!instance) {
		
				if (typeof params === 'object' || !params) {
					$elem.data('smoothZoom', new Zoomer($elem, params));				
				}
			
			// Case 2: If the instance already available - Check for method call
			} else {	

				// getZoomData - Returns {sourceX, sourceY, sourceWidth, sourceHeight, distX, distY, distWidth, distHeight, centerX, centerY, ratio}				
				if (params == 'getZoomData') {				
					return instance[params].apply(instance, Array.prototype.slice.call(arguments, 1));
					
				// destroy | focusTo | zoomIn | zoomOut | moveRight| moveLeft | moveUp | moveDown | Reset | addLandmark | removeLandmark | attachLandmark | refreshAllLandmarks
				} else if (instance[params]) {
					instance[params].apply(instance, Array.prototype.slice.call(arguments, 1));
				}
			}					
		}	
		
		//return for chainability for possible cases
		if (params !== 'getZoomData') {
			return this;
		}
	};
	
	function checkBoolean(_var) {
		if (_var === true) {
			return true;
		} else if (_var) {
			_var = _var.toLowerCase();
			if (_var == 'yes' || _var == 'true') {
				return true;
			}
		}
		return false;
	}
	
	
	//...................................................................................................................
	//Using Modernizr to check browser capabilities and property names prefixed
	
	/* Modernizr 2.5.3 (Custom Build) | MIT & BSD
	 * Build: http://www.modernizr.com/download/#-borderradius-csstransforms-csstransforms3d-touch-prefixed-teststyles-testprop-testallprops-prefixes-domprefixes
 	*/
	//var Modernizr=function(a,b,c){function y(a){i.cssText=a}function z(a,b){return y(l.join(a+";")+(b||""))}function A(a,b){return typeof a===b}function B(a,b){return!!~(""+a).indexOf(b)}function C(a,b){for(var d in a)if(i[a[d]]!==c)return b=="pfx"?a[d]:!0;return!1}function D(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:A(f,"function")?f.on(d||b):f}return!1}function E(a,b,c){var d=a.charAt(0).toUpperCase()+a.substr(1),e=(a+" "+n.join(d+" ")+d).split(" ");return A(b,"string")||A(b,"undefined")?C(e,b):(e=(a+" "+o.join(d+" ")+d).split(" "),D(e,b,c))}var d="2.5.3",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j,k={}.toString,l=" -webkit- -moz- -o- -ms- ".split(" "),m="Webkit Moz O ms",n=m.split(" "),o=m.toLowerCase().split(" "),p={},q={},r={},s=[],t=s.slice,u,v=function(a,c,d,e){var h,i,j,k=b.createElement("div"),l=b.body,m=l?l:b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:g+(d+1),k.appendChild(j);return h=["&#173;","<style>",a,"</style>"].join(""),k.id=g,(l?k:m).innerHTML+=h,m.appendChild(k),l||(m.style.background="",f.appendChild(m)),i=c(k,a),l?k.parentNode.removeChild(k):m.parentNode.removeChild(m),!!i},w={}.hasOwnProperty,x;!A(w,"undefined")&&!A(w.call,"undefined")?x=function(a,b){return w.call(a,b)}:x=function(a,b){return b in a&&A(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=t.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(t.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(t.call(arguments)))};return e});var F=function(c,d){var f=c.join(""),g=d.length;v(f,function(c,d){var f=b.styleSheets[b.styleSheets.length-1],h=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"",i=c.childNodes,j={};while(g--)j[i[g].id]=i[g];e.touch="ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch||(j.touch&&j.touch.offsetTop)===9,e.csstransforms3d=(j.csstransforms3d&&j.csstransforms3d.offsetLeft)===9&&j.csstransforms3d.offsetHeight===3},g,d)}([,["@media (",l.join("touch-enabled),("),g,")","{#touch{top:9px;position:absolute}}"].join(""),["@media (",l.join("transform-3d),("),g,")","{#csstransforms3d{left:9px;position:absolute;height:3px;}}"].join("")],[,"touch","csstransforms3d"]);p.touch=function(){return e.touch},p.borderradius=function(){return E("borderRadius")},p.csstransforms=function(){return!!E("transform")},p.csstransforms3d=function(){var a=!!E("perspective");return a&&"webkitPerspective"in f.style&&(a=e.csstransforms3d),a};for(var G in p)x(p,G)&&(u=G.toLowerCase(),e[u]=p[G](),s.push((e[u]?"":"no-")+u));return y(""),h=j=null,e._version=d,e._prefixes=l,e._domPrefixes=o,e._cssomPrefixes=n,e.testProp=function(a){return C([a])},e.testAllProps=E,e.testStyles=v,e.prefixed=function(a,b,c){return b?E(a,b,c):E(a,"pfx")},e}(this,this.document);
	
	var prop_transform = Modernizr.prefixed('transform');
	var prop_origin = Modernizr.prefixed('transformOrigin');
	var prop_radius = Modernizr.prefixed('borderRadius');
	var supportsTrans3D = Modernizr.csstransforms3d;
	//var supportsTouch = Modernizr.touch;
	var supportsTouch = $('html.screen--is-touch').length;
	
//})(jQuery, window, document);


	};

	init();	return api;
};

//End - smoothZoom

//...................................................................................................................
//For mouse wheel support

/*! Copyright (c) 2011 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.0.6
 * 
 * Requires: 1.2.2+
 */
//(function(a){function d(b){var c=b||window.event,d=[].slice.call(arguments,1),e=0,f=!0,g=0,h=0;return b=a.event.fix(c),b.type="mousewheel",c.wheelDelta&&(e=c.wheelDelta/120),c.detail&&(e=-c.detail/3),h=e,c.axis!==undefined&&c.axis===c.HORIZONTAL_AXIS&&(h=0,g=-1*e),c.wheelDeltaY!==undefined&&(h=c.wheelDeltaY/120),c.wheelDeltaX!==undefined&&(g=-1*c.wheelDeltaX/120),d.unshift(b,e,g,h),(a.event.dispatch||a.event.handle).apply(this,d)}var b=["DOMMouseScroll","mousewheel"];if(a.event.fixHooks)for(var c=b.length;c;)a.event.fixHooks[b[--c]]=a.event.mouseHooks;a.event.special.mousewheel={setup:function(){if(this.addEventListener)for(var a=b.length;a;)this.addEventListener(b[--a],d,!1);else this.onmousewheel=d},teardown:function(){if(this.remove_eventListener)for(var a=b.length;a;)this.remove_eventListener(b[--a],d,!1);else this.onmousewheel=null}},a.fn.extend({mousewheel:function(a){return a?this.on("mousewheel",a):this.trigger("mousewheel")},unmousewheel:function(a){return this.off("mousewheel",a)}})})(jQuery)

//...................................................................................................................

app.globalExt['tooltip'] = function() {
	var api = {};

	var $win	= app.vars.$win;
    var $doc	= app.vars.$doc;
	var $body	= app.vars.$body;

	var templates = {
		tooltip: '<span class="tooltip"><span class="tooltip__inner">{{text}}</span></span>',
	};

	var classes = {
		tooltip: '.tooltip',
		selector: '[data-tooltip]',
	};

	var init = function() {
		addListeners();
	};

	var addListeners = function() {
		$doc.on('mouseenter touchend', classes.selector, tooltipToogle);
        $doc.on('mouseleave', classes.selector, tooltipHide);
        $doc.on('touchend', tooltipHide);
	};

	var tooltipToogle = function(e) {
        //e.preventDefault();
        //e.stopImmediatePropagation();
        e.stopPropagation();
        var $target = $(e.currentTarget);
            
        //console.log($target);
        
        if($target.data('tooltip')) {
		    tooltipShow($target);
        }
	};

	var tooltipHide = function(e) {
        $(classes.tooltip).remove();
    }
    var tooltipShow = function($target) {
		var template = templates.tooltip;
        var pos = $target.offset();
        var top = Math.round(pos.top + $target.outerHeight());
        var left = pos.left + $target.outerWidth() / 2;

		$template = $(template.replace('{{text}}', $target.data('tooltip')));
		$body.append($template);

        var w = $template.outerWidth();
        left = Math.max(0, Math.min($win.innerWidth() - w, Math.round(left - w / 2)));
        $template.css('left', left).css('top', top);
	};

	init();	return api;
};

app.globalExt['tracking'] = function() {
	var api = {};

	var init = function() {
		window.dataLayer = window.dataLayer || [];

		// UTM PARAMS
		var utm_source = app.vars.urlParam['utm_source'];

		if(utm_source){
			var utm_params = ['utm_source','utm_campaign','utm_medium','utm_content','utm_term'];
			var utm = {};

			for(var i=0; i<utm_params.length; i++){
				var p = utm_params[i];
				var v = app.vars.urlParam[p];
				if(v) utm[p] = v;
			};

			// SET UTM COOKIE
			Cookies.set(app.vars.utm.cookie_name, utm, {expires: 1});
		}
	};

	api.track = function(data){
		if(typeof window.dataLayer !== 'undefined'){
			const defaultData = {
				category: '-',
				action: '-',
				label: '-',
				value: '-',
				platform: 'ga_event',
				event: false,
				attributes: false,
			}
			const fullData = Object.assign(defaultData, data)
			const eventData = {
				event: fullData.event || fullData.platform,
			};
			if (fullData.category !== '-') eventData.category = fullData.category;
			if (fullData.action !== '-') eventData.action = fullData.action;
			if (fullData.label !== '-') eventData.label = fullData.label === 'path' ? window.location.pathname : fullData.label;
			if (fullData.value !== '-') eventData.value = fullData.value;
			if(fullData.attributes) eventData.attributes = fullData.attributes

			console.log(eventData)

			window.dataLayer.push(eventData);
		}
	};

	init();	return api;
};
app.ext['search'] = function($el) {
	
	// =======================================
	//  VARS
	// =======================================

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var api = {
		isOpen: false,
		isOpened: false,
	};

	// =======================================
	//  TRANSLATIONS
	// =======================================
	
		// CMS GENERATED JSON OBJECTS
		if (typeof documentCategories === 'undefined') {
			documentCategories = {};
		}
		if (typeof mediaCategories === 'undefined') {
			mediaCategories = {};
		}
		if (typeof documentCategoriesOrder === 'undefined') {
			documentCategoriesOrder = {};
		}
	
		// TRANSLATIONS
		var tl = app.tl;
	
		// FILTER FACETS - TITLE / ORDER
		var filter_titles = api.filter_titles = {
			'year':								'Year',
			'month':							'Month',
			'media_type':						'Media type',
			'category':							'Category',
			'company':							'Company',
			'country':							'Country',
			'type':								'Type',
			'location':							'Location',
			'application_type': 				'Application',
			'language.label': 					'Language',
	
			// NEWS
			'type.label':						'Type',
			'categories.title':					'Category',
	
			// BLOG
			'tags.title':						'Tags',
			'locationID':						'Location',
	
			// PRODUCTS
			'properties.computed.region':		'Country',
			'properties.imported.brandn_name':	'Brand',
			'properties.imported.matman':		'Material',
			'properties.imported.matsub':		'Submaterial',
			'properties.imported.indman':		'Industry',
			'properties.imported.indsub':		'Subindustry',
			'properties.imported.proman':		'Subprocess',
			'properties.imported.prosub':		'Process',
			//'properties.imported.melwei_val':	'MFR',
			'properties.imported.melval':		'MFR',
			'properties.imported.denval_val':	'Density',
	
			// MEDIA
			'filters.media.1':					'Category',
	
			// DOCUMENTS
			'filters.documents.1':				'Category',
	
			// VIDEOS
			'filters.videos.1':					'Category',
		};
	
		var filter_titles_variants = {
			'documents': {
				'type':							'Document Type',
			},
			'jobs': {
				'type':							'Contract',
			}
		};
	
		// FILTER FACETS - UNITS
		var filter_units = api.filter_units = {
			'properties.imported.melval':		tl('g/10min'),
			'properties.imported.denval_val':	tl('kg/m³'),
		};

	// =======================================
	//  TEMPLATES
	// =======================================
	var tpl = (api.tpl = {
	  params: {
	    media:
	      'data-media-img="###data-img###" \
							data-media-title="###data-title###" \
							data-media-copy="###data-copy###" \
							data-media-desc="###data-desc###" ',
	
	    video: 'data-type="###videoType###" \
							data-video-id="###video###" ',
	
	    download: 'data-id="###id###" \
							data-title="###title###" \
							data-url="" ',
	  },
	  all: {
	    title: "<li>###title###</li>",
	    imgs: '<span class="search__categories__images">###imgs###</span>',
	    img: '<span class="search__categories__image" style="background-image: url(###img###)"></span>',
	  },
	  button: {
	    video:
	      '<a href="javascript:;" class="video-button"><span><i></i><span></span></span></a>',
	  },
	  category: {
	    separator: '<span class="article-label__separator"></span>',
	  },
	  subheadline: '<h6 class="h6 color--blue-light">###subheadline###</h6>',
	
	  contacts: {
	    title: '<h5 class="h5-small">###address-title###</h5>',
	    desc: '<h5 class="h5-small">###title###</h5>\
							<p>###desc###</p>',
	
	    img: '<div class="list__item__cols-inner">\
								<div class="list__item__img">\
									<div data-bg="###img###" class="gallery__item  js-media__item" data-component=\'{ "component": "media-item" }\' \
											###tpl-params-media### \
										>\
										###tpl-media###\
									</div>\
								</div>\
								<div class="list__item__cols-inner__col">\
									<h5 class="h5-small">###title###</h5>\
									<p>###desc###</p>\
									###tpl-links###\
								</div>\
							</div>',
	
	    address:
	      '<div class="list__item__col">\
								###tpl-postal###\
								###address-title###\
								<p>###address-body###<br>\
									###telephone###\
									###fax###\
									###email###\
								</p>\
								###tpl-address-mobile###\
							</div>',
	
	    address_mobile:
	      '<div class="list__item__mobile">\
										###directions###\
										###links###\
									</div>',
	
	    postal:
	      '<h6 class="h6 color--blue-light no-space--bottom">' +
	      tl("Postal address") +
	      '</h6>\
							<p>###postal-address-body###</p>\
							<h6 class="h6 color--blue-light no-space--bottom">' +
	      tl("Visiting address") +
	      "</h6>",
	
	    telephone:
	      '<strong>###telephone-title###</strong> <span class="color--blue-light">###telephone-number###</span>',
	    fax:
	      "<br><strong>" +
	      tl("Fax:") +
	      '</strong> <span class="color--blue-light">###fax###</span>',
	    email:
	      "<br><strong>" +
	      tl("E-mail:") +
	      ':</strong> <a href="mailto:###email###">###email###</a>',
	
	    city: '<h6 class="h6 color--blue-light">###city-country###</h6>',
	    description: "<p>###desc###</p>",
	    directions: "<p>###directions###</p>",
	    direction:
	      '<a class="directions" href="###directions-url###" target="_blank">###directions-title###</a><br>',
	    links: "<p>###links###</p>",
	    link: '<a class="more" href="###link-url###" target="###link-target###">###link-title###</a><br>',
	  },
	  list: {
	    items: "<ul>###list###</ul>",
	    item: "<li>###li###</li>",
	  },
	  image: {
	    copy: '<div class="article-teaser__copy"><p>###copy###</p></div>',
	    overlay:
	      '<div class="gallery__item__overlay">\
								<div class="gallery__item__overlay__content">\
									<div class="gallery__item__overlay__full"></div>\
									###tpl-downloads###\
								</div>\
							</div>',
	    downloads:
	      '<div class="gallery__item__overlay__options  downloads">\
								<div class="downloads__item  js-more-options">\
									<div class="downloads__item__section  downloads__options  js-downloads-add" data-downloads=\'###downloads###\'>\
										<div class="downloads__icon  circle-icon  circle-icon--download" title="' +
	      tl("Download") +
	      '"></div>\
									</div>\
								</div>\
							</div>',
	  },
	  documents: {
	    distinct_result: '<span class="downloads__lg">###distinct-result###</span>',
	  },
	  downloads: {
	    section:
	      '<div class="downloads__item__section  downloads__options  js-downloads-add" ###downloads-groups### data-downloads=\'###downloads###\'>\
								<div class="downloads__icon  circle-icon  circle-icon--download" title="' +
	      tl("Download") +
	      '"></div>\
								<div class="downloads__icon  downloads__icon--close  circle-icon  circle-icon--light  circle-icon--close  js-more-options-close"></div>\
							</div>',
	    img: '<div class="downloads__img-container">\
								<div class="downloads__img" data-bg="###img###"></div>\
							</div>',
	  },
	  jobs: {
	    list:
	      '<ul class="icon-list">\
								<li><i class="icon--location-light"></i><strong>' +
	      tl("Location") +
	      ':</strong> ###location###</li>\
								<li><i class="icon--calendar"></i><strong>' +
	      tl("Type") +
	      ':</strong> ###type###</li>\
								<li><i class="icon--deadline"></i><strong>' +
	      tl("Application Deadline") +
	      ':</strong> ###end###</li>\
								<li><i class="icon--clock"></i><strong>' +
	      tl("Hours") +
	      ":</strong> ###hours###</li>\
							</ul>",
	    desc:
	      '<ul class="icon-list">\
								<li><i class="icon--location-light"></i><strong>' +
	      tl("Location") +
	      ":</strong> ###location###</li>\
							</ul>",
	    /*desc:		'<p>###cont###</p>\
								<p class="more">' + tl('Read more') + '</p>',*/
	  },
	  pages: {
	    breadcrumbs: '<p class="breadcrumbs">###breadcrumbs###</p>',
	    breadcrumb: '<a href="###breadcrumbs-url###">###breadcrumbs-title###</a>',
	  },
	  publications: {
	    authors:
	      '<p class="text--uppercase">###authors### - <span class="color--blue-light">###year###</span></p>',
	  },
	  tags: {
	    items:
	      '<div class="article-tags js-search-item-filter" data-search-item-filter="tags.title">###tags###</div>',
	    item: '<div class="article-tag" data-search-item-filter-value="###tag###">###tag###</div>',
	  },
	  group: {
	    playlist: {
	      wrapper:
	        '<div class="playlist__group">\
									<div class="playlist__group__items">###items###</div>\
								</div>',
	      items:
	        '<div class="playlist__items">\
									<div class="playlist__items__header">\
										<h2 class="playlist__headline h3-small">###headline###</h2>\
										<div class="playlist__total">###total###</div>\
									</div>\
									<div class="playlist__items__outer">\
										<div class="playlist__items__inner js-search-results" data-component=\'{ "component": "slider" }\'  data-slider-settings=\'{ "pagination": true, "slidesPerView": 1, "breakpoints": { "mobile-landscape": { "slidesPerView": 2 }, "tablet-landscape": { "slidesPerView": 3 } , "wide": { "slidesPerView": 4 } }} \'>###items###</div>\
									</div>\
								</div>',
	    },
	  },
	});
	
	var templates = (api.templates = {
	  items: {
	    all_wrapper:
	      '<div class="search__categories is-main-categories ###align###">\
								<div class="search__categories__header">\
									<h4 class="h4">' +
	      tl("We’re here to help") +
	      "</h4>\
									<p>" +
	      tl(
	        "Please select one of the categories to find the desired information or use the search field."
	      ) +
	      "</p>\
								</div>\
								<ul>###all###</ul>\
							</div>",
	    all: '<li data-category-link="###index###">\
								<div>\
									<h4>###indexName### (###total###)</h4>\
									<div>\
										<h4>###indexName### (###total###)</h4>\
										<p>###indexDesc###</p>\
									</div>\
								</div>\
							</li>',
	    header:
	      '<div class="overview__header">\
								<h4 class="overview__title"> ' +
	      tl("Results") +
	      " (###total###)</h4>\
							</div>",
	    header_all:
	      '<div class="overview__header">\
								<h2 class="h2">###indexName###</h2>\
								<h4 class="overview__title"> ' +
	      tl("Results") +
	      " (###total###)</h4>\
							</div>",
	    button:
	      '<div class="overview__button"><a href="javascript:;" class="button button--full" data-category="###index###">' +
	      tl("More") +
	      " ###indexName###</a></div>",
	    news: '<div class="article-teaser__items">###items###</div>',
	    blog: '<div class="blog-list__items__inner">###items###</div>',
	    media: '<div class="media-list__items">###items###</div>',
	    video: '<div class="media-list__items">###items###</div>',
	    documents: '<div class="list list--documents">###items###</div>',
	    products:
	      '<table class="table table--products"><thead><tr><th>' +
	      tl("Product name") +
	      "</th><th>" +
	      tl("MFR value") +
	      "</th><th>" +
	      tl("Density") +
	      "</th><th>" +
	      tl("Product Data sheet") +
	      "</th></tr></thead><tbody>###items###</tbody></table>",
	    products_borouge:
	      '<table class="table table--products"><thead><tr><th>' +
	      tl("Product name") +
	      "</th><th>" +
	      tl("MFR value") +
	      "</th><th>" +
	      tl("Density") +
	      "</th><th>" +
	      tl("Data sheet") +
	      "</th></tr></thead><tbody>###items###</tbody></table>",
	    contacts: '<div class="list list--contacts">###items###</div>',
	    locations: '<div class="list list--locations">###items###</div>',
	    events: '<div class="list list--events">###items###</div>',
	    jobs: '<div class="list list--jobs headline--blue-medium">###items###</div>',
	    pages: '<div class="list list--pages">###items###</div>',
	    publications:
	      '<div class="list list--publications headline--blue-medium">###items###</div>',
	  },
	
	  item: {
	    all: "<li>###title###</li>",
	
	    news:
	      '<div class="article-teaser">\
								<div class="article-teaser__col  article-teaser__col--side  ###hidden###">\
									<div class="article-teaser__img article-teaser--vid js-media__item" data-component=\'{ "component": "media-item" }\' \
											' +
	      tpl.params.video +
	      ' \
										>\
										<div class="video-inline__img" data-bg="###img###"></div>\
										' +
	      tpl.button.video +
	      ' \
									</div>\
									<a href="###link###" class="article-teaser__img article-teaser--img" data-bg="###img###" ></a>\
									' +
	      tpl.image.copy +
	      ' \
								</div>\
								<div class="article-teaser__col  article-teaser__col--main">\
									<div class="article-teaser__label  article-label">\
										<span class="article-label__category js-search-item-filter" data-search-item-filter="categories.title">###category###</span>\
										<span class="article-label__date">###date###</span>\
									</div>\
									<div class="article-teaser__title-content">\
										<a href="###link###" class="article-teaser__small-img" data-bg="###img###"></a>\
										<div class="article-teaser__title">\
											<a href="###link###">###title###</a>\
										</div>\
										' +
	      tpl.image.copy +
	      ' \
									</div>\
									<div class="article-teaser__text">\
										<p>###excerpt###</p>\
									</div>\
									<a href="###url###" class="article-teaser__more  more">' +
	      tl("Read more") +
	      "</a>\
								</div>\
							</div>",
	
	    blog: '<a class="blog-list__item" href="###url###">\
								<div class="blog-list__item__inner">\
									<div class="blog-list__img">\
										<div class="blog-list__img__src" data-bg="###img###" ###copy###></div>\
									</div>\
									<div class="blog-list__content">\
										<div class="blog-list__content__inner">\
											<div class="blog-list__text">\
												<div class="article-label">\
													<span class="article-label__category js-search-item-filter" data-search-item-filter="categories.title">\
														<span>###category###</span>\
													</span>\
													<span class="article-label__date">###date###</span>\
												</div>\
												<h4 class="blog-list__title h4">###title###</h4>\
											</div>\
											###tpl-tags###\
										</div>\
									</div>\
								</div>\
							</a>',
	
	    media:
	      '<div class="media-list__item gallery__item  js-media__item" data-component=\'{ "component": "media-item" }\' ###js-video-player### ' +
	      tpl.params.media +
	      ' ###tpl-media-data### >\
								<div class="media-list__item__inner">\
									<div data-bg="###img###" class="media-list__img" ###js-video-player### \
											' +
	      tpl.params.media +
	      ' \
											###tpl-media-data### \
										>\
										###tpl-media###\
									</div>\
									<div class="media-list__info">\
										<span class="media-list__title">###title### <span class="media-list__copy">###copy###</span></span>\
										<span class="media-list__duration"></span>\
									</div>\
								</div>\
							</div>',
	
	    video:
	      '<div class="media-list__item gallery__item  js-media__item" data-component=\'{ "component": "media-item" }\' ###js-video-player### ' +
	      tpl.params.media +
	      ' ###tpl-media-data###   data-id="###data-id###"" >\
								<div class="media-list__item__inner">\
									<div data-bg="###img###" class="media-list__img " ###js-video-player### \
											' +
	      tpl.params.media +
	      ' \
											###tpl-media-data### \
										>\
										###tpl-media###\
									</div>\
									<div class="media-list__info">\
										<span class="media-list__title">###title### <span class="media-list__copy">###copy###</span></span>\
										<span class="media-list__duration"></span>\
									</div>\
								</div>\
							</div>',
	
	    documents:
	      '<div class="downloads__item  js-more-options">\
								<div class="downloads__item__section">\
									###img###\
									<div>\
										<span class="downloads__title">###type###</span>\
										<span class="downloads__info">###title###</span>\
										###distinct-result###\
									</div>\
								</div>\
								<div class="downloads__item__section  downloads__toggle  js-more-options-toggle">\
									<div class="downloads__icon  circle-icon  circle-icon--more"></div>\
								</div>\
								' +
	      tpl.downloads.section +
	      "\
							</div>",
	
	    products:
	      '<tr class="">\
								<td>\
									<h5 class="h5-small">###title###</h5>\
									<a href="###url###">Test link</a>\
									<p>###desc###</p>\
									<div class="table__more"><span class="more">' +
	      tl("Download all data sheets and general documents") +
	      '</span></div>\
								</td>\
								<td class="table--nowrap" data-label="' +
	      tl("MFR value") +
	      ': " data-title="###mfr###"><p>###mfr###</p></td>\
								<td class="table--nowrap" data-label="' +
	      tl("Density") +
	      ': " data-title="###density###"><p>###density###</p></td>\
								<td class="table__downloads">\
									' +
	      tpl.downloads.section +
	      '\
									<p class="table__more"><a href="###url###" target="_top" class="more">' +
	      tl("Download all data sheets and general documents") +
	      "</a></p>\
								</td>\
							</tr>",
	
	    products_borouge:
	      '<tr class="js-downloads-add-trigger js-more-options js-click-child" data-target=".more">\
								<td>\
									<h5 class="h5-small">###title###</h5>\
									<p>###desc###</p>\
								</td>\
								<td class="table--nowrap" data-label="' +
	      tl("MFR value") +
	      ': " data-title="###mfr###"><p>###mfr###</p></td>\
								<td class="table--nowrap" data-label="' +
	      tl("Density") +
	      ': " data-title="###density###"><p>###density###</p></td>\
								<td class="table__downloads">\
									' +
	      tpl.downloads.section +
	      "\
								</td>\
							</tr>",
	
	    contacts:
	      '<div class="list__item ###list-item-class###">\
								###subheadline###\
								<div class="list__item__cols">\
									<div class="list__item__col">\
										###tpl-desc###\
										<div class="list__item__desktop">\
											###directions###\
											###links###\
										</div>\
									</div>\
									###tpl-address###\
								</div>\
							</div>',
	
	    locations:
	      '<div class="list__item">\
								###subheadline###\
								<div class="list__item__cols">\
									<div class="list__item__col">\
										###subheadline-addr###\
										###tpl-desc###\
										<div class="list__item__desktop">\
											###directions###\
											###links###\
										</div>\
									</div>\
									###tpl-address###\
								</div>\
							</div>',
	
	    events:
	      '<a href="###link-url###" target="_blank" class="list__item">\
								<div class="list__item__cols list__item__cols--flex">\
									<div class="list__item__col list__item__col--static">\
										<p class="icon"><i class="icon--calendar"></i>###date###</p>\
									</div>\
									<div class="list__item__col">\
										<h5 class="h5">###title###</h5>\
										###list###\
									</div>\
									<div class="list__item__col">\
										<p class="icon"><i class="icon--location-light"></i>###subheadline###</p>\
									</div>\
								</div>\
							</a>',
	
	    jobs: '<a href="###url###" class="list__item">\
								<h5 class="h5">###title###</h5>\
								###tpl-jobs-list###\
								###tpl-jobs-desc###\
							</a>',
	
	    pages:
	      '<div class="list__item">\
								<div class="list__item__inner">\
									###breadcrumbs###\
									<h5 class="h5"><a href="###url###">###title###</a></h5>\
									<p>###cont###</p>\
									<p class="more"><a href="###url###">' +
	      tl("Visit page") +
	      "</a></p>\
								</div>\
							</div>",
	
	    publications:
	      '<div class="list__item">\
									<div class="list__item__inner">\
										<h5 class="h5 no-space--bottom"><a href="###url###">###title###</a></h5>\
										###authors###\
										<p>###desc###</p>\
										<p class="more"><a href="###url###">###url-title###</a></p>\
									</div>\
								</div>',
	  },
	
	  filter: {
	    item:
	      '<div class="subnav__item  filters__button  dropdown  js-dropdown  js-filters-group">\
								<div class="dropdown__label">\
									<span class="dropdown__label__text">\
										<span class="dropdown__label__text__inner">' +
	      tl("Type") +
	      '</span>\
										<span class="dropdown__label__text__replaced">\
											<span class="dropdown__label__text__replaced__option">' +
	      tl("Subcategories") +
	      '</span>\
											<span class="dropdown__label__text__replaced__option">2</span>\
										</span>\
									</span>\
									<span class="dropdown__label__chosen  js-filters-chosen"></span>\
									<div class="dropdown__reset  js-filters-reset  js-dropdown-close"></div>\
								</div>\
								<div class="dropdown__content  js-dropdown-content  form">\
									<div class="dropdown__title  open  js-dropdown-close">' +
	      tl("Type") +
	      '</div>\
									<div class="dropdown__search">\
										<input type="text" class="dropdown__search__field  js-filters-search" placeholder="' +
	      tl("Search") +
	      '">\
										<div class="dropdown__search__reset  js-filters-search-reset"></div>\
									</div>\
									<div class="dropdown__main  js-dropdown-main">\
										<div class="dropdown__items"></div>\
									</div>\
									<div class="dropdown__no-results  js-filters-no-results">\
										' +
	      tl("No filters matching your criteria") +
	      '\
									</div>\
									<div class="dropdown__button  button  button--full  button--empty  button--small  button--blue-medium  js-tabs-reload  js-dropdown-close">' +
	      tl("Apply") +
	      "</div>\
								</div>\
							</div>",
	
	    group:
	      '<div class="subnav__item  filters__button  dropdown  dropdown--double  dropdown--tabbed  js-dropdown  js-filters-group  js-slideout" data-tabbed="true">\
								<div class="dropdown__label">\
									<span class="dropdown__label__text">\
										<span class="dropdown__label__text__inner">' +
	      tl("Special filter") +
	      '</span>\
									</span>\
									<span class="dropdown__label__chosen  js-filters-chosen"></span>\
								</div>\
								<div class="dropdown__content  js-dropdown-content  form">\
									<div class="dropdown__title  dropdown__title--nav  open">\
										<div data-item="1" class="dropdown__title__link  js-slideout-nav-link  is-active">' +
	      tl("Industry") +
	      '</div>\
										<div data-item="2" class="dropdown__title__link  js-slideout-nav-link">' +
	      tl("Subindustry") +
	      '</div>\
										<div class="dropdown__close-area  js-dropdown-close"></div>\
									</div>\
									<div class="dropdown__section-container  js-slideout-container">\
										<div data-item="1" class="dropdown__section  js-filters-group-section  js-slideout-content-item  is-default">\
											<div class="dropdown__search">\
												<input type="text" class="dropdown__search__field  js-filters-search" placeholder="' +
	      tl("Search") +
	      '">\
												<div class="dropdown__search__reset  js-filters-search-reset"></div>\
											</div>\
											<div class="dropdown__main  js-dropdown-main">\
												<div class="dropdown__items"></div>\
											</div>\
											<div class="dropdown__no-results  js-filters-no-results">' +
	      tl("No filters matching your criteria") +
	      '</div>\
											<div class="dropdown__button  button  button--full  button--empty  button--small  button--blue-medium  js-tabs-reload  js-dropdown-close">' +
	      tl("Apply") +
	      '</div>\
										</div>\
										<div data-item="2" class="dropdown__section  js-filters-group-section  js-slideout-content-item">\
											<div class="dropdown__search">\
												<input type="text" class="dropdown__search__field  js-filters-search" placeholder="' +
	      tl("Search") +
	      '">\
												<div class="dropdown__search__reset  js-filters-search-reset"></div>\
											</div>\
											<div class="dropdown__main  js-dropdown-main">\
												<div class="dropdown__items"></div>\
											</div>\
											<div class="dropdown__no-results  js-filters-no-results"> ' +
	      tl("No filters matching your criteria") +
	      '</div>\
											<div class="dropdown__button  button  button--full  button--empty  button--small  button--blue-medium  js-tabs-reload  js-dropdown-close">' +
	      tl("Apply") +
	      "</div>\
										</div>\
									</div>\
								</div>\
							</div>",
	
	    button_nested:
	      '<div class="subnav__item  dropdown  filters__button  filters__button--nested-info">\
									<div class="dropdown__label">\
										<span class="dropdown__label__text">\
											<span class="dropdown__label__text__inner">###title###</span>\
										</span>\
									</div>\
								</div>',
	
	    button:
	      '<div class="subnav__item  dropdown  filters__button  filters__button--slider  js-overlay">\
								<div class="dropdown__label">\
									<span class="dropdown__label__text">\
										<span class="dropdown__label__text__inner">' +
	      tl("Type") +
	      '</span>\
									</span>\
									<span class="dropdown__label__chosen  js-filters-chosen"></span>\
								</div>\
							</div>',
	
	    overlay:
	      '<div class="overlay overlay--small overlay--search-filter">\
								<div class="overlay__outer">\
									<div class="overlay__inner">\
										<div class="header">\
											<div class="header__content">\
												<h3 class="h3-small">###title###</h3>\
											</div>\
										</div>\
										<div class="overlay__content  is-active">\
											<div class="section section--overlay">\
												<div class="section__inner">\
													<div class="advanced-filter">\
														<form action=""></form>\
														<div class="advanced-filter__button-container">\
															<div class="button button--blue-medium js-advanced-filter-show" data-title="' +
	      tl("Show results") +
	      '"></div> <div class="button button--empty js-advanced-filter-reset">' +
	      tl("Reset Filter") +
	      '</div>\
														</div>\
													</div>\
												</div>\
											</div>\
										</div>\
									</div>\
									<div class="button-close"><i></i></div>\
								</div>\
							</div>',
	
	    slider:
	      '<div class="advanced-filter__section">\
								<div class="advanced-filter__label  advanced-filter__label--spacious">###slider-title###</div>\
								<div class="advanced-filter__slider">\
									<div class="range-slider  js-range-slider" data-range="0,1000" data-initial="200,800" data-callback="filterRangeUpdate">\
										<div class="range-slider__header">\
											<div class="range-slider__header__left">' +
	      tl("Min.") +
	      '</div>\
											<div class="range-slider__header__right">' +
	      tl("Max.") +
	      '</div>\
										</div>\
										<div class="range-slider__slider js-range-slider-line"></div>\
										<div class="range-slider__fields">\
											<div class="range-slider__fields__item  range-slider__fields__left">\
												<input type="number" class="range-slider__field  js-range-slider-min">\
												<span class="range-slider__fields__label">###unit###</sup></span>\
											</div>\
											<div class="range-slider__fields__item  range-slider__fields__right">\
												<input type="number" class="range-slider__field  js-range-slider-max">\
												<span class="range-slider__fields__label">###unit###</sup></span>\
											</div>\
										</div>\
									</div>\
								</div>\
							</div>',
	
	    option:
	      '<div class="form__row  dropdown__col  js-filters-item">\
								<input type="checkbox" id="" name="" class="form__checkbox">\
								<label for="" class="form__checkbox-label"></label>\
							</div>',
	
	    separator:
	      '<div class="subnav__item subnav__item--divider subnav__item--tablet"><div class="subnav__item__divider"></div></div>',
	  },
	  pagination:
	    '<div class="overview__pagination pagination">\
								<div class="pagination__button pagination__button--prev"></div>\
								<div class="pagination__info">' +
	    tl("Page") +
	    ' <span>###page###</span>/<span>###pages###</span></div>\
								<div class="pagination__button pagination__button--next"></div>\
							</div>',
	  more:
	    '<div class="search__results__more"><a class="button button--big js-search-more" href="javascript:;">' +
	    tl("Load more") +
	    "</a></div>",
	  noresults: function (obj) {
	    var html =
	      '<div class="search__no-results">\
	                                            <h4 class="h4">' +
	      tl(obj && obj.headline ? obj.headline : "We didn’t find any results") +
	      ".</h4>\
	                                            <p>" +
	      tl(obj && obj.text ? obj.text : "Please adjust your search phrase") +
	      ".</p>\
	                                        </div>";
	    return html;
	  },
	  noresults_alt:
	    '<div class="search__no-results">\
								<h4 class="h4">' +
	    tl("We didn’t find any results in the selected category") +
	    ".</h4>\
								<p>" +
	    tl(
	      "Please take a look at below categories for further results or adjust your search phrase"
	    ) +
	    '.</p>\
								<div class="search__no-results__categories search__categories ###align###"><ul>###items###</ul></div>\
							</div>',
	});
	

	// =======================================
	//  STRING SEARCH & REPLACE
	// =======================================
		String.prototype.replaceAll = function(search, replacement) {
			var target = this;
			return target.replace(new RegExp(search, 'g'), replacement);
		};
	
		var strReplace = api.strReplace = function(str, find, replace, empty) {
			if (replace) str = str.split('###' + find + '###').join(replace);
			else 		str = str.split('###' + find + '###').join(empty || '');
	
			var environment = $('html').attr('data-environment');
	
			switch(environment){
				case 'PROD':
					if(location.hostname == 'www.borealisgroup.com'){
						str = str.replaceAll('live.cms.borealisgroup.com', location.hostname);
					}
					break;
				case 'STAGE':
					if(location.hostname == 'stage.cdn.borealisgroup.com'){
						str = str.replaceAll('stage.cms.borealisgroup.com', location.hostname);
					}
					break;
				case 'DEVELOP':
					break;
				case 'LOCAL':
					break;
			}
	
			return str;
		};
	
		// MEDIA
	
		var strReplace_Media = api.strReplace_Media = function(item, hit) {
			// OVERLAY
			item = strReplace(item, 'tpl-media',		tpl.image.overlay);
			item = strReplace(item, 'data-id',			hit.objectID);
			item = strReplace(item, 'data-title',		(hit.translatedTitle && hit.translatedTitle[app.vars.lang] && hit.translatedTitle[app.vars.lang] != '' ? hit.translatedTitle[app.vars.lang] : hit.title));
			item = strReplace(item, 'data-desc',		(hit.translatedDescription && hit.translatedDescription[app.vars.lang] && hit.translatedDescription[app.vars.lang] != '' ? hit.translatedDescription[app.vars.lang] : hit.description));
			item = strReplace(item, 'data-copy',		hit.copyright);
	
			if (!hit.filters.videos) {
				item = strReplace(item, 'data-img',			hit.url);
				item = strReplace(item, 'tpl-media-data',	tpl.params.download);
				item = strReplace(item, 'js-video-player',	'');
	
				// DOWNLOADS
				item = strReplace(item, 'tpl-downloads',	tpl.image.downloads);
				item = downloads(item, [{id: hit.objectID, lg: '', url: hit.url}], hit.title);
			} else {
				item = strReplace(item, 'data-img',			hit.url_preview);
				// VIDEO
				item = strReplace(item, 'tpl-downloads',	'');
				item = strReplace(item, 'tpl-media-data',	'');
				item = strReplace(item, 'js-video-player',	tpl.params.video);
				item = strReplace(item, 'video',			hit.url);
				item = strReplace(item, 'videoType', hit.videoType ? hit.videoType : 'vimeo')
			}
	
	
			item = strReplace(item, 'img',				hit.url_preview);
			item = strReplace(item, 'copy',				hit.copyright);
			item = strReplace(item, 'date',				hit.date);
	
			return item;
		};
	
		// JOBS
	
		var strReplace_Jobs = api.strReplace_Jobs = function(item, hit) {
	
			//moment.locale('en-gb');
	
			if(hit.application_type != 'Spontaneous Applications'){
				item = strReplace(item, 'tpl-jobs-list',	tpl.jobs.list);
				item = strReplace(item, 'tpl-jobs-desc',	'');
				item = strReplace(item, 'type',			hit.type_text);
				item = strReplace(item, 'location',		hit.location);
				item = strReplace(item, 'end',			moment(hit.application_end).format('ll'));
				item = strReplace(item, 'hours',		hit.hours == '' ? hit.extent : hit.extent + ' (' + hit.hours + ')');
			}else{
				/*var max = 400;
				var desc = hit.description;
	
				if(desc.length>400){
					desc = desc.substr(0, max).split(' ');
					desc.pop();
					desc = desc.join(' ') + '...';
				}
	
				item = strReplace(item, 'tpl-jobs-list',	'');
				item = strReplace(item, 'tpl-jobs-desc',	tpl.jobs.desc);
				item = strReplace(item, 'cont',				desc);*/
	
				item = strReplace(item, 'tpl-jobs-list',	'');
				item = strReplace(item, 'tpl-jobs-desc',	tpl.jobs.desc);
				item = strReplace(item, 'location',		hit.location);
			}
			item = strReplace(item, 'url',			hit.url);
	
			return item;
		};
	
		// EVENTS
	
		var strReplace_Events = api.strReplace_Events = function(item, hit) {
			if (hit.link && hit.link.url.length > 0) {
				item = strReplace(item, 'link-url',		hit.link.url);
				item = strReplace(item, 'link-target',	hit.link.target);
			} else {
				item = strReplace(item, 'link-url',		'javascript:;');
				item = strReplace(item, 'link-target',	'_self');
			}
			item = strReplace(item, 'date',			date_FromTo(hit.start, hit.end));
			item = strReplace_List(item, hit.topics);
			item = strReplace_CityCountry(item, hit, ', ');
	
			return item;
		};
	
		// LOCATIONS
	
		var strReplace_Locations = api.strReplace_Locations = function(item, hit) {
			var postal = (hit.postal_address_body && hit.postal_address_body != '');
	
			item = strReplace(item, 'tpl-address',		tpl.contacts.address);
	
			item = strReplace(item, 'subheadline',		!postal ? tpl.subheadline : '');
			item = strReplace(item, 'subheadline-addr',	postal ? tpl.subheadline : '');
	
			item = strReplace_CityCountry(item, hit, ' - ');
	
			item = strReplace(item, 'tpl-desc',			tpl.contacts.desc);
			item = strReplace_Types(item, hit);
	
			item = strReplace(item, 'title',			hit.address_title);
			item = strReplace(item, 'address-title',	'');
			item = strReplace(item, 'address-body',		hit.address_body);
	
			item = strReplace(item, 'tpl-address-mobile',	hit.driving_directions || hit.links ? tpl.contacts.address_mobile : '');
	
			item = strReplace_Address_Details(item, hit);
			item = strReplace_Links(item, hit);
			item = strReplace_Directions(item, hit);
	
			return item;
		};
	
		// DOCUMENTS
	
		var strReplace_Documents = api.strReplace_Documents = function(item, hit) {
			item = strReplace(item, 'type',		tl(hit.type));
	
			if (hit.url_preview) {
				item = strReplace(item, 'img',				tpl.downloads.img);
				item = strReplace(item, 'img',				hit.url_preview);
			} else {
				item = strReplace(item, 'img',				'');
			}
			item = strReplace(item, 'downloads-groups',		'');
	
			var _downloads = [{id: hit.objectID, lg: hit.language.label, url: hit.url}];
	
			/*if(hit.siblings){
				for (var s in hit.siblings) {
					var sibling = hit.siblings[s];
					_downloads.push({id: sibling.objectID, lg: sibling.language, url: sibling.url})
				}
				_downloads.sort(function(a, b) {
					var s1 = a.lg.toLowerCase();
					var s2 = b.lg.toLowerCase();
					if(s1.indexOf('english')>=0){
						return -1;
					} else if(s2.indexOf('english')>=0){
						return 1;
					} else {
						return s1.localeCompare(s2);
					}
				});
			}*/
	
			//item = downloads(item, _downloads, (hit.prefixTitle && hit.prefixTitle != '' ? hit.prefixTitle : hit.title));
	
			if(!index || !filter_distinct[index] || !hit[filter_distinct[index]]){
				item = strReplace(item, 'distinct-result', '');
				item = downloads(item, _downloads, (hit.prefixTitle && hit.prefixTitle != '' ? hit.prefixTitle : hit.title));
			}else{
				item = strReplace(item, 'title', '###' + hit[filter_distinct[index]] + '-distinct-title###');
				item = strReplace(item, 'distinct-result', tpl.documents.distinct_result);
				item = strReplace(item, 'distinct-result','###'+hit[filter_distinct[index]]+'-distinct-result###');
				item = strReplace(item, 'downloads','###'+hit[filter_distinct[index]]+'-downloads###');
			}
	
			return item;
		};
	
		// NEWS
	
		var strReplace_News = api.strReplace_News = function(item, hit) {
			item = strReplace(item, 'excerpt',		hit.excerpt);
	
			if (hit.categories) {
				var media = hit.media.images ? hit.media.images : hit.media.video;
				var has_media = media && media[0];
				var cats = hit.categories;
				var cat = '';
	
				if(local_page){
					hit.url = location.protocol + '//' + location.hostname + '/'+local_page+'/'+hit.url.replace(/^(?:\/\/|[^\/]+)*\//, "");
				}
	
				for (var c in cats) {
					var title = tl(cats[c].title);
					cat += '<span data-search-item-filter-value="' + title + '">' + title + '</span>' + ' ' + tpl.category.separator + ' ';
				}
	
				item = strReplace(item, 'category',	tl(cat));
				item = strReplace(item, 'link',		hit.url);
				//if(has_media){
					item = strReplace(item, 'img',		has_media ? media[0].url : '');
					item = strReplace(item, 'copy',		has_media ? media[0].copyright : '');
					item = strReplace(item, 'desc',		has_media ? media[0].description : '');
				//}else{
					item = strReplace(item, 'hidden',	has_media ? '' : 'is-hidden');
				//}
			}
	
			return item;
		};
	
		// BLOG
	
		var strReplace_Blog = api.strReplace_Blog = function(item, hit) {
			item = strReplace(item, 'excerpt',		hit.excerpt);
	
			if (hit.categories) {
				var media = hit.media.images ? hit.media.images : false;
				var has_media = media && media[0];
				var cats = hit.categories;
				var cat = '';
	
				for (var c in cats) {
					var title = tl(cats[c].title);
					cat += '<span data-search-item-filter-value="' + title + '">' + title + '</span>';
				}
	
				item = strReplace(item, 'category',	tl(cat));
				
				item = strReplace(item, 'img',		has_media ? media[0].url : '');
				item = strReplace(item, 'copy',		has_media ? (media[0].copyright.length > 0 ? 'data-copy="' + media[0].copyright + '"' : '') : '');
				item = strReplace(item, 'desc',		has_media ? media[0].description : '');
	
				item = strReplace(item, 'hidden',	has_media ? '' : 'is-hidden');
	
				item = strReplace_Tags(item, hit);
			}
	
			return item;
		};
	
		// PRODUCTS
	
		var strReplace_Products = api.strReplace_Products = function(item, hit) {
			item = strReplace(item, 'mfr',		hit.properties.computed.mfr_value, 	'-');
			item = strReplace(item, 'density',	hit.properties.computed.density,	'-');
	
			/*if(location.href.indexOf('.devlocal')>=0){
				item = strReplace(item, 'url',	'http://borealisgroup.devlocal/partials/overlay-test.php');
			}*/
	
			item = downloadGroups(item, hit.downloads.datasheet, hit.title);
	
			return item;
		};
	
		// PRODUCTS BOROUGE
	
		var strReplace_Products_Borouge = api.strReplace_Products_Borouge = function(item, hit) {
			item = strReplace(item, 'mfr',		hit.properties.computed.mfr_value, 	'-');
			item = strReplace(item, 'density',	hit.properties.computed.density,	'-');
	
			item = downloadGroups(item, hit.downloads, hit.title);
	
			if(item.indexOf("data-downloads='[]'") >=0 ){
				item = item.split('<tr class=').join('<tr data-downloads-cnt="0" class=');
			}
	
			return item;
		};
	
		// CONTACTS
	
		var strReplace_Contacts = api.strReplace_Contacts = function(item, hit) {
			item = strReplace(item, 'list-item-class',		hit.media ? 'list__item--middle' : '');
			item = strReplace(item, 'category',				tl(hit.category));
			item = strReplace(item, 'tpl-address',			hit.address ? tpl.contacts.address : '');
	
			if (!hit.media || hit.media.images.length < 1) {
				item = strReplace(item, 'tpl-desc',			tpl.contacts.desc);
				item = strReplace(item, 'tpl-downloads',	'');
			} else {
				item = strReplace(item, 'tpl-desc',			tpl.contacts.img);
				item = strReplace(item, 'tpl-params-media',	tpl.params.media);
	
				var media = hit.media.images;
				var data_title = '' + hit.title.split("'").join("\\'");
	
				item = strReplace(item, 'img',				media[0].url);
				item = strReplace(item, 'tpl-media-data',	tpl.params.download);
				item = strReplace(item, 'tpl-media',		tpl.image.overlay);
				item = strReplace(item, 'data-title',		data_title);
				item = strReplace(item, 'data-desc',		media[0].description);
				item = strReplace(item, 'data-img',			media[0].url);
				item = strReplace(item, 'data-copy',		media[0].copyright);
	
				item = strReplace(item, 'tpl-downloads',	tpl.image.downloads);
				item = downloads(item, [{id: hit.objectID, lg: '', url: media[0].url}], hit.title);
			}
	
			if (hit.address) {
				item = strReplace(item, 'tpl-address',		tpl.contacts.address);
				item = strReplace(item, 'address-title',	hit.address.title ? tpl.contacts.title : '');
				item = strReplace(item, 'address-title',	hit.address.title);
				item = strReplace(item, 'address-body',		hit.address.desc);
	
				item = strReplace(item, 'tpl-address-mobile',	hit.driving_directions || hit.links ? tpl.contacts.address_mobile : '');
			}
	
			item = strReplace_Type(item, hit);
			item = strReplace_Address_Details(item, hit);
			item = strReplace_Links(item, hit);
			item = strReplace_Directions(item, hit);
	
			return item;
		};
	
		// PAGES
	
		var strReplace_Pages = api.strReplace_Pages = function(item, hit) {
			var breadcrumbs = '';
			var cont_highlight = hit._highlightResult.content.value;
			var cont = cont_highlight;
			var mark_first = Math.max(0, cont_highlight.indexOf('<em>'));
			var mark_len = (cont_highlight.split('<em>').length-1)*4 + (cont_highlight.split('</em>').length-1)*5;
			var max = 400 + mark_len;
	
			//console.log(hit.title);
			//console.log(cont_highlight);
			//console.log(mark_len+', '+max+', '+mark_first);
			//if(mark_first < 200) {mark_first = 0; mark_len = 0;}
	
			if(mark_len>0){
				var cont_start = cont_highlight.substr(0, mark_first).split(' ');
				cont_start = cont_start.splice(Math.max(0, cont_start.length-5), cont_start.length).join(' ');
				mark_first -= cont_start.length;
			}
			if (cont_highlight.length > max+mark_first) {
				cont = cont_highlight.substr(mark_first, max).split(' ');
				cont = (mark_len>0 ? '...' : '') + cont.splice(0, cont.length - 1).join(' ') + '...';
			}
	
			if (hit.breadcrumbs) {
				for (var b in hit.breadcrumbs) {
					var bc = '' + tpl.pages.breadcrumb;
					bc = strReplace(bc, 'breadcrumbs-title',	hit.breadcrumbs[b].title);
					bc = strReplace(bc, 'breadcrumbs-url',		hit.breadcrumbs[b].url);
					breadcrumbs += bc;
				}
			}
			item = strReplace(item, 'cont',					cont);
			item = strReplace(item, 'breadcrumbs',			breadcrumbs != '' ? tpl.pages.breadcrumbs : '');
			item = strReplace(item, 'breadcrumbs',			breadcrumbs);
	
			return item;
		};
	
		var strReplace_Publications = api.strReplace_Publications = function(item, hit) {
			if (hit.authors) {
				var authors = '';
				for (var a in hit.authors) {
					authors += ', ' + hit.authors[a].name;
				}
				item = strReplace(item, 'authors',			tpl.publications.authors);
				item = strReplace(item, 'authors',			authors.substr(2));
			}
			item = strReplace(item, 'year',			hit.year);
			item = strReplace(item, 'url-title',	hit.url_title);
	
			return item;
		};
	
		// GENERAL
	
		var strReplace_General = api.strReplace_General = function(item, hit) {
			//moment.locale($html.attr('lang'));
			var dt = hit.date ? moment(new Date(hit.date * 1000), 'x').format('LL') : false;
	
			item = strReplace(item, 'date',		dt);
			item = strReplace(item, 'title',	hit.title);
			item = strReplace(item, 'desc',		hit.description);
			item = strReplace(item, 'id',		hit.objectID);
			item = strReplace(item, 'url',		hit.url ? (hit.url.indexOf('//')>=0 ? location.protocol + '//' + hit.url.split('//')[1] : hit.url) : false );
	
			return item;
		};
	
	
		// HELPERS
	
		var date_FromTo = api.date_FromTo = function(from, to) {
			var start		= from.split('-').reverse().join('.');
			var end			= to.split('-').reverse().join('.');
			var month_start	= start.substr(3, 2);
			var month_end	= end.substr(3, 2);
			var date		= '<span class="list__item__col__from-to">' + ((from == to) ? moment(from).format('ll')  :  '<span>' + moment(from).format('ll') + ' -&nbsp;</span><span">' + moment(to).format('ll') + '</span>') + '</span>';
	
			return date;
		};
		var strReplace_List = api.strReplace_List = function(item, obj) {
			var list = obj;
			var str = '';
	
			if (list && list.length > 0) {
				for (var l in list) {
					var li = '' + tpl.list.item;
					li = strReplace(li, 'li',	list[l]);
					str += li;
				}
			}
			item = strReplace(item, 'list',				str != '' ? tpl.list.items : '');
			item = strReplace(item, 'list',				str);
	
			return item;
		};
		var strReplace_CityCountry = api.strReplace_CityCountry = function(item, hit, separator) {
			var city = '';
	
			if (hit.city)	city += separator + hit.city;
			if (hit.state)	city += separator + hit.state;
			if (hit.country)	city += separator + hit.country;
	
			city = city.substr(separator.length);
	
			item = strReplace(item, 'city-country',		city != '' ? tpl.contacts.city : '');
			item = strReplace(item, 'subheadline',		city);
	
			return item;
		};
		var strReplace_Type = api.strReplace_Type = function(item, hit) {
			var type = '';
			if (hit.type && hit.type.length > 0) {
				for (var t in hit.type) {
					type += ', ' + hit.type[t];
				}
			}
			type = type.substr(2);
			item = strReplace(item, 'subheadline',				type != '' ? tpl.subheadline : '');
			item = strReplace(item, 'subheadline',				type);
	
			return item;
		};
		var strReplace_Types = api.strReplace_Types = function(item, hit) {
			var types = '';
			if (hit.company && hit.company.length > 0) {
				for (var c in hit.company) {
					types += ', ' + hit.company[c];
				}
			}
			if (hit.type && hit.type.length > 0) {
				for (var t in hit.type) {
					types += ', ' + hit.type[t];
				}
			}
			types = types.substr(2);
			item = strReplace(item, 'desc',				types);
	
			return item;
		};
		var strReplace_Address_Details = api.strReplace_Address_Details = function(item, hit) {
			var postal		= (hit.postal_address_body && hit.postal_address_body != '');
			var telephone	= '';
			if (hit.telephone) {
				for (var t in hit.telephone) {
					var tel		= '' + tpl.contacts.telephone;
					tel			= strReplace(tel, 'telephone-title',	hit.telephone[t].title);
					tel			= strReplace(tel, 'telephone-number',	hit.telephone[t].number);
					telephone	+= '<br />' + tel;
				}
			}
			item = strReplace(item, 'telephone',		telephone);
	
			item = strReplace(item, 'fax',				hit.fax ? tpl.contacts.fax : '');
			item = strReplace(item, 'fax',				hit.fax);
	
			item = strReplace(item, 'email',			hit.email ? tpl.contacts.email : '');
			item = strReplace(item, 'email',			hit.email);
	
			item = strReplace(item, 'tpl-postal',			postal ? tpl.contacts.postal : '');
			item = strReplace(item, 'postal-address-body',	postal ? hit.postal_address_body : '');
	
			return item;
		};
		var strReplace_Links = api.strReplace_Links = function(item, hit) {
			var links = '';
			if (hit.links) {
				for (var l in hit.links) {
					var link = '' + tpl.contacts.link;
					link = strReplace(link, 'link-title',	hit.links[l].title);
					link = strReplace(link, 'link-url',	hit.links[l].url);
					link = strReplace(link, 'link-target',	hit.links[l].target);
					links += link;
				}
			}
			item = strReplace(item, 'tpl-links',			links != '' ? tpl.contacts.links : '');
			item = strReplace(item, 'links',				links);
			return item;
		};
		var strReplace_Tags = api.strReplace_Tags = function(item, hit) {
			var tags = '';
			if (hit.tags) {
				for (var i in hit.tags) {
					var tag = '' + tpl.tags.item;
					tag = strReplace(tag, 'tag',	hit.tags[i].title);
					tags += tag;
				}
			}
			item = strReplace(item, 'tpl-tags',			tags != '' ? tpl.tags.items : '');
			item = strReplace(item, 'tags',				tags);
			return item;
		};
		var strReplace_Directions = api.strReplace_Directions = function(item, hit) {
			var directions = '';
			if (hit.driving_directions) {
				for (var d in hit.driving_directions) {
					var direction = '' + tpl.contacts.direction;
					direction = strReplace(direction, 'directions-title',	hit.driving_directions[d].title);
					direction = strReplace(direction, 'directions-url',		hit.driving_directions[d].coordinates ? 'https://maps.google.com/maps?q=' + hit.driving_directions[d].coordinates.lat + ',' + hit.driving_directions[d].coordinates.lng : hit.driving_directions[d].url);
					directions += direction;
				}
			}
			item = strReplace(item, 'directions',			directions != '' ? tpl.contacts.directions : '');
			item = strReplace(item, 'directions',			directions);
	
			return item;
		};
	
		var backQuote = function(str){
			return str.split('"').join("&quot;").split("'").join("&apos;");
		};


	// =======================================
	//  CLASSES
	// =======================================

	var classes = {
		search:			'.search',
		nav:			'.nav-search a:not(.js-search-overlay__trigger)',
		search_input:	'.search__input',
		input:			'.search__input input',
		input_bar:		'.search-bar__input input',
		input_reset:	'.search__input__reset',
		categories:		'.search__categories.is-main-categories',
		overview_inner: '.overview__inner',
		results:		'.search__results',
		more:			'.search__results__more',
		list:			'.overview__results, .js-search-results',
		total:			'.overview__total',
		subnav:			'.subnav:not(.filters)',
		//subnav_algolia:	'.subnav__inner--algolia a, .search-bar__filter input',
		subnav_algolia:	'.subnav__inner--algolia a',
		subnav_items:	'.subnav:not(.filters) a',
		subnav_active:	app.states.isActive,
		filters_form:	'.filters__content form',
		pagination:		'.pagination__button',
		keywords:		'.keywords',
		keywords__list:	'.panel__keywords',
        buttons_change:	'.buttons-change',
        filters_selected: '.js-filters-selected',
	};

	var search;
	var search_global	= $el.hasClass('search--global');
	var search_bar		= $el.hasClass('search--bar');
	var search_page		= $el.hasClass('search--page');
	var bgPage			= $el.parents('#overlay-bg-page').length;
	var search_borouge	= $('.site-main').children().length < 1;
	var $search			= $el;
	var $search_input	= $(classes.search_input, $search);
	var $input			= $(classes.input, $search);
	var $input_bar		= $(classes.input_bar, $search);
	var $input_reset	= $(classes.input_reset, $search);
	var $categories		= $(classes.categories, $search);
	var $overview_inner	= $(classes.overview_inner, $search);
	var $results		= $(classes.results, $search);
	var $results_list	= $(classes.list, $results);
	var $total			= $(classes.total, $results);
	var $subnav			= $(classes.subnav, $results);
	var $subnav_items 	= $(classes.subnav_items, $results);
	var $subnav_algolia = $(classes.subnav_algolia, $search);
	var $filters_form	= $(classes.filters_form, $search);
    var $filters_selected = $(classes.filters_selected, $search);
	var $keywords		= $(classes.keywords, $search);
	var $keywords__list	= $(classes.keywords__list, $search);
	var local_page 		= $html.data('local-page-slug');
	var is_touch		= $('html.screen--is-touch').length;
	var $filterChange;
	var $filterReset;
	var searchTrackingTimer;
	var result_timer

	// A L G O L I A

	api.vars = {
		client			: algoliasearch('H9MGR4J50G', '222db8d1210fa4a119a57e09b3e768d9', {protocol: 'https:'}),
		prefix			: app.vars.urlParam['search-env'] ? (app.vars.urlParam['search-env'].length > 0 ? app.vars.urlParam['search-env'] + '_' : '') : $html.attr('data-search-prefix'), // || 'develop_',
		sorted			: '_sorted',
		suffix			: '',
		cache			: false,
	};

	var algolia               = location.search.indexOf('no-algolia') < 0;
	var client                = api.vars.client;
	var prefix                = api.vars.prefix;
	var sorted                = api.vars.sorted;
	var suffix                = api.vars.suffix;
	var indexList             = {};
	var index;
	var indexNew;
	var searchData            = $search.data();
	var hitsPerPage           = searchData.searchHitsPerPage || 12;
	var hitsMore              = 0;
	var params                = {hitsPerPage: hitsPerPage, facets: '*', facetFilters: ''};
	var filters_set           = {};
	var filters_get;
	var filters_initial;
	var filter_reset;
	var filters_add           = '';
	var filters_active_add    = '';
	var filter_change_nested;
	var input_initial;
	var result;
	var result_timer;
	var result_swiper         = searchData.searchResultsSwiper;
	var url_params            = '';
	var history_url           = '';
	var search_param          = search_global ? 'search-global' : 'search-category';
	var search_callback       = searchData.searchResultCallback;
	var search_object         = searchData.searchObject || 'search';
    var search_index          = searchData.searchIndex || false;
    var search_category       = searchData.searchCategory || false;
	var search_filters        = searchData.searchFilters;
	var search_filters_active = searchData.searchFiltersActive;
	var search_filters_hidden = searchData.searchFiltersHidden;
	var search_filters_nested = searchData.searchFiltersNested;
	var search_filters_set;
	var search_sort           = searchData.searchSort;
	var search_group          = searchData.searchGroup;
	var search_exclude        = searchData.searchExclude;
	var search_by_object_id   = !search_global && search_filters && search_filters.objectID;
	var search_media_id       = 'id-media-search';
	var search_count          = 0;
	var scroll                = !searchData.searchNoscroll;
	var history_pop;
	var pagination_type       = searchData.searchPaginationType || 'default';
	var pagination_click;
	var algoliaAutocomplete;
	var search_initialized;
	var searchBorouge;

	var init = function() {
		addListeners();

		if ($('.search--iframe').length) {
			$html.addClass('site--iframe');
		}
		if ($('.site__wrapper .search--global').length) {
			$html.addClass('search--page');
		}

		// SET LANGUAGE
		var locale = $html.attr('lang') || 'en-gb';
		moment.locale(locale == 'en' ? 'en-gb' : locale);

		// FILTER HISTORY
		api.filterHistoryCheck();
		$win.off('popstate.' + search_object).on('popstate.' + search_object, api.filterHistoryCheck);

		if(search_page) {
			addOpenHandler();
			if(bgPage && search_global){
				$('[data-category-link="products"]', $el).trigger('click.search_category_index');
			}
		}else if(search_bar){
			searchBar();
		}
	};

	// #######################################
	//  A L G O L I A  F U N C T I O N S
	// #######################################

	// =======================================
	//  CREATE INDICES OBJECT
	// =======================================
		var indices = function(indexName) {
			var obj		= [];
			var _index	= !search_borouge ? 'autocomplete' : 'autocomplete_borouge';
			var list	= [{index: _index}];
			hits		= 6;
	
			for (var i in list) {
				obj.push({
					source: autocomplete.sources.hits(client.initIndex(prefix + list[i].index + suffix), {hitsPerPage: hits, facetFilters: params.facetFilters, filters: params.filters}),
					displayKey: 'title',
					templates: {
						suggestion: function(suggestion) {
							var sugTemplate = '<span>' + suggestion._highlightResult.title.value + '</span>';
							return sugTemplate;
						},
					},
				});
			}
			return obj;
		};

	// =======================================
	//  AUTOCOMPLETE
	// =======================================
		api.algoliaAutocomplete = function(indexName) {
			if (search_global || search_bar) {
				if (algoliaAutocomplete) {
					algoliaAutocomplete.autocomplete.destroy();
				}
				//console.log('algoliaAutocomplete - index:'+indexName);
				algoliaAutocomplete = autocomplete((search_global ? '#search' : '#search-bar'), {hint: false, debug: true, autoselectOnBlur: false, autoselect: false, openOnFocus: false}, indices(indexName))
					.off('autocomplete:selected').on('autocomplete:selected', function(event, suggestion, dataset) {
						if (search_global) {
							api.search(index, false);
						}else if (search_bar) {
							searchBar.submit(suggestion.title, indexName);
						}
					})
					.off('autocomplete:updated').on('autocomplete:updated', function(event, suggestion, dataset) {
					})
				;
			}
		};

	// =======================================
	//  KEYWORDS
	// =======================================
		var keywords = function() {
			var $suggestion = $('.aa-dropdown-menu .aa-suggestion', $search);
	
			if ($suggestion.length || $input.val() == '') {
				$keywords.removeClass('keywords--show');
				$keywords__list.empty();
			}
			if ($suggestion.length) {
				$keywords.addClass('keywords--show');
				$suggestion.each(function() {
					$keywords__list.append('<li>' + $(this).text() + '</li>');
				});
			}
		};

	// =======================================
	//  SEARCH
	// =======================================
	api.search = function (indexName, callback) {
		var queries = [];
		var query = $input.length ? $input.val() : '';
	
		//console.log('indexName: '+indexName);
		//console.log($input);
	
		search_count++;
	
		if (!api.vars.cache) client.setExtraHeader('Cache-Control', Date.now());
	
		if (search_count < 2) {
			input_initial = query.length > 0;
		}
	
		if (!indexName || indexName == 'all') {
			index = false;
			params.hitsPerPage = 0;
	
			for (var i in indexList) {
				filterAutoActive(indexList[i].index);
				params.filters = filters_active_add;
	
				// hide entries
				if (indexName == 'all') {
					if (params.filters.length) {
						params.filters += ' AND ';
					}
					params.filters += '(NOT visible:false)';
				}
	
				queries.push({ indexName: prefix + indexList[i].index + suffix, query: query, params: JSON.parse(JSON.stringify(params)) });
			}
		} else {
			index = indexName;
			params.hitsPerPage = hitsPerPage * (hitsMore + 1);
	
			filterAutoActive(index);
			params.filters = filters_active_add + ((filters_active_add != '' && filters_add != '') ? ' AND ' : '') + filters_add;
	
			if (index == 'news' || index == 'events') {
				if (params.filters.length) {
					params.filters += ' AND ';
				}
				params.filters += '(NOT visible:false)';
			}
	
			if (search_sort) {
				filtersAdd(search_sort, 'OR');
			}
			if (search_exclude) {
				filtersAdd(search_exclude, 'AND', 'NOT');
			}
	
			// SINGLE INDEX QUERY
			queries.push({
				indexName: prefix + indexName + suffix, query: query, params: params,
			});
		}
	
		$search.attr('data-input', query);
	
		console.log(queries);
	
		// TRACKING
		clearTimeout(searchTrackingTimer);
		searchTrackingTimer = setTimeout(function () {
			app.obj.tracking.track({
				category: 'Header',
				action: 'Search Order - Submit',
				label: (query.length > 1 ? query : ''),
			});
		}, 1000);
	
		client.search(queries, function searchDone(err, content) {
			if (!callback) {
				showResults(content);
				keywords();
			} else {
				callback(content, filters_set);
			}
		});
	
		if (!search_initialized) {
			app.parse($('.js-tabs-nav, .js-tabs-container', $search));
			search_initialized = true;
	
			console.log('search_initialized');
	
			// MEDIA DIRECT LINK
			var media_id = app.getParam(search_media_id);
			if (media_id && typeof window.search_media_id_initialized === 'undefined') {
				window.search_media_id_initialized = true;
				mediaDirectLink(index, media_id, true);
			}
			//mediaDirectLink(app.getParam(search_param_media), true);
		}
	};
		var searchBar = function() {
			var $search_global = $('.search--global');
			var $categories = $('.search-bar__filter .dropdown', $search);
			var $button = $('.search-bar__button', $search);
			var $checked = $('input:checked', $categories);
			var selected = 'is-nested--selected';
			var _index = index;
			var _index_default = false; // 'products'
			var _index_cookie = Cookies.get(app.vars.searchbar.cookie.name) || ($html.hasClass('from-tablet') ? _index_default : false);
			
			// INITIAL INDEX
			$checked = (!$checked.length && _index_cookie) ? $('input[data-category="' + _index_cookie +'"]', $categories).prop("checked", true) : $checked;
	
			if ($checked.length){
				_index = $checked.data('category');
				$categories.addClass(selected);
				$('.dropdown__label__text__replaced__option:last-child', $categories).text(tl($checked.val()));
			}
	
			// AUTOCOMPLETE
			api.algoliaAutocomplete();
	
			// AUTOFOCUS
			setTimeout(function () {
				if (!is_touch) $input_bar.focus();
			}, 800);
	
			// INDICES
			$categories.on('change.search-bar-filter', 'input[type="checkbox"]', function(e) {
				var $_input		= $(this);
				var checked		= $_input.prop('checked');
				var v			= $_input.attr('value');
	
				$('input', $categories).not($_input).prop('checked', false).removeAttr('checked');
	
				if(checked){
					if(!$categories.hasClass(selected)){
						$categories.addClass(selected);
						$('.dropdown__label__text__replaced__option:last-child', $categories).text($('.dropdown__label__text__inner', $categories).text());
					}
					//$('.dropdown__label__text__inner, .dropdown__title', $categories).text(tl(v));
					$('.dropdown__label__text__replaced__option:first-child', $categories).text(tl(v)).appendTo($categories.find('.dropdown__label__text__replaced'));
					_index = $_input.data('category');
	
					// SET INDEX COOKIE
					Cookies.set(app.vars.searchbar.cookie.name, _index, { expires: app.vars.searchbar.cookie.expire });
				}else{
					$categories.removeClass(selected);
					_index = false;
				}
	
				$doc.trigger('click.dropdown');
				api.algoliaAutocomplete(_index || index);
			});
	
			// KEY EVENTS
			$search.on('keyup.search_bar_key', classes.input_bar, function(e){
				if (typeof e.keyCode !== 'undefined') {
					if (e.keyCode == 13) {
						$button.trigger('click');
					}
				}
			});
	
			// BUTTON
			$button.on('click', function(){
				searchBar.submit(algoliaAutocomplete.autocomplete.getVal());
			});
	
			// SUBMIT
			searchBar.submit = function(query){
				var url = location.href.split('?')[0] + '?search-global-search&input=' + query + (_index ? '&index-search='+_index : '');
				//$('<a href="'+url+'"></a>').appendTo($body).trigger('click.search_link').remove();
				history.pushState({ type: 'search' }, document.title, url);
				$search_global.data('search').filterHistoryCheck();
			};
		}

	api.algoliaInit = function() {
		$search.removeAttr('data-input data-filter-length data-filter-visible data-total');
		
		if (!api.isOpened) {
			api.isOpened = true;

			if(!search_page && !search_bar) $search.append($('.site__wrapper > .site-footer').clone());

			if (algolia) {
				$html.addClass('search--algolia');
				$('.subnav:eq(0) .subnav__inner:not(.subnav__inner--algolia)', $results).remove();
				$filters_form.empty();

				$subnav_algolia.not('[data-category="all"]').each(function() {
					var $self = $(this), i = $self.data('category');
					indexList[i] = {title: $self.text(), index: i};
				});

				//console.log('indexList:');
				//console.log(indexList);

				$('.js-filters', $search).off('change', 'input[type="checkbox"]');
			} else {
				$('.subnav__inner--algolia', $results).remove();
			}
			app.parse($('.site-footer', $search));
		}
		
		api.algoliaAutocomplete();
	};

	// #######################################
	//  L I S T E N E R S
	// #######################################
		var addListeners = function() {
			if (search_global) {
				$doc.on('click.search_nav', classes.nav, addOpenHandler);
				$doc.on('input.search_key', classes.input, inputHandler);
				$doc.on('keyup.search_key', classes.input, inputHandler);
				$doc.on('click.search_keywords_list', classes.keywords__list + ' li', keywordHandler);
				$doc.on('click.search_category_index', '.search [data-category-link]', categoryHandler);
				$doc.on('click.search_link', '[href*="?search-global-search"]', linkHandler);
				$input_reset.on('click.search_input_reset', function(e){
					$input.val('');
					api.search(index, false);
				});
			} else if (search_bar) {
				//$doc.on('input.search_bar_key', classes.input_bar, inputHandler);
				//$doc.on('keyup.search_bar_key', classes.input_bar, inputHandler);
			}
			$subnav.on('click.search_subnav', 'a', categoriesHandler);
			$search.on('click.search_pagination', classes.pagination, paginationHandler);
			$search.on('click.search_more', '.js-search-more', moreHandler);
			$search.on('click.search_filter_change', classes.buttons_change + ' [data-filter-change]', filterChangeHandler);
	
			if ($filters_selected.length) {
				$search.on('click.search_filter_selected', '[data-filter-selected]', filterSelectedHandler);
			}
		};


	// #######################################
	//  H A N D L E R S
	// #######################################

	// =======================================
	//  SEARCH OPEN
	// =======================================
		var addOpenHandler = function(event) {
			api.isOpen = !api.isOpen;
	
			if (api.isOpen) {
				//if(!search_initialized){
					api.algoliaInit();
				//}
	
				if(!search_page){
					$results_list.empty();
					$keywords.removeClass('keywords--show');
					$keywords__list.empty();
					if (algolia) $('.filters form', $search).empty();
	
					filterReset();
	
					$html.removeClass('search--results search--category');
					$categories.removeClass('is-set').removeAttr('style');
					$('.preloader', $search).remove();
					$overview_inner.removeAttr('style');
					$('.site-header').removeAttr('style');
	
					// FREEZE
					app.obj['nav-main'].close();
					$html.addClass('search--open');
					app.obj.freeze.enable();
				}else{
					app.obj['nav-main'].close();
				}
	
				$win.trigger('scroll'); // show main navigation if hidden
	
				app.obj['downloads'].overlayClose();
	
				// ADD SWIPER NAVIGATION
				// if ($subnav.data('subnav')) $subnav.data('subnav').swiper();
	
				//if(!filters_get) $input.val('');
				setTimeout(function() {
					if (!is_touch) $input.focus();
				}, 800);
			} else if(!search_page) {
				api.close();
			} else {
				app.obj['nav-main'].close();
				app.obj['downloads'].overlayClose();
			}
		};

	// =======================================
	//  SEARCH CLOSE
	// =======================================
		api.close = function() {
			api.isOpen	= false;
			search		= false;
			index		= false;
	
			//$html.addClass('search--open-change');
	
			app.obj.freeze.disable();
	
			if ($input.val() != '' && algoliaAutocomplete && algoliaAutocomplete.autocomplete) {
				//algoliaAutocomplete.autocomplete.destroy();
			}
	
			$input.val('');
			if (location.href.indexOf('?' + search_param + '-' + search_object) >= 0 || location.href.indexOf('&' + search_param + '-' + search_object) >= 0) {
				var p = location.href.indexOf('?' + search_param + '-' + search_object) >= 0 || location.href.indexOf('?') < 0 ? '?' : '&';
				var url = location.href.split(p + search_param + '-' + search_object)[0];
				history.pushState({ type: 'search' }, document.title, url);
			}
	
			$html.removeClass('search--open search--results search--category search--open-change');
			//$freeze.removeAttr('style');
			//$search.css('top', (y - s) + 'px');
		};

	// =======================================
	//  SEARCH INPUT
	// =======================================
		var inputHandler = function(e) {
			if (typeof e.keyCode !== 'undefined') {
				params.page = 0;
				hitsMore = 0;
				//$input = $(e.target);
				if (e.keyCode == 13) {
					$input.blur();
					api.search(index, false);
				} else {
					api.search(index, false);
				}
			}
		};

	// =======================================
	//  SEARCH CATEGORIES
	// =======================================
		var categoriesHandler = function(e) {
			var $target = $(e.currentTarget);
			var category = $target.data('category') ? $target.data('category') : index;
			//var filters_nav = $target.data('search-filters');
	
			params.page = 0;
			$html.addClass('search--results search--category');
			$categories.addClass('is-set').slideUp({duration: 600, easing: 'easeOutExpo'});
	
			if ($target.is('li')) {
				if (algolia) {
					$subnav_algolia.filter(':eq(' + ($('li', $categories).index($target) + 1) + ')').trigger('click');
				} else {
					$('a:eq(' + ($('li', $categories).index($target) + 1) + ')', $subnav).trigger('click');
					$('.search .overview__main__inner', $search).css('opacity', 0);
				}
			} else if (algolia && !$target.filter('[data-url]').length) {
				e.preventDefault();
	
				//$subnav_algolia.removeClass(classes.subnav_active);
				$target.siblings().removeClass(classes.subnav_active);
				$target.addClass(classes.subnav_active);
	
				//suffix = category == 'products' ? sorted : '';
	
				if (!search_global) filters_get = false;
				filterReset();
				filterSet();
	
				//console.log(params);
	
				/*if(filters_nav){
					$filterChange = false;
					filters_set = JSON.parse(JSON.stringify(filters_nav));
					filters_get = JSON.parse(JSON.stringify(filters_nav));
					filterSet();
					//console.log(filters);
				}*/
	
				api.search(category, false);
				api.algoliaAutocomplete(index);
			}
	
			setTimeout(function() {
				if (!is_touch) $input.focus();
			}, 800);
		};

	// =======================================
	//  KEYWORDS
	// =======================================
		var keywordHandler = function(e) {
			var $target = $(e.currentTarget);
			$input.val($target.text());
			api.search(index, false);
		};

	// =======================================
	//  FILTER HANDLER
	// =======================================
		var filterChangeHandler = function(e){
			e.preventDefault();
			var $target = $(e.currentTarget);
			var _filters = $target.data('filter-change');
	
			$target.parents(classes.buttons_change).find('[data-filter-change]').removeClass('is-active').filter($target).addClass('is-active');
	
			params.page = 0;
			hitsMore = 0;
			filters_get = false;
			$filterReset = false;
			filterReset();
	
			//filters_set = {};
			/*for (var f in search_filters) {
				if (search_filters[f].opt.length > 0) {
					filters_set[f] = JSON.parse(JSON.stringify(search_filters[f]));
				}
			}
			if (filters_set != {}) {
				filters_get = JSON.parse(JSON.stringify(filters_set));
				filterSet();
			}*/
	
			/*for(var _f in _filters){
				if (_filters[_f].opt.length > 0) {
					filters_set[_f] = JSON.parse(JSON.stringify(_filters[_f]));
				}
			}*/
	
			if (search_filters) {
				filters_set = {};
				for (var _f in _filters) {
					if (_filters[_f].opt.length > 0) {
						filters_set[_f] = JSON.parse(JSON.stringify(_filters[_f]));
					}
				}
				if (filters_set != {}) {
					filters_get = JSON.parse(JSON.stringify(filters_set));
					filterSet();
				}
			}
	
			//console.log(filters_set);
	
			api.search(index, false);
	
			//filterSet();
	
			/*for(var _c in _categories){
				search_filters_active[_c] = _categories[_c];
				api.search(index, false);
			}*/
		};
	var filterSelectedHandler = function(e){
	  var $target = $(e.currentTarget);
	  var facet = $target.attr('data-filter-selected');
	  var t = $target.text();
	
	  for (var i in filters_set[facet].opt) {
	    var vi = filters_set[facet].opt[i];
	
	    if (vi == t) {
	      filters_set[facet].opt.splice(i, 1);
	      if (filters_set[facet].opt.length < 1) {
	        delete filters_set[facet];
	      }
	
	      filterSet();
	      api.search(index, false);
	      break;
	    }
	  }
	};

	// =======================================
	//  CATEGORY
	// =======================================
		var categoryHandler = function(e) {
			var $target = $(e.currentTarget);
			$('[data-category="' + $target.data('category-link') + '"]', $subnav).trigger('click');
		};

	// =======================================
	//  MORE
	// =======================================
	var moreHandler = function (e) {
	    if (algolia) {
	        pagination_click = true;
	        //params.page = Math.max(0, Math.min(result.nbPages - 1, result.page + 1));
	        hitsMore += 1;
	        api.search(index, false);
	    }
	};

	// =======================================
	//  PAGINATION
	// =======================================
		var paginationHandler = function(event) {
			if (algolia) {
				var $button = $(this);
	
				//console.log('||||'+index);
	
				if (!$button.hasClass(app.states.isDisabled)) {
					pagination_click = true;
					params.page = Math.max(0, Math.min(result.nbPages - 1, result.page + ($button.hasClass('pagination__button--prev') ? -1 : 1)));
					api.search(index, false);
				}
			}
		};

	// =======================================
	//  SCROLL
	// =======================================
		var scrollUp = function() {
			if (scroll) {
				//var y = $search_input.offset().top + $search_input.outerHeight();
				var y = search_global ? 0 : $search.offset().top - $('.site-header').height();
				app.obj.site.scrollController.scrollTo(y, {
					callback: function() { if (typeof app.obj.site.scrollController.update !== 'undefined') app.obj.site.scrollController.update(true); },
					duration: 1,
				});
			}
		};


	// #######################################
	//  F I L T E R  S E T T I N G S
	// #######################################

	// =======================================
	//  PREDEFINED FILTER STRUCTURE
	// =======================================
		// FILTER RELATIONS
		var filter_group = {
			'properties.imported.matman' : 'properties.imported.matsub',
			'properties.imported.indman' : 'properties.imported.indsub',
			//'properties.imported.proman' : 'properties.imported.prosub',
		};
		var filter_parent = {
			'properties.imported.matsub' : 'properties.imported.matman',
			'properties.imported.indsub' : 'properties.imported.indman',
			//'properties.imported.prosub' : 'properties.imported.proman',
	
			'properties.imported.denval_val' : 'properties.imported.melval',
		};
	
		// FILTER ACTIVE
		var filter_active = api.filter_active = {
			'locations' : {
				'visible_in_map' : 				':' + true,
			},
			'events' : {
				'end_integer' :					' >= ' + moment(new Date()).format('YYYYMMDD'),
			},
		};
	
		// FILTER DISTINT
		var filter_distinct = {
			'documents' : 'distinct',
		};
	
		// FILTER SLIDER
		var filter_slider = {
			'properties.imported.melval' : true,
			'properties.imported.denval_val' : true,
		};
	
		var filter_slider_parent = {
			'properties.imported.denval_val' : 'properties.imported.melval',
		};
	
		// FILTER HIDDEN
		var filter_hidden = api.filter_hidden = {
			'visible_in_map' :					true,
			'visible_in_teaser' :				true,
			'properties.imported.denval_val' :	true,
			'properties.imported.melwei_val' :	true,
			'properties.imported.melval' :		true,
			'newslocation' :					true,
			'channels.title' :					true,
			'isLocal' :							true,
			'end_integer' :						true,
			'distinct' :						true,
			'locationID' :						true,
			'visible' :							true,
		};
	
		// FILTER KEYS - SQL
		var filter_keys = api.filter_keys = {
			//'properties.imported.melwei_val':	'properties.imported.melval',
		};

	// =======================================
	//  FILTER SORTING
	// =======================================
		var filter_values = {
			'year':			'DESC',
			'month':		['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
		};
	
		var sorted_values = {};
	
		var filterCategories = [
			{
				'name': 'filters.documents',
				'categories': documentCategories,
			},{
				'name': 'filters.media',
				'categories': mediaCategories,
			}
		];
	
		var sortedCategories = [
			{
				'name': 'filters.documents',
				'categories': documentCategoriesOrder,
			},
		];
	
		var filterValuesAdd = function(i, n, k, val, obj) {
			if (val.length > 2) {
				//console.log(i+','+k+','+val+','+filter_values[k])
				if (!filter_values[k]) filter_values[k] = [];
				if (filter_values[k].indexOf(val) < 0) filter_values[k].push(val);
				if (!filter_values[n +'.'+ i]) filter_values[n +'.'+ i] = [];
				if (filter_values[n +'.'+ i].indexOf(val) < 0) filter_values[n +'.'+ i].push(val);
			} else if (typeof obj === 'string' && obj.length > 1) {
				if (!filter_values[k]) filter_values[k] = [];
				if (filter_values[k].indexOf(obj) < 0) filter_values[k].push(obj);
				if (!filter_values[n +'.'+ i]) filter_values[n +'.'+ i] = [];
				if (filter_values[n +'.'+ i].indexOf(obj) < 0) filter_values[n +'.'+ i].push(obj);
			}
	
			for (var key in obj) {
				var cat = obj[key];
				if((typeof cat === 'object') || (typeof cat === 'array') || (typeof cat === 'string' && cat.length > 1)){
					filterValuesAdd(i+1, n, val, key, cat);
				}else{
					//console.log('--'+(typeof obj)+' = '+key)
				}
			}
		};
	
		var sortedValuesAdd = function(i, n, key, obj) {
			if (!sorted_values[n+'.'+i]) sorted_values[n+'.'+i] = {};
			sorted_values[n+'.'+i][key] = obj;
			//console.log(i+' | '+key+' | '+obj+' | '+children);
	
			for (var key in obj.children) {
				var cat = obj.children[key];
				if((typeof cat === 'object')){
					sortedValuesAdd(i+1, n, key, cat);
				}
			}
		}
	
		// CREATE AND SORT CMS GENERATED FILTER CATEGORIES/VALUES
		for(var c in filterCategories){
			var name = filterCategories[c].name;
			var categories = filterCategories[c].categories;
	
			for (var key_1 in categories) {
				var cat_1 = categories[key_1];
				filterValuesAdd(1, name, name+'.1', key_1, cat_1);
			}
		}
		//console.log(filter_values);
	
		for(var c in sortedCategories){
			var name = sortedCategories[c].name;
			var categories = sortedCategories[c].categories;
	
			for (var key_1 in categories) {
				var cat_1 = categories[key_1];
				sortedValuesAdd(1, name, key_1, cat_1);
			}
		}
		//console.log(sorted_values);


	// #######################################
	//  F I L T E R  F U N C T I O N S
	// #######################################

	// =======================================
	//  FILTER HISTORY
	// =======================================
		var filterHistory = function() {
			if (!history_pop) {
	
				// NEW
				if (!search_filters || search_filters_set) {
					var p = location.href.indexOf('?' + search_param + '-' + search_object) >= 0 || location.href.indexOf('?') < 0 ? '?' : '&';
					history_url = location.href.split(p + search_param + '-' + search_object)[0] + p + search_param + '-' + search_object + (index ? '&index-' + search_object + '=' + index : '') + ($input.val() != '' ? '&input=' + $input.val() : '');
					if (params.page) history_url += '&page-' + search_object + '=' + params.page;
					//console.log('params.page ' + params.page);
					if (index && url_params != '') history_url += '&filter-' + search_object + '=' + encodeURIComponent(url_params.substr(1).split('|,').join(','));
					filterHistoryID('POST');
				} else {
					search_filters_set = true;
				}
				//
			} else {
				history_pop = false;
			}
		};
	
		api.filterHistoryCheck = function(e) {
			if(typeof e !== 'undefined'){
				hitsMore = 0;
			}
			app.urlParams();
			if (app.vars.urlParam[search_param + '-' + search_object]) {
				var search_id = app.vars.urlParam['id-' + search_object];
	
					//console.log('filterHistoryCheck');
					searchNavCheck();
	
				if (search_id) {
					filterHistoryID('GET', search_id);
				} else {
					history_url = location.href;
					filterHistorySet();
				}
			} else if (!search_global && !search_initialized) {
				var index_category = search_index || $search.data('search-category');
	
				if(index_category){
					index = index_category;
					if (search_filters) {
						filters_set = {};
						for (var f in search_filters) {
							if (search_filters[f].opt.length > 0) {
								filters_set[f] = JSON.parse(JSON.stringify(search_filters[f]));
							}
						}
						if (filters_set != {}) {
							filters_get = JSON.parse(JSON.stringify(filters_set));
							filterSet();
						}
					}
	
					api.search(index, false);
				}
			} else if (search_global && api.isOpen) {
				api.close();
			}
		};
		var filterHistoryID = _.debounce(function(type, id) {
			//console.log('filterHistoryID: ' + type);
			jQuery.ajax({
				context: this,
				url: '/api/search.php?cache=' + Date.now(),
				type: 'POST',
				data: {
					type: type,
					id: id,
					query: encodeURIComponent(history_url),
				},
				dataType: 'json',
				cache: false,
				success: function(data) {
					if (type == 'POST') {
						//var url = location.href.split('?')[0]+'?'+search_param+'&index='+index;
						var p = location.href.indexOf('?' + search_param + '-' + search_object) >= 0 || location.href.indexOf('?') < 0 ? '?' : '&';
						var url = location.href.split(p + search_param + '-' + search_object)[0] + p + search_param + '-' + search_object + '&index-' + search_object + '=' + index + '&id-' + search_object + '=' + data.id;
						var url_filter = url.indexOf('filter-' + search_object);
						
						if (url_filter >= 0) {
							url = url.substring(0, url_filter) + url.substring(url.indexOf('&', url_filter + 1));
						}
	
						if (!history.state || history.state.id != data.id) {
							if (params.page) url += '&page-' + search_object + '=' + params.page;
							history.pushState({ type: 'search', id: data.id }, document.title, url);
						}
						//console.log('PUSH');
					} else {
						history_url = decodeURIComponent(data.query);
						//params.page = app.getParam('page-'+search_object, history_url) || 0;
						filterHistorySet();
					}
				},
				error:function(data) {},
			}).done(function() {});
		}, 1000);
	
		var filterHistorySet = function() {
			//console.log('filterHistorySet');
			history_pop = true;
			$filterChange = false;
			filtersGet();
			filterReset();
			filterSet();
			//$('html:not(.search--open)').addClass('search--open search--results search--category');
			
			if (search_global) {
				var is_category = (index && index != 'all');
				var category_opened = is_category ? $html.hasClass('search--category') : false;
				var search_opened = $('html.search--open').length;
			
				if (!search_opened || (is_category && !category_opened)) {
					//$(classes.nav).trigger('click.search_nav');
					setTimeout(function() {
						if(!search_opened) addOpenHandler();
			
						if (is_category) {
							if (!search_borouge && category_opened) {
								$('.search--global [data-category-link="' + index + '"]').trigger('click.search_category_index');
							} else {
								$html.addClass('search--results search--category');
								$categories.addClass('is-set').slideUp({duration: 600, easing: 'easeOutExpo'});
								api.search(index, false);
								api.algoliaAutocomplete(index);
							}
						} else {
							api.search(false, false);
						}
					}, 10);
				} else {
					api.algoliaAutocomplete(index);
					api.search(index, false);
				}
			} else {
				api.search(index, false);
			}
		};
	
		var linkHandler = function(e){
			var base = location.href;
			var href = $(e.currentTarget).attr('href');
	
			e.preventDefault();
			if(href.indexOf('?search-global')==0){
				if(base.indexOf('search-global')>=0){
					base = base.split('search-global')[0];
					href = base+href.substr(1);
				}else{
					href = base+(base.indexOf('?')>=0 ? '&' : '?')+href.substr(1);
				}
			}
			history.pushState({ type: 'search' }, document.title, href);
			api.filterHistoryCheck();
		};
	
		var searchNavCheck = function() {
			if (!search_global) {
				var $button = $(classes.subnav + ' [href*="' + location.href.split('/').pop().split('&search-category')[0] + '"]:eq(0)', $search.parents('.js-tabs '));
				$button.parent().parent().parent().parent().find('.' + app.states.isActive).removeClass(app.states.isActive);
				$button.addClass(app.states.isActive);
			}
		};

	// =======================================
	//  FILTER TITLES
	// =======================================
		var filterTitles = function(f) {
			var title = (!filter_titles_variants[index] || !filter_titles_variants[index][f]) ? filter_titles[f] : filter_titles_variants[index][f];
			return title ? title : f;
		};

	// =======================================
	//  FILTER AUTO ACTIVE
	// =======================================
		var filterAutoActive = function(category) {
			params.facetFilters = [];
			filters_active_add = '';
			if (filter_active[category]) {
				for (var f in filter_active[category]) {
					//params.facetFilters.push(f + filter_active[category][f]);
					filters_active_add += (filters_active_add == '' ? '' : ' AND ') + '(' + (f + filter_active[category][f]) + ')';
				}
			}
	
			if (search_filters_active && search_filters_active[category]) {
				for (var f in search_filters_active[category]) {
					params.facetFilters.push(f + ':' + search_filters_active[category][f]);
				}
			}
		};

	// =======================================
	//  FILTER RESET
	// =======================================
		var filterReset = function() {
			//console.log('filterReset');
	
			if (!filters_get) {
				$('.js-filters .js-dropdown.is-selected', $search).removeClass('is-selected');
				$('.js-filters .js-filters-item input:checked', $search).prop('checked', false).removeAttr('checked');
				params.filters = '';
				//params.page = 0;
				filters_set = {};
				filter_reset = true;
			} else {
				filters_set = JSON.parse(JSON.stringify(filters_get));
				//filterSet();
			}
		};

	// =======================================
	//  FILTER CHANGE NESTED
	// =======================================
		var filterChangeNested = function($filter) {
			//console.log('filterChangeNested');
			filter_change_nested = true;
			$filter.addClass(app.states.isChange+' is-nested--selected');
			setTimeout(function(){
				$filter.removeClass(app.states.isChange);
			}, 30);
			/*setTimeout(function(){
				$filter.next().filter('.is-nested:not(.is-disabled):not(.is-hidden)').trigger('click.dropdown_element');
			}, 700);*/
		};

	// =======================================
	//  FILTER SET
	// =======================================
	var filterSet = function () {
		var filters = '';
		url_params = '';
		suffix = '';
		var rangeCounter = 0;
	
		console.log('filterSet:');
		console.log(filters_set);
	
		for (var f in filters_set) {
			var fi = filters_set[f];
			var opt = fi.opt;
			var sql = '';
			var operator = fi.operator || 'AND';
			var opt_op = fi.opt_operator || 'OR';
			var range = fi.type && fi.type == 'range';
			var key = filter_keys[f] || f;
			
	
			operator = ' ' + operator + ' ';
			opt_op = ' ' + opt_op + ' ';
	
			//if($('[data-filter="'+f+'"]', $search).length){
			if ($('[data-filter="' + f + '"] .dropdown__items:eq(0) input', $search).length || range || filters_get) {
	
				var _url_params = '';
	
				if (!range) {
					var _sql = '';
					var _opt = '|' + opt.join('|') + '|';
					
					for (var v in opt) {
						var vi = opt[v];
	
						if ($('[data-filter="' + f + '"] [value="' + vi + '"]', $search).length || filters_get) {
							_url_params += vi + '|';
							sql += opt_op + key + ':' + '"' + vi + '"';
	
							// SORTED INDEX
							if (sorted_values[f]) {
								var sort_obj = sorted_values[f][vi];
								if (sort_obj.order != 'default') {
									suffix = '_' + sort_obj.order.toLowerCase() + '_' + sort_obj.orderby;
									//console.log('suffix:'+suffix);
								}
							}
	
						} else {
						
							opt.splice(_opt.indexOf('|' + vi + '|'), 1);
						}
					}
					if (_url_params.length > 0) _url_params = _url_params.substr(0, _url_params.length - 1);
					_sql = sql.substring(opt_op.split('NOT').shift().length);
	
					if (_sql.length > 0) filters += ((filters != '') ? operator : '') + '(' + _sql + ')';
				} else {
	
					rangeCounter++
					
				
					_url_params += opt.min_range + '|' + opt.max_range + '|' + opt.min + '|' + opt.max;
	
					console.log(Object.keys(filters_set))
	
					if(Object.keys(filters_set).includes('properties.imported.denval_val') && Object.keys(filters_set).includes( 'properties.imported.melval')) {
				
						if(rangeCounter === 1 ) {
							filters += '(' + key + ' >= ' + opt.min + ')' + ' AND ' + '(' + key + ' <= ' + opt.max + ')' + ' AND ';
						} else {
							filters += '(' + key + ' >= ' + opt.min + ')' + ' AND ' + '(' + key + ' <= ' + opt.max + ')';
						}
	
					} else {
						filters += '(' + key + ' >= ' + opt.min + ')' + ' AND ' + '(' + key + ' <= ' + opt.max + ')';
					}
					
					
	
	
					
					
				}
				if (_url_params.length > 0) {
					url_params += ',' + f + '[' + _url_params + ']';
				}
	
			
	
	
			}
		}
	
		//suffix = filters.length>0 ? '' : (index == 'products' ? sorted : '');
		if ($filterChange) {
			params.page = 0;
			hitsMore = 0;
		}
	
	
		
	
		filters_add = filters;
	
	
	};

	// =======================================
	//  FILTERS ADD
	// =======================================
	var filtersAdd = function (_filters, _operator, _opt_operator) {
	  var sql = '';
	
	  for (var f in _filters) {
	    var _filter       = _filters[f];
	    var opt           = _filter.opt;
	    var operator      = _filter.operator ? ' ' + _filter.operator + ' ' : (_operator ? ' ' + _operator + ' ' : ' AND ');
	    var opt_operator  = _filter.opt_operator ? ' ' + _filter.opt_operator + ' ' : (_opt_operator ? ' ' + _opt_operator + ' ' : ' OR ');
	
	    for (var o in opt) {
	      sql += opt_operator + f + ':' + '"' + opt[o] + '"';
	    }
	  }
	
	  params.filters += ((params.filters != '') ? operator : '') + '(' + sql.substring(opt_operator.split('NOT').shift().length) + ')';
	};

	// =======================================
	//  FILTERS GET
	// =======================================
		var filtersGet = function() {
			if (location.search.length > 0 && app.vars.urlParam[search_param + '-' + search_object]) {
	
				var query		= history_url;
				//var url_filter	= query.split('&filter-'+search_object+'=')[1];
				//var url_input	= query.split('&input=')[1];
				var url_filter	= app.getParam('filter-' + search_object, query);
				var url_input	= app.getParam('input', query);
	
				//params.page		= query.split('&page-'+search_object+'=')[1].split('&')[0];
				params.page		= app.getParam('page-' + search_object, query) || 0;
				filters_get		= {};
				index			= app.vars.urlParam['index-' + search_object];
	
				//console.log('filtersGet');
				//console.log(query);
	
				if (index && (index == '' || index == 'false'))	index = false;
				//$input.val(url_input ? decodeURIComponent(url_input.split('&')[0]) : '');
				$input.val(url_input ? decodeURIComponent(url_input) : '');
	
				if (url_filter) {
					url_filter	= decodeURIComponent(url_filter);
					var p		= url_filter.indexOf('],') >= 0 ? url_filter.split('],') : [url_filter];
	
					console.log(url_filter);
					console.log(p);
	
					for (var i in p) {
						var f = p[i].split('[');
						var v = f[1].split(']')[0].split('|');
						var facet = f[0];
	
						if (!filter_slider[facet]) {
							filters_get[facet] = {opt:v};
							filterChangeButtons(facet, v);
						} else {
							filters_get[facet] = {type:'range', opt:{min_range: v[0], max_range: v[1], min: v[2], max: v[3]}};
						}
						// FIRST CALL - PAGE LOAD
						if(search_count<1) filters_initial = true;
					}
					//console.log(filters_get);
				} else {
					filters_get = false;
				}
			}else{
				$input.val('');
			}
		};
	
		var filterChangeButtons = function(facet, opt){
			//console.log('filterChangeButtons:'+facet);
			$search.find(classes.buttons_change+' a').filter("[data-filter-change*='{\""+facet+"\"']").removeClass('is-active').each(function(){
				var $self = $(this);
				if($self.data('filter-change')[facet].opt[0] == opt[0]){
					$self.addClass('is-active');
				}
			});
		};

	// =======================================
	//  FILTER RANGE
	// =======================================
	var filterRangeTimer;
	var filterRangeUpdate = function (min, max) {
		var $range = $(this);
		var $overlay = $range.parents('.overlay');
		var $button = $('.js-advanced-filter-show', $overlay);
		var $filter = $range.parents('[data-filter-slider]');
		var range = $range.data('range').split(',');
		var button_title = $button.data('title');
		var _f = $filter.data('filter-slider');
		var values = $filter.data('values');
	
		$filterChange = $filter;
	
		clearTimeout(filterRangeTimer);
		filterRangeTimer = setTimeout(function () {
	
			//params.numericFilters = '["'+_f+' >= '+min+'","'+_f+' <= '+max+'"]';
	
			filters_set[_f] = { type: 'range', opt: { min_range: range[0], max_range: range[1], min: min, max: max } };
	
			filterSet();
			api.algoliaAutocomplete(index);
			api.search(index, function (content) {
				var hits = content.results[0].nbHits;
				$button.text(button_title + ' (' + hits + ')').removeClass('button--disabled').addClass(hits > 0 ? '' : 'button--disabled');
			});
		}, 100);
	};

	// =======================================
	//  FILTER TRACKING
	// =======================================
	
		var filterTracking = function() {
			var _filters_get = JSON.parse(JSON.stringify(filters_set));
			var _filters_set = {}
			for (var f in _filters_get) {
				_filters_set[filter_titles[f]] = _filters_get[f];
			}
			return _filters_set;
		};

	// =======================================
	//  FILTER CREATE
	// =======================================
	var filterCreate = function (f, category) {
		var facet = category.facets[f];
		var facet_stats = category.facets_stats ? category.facets_stats[f] : false;
		var filter = { title: filterTitles(f), values: [] };
		var slider = filter_slider[f];
		var group = filter_group[f];
		var parent = filter_parent[f];
		var hidden = filter_hidden[f];
		var title = filterTitles(f);
		var $filter = $('[data-filter="' + f + '"]', $search);
		var $item;
		var $parent;
		var nested;
		var change = $filterChange && ($filterChange[0] == $filter[0]);
		var changeParent = $filterChange && $filterChange.parents('.filters__button').length > 0 && $filterChange.parents('.filters__button')[0] == $filter[0];
		var reset = $filterReset && ($filterReset[0] == $filter[0]);
		var other = 'Other';
	
	
	
	
	
		if (change || changeParent || reset) {
			//console.log('- change: ' + change);
			//console.log('- changeParent: ' + changeParent);
			//console.log('- reset: ' + reset);
		}
	
		if (changeParent) {
			change = true;
			/*if(!$('.dropdown__items:eq(0) input:checked', $filterChange).length){
				change = false;
			}*/
		}
	
		if (reset || !change) {
	
			if (!reset && $filter.length && !parent) {
				//$filter.remove();
			}
	
			if (!parent) {
				if ($filter.length) {
					$item = $filter;
				} else {
					if (!slider && !group && !parent && !reset) {
						$item = $(templates.filter.item);
					} else if (group) {
						$item = $(templates.filter.group);
					} else if (slider) {
						$item = $(templates.filter.button);
					} else if (reset) {
						$item = $filter;
					}
				}
			} else {
				$parent = $('[data-filter="' + parent + '"]');
	
				if (!slider) {
					$item = $('.dropdown__section[data-item="2"]', $parent);
				} else {
					$item = $('form', $parent);
				}
				//console.log('PARENT');
			}
	
			var $options = $('.dropdown__items:eq(0)', $item);
	
			if (reset || (!$filterChange || $filterChange[0] != $filter[0])) {
				$options.empty();
				if (reset) {
					$filterReset = false;
					console.log('---- RESET ----');
				}
			}
	
			$item.attr('data-filter', f).data('i', Object.keys(filter_titles).indexOf(f));
	
			// SORT NESTED FILTER VALUES
			if (search_filters_nested && search_filters_nested[index]) {
				if (search_filters_nested[index].join(',').indexOf(f) > -1) {
					var $prev = $('input:checked', $item.prev());
	
					$item.addClass('is-nested');
					nested = true;
	
					if (!$prev.length) $prev = $('input:checked', $filters_form.children().last());
					//if ($prev.length) {
					if ($prev.length && !filter_values[f]) {
						filter_values[f] = filter_values[$prev.attr('value')];
						//console.log('NESTED:'+$prev.attr('value')+', '+f);
						//console.log(filter_values[f]);
					}
				}
			}
	
			// READ & SORT FILTER VALUES
			//if(!slider){
			for (var v in facet) {
				if (!slider) filter.values.push(v != 'false' ? v : other);
				else if (v != 'false') filter.values.push(parseFloat(v));
			}
			if (!slider) {
				var sort = filter_values[f] || 'ASC';
				if (!Array.isArray(sort)) {
					filter.values.sort(function (a, b) {
						if (a !== other && b !== other) return (sort == 'ASC' ? a.toLowerCase().localeCompare(b.toLowerCase()) : b.toLowerCase().localeCompare(a.toLowerCase()));
						else if (a === other) return 1;
						else return -1;
					});
				} else {
					filter.values.sort(function (a, b) {
						var v1 = filter_values[f].indexOf(a);
						var v2 = filter_values[f].indexOf(b);
						//console.log(v1+': '+a+' | '+v2+': '+b+' = '+(v1 == v2 ? '0' : (v1 > v2 ? '1' : '-1')));
						//if(v1 == v2) return 0;
						return v1 > v2 ? 1 : -1;
						//return filter_values[f].indexOf(a) - filter_values[f].indexOf(b);
					});
				}
			}
			//}
	
			$('.dropdown__label__text__inner, .dropdown__title.js-dropdown-close', $item).text(tl(title.indexOf('filters.') < 0 ? title : 'Subcategories'));
	
			if (group) {
				$('.dropdown__title__link[data-item="1"]', $item).text(tl(title));
			} else if (parent) {
				$('.dropdown__title__link[data-item="2"]', $parent).text(tl(title));
			}
	
			if (!slider && !hidden) {
	
				// CREATE OPTIONS
				var i = 0;
				var i_active = 0;
				$item.removeClass('is-selected');
	
				for (var v in filter.values) {
					var label = filter.values[v];
					var val = label != other ? label : 'false';
					var $option = $(templates.filter.option);
					var $_input = $('input', $option);
					var id = search_object + '-facet__' + f + '__' + i;
					var active = filters_set[f] && ('|' + filters_set[f].opt.join('|') + '|').indexOf('|' + val + '|') >= 0;
	
					$('label', $option).attr('for', id).text(tl(label));
					$('input', $option).attr('id', id).attr('name', id).attr('value', val);
	
					if (active) {
						i_active++;
						$_input.prop('checked', true).attr('checked', 'checked');
						$item.addClass('is-selected');
					}
					$options.append($option);
					i++;
	
					if (reset) $win.trigger('scrollRefresh');
				}
	
				//console.log(filters_get);
	
				// FILTERS HIDDEN
				if (search_filters_hidden && search_filters_hidden[index]) {
					if (String(',' + search_filters_hidden[index].join(',') + ',').indexOf(',' + f + ',') > -1) {
						$item.addClass('is-hidden');
					}
				}
	
				// FILTER NESTED SELECTED
				var $checked = $('input:checked', $item);
				if ($checked.length && nested) {
					$item.addClass('is-nested--selected');
					$('.dropdown__label__text__replaced__option:last-child', $item).text(tl($checked.val()));
				}
	
				// APPEND FILTER
				if (!parent && !reset && !$filter.length) {
					$filters_form.append($item);
					if (!group) app.parse($item);
	
					/*setTimeout(function(){
						$('input[type="checkbox"]:eq(0)', $item).trigger('change.filterInput');
					}, 0);*/
	
					// ADD LISTENERS
					//$item.off('change', 'input[type="checkbox"]');
					$item.on('change.algolia', 'input[type="checkbox"]', function (e) {
						var $_input = $(this);
						var checked = $_input.prop('checked');
						var name = $_input.attr('name');
						var facet_arr = name.split('__');
						var facet = facet_arr[1];
						var v = $_input.attr('value');
						var $_filter = $('[data-filter="' + facet + '"]', $search);
	
						$filterChange = $_filter;
						$filterReset = false;
	
						//console.log('change.algolia');
	
						if (!filters_set[facet]) filters_set[facet] = { opt: [] };
	
						var _f = filters_set[facet];
	
						// FILTERS NESTED
						if (search_filters_nested && search_filters_nested[index]) {
							if (search_filters_nested[index].join(',').indexOf(facet) > -1) {
								$('input', $_filter).not($_input).prop('checked', false).removeAttr('checked');
								_f.opt = [];
								$_filter.nextAll().each(function () {
									var $f = $(this);
									var __f = $f.data('filter');
	
									if (__f && search_filters_nested[index].join(',').indexOf(__f) > -1) {
										$f.addClass('is-hidden').removeClass('is-selected');
										$('input', $f).prop('checked', false).removeAttr('checked');
										delete filters_set[__f];
									}
								});
								if (checked) {
									if (!$_filter.hasClass('is-nested--selected')) {
										$('.dropdown__label__text__replaced__option:last-child', $_filter).text($('.dropdown__label__text__inner', $_filter).text());
									}
									filterChangeNested($_filter);
									//$('.dropdown__label__text__inner, .dropdown__title', $_filter).text(tl(v));
									$('.dropdown__label__text__replaced__option:first-child', $_filter).text(tl(v)).appendTo($_filter.find('.dropdown__label__text__replaced'));
								}
							}
						}
	
						var _opt = '|' + _f.opt.join('|') + '|';
	
						if (checked) {
							_f.opt.push(v);
							$_input.attr('checked', 'checked');
						} else {
							_opt = _opt.split('|' + v + '|').join('|');
							var _opt_new = _opt.substr(1, _opt.length - 2);
							_f.opt = _opt_new != '' ? _opt_new.split('|') : [];
							$_input.removeAttr('checked');
	
							if (!$('input:checked', $_filter).length) {
								$filterReset = $_filter;
								//console.log('filterReset: ' + facet);
							}
						}
	
						//console.log(_f.opt);
	
						if (_f.opt.length < 1) {
							delete filters_set[facet];
							//console.log('DELETE: ' + facet);
						}
	
						filterSet();
						api.algoliaAutocomplete(index);
						api.search(index, false);
					});
				} else if (!reset && !$filter.length) {
					app.parse($item.parents('[data-filter="' + parent + '"]'));
				}
	
				/* 	FILTER SINGLE OPTION
					Hide filter if just one option is available
					Still show the filter if the initial search request contains a query to provide the possibility of changing the filter settings
				*/
				//console.log('filters_initial: '+filters_initial+', input_initial: '+input_initial);
	
				$item.removeClass('is-single is-single--selected');
	
				var single;
				if (i < 2 && i_active < 1) {
					$item.addClass('is-single');
					single = true;
	
					// SHOW SINGLE SELECT OPTIONS
					if (nested) {
						$item.addClass('is-single--selected');
						$('.dropdown__label__text__replaced__option:last-child', $item).text(tl($('.dropdown__items input:eq(0)', $item).val()));
					}
				} else if (filters_initial && i < 2 && i_active > 0) {
					filters_initial = false;
					$item.removeClass('is-hidden');
				}
	
				// FILTERS NESTED
				if (search_filters_nested && search_filters_nested[index]) {
					if (search_filters_nested[index].join(',').indexOf(f) > -1) {
						var $prevAll = $item.prevAll().filter('.is-nested');
						var $prev = $item.prev().filter('.is-nested');
						var $prev_checked = $('input:checked', $prev);
						var $prevMulti = $prevAll.filter(':not(.is-single)');
	
						//console.log(f);
						//console.log('$prev_checked.length:'+$prev_checked.length+', $prevMulti.length:'+$prevMulti.length+', single:'+single);
	
						//if ($prev_checked.length || !$prevMulti.length || (single && !$prevMulti.length)) {
						if ($prev_checked.length || !$prevMulti.length || (single && !$prevAll.filter(':not(.is-selected):not(.is-single)').length)) {
							$item.removeClass('is-hidden');
						} else if (!filter_titles[f]) {
							$item.addClass('is-hidden');
							$prev.removeClass('is-nested--selected');
						}
					}
				}
	
				/*var nested_single = $item.filter('.is-single.is-nested').length;
				if(nested_single){
					console.log('nested_single:'+$('.dropdown__items input:eq(0)', $item).val());
					$('.dropdown__label__text__replaced__option:last-child', $item).addClass('---').text(tl($('.dropdown__items input:eq(0)', $item).val()));
					$item.removeClass('is-hidden is-single').addClass('is-selected is-single--selected');
				}*/
	
				// SHOW/HIDE SEARCH INPUT FIELD
				if ($('.js-filters-item', $item).length <= 10) {
					$('.dropdown__search', $item).hide();
				} else {
					$('.dropdown__search', $item).show();
				}
	
				if (!parent) {
					//$('input[type="checkbox"]:eq(0)', $item).trigger('change.filterInput');
				}
	
			} else if (slider) {
	
				// SLIDER
	
				var range = [facet_stats.min, facet_stats.max];
	
	
	
				if (filters_get && filters_get[f]) {
					facet_stats.min = filters_get[f].opt.min;
					facet_stats.max = filters_get[f].opt.max;
					range = [Math.min(range[0], filters_get[f].opt.min_range), Math.max(range[1], filters_get[f].opt.max_range)];
	
					//console.log('----- SLIDER GET ------');
					//console.log(facet_stats.min + ' <> ' + facet_stats.max);
					//console.log(range[0] + ' | ' + range[1]);
				}
	
				var $filter_slider = $('[data-filter-slider="' + f + '"]');
				var $slider = $(strReplace(('' + templates.filter.slider).split('###unit###').join(filter_units[f]), 'slider-title', tl(title))).attr('data-filter-slider', f).data('values', filter.values);
				var $range = $('.range-slider', $slider).attr('data-range', range[0] + ',' + range[1]).attr('data-initial', facet_stats.min + ',' + facet_stats.max);
	
				$range.data('filterRangeUpdate', filterRangeUpdate.bind($range));
	
				//console.log(range[0]+' = '+range[1]);
	
				if (range[0] == range[1]) {
					$item.addClass('is-disabled-slider');
				} else {
					$item.removeClass('is-disabled-slider');
				}
	
				if ($filter_slider.length) {
					change = $filterChange && ($filterChange[0] == $filter_slider[0]);
				}
	
				var _slider = { title: tl(title), tpl: $slider, values: filter.values };
	
				if (!parent) {
					$item.data('filter_slider', {});
					$item.data('filter_slider')[f] = _slider;
	
					if (!$filter.length) {
						//$item.data('filter_slider', {});
						//$item.data('filter_slider')[f] = _slider;
						$item.addClass('subnav__item--divided').prepend($(templates.filter.separator));
						$filters_form.append($item);
	
						//console.log('slider-create');
	
						$item.on('click.filterSlider', function (e) {
							var $self = $(this);
							var s = $self.data('filter_slider');
							var $overlay = $(templates.filter.overlay);
							var $form = $('form', $overlay);
							var $button = $('.js-advanced-filter-show', $overlay);
							var $resetButton = $('.js-advanced-filter-reset', $overlay)
							var $close = $('.button-close', $overlay);
							var _title = '';
	
							for (var i in s) {
								$form.append(s[i].tpl);
								_title += '/' + s[i].title;
							}
	
							$('h3', $overlay).text(_title.substr(1) + ' ' + tl('Filter'));
							$('body').append($overlay);
	
							$resetButton.on('click', function (e) {
	
								$close.trigger('click');
	
								//I dont know why this works but it works
	
								filters_set = { type: 'range', opt: { min_range: 0, max_range: 0, min: 0, max: 0 } };
	
								filterSet()
								api.search(index);
	
	
	
							})
	
	
	
							$button.on('click.filterSliderSubmit', function (e) {
	
	
	
								if (!$button.hasClass('button--disabled')) {
									$('.js-range-slider', $overlay).each(function (i) {
										var $_range = $(this);
	
	
	
										var _f = $_range.closest('[data-filter-slider]').data('filter-slider');
										var val = $('.js-range-slider-min', $_range).val() + ',' + $('.js-range-slider-max', $_range).val();
	
										$('.js-range-slider', s[_f].tpl).attr('data-initial', val);
									});
									api.search(index);
									$close.trigger('click');
								}
							});
	
							setTimeout(function () {
								$html.addClass('overlay--open');
								app.obj.site.overlayOpen = true;
								app.parse($overlay);
								$win.scrollTop(0);
							}, 100);
						});
						//app.parse($item);
					} else if (filters_get && filters_get[f]) {
						$item.data('filter_slider')[f] = _slider;
					}
				} else {
					if (($parent.data('filter_slider') && !$parent.data('filter_slider')[f]) || (filters_get && filters_get[f])) $parent.data('filter_slider')[f] = _slider;
	
					var $title = $('.dropdown__label__text__inner, .dropdown__title.js-dropdown-close', $parent);
					$title.text($title.text() + '/' + tl(title));
				}
	
				/*var $item = $parent ? $parent : $item;
				var $currentChosen = $('.dropdown__label__chosen', $item);
	
				if(!$parent){
					$currentChosen.text('');
					$item.removeClass('is-selected');
				}
				if(filters_set && filters_set[f]){
					$currentChosen.text($currentChosen.text()+($parent ? '/' : '')+filters_set[f].opt.min+'-'+filters_set[f].opt.max);
					$item.addClass('is-selected');
				}*/
	
				if (!change && !changeParent && !$filter_slider.data('values')) {
					$filter_slider.data('values', filter.values);
				}
			}
	
		}
	};

	// =======================================
	//  FILTER SELECTED (BOXES)
	// =======================================
	var filterSelected = function () {
	  if ($filters_selected.length){
	    var $items = $filters_selected.find('.js-filters-selected-items');
	    var filters_selected = '';
	    var cnt = 0;
	
	    for (var f in filters_set) {
	      var fi = filters_set[f];
	      var opt = fi.opt;
	      
	      for (var v in opt) {
	        var vi = opt[v];
	
	        if ($('[data-filter="' + f + '"] [value="' + vi + '"]', $search).length || filters_get) {
	          filters_selected += '<div class="filters__selected__item" data-filter-selected="' + f + '">' + vi + '</div>';
	          cnt++;
	        }
	      }
	    }
	
	    $filters_selected.attr('data-total', cnt);
	    $items.html(filters_selected);
	  }
	}


	// #######################################
	//  S E A R C H  R E S U L T S
	// #######################################

	// =======================================
	//  SHOW RESULTS
	// =======================================
		var searchDistinct = function(query, distinct, items_all, categoryIndex, total){
			if(distinct.length>0){
				//var query = $input.length ? $input.val() : '';
				var _params = JSON.parse(JSON.stringify(params));
				var _f = filter_distinct[categoryIndex];
				var _join = _f+':"';
				var distinct_filter = '(' + _join + distinct.join('" OR ' + _join) + '")';
				var distinct_obj = {};
				var lg_locals = {
					'en': 'english',
					'de': 'german',
					'fr': 'french',
					'nl': 'dutch',
					'pt': 'brazilian',
					'fi': 'finnish',
					'se': 'swedish',
				};
				var lg_local = lg_locals[app.vars.$html.attr('lang')];
	
				_params.distinct = 0;
				_params.hitsPerPage = 500;
				_params.page = 0;
				//filterAutoActive(categoryIndex);
				//_params.filters	= filters_active_add + ((filters_active_add != '' && filters_add != '') ? ' AND ' : '') + filters_add;
				_params.filters	+= (_params.filters != '' ? ' AND ' : '') + distinct_filter;
	
				var _queries = [{
					indexName: prefix + (search_index || categoryIndex) + suffix, query: query, params: _params,
				}];
	
				client.search(_queries, function searchDone(err, content) {
					var results = content.results[0];
					//console.log(results);
	
					for (var h in results.hits) {
						var hit = results.hits[h];
						var d = hit[_f];
	
						if(!distinct_obj[d]) distinct_obj[d] = [];
	
						if(categoryIndex == 'documents'){
							distinct_obj[d].push(hit);
						}
					}
	
					for (var o in distinct_obj) {
						var siblings = distinct_obj[o];
						var hit = siblings[0];
						var _downloads = [];
	
						for (var s in siblings) {
							var sibling = siblings[s];
							_downloads.push({ id: sibling.objectID, lg: tl(sibling.language.label), lg_val: sibling.language.value, url: sibling.url });
							if (sibling.language.value.split('-').shift() == lg_local) {
								hit.title = sibling.title;
							}
						}
	
						_downloads.sort(function(a, b) {
							var s1 = a.lg_val.split('-').shift();
							var s2 = b.lg_val.split('-').shift();
							if(s1.indexOf(lg_local)>=0){
								return -1;
							} else if(s2.indexOf(lg_local)>=0){
								return 1;
							} else {
								return s1.localeCompare(s2);
							}
						});
						
						var items_obj = downloads(items_all, _downloads, (hit.prefixTitle && hit.prefixTitle != '' ? hit.prefixTitle : hit.title), o+'-downloads', true);
						items_all = strReplace(items_obj.str, o+'-distinct-result', items_obj.lg.join(', '));
						items_all = strReplace(items_all, o + '-distinct-title', hit.title);
					}
	
					//console.log(distinct_obj);
	
					resultsRender(query, items_all, categoryIndex, total);
				});
			}
		};
		var resultsRender = function(query, items_all, categoryIndex, total, pagination_click){
			clearTimeout(result_timer);
			result_timer = setTimeout(function() {
				$overview_inner.removeAttr('style').removeClass('overview__inner--hide');
	
				// NO RESULTS
				//console.log('filters_set: '+Object.keys(filters_set));
				//console.log('resultsRender total:'+total);
				//console.log('pagination_click:' + pagination_click);
				/*if(Object.keys(filters_set).length>0){
					text_noresults = tl('We didn\'t find any results for "'+query+'" with the current filter settings.<br><br><span class="button js-search-filters-reset">Reset filter settings</span>');
				}*/
	
				// CREATE DOM
				var $search_more = $(classes.more, $search);
				if ($search_more.length && pagination_click) {
					$search_more.replaceWith(items_all);
				}else{
					$results_list.html(items_all);
					if (!result_swiper){
						if (index && search_global && total < 1 & query.length > 0) {
							showNoResults(query);
						} else {
							$results_list.prepend($(templates.noresults($search.find('[data-search-no-results].is-active').data('search-no-results'))));
						}
					}
				}
				$results.attr('data-search-category', categoryIndex);
	
				$search.attr('data-filter-length', $filters.length).attr('data-filter-visible', $filters.length - $filters.filter('.is-hidden, .is-single:not(.is-selected):not(.is-single--selected), .is-disabled:not(.is-selected)').length);
				//$search.attr('data-filter-length', $_filters.length).attr('data-filter-visible', $_filters.length - $_filters.filter('.is-hidden, .is-single:not(.is-selected):not(.is-single--selected), .is-disabled:not(.is-selected)').length);
				$search.attr('data-total', total);
	
				/*$(classes.filters_reset, $results_list).on('click.search-filters-reset', function(){
					$('.subnav__item.is-active', $subnav).trigger('click');
				});*/
	
				$search.removeClass('search--results-render');
	
				app.parse($results_list);
				window.parseNewComponents($results_list[0])
				setTimeout(function() {
					$('[data-bg], [data-src]', $results_list).lazyLoadXT();
				}, 100);
			}, 200);
		};
	var showResults = function (content) {
	  var query = content.results[0].query;
	  var input = query.length > 0;
	  var total = 0;
	
	  if (algolia) {
	    var items_all = "";
	    var categories = content.results;
	    var category;
	    var categoryIndex = "all";
	    var cnt = 0;
	
	    if (index) {
	      categoryIndex = search_category || index;
	      for (var c in content.results) {
	        var cat = content.results[c];
	        if (index.split(prefix).join("").split(suffix).join("") == cat.index) {
	          categories = [cat];
	        }
	      }
	    }
	
	    //results.sort(function(a, b){return a-b});
	
	    $search.data("search-result", content);
	
	    $(".filters__button--nested-info", $search).remove();
	
	    // RESULTS
	    for (var c in categories) {
	      var items_wrapper = "" + templates.items[categoryIndex];
	      var items = "";
	      var distinct = [];
	      var group = search_group
	        ? JSON.parse(JSON.stringify(search_group))
	        : false;
	
	      category = categories[c];
	      result = category;
	      total += category.nbHits;
	
	      if (category.nbHits > 0) {
	        // SORT DOWNLOADS BY OBJECT ID FILTER SETTING
	        category.hits = sortDownloads(category.hits);
	
	        // SORT HITS BY FACETS
	        category.hits = sortByFacets(category.hits);
	
	        // RENDER RESULTS
	        for (
	          var h = Math.max(0, hitsPerPage * hitsMore - 1);
	          h < category.hits.length;
	          h++
	        ) {
	          var hit = category.hits[h];
	
	          if($search[0].dataset.videoType) {
	            hit.videoType = $search[0].dataset.videoType
	          }
	
	          if (hit.title) {
	            var item = "" + templates.item[categoryIndex];
	
	            if (items == "" && result_swiper) {
	              items_wrapper = "###items###";
	            }
	
	            // PLACEHOLDERS
	
	            switch (categoryIndex) {
	              // ALL
	              case "all":
	                break;
	
	              // DOCUMENTS
	              case "documents":
	                item = strReplace_Documents(item, hit);
	                break;
	
	              // NEWS
	              case "news":
	                item = strReplace_News(item, hit);
	                break;
	
	              // BLOG
	              case "blog":
	                item = strReplace_Blog(item, hit);
	                break;
	
	              // PRODUCTS
	              case "products":
	                item = strReplace_Products(item, hit);
	                break;
	
	              case "products_borouge":
	                item = strReplace_Products_Borouge(item, hit);
	                break;
	
	              // CONTACTS
	              case "contacts":
	                item = strReplace_Contacts(item, hit);
	                break;
	
	              // LOCATIONS
	              case "locations":
	                item = strReplace_Locations(item, hit);
	                break;
	
	              // MEDIA
	              case "video":
	              case "media":
	                item = strReplace_Media(item, hit);
	                break;
	
	              // JOBS
	              case "jobs":
	                item = strReplace_Jobs(item, hit);
	                break;
	
	              // EVENTS
	              case "events":
	                item = strReplace_Events(item, hit);
	                break;
	
	              // PAGES
	              case "pages":
	                item = strReplace_Pages(item, hit);
	                break;
	
	              // PUBLICATIONS
	              case "publications":
	                item = strReplace_Publications(item, hit);
	                break;
	
	              default:
	            }
	
	            item = strReplace_General(item, hit);
	
	            // DISTINCT
	            if (
	              index &&
	              filter_distinct[index] &&
	              hit[filter_distinct[index]]
	            ) {
	              var d = hit[filter_distinct[index]];
	              item = strReplace(item, "distinct", d);
	              distinct.push(d);
	            }
	
	            if (!group) {
	              items += item;
	            } else {
	              // GROUP
	              if (!hit[group.key]) {
	                hit[group.key] = ["default"];
	              }
	              for (var g = 0; g < hit[group.key].length; g++) {
	                var g_obj = hit[group.key][g];
	                var key = g_obj["title"] || g_obj;
	
	                // console.log(key);
	
	                if (!group.opt[key]) {
	                  group.opt[key] = [];
	                }
	                group.opt[key].push({
	                  item: item,
	                  position: g_obj["position"] || "0",
	                });
	              }
	            }
	          }
	        }
	
	        // GROUP ITEMS
	        if (group) {
	          var tpl_group = tpl.group[group.key];
	
	          for (var g in group.opt) {
	            var _total = group.opt[g].length;
	            var _items = "";
	            var _group_items = "";
	
	            // SORT BY GROUP POSITION
	            group.opt[g].sort(function (a, b) {
	              return a.position - b.position;
	            });
	
	            if (_total > 0) {
	              for (var i in group.opt[g]) {
	                _group_items += group.opt[g][i].item;
	              }
	              _items = strReplace("" + tpl_group.items, "items", _group_items);
	              _items = strReplace(_items, "headline", g);
	              _items = strReplace(
	                _items,
	                "total",
	                _total + " " + tl(_total > 1 ? "videos" : "video")
	              );
	              items += _items;
	            }
	          }
	
	          items = strReplace(tpl_group.wrapper, "items", items);
	        }
	
	        if (items != "" || !index) {
	          items = items_wrapper.split("###items###").join(items);
	
	          if (index != "blog" || search_global) {
	            if (index) items = "" + templates.items.header + items;
	
	            var c_index = category.index
	              .split(prefix)
	              .join("")
	              .split(suffix)
	              .join("");
	            var $_category = $(
	              'li[data-category-link="' + c_index + '"]',
	              $categories
	            );
	
	            items = items.split("###index###").join(c_index);
	            items = items
	              .split("###indexName###")
	              .join($("h4", $_category).eq(0).text());
	            items = items
	              .split("###indexDesc###")
	              .join($("p", $_category).text());
	            items = items.split("###total###").join(category.nbHits);
	            cnt++;
	          }
	        }
	      }
	
	      items_all += items;
	    }
	
	    if (!index) {
	      items_all =
	        "" +
	        templates.items.all_wrapper
	          .split("###all###")
	          .join(items_all)
	          .split("###align###")
	          .join(cnt < 4 ? "search__no-results__categories--center" : "");
	    }
	
	    if (indexNew != index || filter_reset) {
	      filterReset();
	      filter_reset = false;
	      $("[data-filter]", $search).remove();
	      indexNew = index;
	    }
	
	    if (categories.length == 1) {
	      if (category.nbPages > 1) {
	        // PAGINATION
	        var pagination = "";
	
	        if (pagination_type == "default") {
	          pagination = templates.pagination
	            .split("###page###")
	            .join(category.page + 1)
	            .split("###pages###")
	            .join(category.nbPages);
	
	          if (category.nbPages - 1 <= params.page)
	            pagination = pagination
	              .split("pagination__button--next")
	              .join("pagination__button--next " + app.states.isDisabled);
	          if (category.page == 0)
	            pagination = pagination
	              .split("pagination__button--prev")
	              .join("pagination__button--prev " + app.states.isDisabled);
	        } else if (pagination_type == "more") {
	          pagination = templates.more;
	        }
	
	        items_all += pagination;
	      }
	
	      //FILTERS
	      if (category.facets) {
	        var keys = categoriesSort(category.facets);
	        var $subnav_active;
	
	        for (var i in keys) {
	          var filter_set = filters_set[keys[i].key];
	
	          // FILTER CREATE
	          filterCreate(keys[i].key, category, false);
	        }
	
	        // DOM SORT ORDER
	        //$('.filters__button[data-filter]', $search).sort(function(a, b) { return $(a).data('i') > $(b).data('i'); }).appendTo($filters_form);
	        //$('.filters__button[data-filter]', $search).appendTo($filters_form);
	
	        // FILTER SQL
	        filterSet();
	        filterSelected();
	      }
	
	      // FILTERS HEADLINES (COUNT)
	      //$('.js-filters-group.is-selected', $search).each(function(){
	      $(".js-filters-group", $search).each(function () {
	        var $item = $(this);
	        var cnt = $("input:checked", $item).length;
	        $item.attr("data-selected", cnt);
	        $(".dropdown__label__chosen", $item).text(cnt);
	      });
	    }
	
	    // TOTAL
	    $total.text(category.nbHits);
	
	    // DISABLE FILTERS
	    $filters = $(".js-filters-content [data-filter]", $search);
	
	    $filters.each(function () {
	      var $filter = $(this);
	      var disabled = false;
	      if (!category.facets[$filter.data("filter")]) {
	        $filter.addClass("is-disabled");
	        disabled = true;
	      } else {
	        $filter.removeClass("is-disabled");
	      }
	      //console.log('--------------------------')
	      //console.log($filter.data('filter')+':disabled='+disabled+'; is-nested:'+$filter.hasClass('is-nested')+', next-nested:'+$filter.next().hasClass('is-nested')+', next-disabled:'+$filter.next().hasClass('is-disabled')+', checked:'+$('input:checked', $filter).length)
	    });
	
	    // LAST NESTED FILTER SELECTION
	    /*$('.js-filters-content [data-filter]:not(.is-disabled)', $search).each(function(){
					var $filter = $(this);
					if($filter.hasClass('is-nested') && (!$filter.next().hasClass('is-nested') || $filter.next().hasClass('is-disabled')) && $('input:checked', $filter).length){
						$(strReplace(templates.filter.button_nested, 'title', $('input:checked', $filter).val())).insertAfter($filter);
						//console.log('--ADD FILTER TEXT')
					}
				});*/
	
	    var $form = $(".js-tabs-filters-form", $search);
	    var nested_str =
	      search_filters_nested && search_filters_nested[index]
	        ? search_filters_nested[index].join(",")
	        : false;
	
	    for (var key in filter_titles) {
	      if (!(nested_str && nested_str.indexOf(key) > -1)) {
	        $(
	          '.js-tabs-filters-form > [data-filter="' + key + '"]',
	          $search
	        ).appendTo($form);
	      }
	    }
	
	    // PREPEND NESTED FILTERS
	    //$('.is-nested', $search).prependTo($filters_form);
	
	    // SUB NAVIGATION
	    $subnav_algolia.removeClass(classes.subnav_active);
	    $subnav_algolia
	      .filter('[data-category="' + categoryIndex + '"]')
	      .addClass(classes.subnav_active);
	
	    $overview_inner
	      .css("height", $overview_inner.prop("scrollHeight") + "px")
	      .addClass("overview__inner--hide");
	
	    // RESULTS RENDER
	    //if (!index || distinct.length < 1) {
	    if (!index || !filter_distinct[index] || distinct.length < 1) {
	      resultsRender(query, items_all, categoryIndex, total, pagination_click);
	    } else {
	      searchDistinct(query, distinct, items_all, categoryIndex, total);
	    }
	
	    // EXPAND LAST NESTED FILTER
	    if (search_global || filter_change_nested) {
	      if (!$filterChange || $filterChange.hasClass("is-nested")) {
	        setTimeout(function () {
	          if ($html.hasClass("from-tablet")) {
	            var found;
	
	            $(
	              ".filters__button.is-nested:not(.is-single):not(.is-disabled)",
	              $el
	            ).each(function () {
	              var $self = $(this);
	              var $found = $self
	                .filter(":not(.is-current):not(.is-selected)")
	                .find(".dropdown__label");
	
	              if ($found.length) {
	                if (!found && !$self.hasClass("is-active")) {
	                  $(
	                    ".filters__button.is-nested.is-active.is-hidden .js-dropdown-close",
	                    $el
	                  ).trigger("click.dropdown_close");
	                  $found.trigger("click.dropdown_element");
	                }
	                found = true;
	              }
	            });
	            if (!found) {
	              $(
	                '.filters__button.is-nested ~ .filters__button:not(".is-nested"):not(.is-selected):not(.is-active)',
	                $el
	              )
	                .not(":hidden")
	                .first()
	                .find(".dropdown__label")
	                .trigger("click.dropdown_element");
	            }
	          }
	
	          // UPDATE ACTIVE FILTER SCROLLBOX
	          var scroller = $(".filters__button.is-active .js-dropdown-main").data(
	            "scroller"
	          );
	          if (scroller) {
	            scroller.refresh();
	            var $scroller = scroller["holder"];
	            if (!$(".iScrollIndicator:visible", $scroller).length) {
	              $scroller.removeClass("scrollbar--enabled");
	            } else {
	              $scroller.addClass("scrollbar--enabled");
	            }
	          }
	        }, 10);
	      }
	    }
	
	    if (pagination_click && pagination_type == "default") {
	      scrollUp();
	    }
	    pagination_click = false;
	    filter_change_nested = false;
	    $filterChange = false;
	    filterHistory();
	  } else {
	    app.obj.tabs["search"].loadTab();
	  }
	
	  if (search_global) {
	    if ((!search && input) || filters_get) {
	      search = true;
	      $categories
	        .not(".is-set")
	        .addClass("is-hidden")
	        .slideUp({ duration: 600, easing: "easeOutExpo" });
	      $html.addClass("search--results");
	      filters_get = false;
	    } else if (search && !input) {
	      /*search = false;
					$categories.not('.is-set').slideDown({duration: 800, easing: 'easeInOutQuint'});
					setTimeout(function() {
						$categories.removeClass('is-hidden');
						$html.removeClass('search--results');
					}, 30);*/
	    }
	  }
	
	  if (search_callback && $(search_callback) && $(search_callback).data("search-result-update")) {
	    $(search_callback).data("search-result-update")(content, filters_set);
	  }
	};
	
		var showNoResults = function(query){
			var queries = [];
	
			// console.log('showNoResults: ' + query);
	
			if (query.length > 0) {
				//var params = {};
				params.hitsPerPage = 0;
	
				for (var i in indexList) {
					filterAutoActive(indexList[i].index);
					params.filters = filters_active_add;
					if (indexList[i].index != index) {
						queries.push({ indexName: prefix + indexList[i].index + suffix, query: query, params: JSON.parse(JSON.stringify(params)) });
					}
	      }
	      
	      client.search(queries, function searchDone(err, content) {
					var items_all = '';
					var categories = content.results;
					var category;
					var cnt = 0;
	
					// console.log(content);
					
					for (var c in categories) {
	
						category = categories[c];
	
						if (category.nbHits > 0) {
							var items_wrapper = '' + templates.items['all'];
							var items = items_wrapper.split('###items###').join(items);
	
							var c_index = category.index.split(prefix).join('').split(suffix).join('');
							var $_category = $('li[data-category-link="' + c_index + '"]', $categories);
	
							items = items.split('###index###').join(c_index);
							items = items.split('###indexName###').join($('h5', $_category).eq(0).text());
							items = items.split('###indexDesc###').join($('p', $_category).text());
							items = items.split('###total###').join(category.nbHits);
							
							items_all += items;
							cnt++;
						}
					}
	
					if(items_all != ''){
						$results_list.prepend($(strReplace(strReplace(templates.noresults_alt, 'align', (cnt < 4 ? 'search__no-results__categories--center' : '')), 'items', items_all)));
					} else {
						$results_list.prepend($(templates.noresults()));
					}
					
	      });
			}
	
		};

	// =======================================
	//  SORTING RESULTS
	// =======================================
		var categoriesSort = api.categoriesSort = function(categories) {
			var keys = [];
			var nested_str = (search_filters_nested && search_filters_nested[index]) ? search_filters_nested[index].join(',') : false;
			for (var prop in categories) {
				if (categories.hasOwnProperty(prop)) keys.push({'key': prop});
			}
	
			keys.sort(function(a, b) {
				if (nested_str && (nested_str.indexOf(a.key) > -1 || nested_str.indexOf(b.key) > -1)) {
					var n1 = nested_str.indexOf(a.key);
					var n2 = nested_str.indexOf(b.key);
					var i = (n1 > -1 && n2 > -1) ? (n1 - n2 < 0 ? -1 : 1) : (n1 > -1 ? -1 : -1);
					//alert(a.key+' :: '+b.key+' = '+i);
					return i;
				} else if (filter_titles[a.key] && filter_titles[b.key]) {
					//alert(a.key+' == '+b.key);
					return Object.keys(filter_titles).indexOf(a.key) - Object.keys(filter_titles).indexOf(b.key);
				} else {
					return -1;
				}
			});
			//console.log(keys);
			return keys;
		};
	var sortByFacets = function(hits){
	    if (search_sort) {
	        for (var f in search_sort) {
	            var opt = search_sort[f].opt;
	            var facet = f.split('.');
	
	            console.log('sortByFacets:' + f);
	            
	            for (var o in opt) {
	                hits.sort(function (a, b) {
	                    var a_opt = a[facet[0]];
	                    var b_opt = b[facet[0]];
	                    var a_found, b_found;
	
	                    for (var i = 0; i < a_opt.length; i++) {
	                        if (a_opt[i][facet[1]] == opt[o]) {
	                            console.log('a_opt:' + a_opt[i][facet[1]] + ' = ' + opt[o]);
	                            a_found = true;
	                            break;
	                        }
	                    }
	                    for (var i = 0; i < b_opt.length; i++) {
	                        if (b_opt[i][facet[1]] == opt[o]) {
	                            console.log('b_opt:' + b_opt[i][facet[1]] + ' = ' + opt[o]);
	                            b_found = true;
	                            break;
	                        }
	                    }
	
	                    if (a_found && !b_found) {
	                        return -1;
	                    } else if (!a_found && b_found) {
	                        return 1;
	                    } else {
	                        return 0;
	                    }
	                });
	            }
	        }
	    }
	
	    return hits;
	};
		var sortDownloads = function(hits){
			if (search_by_object_id){
	
	            // SORT BY SORT ATTRIBUTE
	            if (typeof search_filters.objectID.sort !== 'undefined') {
	                var _sort = search_filters.objectID.sort;
	                var _order = search_filters.objectID.order || 'ASC';
	
	                hits.sort(function (a, b) {
	                    if (a[_sort] && b[_sort]){
	                        return _order == 'ASC' ? a[_sort].toLowerCase().localeCompare(b[_sort].toLowerCase()) : b[_sort].toLowerCase().localeCompare(a[_sort].toLowerCase());
	                    }else{
	                        return 0;
	                    }
	                });
	
	            // SORT BY OBJECT ID ORDER
	            }else{
	                hits.sort(function (a, b) {
	                    return search_filters.objectID.opt.indexOf(Number(a.objectID)) - search_filters.objectID.opt.indexOf(Number(b.objectID));
	                });
	            }
	        }
	        return hits;
		};

	// =======================================
	//  DOWNLOADS
	// =======================================
	
		var downloadGroups = function(item, groups, title) {
			var group_count = 0;
			var group_curr;
	
			for (var g in groups) {
				if ((g == 'datasheet' || g == 'safety_datasheets' || g == 'safety_informationsheets')  && groups[g].length > 0) {
					group_count++;
					group_curr = groups[g];
				} else if (g == 'other') {
					for (var o in groups[g]) {
						group_count++;
						group_curr = groups[g][o];
					}
				}
			}
	
			if (group_count == 0) group_curr = groups;
	
			if (group_count < 2) {
				item = strReplace(item, 'downloads-groups', '');
				item = downloads(item, group_curr, title);
			} else {
				var str = '';
				var str_groups = '';
				var i = 1;
	
				for (var g in groups) {
	
					switch(g){
						case 'datasheet':
							var label = tl('Product Data Sheet');
							break;
						case 'safety_datasheets':
							var label = tl('Safety Data Sheet');
							break;
						case 'safety_informationsheets':
							var label = tl('Safety Information Sheet');
							break;
						default:
							var label = groups[g].title;
	
					}
					var group = (g == 'other' ? groups[g] : [groups[g]]);
	
					if (group[0] && group[0].length > 0) {
						for (var items in group) {
							var attr = group[items].documents ? group[items].documents : group[items];
	
							if(typeof attr[0].id !== 'undefined'){
								if (g == 'other') {
									label = attr[0].title;
								}
	
								str_groups += ',{"id":"' + i + '","label":"' + label + '"}';
	
								for (var o in attr) {
									var opt = attr[o];
									str += ',{"group":"' + i + '","id":"' + opt.id + '","lg":"' + opt.lg + '","title":"' + title + '","url":"' + opt.url + '"}';
								}
								i++;
							}
						}
					}
				}
				item = strReplace(item, 'downloads-groups', 'data-download-groups=\'[' + str_groups.substr(1) + ']\'');
				item = strReplace(item, 'downloads', '[' + str.substr(1) + ']');
			}
			return item;
		};
	
		var downloads = function(item, attr, title, find, obj) {
			var str = '';
			var lg = [];
			for (var o in attr) {
				var opt = attr[o];
				if(typeof opt.id !== 'undefined') {
					str += ',{"id":"' + opt.id + '","lg":"' + opt.lg + '","title":"' + backQuote(title) + '","url":"' + opt.url + '"}';
					if(obj) lg.push(opt.lg);
				}
			}
			str = strReplace(item, (find || 'downloads'), '[' + str.substr(1) + ']');
			return !obj ? str : {'str':str, 'lg':lg};
		};
	
		/*var downloads = function(item, attr, title) {
			var str = '';
			for (var o in attr) {
				var opt = attr[o];
				if(typeof opt.id !== 'undefined') str += ',{"id":"' + opt.id + '","lg":"' + opt.lg + '","title":"' + backQuote(title) + '","url":"' + opt.url + '"}';
			}
			str = strReplace(item, 'downloads', '[' + str.substr(1) + ']');
			return str;
		};*/

	// =======================================
	//  MEDIA OVERLAY
	// =======================================
		var mediaDirectLink = function(category, media_id, trigger) {
			//console.log('mediaDirectLink:'+media_id+', category:'+category);
			if(media_id){
				var _index			= category;
				var _params			= {hitsPerPage: 1, facets: '*', facetFilters: '', filters: 'objectID:'+media_id};
				var _queries		= [{
					indexName: prefix + _index + suffix, query: '', params: _params,
				}];
	
				client.search(_queries, function searchDone(err, content) {
					var hits = content.results[0].hits;
	
					if(hits.length>0){
						var hit = content.results[0].hits[0];
						var item = '' + templates.item[_index];
	
						item = strReplace_Media(item, hit);
						item = strReplace_General(item, hit);
	
						var $hidden = $('<div class="media__holder media__holder--hidden" data-param-media="id-media-search" style="display: none;"></div>').appendTo('body');
						var $media = $(item).appendTo($hidden);
	
						app.parse($media);
						
						if(trigger){
							$media.trigger('click');
						}
					}
				});
			}
		}

	$el.data('search', api);

	init();	return api;
};
app.ext['accordion'] = function($el) { 
	var api = {};

	var settings = {
		duration: app.settings.duration,
	};

	var classes = {
		item    : '.js-accordion-item',
		header  : '.js-accordion-header',
		content : '.js-accordion-content',
	};

	var $header  = $(classes.header, $el);
	var $content = $(classes.content, $el);

	var init = function() {
		addListeners();
	};

	var addListeners = function() {
		$el.on('click', classes.header, headerClickHandler);
	};

	var headerClickHandler = function(e) {
		e.preventDefault();
		var $item = $(this).closest(classes.item);
		toggleItem($item);
	};

	var toggleItem = function($item) {
		if ($item.hasClass(app.states.isOpen)) {
			closeItem($item);
		} else {
			openItem($item);
		}
	};

	var closeItem = function($item) {
		var $content = $(classes.content, $item);
		$item.removeClass(app.states.isOpen);
		$content.slideUp({duration: 500, easing: 'easeInOutQuart'});
	};

	var openItem = function($item) {
		var $content = $(classes.content, $item);
		$item.addClass(app.states.isOpen);
		$content.slideDown({duration: 500, easing: 'easeInOutQuart'});
	};

	init();	return api;
};

app.ext['advanced-filter'] = function ($el) {
	var api = {};

	var classes = {
		navButton: '.js-advanced-filter-nav-button',
		typeButton: '.js-advanced-filter-type-button',
		page: '.js-advanced-filter-page',
		nav: '.js-advanced-filter-nav',
		show: '.js-advanced-filter-show',
		reset: '.js-advanced-filter-reset'
	};

	// elements
	var $navButton = $(classes.navButton, $el);
	var $typeButton = $(classes.typeButton, $el);
	var $page = $(classes.page, $el);
	var $nav = $(classes.nav, $el);
	var $show = $(classes.show, $el);
	var $reset = $(classes.reset, $el)

	// vars
	var ajaxCall;

	var init = function () {
		addListeners();
	};

	var addListeners = function () {
		$navButton.on('click', navButtonClickHandler);
		$typeButton.on('click', typeButtonClickHandler);
		$el.on('click', classes.show, showClickHandler);
		$el.on('click', classes.reset, resetFilters)
	};

	var navButtonClickHandler = function (event) {
		event.preventDefault();
		var $this = $(this);
		if ($this.hasClass(app.states.isDisabled)) return false;
		showPage($(this).data('page'));
	};

	var typeButtonClickHandler = function (event) {
		event.preventDefault();
		var $this = $(this);
		var url = $this.data('url');
		loadFilterPage(url);
	};



	var showClickHandler = function (event) {

		showResults();
	};

	var loadFilterPage = function (url) {

		if (ajaxCall !== undefined) {
			ajaxCall.abort();
		}

		app.obj['preloader'].hidePreloader($nav, 'fade');
		ajaxCall = $.ajax({
			xhr: function () {
				var xhr = new window.XMLHttpRequest();
				app.obj['preloader'].showPreloader(xhr, $nav);
				return xhr;
			},
			url: url,
			method: 'POST',
		})
			.done(function (response) {
				var $response = $(response);
				var $filterPage = $page.filter('[data-page="2"]');
				$filterPage.html($response);
				app.parse($response);
				showPage(2);
				app.obj['preloader'].hidePreloader($nav, 'fade');
			});
	};

	var showPage = function (pageNo) {
		var $oldPage = $page.filter('.' + app.states.isActive);
		var $oldNavButton = $navButton.filter('.' + app.states.isActive);
		var $newPage = $page.filter('[data-page="' + pageNo + '"]');
		var $newNavButton = $navButton.filter('[data-page="' + pageNo + '"]');

		$oldPage.hide().removeClass(app.states.isActive);
		$oldNavButton.removeClass(app.states.isActive);
		$newPage.show().addClass(app.states.isActive);
		$newNavButton.addClass(app.states.isActive);
	};

	var showResults = function () {
		console.log("button clicked")
		var $overlayCloseButton = $('.button-close', $el);
		$overlayCloseButton.trigger('click.close');
		app.obj.tabs['search'].loadTab();
	};

	var resetFilters = function() {
		console.log('reset Filters')
	}

	init(); return api;
};

app.ext['applications'] = function ($el) {
	var api = {};

	var $win = app.vars.$win;

	var classes = {
		list:			'.applications__list',
		item:			'.applications__item',
		close:			'.applications__close',
		sub:			'.applications__sub',
		sub_outer:		'.applications__sub__outer',
		sub_cols_inner:	'.applications__sub__cols__inner',
		sub_col:		'.applications__sub__col, .applications__text',
		description:	'.js-applications-description',
		active:			'is-active',
		hidden:			'is-hidden',
	};

	var $item			= $(classes.item, $el);
	var $list			= $(classes.list, $el);
	var $sub			= $(classes.sub, $el);
	var $sub_outer		= $(classes.sub_outer, $el);
	var $sub_cols_inner = $(classes.sub_cols_inner, $sub);
	var $sub_col		= $(classes.sub_col, $sub);
	var $description	= $(classes.description, $el);
	var $item_active;

	var init = function () {
		addListeners();
	};

	var addListeners = function () {
		$('a', $item).off().on('click.applications', itemSelectHandler);
		$(classes.close).on('click.applications-close', itemCloseHandler);

		$win.on('resize.applications orientationchange.applications', function () {
			subPos();
		});
	};

	var itemCloseHandler = function (e) {
		$(classes.item + '.' + classes.active + ' a').trigger('click.applications');
	};

	var itemSelectHandler = function (e) {
		if ($(e.currentTarget).attr('href') === 'javascript:;') {
			e.preventDefault();
			$item_active = $(e.currentTarget).parent();

			var was_active = $item.filter('.' + classes.active).length;
			var is_active = $item_active.hasClass(classes.active);
			$item.filter('.' + classes.active).removeClass(classes.active);

			if (!is_active) {
				$item_active.addClass(classes.active);
			} else {
				$item_active = false;
			}
			subChange(was_active);
		}
	};

	var subChange = function (was_active) {
		$sub.addClass('is-changing');

		if ($item_active) {
			$sub.addClass(classes.hidden);
			scrollUp($item_active);
			$sub.removeClass(classes.hidden);
		}

		$sub_outer.slideUp({
			duration: was_active ? 800 : 0, easing: 'easeInOutQuart', complete: function () {
				subPos();
				if ($item_active) {
					$sub_outer.slideDown({ duration: 800, easing: 'easeInOutQuart' });
					setTimeout(function () {
						$sub.removeClass('is-changing');
						$('*[data-bg]', $sub).lazyLoadXT({ checkDuplicates: false });
					}, 30);
				}
			}
		});
	};

	var subPos = function () {
		$sub_col.addClass(classes.hidden).removeClass('last-2 first-2 first');
		$sub.appendTo($list);

		if ($item_active) {
			var top = $item_active.position().top;
			var items = $item_active.data('items');
			var sel = '';

			$item.filter(':not(.' + classes.hidden + ')').each(function () {
				var $i = $(this);

				if ($i.position().top > top) {
					$sub.insertBefore($i);
					return false;
				}
			});

			if ($item_active.prevAll(classes.sub).length) {
				$sub.appendTo($list);
			}
      
			switchDescription($item_active.data('title'));

			for (var i in items){
				sel += '[data-id="' + items[i] + '"]';
				$sub_col.filter('[data-id="' + items[i] + '"]').removeClass(classes.hidden).appendTo($sub_cols_inner);
			}

			//var $sub_active = $sub_col.filter(sel.split('][').join('],[')).removeClass(classes.hidden);
			var $sub_active = $sub_col.filter(':not(.' + classes.hidden + ')');

			//var $sub_active = $sub_col.filter('[data-sub="' + $item_active.data('sub') + '"], [data-title="' + $item_active.data('title') + '"]').removeClass(classes.hidden);
			$sub_active.slice(-2).addClass('last-2');
			$sub_active.slice(0, 2).addClass('first-2').slice(0, 1).addClass('first');
		}
	};

	var scrollUp = function ($e) {
		var y = $e.offset().top - 10;
		app.obj.site.scrollController.scrollTo(y, {
			callback: function () { if (typeof app.obj.site.scrollController.update !== 'undefined') app.obj.site.scrollController.update(true); },
			duration: 0.8,
			target: $e.offset().top - 10 - app.obj.site.headerHeight,
		});
  };
  
  var switchDescription = function(title) {
    $description.addClass(classes.hidden);
    var $newDescription = $description.filter('[data-title="'+ title +'"]');
    $newDescription.removeClass(classes.hidden);
  }

	init(); return api;
};
app.ext['back'] = function($el) { 
	var api = {};

	var init = function() {
		if (history.length > 1 && document.referrer && (document.referrer.indexOf(window.location.hostname) >= 0 || document.referrer.indexOf('waterfortheworld') >= 0)) {
			$el.attr('href', 'javascript:history.go(-1)');
		}
	};

	init();	return api;
};
app.ext['certificates'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var classes = {
		list:			'.certificates__list',
		item:			'.certificates__item',
		close:			'.certificates__close',
		downloads:		'.downloads, .certificates__body',
		downloads_tab:	'.js-tabs-container',
		downloads_col:	'.downloads__col, .certificates__text',
		downloads_all:	'.downloads__all',
		filter:			'.dropdown',
		active:			'is-active',
		hidden:			'is-hidden',
	};

	var $item			= $(classes.item, $el);
	var $list			= $(classes.list, $el);
	var $downloads		= $(classes.downloads, $el);
	var $downloads_tab	= $(classes.downloads_tab, $downloads);
	var $downloads_col	= $(classes.downloads_col, $downloads);
	var $downloads_all	= $(classes.downloads_all, $el);
	var $downloads_all_headline	= $('> h5', $downloads_all);
	var $filter			= $(classes.filter, $el);
	var $item_active;

	var init = function() {
		//itemsSort($item, 'certificate');
		itemsSort($downloads_col, 'city', 'certificate');
		addListeners();
	};

	var addListeners = function() {
		$('a', $item).off().on('click.certificates', itemSelectHandler);
		$(classes.close).on('click.certificates-close', itemCloseHandler);
		$filter.on('change.certificates', 'input[type="checkbox"]', filterChangeHandler);

		$win.on('resize.certificates orientationchange.certificates', function() {
			downloadsPos();
		});
	};

	var itemsSort = function($items, v1, v2){
		var $holder = $items.parent();
		$items.sort(function (a, b) {
			var c1 = $(a).data(v1), c2 = $(b).data(v1), d1 = $(a).data(v2), d2 = $(b).data(v2);
			if(c1 > c2) {
				return 1;
			}else if(c1 < c2) {
				return -1;
			}else{
				if(d1 > d2) {
					return 1;
				}else if(d1 < d2) {
					return -1;
				}
				return 0;
			}
			//return $(a).data('city') - $(b).data('city');
		}).appendTo($holder);

		/*console.log('---SORTED---');
		$holder.children().each(function(){
			console.log($(this).data(v1)+', '+$(this).data(v2));
		});*/
	};

	var filterChangeHandler = function(e) {
		var $input		= $(this);
		var checked		= $input.prop('checked');
		var name		= $input.attr('name');

		if (checked) {
			$item.addClass(classes.hidden).filter(':not([data-' + name + '=""])').removeClass(classes.hidden);
		}

		$downloads.hide();
		$item.removeClass(classes.active);
	};

	var itemCloseHandler = function(e) {
		$(classes.item+'.'+classes.active+' a').trigger('click.certificates');
	};

	var itemSelectHandler = function(e) {
		e.preventDefault();
		$item_active = $(e.currentTarget).parent();

		var was_active = $item.filter('.' + classes.active).length;
		var is_active = $item_active.hasClass(classes.active);
		$item.filter('.' + classes.active).removeClass(classes.active);

		if (!is_active) {
			$item_active.addClass(classes.active);
		} else {
			$item_active = false;
		}
		downloadsChange(was_active);
		//downloadsPos();
		//scrollUp($item_active);
	};

	var downloadsChange = function(was_active) {
		$downloads.addClass('is-changing');

		if ($item_active) {
			$downloads.addClass(classes.hidden);
			scrollUp($item_active);
			$downloads.removeClass(classes.hidden);
		}

		$downloads.slideUp({duration: was_active ? 800 : 0, easing: 'easeInOutQuart', complete:function() {
			downloadsPos();
			if ($item_active) {
				$downloads.slideDown({duration: 800, easing: 'easeInOutQuart'});
				setTimeout(function() {
					$downloads.removeClass('is-changing');
				}, 30);

				/*setTimeout(function(){
					scrollUp($item_active);
				}, 30);*/
			}
		}});
	};

	var downloadsPos = function() {
		$downloads_col.addClass(classes.hidden).removeClass('last-2 first-2 first');
		$downloads.appendTo($list);

		if ($item_active) {
			var top = $item_active.position().top;

			$item.filter(':not(.' + classes.hidden + ')').each(function() {
				var $i = $(this);

				if ($i.position().top > top) {
					$downloads.insertBefore($i);
					return false;
				}
			});

			if ($item_active.prevAll(classes.downloads).length) {
				$downloads.appendTo($list);
			}

			$downloads_all.removeClass(classes.hidden);
			var $downloads_active = $downloads_col.filter('[data-certificate="' + $item_active.data('certificate') + '"], [data-city="' + $item_active.data('city') + '"]').removeClass(classes.hidden);
			$downloads_active.slice(-2).addClass('last-2');
			$downloads_active.slice(0, 2).addClass('first-2').slice(0, 1).addClass('first');

			//$('[data-downloads]', $downloads_all).attr('data-downloads','');

			var all = [];
			
			$downloads_active.each(function() {
				var $col = $(this);
				var downloads = $('[data-downloads]', $col).data('downloads');

				for(var i=0; downloads && i<downloads.length; i++){
					all.push(downloads[i]);
				}
				$downloads_all_headline.attr('data-count', '('+all.length+')');
			});

			$('[data-downloads]', $downloads_all).attr('data-downloads', JSON.stringify(all)).data('downloads', all);
		}
	};

	var scrollUp = function($e) {
		var y = $e.offset().top - 10;
		app.obj.site.scrollController.scrollTo(y, {
			callback: function() { if (typeof app.obj.site.scrollController.update !== 'undefined') app.obj.site.scrollController.update(true); }, 
			duration: 0.8,
			target: $e.offset().top - 10 - app.obj.site.headerHeight,
		});
	};

	init();	return api;
};

app.ext['click-child'] = function($el) { 
	var api = {};
	var $target = $($el.data('target'), $el);

	var init = function() {
		$el.on('click.child', function(e) {
			$eTarget = $(e.target);
			if ($(e.currentTarget).data('target') && !$eTarget.hasClass('downloads__icon') && $target.length) {
				$target.trigger('click.standard');
			}
		});

		$('a', $el).on('click.standard', function(e) {
			if ($(e.currentTarget)[0] != $target[0]) {
				//e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
			}
		});
	};

	init();	return api;
};

app.ext["countup"] = function ($el) {
	var api = {};

	var init = function () {
		initPlugins();
	};

	var initPlugins = function () {
		$el.each(function (i, e) {
			//  console.log("test");
			//var $el = $(this);
			var to = $el.text();
			var split = $el.text().split(".");
			var decimals = split[1] ? split[1].length : 0;

			//console.log(to+' '+decimals);
			$el.data(
				"countup",
				new CountUp($el[0], 0, to, decimals, 2, {
					decimal: ".",
					separator: ",",
				})
			);

			var tween = new ScrollMagic.Scene({
				triggerElement: e,
				triggerHook: "onEnter",
				offset: 50,
			})
				.on("enter", function () {
					$el.data("countup").start();
				})
				.addTo(app.obj.site.scrollController);
		});
	};

	init();
	return api;
};

app.ext['dots'] = function($el) { 
	var api = {};

	var init = function() {
		api.dots();
		$el.data('dots', api);
	};

	api.dots = function() {
		var dots = $el.dotdotdot({
			ellipsis: '...',
			watch: 'window',
			callback: function(isTruncated, orgContent) {
				if (!isTruncated) {
					$el.addClass('no-height');
				}
			},
		});
		setTimeout(function() {
			$el.trigger('update');
		}, 30);
	};

	init();	return api; 
};

app.ext['dropdown'] = function($el) { 
	var api = {};

	var settings = {
		duration: 0.3,
		distance: 10,
	};

	var classes = {
		content : '.js-dropdown-content',
		label   : '.dropdown__label, .map__filter__item__header',
		close   : '.js-dropdown-close',
		main    : '.js-dropdown-main',
	};

	// vars
	var dropdownOpen = false;
	var dropdownEnter;
	var scrollers    = [];
	var touch;
	var tabbed       = $el.data('tabbed');
	var results_cols = $el.parents('.search__results__cols').length;

	// elements
	var $win         = app.vars.$win;
	var $doc         = app.vars.$doc;
	var $html        = app.vars.$html;
	var $content     = $el.find(classes.content);
	var $label       = $el.find(classes.label);
	var $close       = $el.find(classes.close);
	var $main        = $el.find(classes.main);
	var inline;

	// functions
	var init = function() {
		touch = $html.hasClass('screen--is-touch');
		addListeners();
	};

	var addListeners = function() {
		$label.on('click.dropdown_element', elClickHandler);
		//$el.on('mouseenter.dropdown_element', elMouseenterHandler);
		//$el.on('mouseleave.dropdown_element', elMouseleaveHandler);
		$close.on('click.dropdown_close', closeClickHandler);
		
		$doc.on('click.dropdown', documentClickHandler);
		$win.on('scrollRefresh', scrollRefreshHandler);
		$win.on('resize.dropdown-inline orientationchange.dropdown-inline', resizeHandler).trigger('resize.dropdown-inline');
	};

	var resizeHandler = function(event) {
		inline = $el.hasClass('dropdown--inline') || (results_cols && $html.hasClass('from-desktopEx'));
		if(inline){
			//hideDropdown();
			//$content.removeAttr('style');
		}
	};

	var elClickHandler = function(event) {
		if(!$(event.target).hasClass('js-filters-reset')){
			//console.log($(event.target));
			//$el.parents('.filters').find('.dropdown:not(.is-nested.is-active.is-current) .js-dropdown-close').trigger('click.dropdown_close');
			api.showDropdown();
		}
	};

	var closeClickHandler = function(event) {
		hideDropdown();
	};

	var elMouseenterHandler = function(event) {
		//console.log('elMouseenterHandler');
		clearTimeout(dropdownEnter);
		if (!inline && dropdownOpen) {
			api.showDropdown();
		}
		/*if (!touch) {
			api.showDropdown();
		}*/
	};

	var elMouseleaveHandler = function(event) {
		if (!touch && !inline) {
			clearTimeout(dropdownEnter);
			dropdownEnter = setTimeout(function() {
				hideDropdown();
			}, 50);
		}
	};

	var documentClickHandler = function(event) {
		//console.log('documentClickHandler');
		if (dropdownOpen) {
			var $target = $(event.target);
			if (($target.hasClass('dropdown') && $html.hasClass('until-tablet')) || (!$target.closest('.dropdown').length && ($html.hasClass('until-desktopEx') || $el.closest('.search.search--category').length || $el.closest('.dropdown-lg').length))) {
				hideDropdown();
			}
		}
	};

	var scrollRefreshHandler = function(event) {
		//console.log("scrollRefreshHandler");
		$.each(scrollers, function(index, scroller) {
			scroller.refresh();
			scrollUpdate(scroller);
		});
	};

	api.showDropdown = function() {
		if (dropdownOpen) {
			hideDropdown();
		}else{
			$el.closest('.filters').find('.dropdown.is-active .js-dropdown-close').trigger('click.dropdown_close');
			//console.log('showDropdown');
			clearTimeout(dropdownEnter);
			setTimeout(function() {
				if($('html.until-tablet').length){
					/*$doc.on('touchmove.dropdown','html, body, .site-wrapper, .site-main', function(e){
						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();
						return false;
					});*/

					// FREEZE
					var y = $win.scrollTop();
					setTimeout(function() {
						/*if (app.obj['sticky-top']) {
							$.each(app.obj['sticky-top'], function(index, object) {
								object.freezeStickyKit();
							});
						}*/
						var $freeze = !$('html.search--open').length ? $('.site__wrapper') : ( !app.obj.site.overlayOpen ? $('.search.search--global') : $('.overlay') );
						$freeze.data('y', y);
						$freeze.css('top', -y + $freeze.position().top);
						$html.addClass('page--dropdown');
						$win.scrollTop(0);
					}, 100);
				}else{
					$html.addClass('page--dropdown');
				}
			});
			$el.addClass(app.states.isActive);

			if (!inline) {
				$content.removeAttr('style').show();
				setTimeout(function(){
					$content.addClass('is-active');
					dropdownOpen = true;
					initScroller($content);
				}, 100);
			} else {
				$content.slideDown({duration: 500, easing: 'easeInOutQuart', complete:function() {
					dropdownOpen = true;
					initScroller($content);
				}});
			}
		}
	};

	var hideDropdown = function() {
		//console.log('hideDropdown');
		
		var $freeze = !$('html.search--open').length ? $('.site__wrapper') : ( !app.obj.site.overlayOpen ? $('.search.search--global') : $('.overlay') );
		$el.removeClass(app.states.isActive);
		//$doc.off('touchmove.dropdown');

		// UNFREEZE
		if($('html.until-tablet').length){
			var y = $freeze.data('y');
			$html.removeClass('page--dropdown');
			$win.scrollTop(y);
		}else{
			$html.removeClass('page--dropdown');
		}
		$freeze.removeAttr('style');

		if (!inline) {
			$content.removeClass('is-active');
			setTimeout(function(){
				$content.removeAttr('style').hide();
				dropdownOpen = false;
				$el.parents('.dropdown-lg').remove();
			}, 400);
		} else {
			$content.slideUp({duration: 500, easing: 'easeInOutQuart', complete:function() {
				dropdownOpen = false;
			}});
		}

		$win.off('resize.dropdown orientationchange.dropdown');
	};

	var initScroller = function($group) {
		var $scrollers = $group.find(classes.main);
		var resizeScrollbars = $scrollers.prop('scrollHeight') < 1000;

		$scrollers.each(function() {
			var $scroller = $(this);
			if ($scroller.data('scroller')) {
				var scroller = $scroller.data('scroller');
				scroller.refresh();
				scrollUpdate(scroller);
				return false;
			}
			var scroller = new IScroll($scroller[0], {
				scrollbars: true,
				mouseWheel: true,
				interactiveScrollbars: true,
				resizeScrollbars: resizeScrollbars,
				//scrollbars: 'custom',
				click: false,
				preventDefaultException: {label:/.*/},
			});
			scroller['holder'] = $scroller;
			$scroller.data('scroller', scroller);
			scrollers.push(scroller);
			scrollUpdate(scroller);
		});
	};

	var scrollUpdate = function(scroller){
		var $scroller = scroller['holder'];
		//console.log($scroller);
		if(!$('.iScrollIndicator:visible', $scroller).length){
			$scroller.removeClass('scrollbar--enabled');
		}else{
			$scroller.addClass('scrollbar--enabled');
		}
	};

	$el.data('dropdown', api);

	init();	return api;
};

app.ext['field-adder'] = function($el) {
  var api = {};

  var classes = {
    row       : '.js-field-adder-row',
    field     : '.js-field-adder-field',
    button    : '.js-field-adder-button',
    remove    : '.js-field-adder-remove',
    buttonRow : '.js-field-adder-button-row',
  };

  var $row       = $(classes.row, $el);
  var $button    = $(classes.button, $el);
  var $buttonRow = $(classes.buttonRow, $el);

  var fieldCount = 0;
  var fieldName  = $el.data('fieldName');

  var init = function() {
    addListeners();
  };

  var addListeners = function() {
    $button.on('click', buttonClickHandler);
    $el.on('click', classes.remove, removeClickHandler);
  };

  var buttonClickHandler = function(e) {
    addField();
  };
  var removeClickHandler = function(e) {
    var $row = $(this).closest(classes.row);
    removeField($row);
  };

  var addField = function() {
    fieldCount++;
    var $newRow = $row.clone();
    var $newField = $(classes.field, $newRow);
    $newRow.addClass('has-remove');
    $newField.removeAttr('required').val('');
    $newField.attr('name', fieldName + '[' + fieldCount + ']');
    $buttonRow.before($newRow);
  };

  var removeField = function($row) {
  	if (fieldCount === 0) return false;
    $row.remove();
    recalculateIndexes();
  };

  var recalculateIndexes = function() {
    var $rows = $(classes.row, $el);
    $rows.each(function(index, row) {
      var $currentRow = $(this);
      var $currentField = $(classes.field, $currentRow);
      $currentField.attr('name', fieldName + '[' + index + ']');
    });

    fieldCount = $rows.length - 1;

    console.log(fieldCount);
  };

  init();
  return api;
};

app.ext['filters'] = function ($el) {
	var api = {};

	var $win = app.vars.$win;
	var $doc = app.vars.$doc;
	var $html = app.vars.$html;
	var $body = app.vars.$body;

	var settings = {
		duration: 0.4,
	};

	var classes = {
		toggle: '.js-filters-toggle',
		content: '.js-filters-content',
		chosen: '.js-filters-chosen',
		group: '.js-filters-group',
		search: '.js-filters-search',
		item: '.js-filters-item',
		noResults: '.js-filters-no-results',
		reset: '.js-filters-reset',
		searchReset: '.js-filters-search-reset',
		groupSection: '.js-filters-group-section',
	};

	// elements
	var $toggle = $el.find(classes.toggle);
	var $content = $el.find(classes.content);
	var $search = $el.find(classes.search);
	var $searchReset = $el.find(classes.searchReset);

	// vars
	var filtersOpen = false;
	var objData = $el.data();
	var selectedString = objData['selectedString'];
	var objectName = objData['objectName'];
	var filtersReload = objData['filtersReload'];

	var init = function () {
		addListeners();

		// SHOW/HIDE SEARCH INPUT FIELD
		$(classes.group, $el).each(function () {
			var $group = $(this);
			if ($('.js-filters-item', $group).length <= 10) {
				$('.dropdown__search', $group).remove();
			}
		});
	};

	var addListeners = function () {
		//$toggle.on('click', toggleClickHandler);
		$doc.on('click.filterToggle', classes.toggle, toggleClickHandler);
		//$search.on('keyup', searchKeyupHandler);
		$doc.on('keyup.filterSearch', classes.search, searchKeyupHandler);
		//$searchReset.on('click', searchResetClickHandler);
		$doc.on('click.filterReset', classes.reset, resetClickHandler);
		$doc.on('click.filterSearchReset', classes.searchReset, searchResetClickHandler);
		$el.on('change.filterInput', 'input[type="checkbox"]', checkboxChangeHandler);
	};

	var toggleClickHandler = function (event) {
		if (filtersOpen) {
			hideFilters();
		} else {
			showFilters();
		}
	};

	var searchKeyupHandler = function (event) {
		var $this = $(this);
		filterItems($this);
	};

	var checkboxChangeHandler = function (event) {
		var $checkbox = $(this);
		var $currentGroup = $checkbox.closest(classes.group);
		var checked = $checkbox.prop('checked');
		var multiselect = !$currentGroup.hasClass('js-filters-group-single');
		var radio = $currentGroup.hasClass('js-filters-group-radio');

		if (!multiselect) {
			$currentGroup.find('input[type=checkbox]:checked').prop('checked', false);
			$checkbox.prop('checked', radio ? true : checked);
			if (checked) $checkbox.attr('checked', 'checked');
			//console.log('trigger:'+checked);
		}

		//filterChange($currentGroup);
		markChangedLabel($currentGroup);

		// NESTED
		if (checked) {
			setTimeout(function () {
				$('.js-dropdown-close', $checkbox.closest('.dropdown.is-nested')).trigger('click.dropdown_close');
			}, 100);
		}

		if (filtersReload != false) {
			app.obj['tabs'][objectName].loadTab('no-scroll');
		}
	};

	var resetClickHandler = function (event) {
		var $checkbox = $(this);
		var $currentGroup = $checkbox.closest(classes.group);
		$currentGroup.find('input[type=checkbox]:checked').prop('checked', false).removeAttr('checked').trigger('change');
		//markChangedLabel($currentGroup);
	};

	var searchResetClickHandler = function (event) {
		var $this = $(this);
		var $field = $this.siblings(classes.search);
		$field.val('');
		filterItems($field);
	};

	var showFilters = function () {
		//$content.show();
		/*TweenLite.set($content, {height: 'auto'});
		$el.addClass(app.states.isOpen).addClass(app.states.isAnimated);
		TweenLite.from($content, settings.duration, {height: 0, ease: app.settings.easeInOut, onComplete: function() {
			$el.removeClass(app.states.isAnimated);
			TweenLite.set($content, {height: 'auto'});
		}});*/
		//$el.addClass(app.states.isOpen).addClass(app.states.isAnimated);
		$el.addClass(app.states.isOpen);
		$content.slideDown({
			duration: 500, easing: 'easeInOutQuart', complete: function () {
			}
		});
		filtersOpen = true;
	};

	var hideFilters = function () {
		/*$el.addClass(app.states.isAnimated);
		TweenLite.to($content, settings.duration, {height: 0, display: 'none', ease: app.settings.easeInOut, onComplete: function() {
			$el.removeClass(app.states.isAnimated);
		}});*/
		$el.removeClass(app.states.isOpen);
		$content.slideUp({
			duration: 500, easing: 'easeInOutQuart', complete: function () {
			}
		});
		filtersOpen = false;
	};

	var markChangedLabel = function ($formGroup) {
		var $currentChosen = $formGroup.find(classes.chosen);
		var $checked = $formGroup.find('input[type=checkbox]:checked');
		var checkedCount = $checked.length;

		$(classes.group, $el).removeClass('is-current');
		if (checkedCount) $formGroup.addClass('is-current');
		$formGroup.attr('data-selected', checkedCount || 0);

		if (checkedCount >= 1) {
			//$currentChosen.text(checkedCount + ' ' + selectedString);
			//$currentChosen.html('<span class="dropdown__label__chosen__text">'+$checked.next('label').text()+'</span><span class="dropdown__label__chosen__count">'+checkedCount+'</span>');
			$currentChosen.html($checked.next('label').text());
			$formGroup.addClass(app.states.isSelected);
			/*} else if (checkedCount == 1) {
				var labelText = $checked.next('label').text();
				$currentChosen.text(labelText);
				$formGroup.addClass(app.states.isSelected);*/
		} else {
			$currentChosen.html('');
			$formGroup.removeClass(app.states.isSelected);
		}
	};

	/*var filterChange = function($filter) {
		$filter.addClass(app.states.isChange);
		setTimeout(function(){
			$filter.removeClass(app.states.isChange);
		}, 30);
	};*/

	var filterItems = function ($field) {
		var search = $field.val();
		var $group = $field.closest(classes.group);
		var $items = $group.find(classes.item);
		var $noResults = $group.find(classes.noResults);
		var $searchReset = $group.find(classes.searchReset);
		var activeCount = 0;
		var tabbedGroup = $group.data('tabbed');

		if (tabbedGroup === true) {
			$itemContainer = $field.closest(classes.groupSection);
			$items = $itemContainer.find(classes.item);
			$noResults = $itemContainer.find(classes.noResults);
			$searchReset = $itemContainer.find(classes.searchReset);
		}

		if (search !== '') {
			$searchReset.addClass(app.states.isActive);
		} else {
			$searchReset.removeClass(app.states.isActive);
		}

		$items.each(function () {
			var $item = $(this);
			var name = $item.find('label').text();
			if (name.toLowerCase().indexOf(search.toLowerCase()) === -1) {
				$item.hide();
			} else {
				$item.show();
				activeCount++;
			}
		});

		$items.filter('.' + app.states.isLast).removeClass(app.states.isLast);
		var $lastItem = $items.filter(':visible').last();
		$lastItem.addClass(app.states.isLast);

		if (activeCount) {
			$noResults.hide();
		} else {
			$noResults.show();
		}

		$win.trigger('scrollRefresh');
	};

	init(); return api;
};

app.ext['form-steps'] = function($el) { 
	var api = {};

	var $win = app.vars.$win;

	var classes = {
		progress: '.form-steps__progress',
		nr: '[data-nr]',
		back: '.form-steps__back__button',
		inner: '.form-steps__inner',
		step: '.form-steps__step',
		items: '.form-steps__items',
		item: '.form-steps__item',
		success: '.form-steps__step--success',
	};

	var $inner = $(classes.inner, $el);
	var $step = $(classes.step, $el);
	var $progress = $(classes.progress);
	var $progress_nr = $(classes.nr, $progress);
	var $nr = $(classes.nr, $el);
	var $back = $(classes.back, $el);
	var win_w = $win.innerWidth();
	var timer;
	var start = 0;

	var init = function() {
		addListeners();
		historyGet();
	};

	var addListeners = function() {
		$step.find('a[data-value]').on('click.form-step-value', stepClickHandler);
		$nr.on('click.form-step-nr', nrClickHandler);
		$back.on('click.form-step-back', stepBackHandler);
		$win.on('resize.form-steps orientationchange.form-steps', resize);
	};

	var stepBackHandler = function(e) {
		stepClose($step.filter('.' + app.states.isOpen));
		$el.find('.' + app.states.isActive + ', .' + app.states.isOpen).removeClass(app.states.isActive + ' ' + app.states.isOpen);
		$progress.removeAttr('data-progress');
		stepOpen($step.eq(0));
	};

	var nrClickHandler = function (e) {
		var nr = $(e.currentTarget).data('nr');
		var nr_empty = $progress_nr.filter(':not(.' + app.states.isSelected + '):not(:last-child)').first().data('nr');

		//if ((!nr_empty || nr_empty > nr) && $progress_nr.filter('[data-nr="' + nr + '"]' + '.' + app.states.isSelected).length) {
		if ((!nr_empty || nr_empty > nr) && $progress_nr.filter('[data-nr="' + nr + '"]' + '.' + app.states.isSelected + ', [data-nr]' + '.' + app.states.isSelected + ' + [data-nr="' + nr + '"]').length) {
			stepClose($step.filter('.' + app.states.isOpen));
			stepOpen($step.filter('[data-nr-target="' + nr + '"]'));
		}
	};

	var nrSet = function (nr) {
		if(nr){
			$progress.css('height', $progress.children().prop('scrollHeight'));
			//$progress_nr.removeClass(app.states.isActive + ' ' + app.states.isSelected).filter('[data-nr="' + nr + '"]').addClass(app.states.isActive);
			var $_nr = $progress_nr.removeClass(app.states.isActive).filter('[data-nr="' + nr + '"]').addClass(app.states.isActive);

			// PREVIOUS SELECTIONS
			/*if ($_nr.prev().not('.' + app.states.isSelected).length){
				$progress.removeAttr('style');
			}else{*/
				setTimeout(function(){
					$progress.addClass(app.states.isOpen);
					$progress.removeAttr('style');
				}, 500);
			//}
		}
	};

	var stepClickHandler = function (e) {
		var $target = $(e.currentTarget);
		e.preventDefault();
		stepSet($target, true);
	};

	var stepSet = function ($target, trigger) {
		var value = $target.data('value');
		var nr_next = $target.data('next');
		var nr_target = $target.data('target');
		var progress = $target.data('progress');
		var $_step = $target.closest(classes.step);
		var $_next = nr_next ? $step.filter('[data-nr-target="' + nr_next + '"]') : $_step.next();
		var $_target = nr_target ? $step.filter('[data-nr-target="' + nr_target + '"]') : $_next;

		// SHOW PROGRESS
		if (progress){
			$progress.attr('data-progress', progress);
		}else{
			$progress.removeAttr('data-progress');
		}

		if(value){
			var $_items = $_target.find(classes.items);
			var $_items_active = $_items.filter('[data-value="' + value + '"]');
			var $_item = $target.closest(classes.item);
			var name = $target.closest('[data-name]').data('name');
			var already_active = $_item.hasClass(app.states.isActive);

			//console.log(name+': '+value);

			// SHOW - HIDE SUBCATEGORIES
			$_step.find(classes.item).removeClass(app.states.isActive);
			if ($_items_active.length){
				$_items.filter('[data-value]').removeClass(app.states.isActive);
				$_items_active.addClass(app.states.isActive);
			}

			// SET PROGRESS NR
			$progress_nr.filter('[data-nr="'+$_step.data('nr-target')+'"]').addClass(app.states.isSelected);

			// SET HIDDEN INPUT VALUE
			$el.find('input[name="'+name+'"]').attr('value', value);

			// SET TEXT VARIABLES
			$el.find('[data-name-target="'+name+'"]').html($target.find('.box__title').html());

			// SET BOX ACTIVE
			$_item.addClass(app.states.isActive);
			
			if (!already_active && $_items_active.length){
				nr_target = $_target.data('nr-target');
				$nr.filter('[data-nr="' + nr_target + '"]').removeClass(app.states.isActive + ' ' + app.states.isSelected);
				$_target.find(classes.item).removeClass(app.states.isActive);
			}
			
			// JUMP FORWARD
			if (already_active || !$_items_active.length){
				var nr = $progress.find('li.' + app.states.isSelected + ' + li:not(.' + app.states.isSelected + ')').data('nr') || $progress_nr.filter('.' + app.states.isSelected + ' + ').last().next().data('nr');
				$_next = $step.filter('[data-nr-target="' + nr + '"]');
			}
		}

		if (trigger) {
			stepNext($_step, $_next);
		}
	};

	var stepNext = function ($_step, $_next) {
		//if ($_step.hasClass(app.states.isOpen)) {
			stepClose($_step);
			//setTimeout(function(){
			stepOpen($_next);
			//}, 700);
		//} else {
		//	stepOpen($_step);
		//}
	};

	var stepClose = function($_step) {
		var h = $_step.children().prop('scrollHeight');
		$_step.css('height', h + 'px');
		$_step.removeClass(app.states.isOpen);
		var _timer = setTimeout(function () {
			$_step.removeAttr('style');
		}, 0);
	};

	var stepOpen = function($_step) {
		var h = $_step.children().prop('scrollHeight');
		var nr = $_step.data('nr-target');
		var $_items = $_step.find(classes.items + '.' + app.states.isActive).children();
		
		$inner.css('height', $inner.outerHeight() + 'px');
		$_step.css('height', h + 'px');
		$_step.addClass(app.states.isOpen);

		var _timer = setTimeout(function () {
			$inner.css('height', h + 'px');
		}, 0);
		
		clearTimeout(timer);
		timer = setTimeout(function () {
			$inner.removeAttr('style');
			$step.filter('.' + app.states.isOpen).addClass(app.states.isActive).removeAttr('style');
		}, 500);
		
		nrSet(nr);
		historySet();

		// OPTIONS TEXT
		if ($_items.length<2){
			$_items.find('a').trigger('click');
			$el.find('[data-nr-text="'+nr+'"]').hide();
		}else{
			$el.find('[data-nr-text="'+nr+'"]').show();
		}
		
		historySet();
	};

	api.formSuccess = function (infoSettings){
		$el.addClass('form-steps--success');
		$progress_nr.last().addClass(app.states.isSelected);
		stepClose($step.filter('.' + app.states.isOpen));
		stepOpen($step.filter(classes.success));

		scrollUp();
	};

	var scrollUp = function () {
		var y = 0;
		app.obj.site.scrollController.scrollTo(y, {
			callback: function () { if (typeof app.obj.site.scrollController.update !== 'undefined') app.obj.site.scrollController.update(true); },
			duration: 0.8,
		});
	};

	var resize = function (e) {
		var w = $win.innerWidth();
		if(win_w != w){
			//stepOpen($step.filter('.'+app.states.isOpen));
			win_w = w;
		}
	};

	var historyGet = function () {
		var params = [];
		
		$step.filter('[data-key]').each(function () {
			var $_step = $(this);
			var key = $_step.data('key');
			var val = $_step.data('value');
			var param = app.vars.urlParam[key] || false;

			if (param){
				var $a = $_step.find(classes.item + ' a[data-slug="' + param + '"]');

				//console.log(key + ' = ' + param);

				stepSet($a);
				params.push($a);
			}
		});

		if (params.length>0){
			var nr_active = $progress_nr.filter('.' + app.states.isSelected).last().next().data('nr') || 1;
			var nr_empty = $progress_nr.filter(':not(.' + app.states.isSelected + ')').first().data('nr') || nr_active;
			var $a_last = params.shift();
			var progress = $a_last.data('progress');
			var nr_next = (!progress || progress != 'hidden') ? Math.min(nr_empty, nr_active) : $a_last.data('next');

			$_next = $step.filter('[data-nr-target="' + nr_next + '"]');
			stepOpen($_next);
		}else{
			stepOpen($step.eq(start));
		}
	};

	var historySet = function () {
		var params = '';
		var sandbox = app.vars.urlParam['sandbox'] ? ('sandbox=' + app.vars.urlParam['sandbox'] + '&') : '';

		$step.filter('[data-key]').each(function(){
			var $_step = $(this);
			var $a = $_step.find(classes.item + '.is-active a[data-value]');


			if($a.length){
				params += '&' + $_step.data('key') + '=' + ($a.data('slug') || slugify($a.data('value')) );
			}
		});

		if(params.length > 0){
			var loc = location.href;
			var url = loc.split('?')[0] + '?' + sandbox + params.substr(1);
			if(url != loc){
				history.pushState({ type: 'form-steps' }, document.title, url);
			}
		}
	};

	function slugify(string) {
		/*
		const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœøṕŕßśșțùúüûǘẃẍÿź·/_,:;'
		const b = 'aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuwxyz------'
		const p = new RegExp(a.split('').join('|'), 'g')

		return string.toString().toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with 'and'
			.replace(/[^\w\-]+/g, '') // Remove all non-word characters
			.replace(/\-\-+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') // Trim - from end of text
		*/
		return string;
	};

	init();	return api;
};
app.ext['form-upload'] = function($el) { 
	var api = {};

	var init = function() {
		$('.form__upload', $el).each(function(){
			var $holder = $(this);
			var myDropzone = new Dropzone($holder[0], {
				url: $el.data('upload-url'),
				thumbnailWidth:		40,
				thumbnailHeight:	40,
				//createImageThumbnails: false,
				parallelUploads:	20,
				previewTemplate:	'<div class="dz-preview dz-file-preview">\
										<div class="dz-details">\
											<img data-dz-thumbnail />\
											<div class="dz-filename"><span data-dz-name></span></div>\
										</div>\
										<div class="dz-data">\
											<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\
											<div class="dz-size" data-dz-size></div>\
											<div class="dz-remove" data-dz-remove>Delete</div>\
										</div>\
									</div>',
				autoQueue: true,	// Make sure the files aren't queued until manually added
				previewsContainer:	$('.form__upload__list', $holder)[0],
				clickable:			$('.form__upload__button', $holder)[0], // Define the element that should be used as click trigger to select files.

				init: function() {
					this.on('success', function(obj, response) {
						if (typeof obj === 'object') {
							$el.append($('<input type="hidden" name="uploads[]" value="'+response.id+'">'));
						}
					});
					this.cleanUp = function() {
						this.removeAllFiles(true);
					};
				},
			});

			var cleanUp = function(){
				myDropzone.cleanUp();
			}

			if(!$el.data('dropzone')){
				$el.data('dropzone', [myDropzone]);
			}else{
				$el.data('dropzone').push(myDropzone);
			}
		});
	};


	init();	return api;
};

Dropzone.autoDiscover = false;

app.ext["form"] = function ($el) {
  var api = {};

  var $doc = app.vars.$doc;

  var init = function () {
    addListeners();
  };

  var action = $el.attr("action") || $el.data("action");
  var method = $el.attr("method") || $el.data("method");
  var $submit = $el.find('input[type="submit"]');
  var formBeingSent = false;
  var formSuccess;

  var $radio_checkbox = $('input[type="checkbox"], input[type="radio"]', $el);

  var addListeners = function () {
    $el.on("submit", formSubmitHandler);
    //$('*:not(form) input[type="submit"]', $el).on('click', formSubmitHandler);
    $radio_checkbox.on("change.input", checkBoxHandler);

    $doc.on(
      "keyup.input, change.input",
      "input, textarea, select",
      function (e) {
        var $target = $(e.currentTarget);
        if ($target.val() != "") {
          $target.addClass("not-empty");
        } else {
          $target.removeClass("not-empty");
        }
      }
    );
    $el.find(".form__check").on("click.form-input-clear", function () {
      $(this)
        .parent()
        .find("input:not(:valid)")
        .val("")
        .removeClass("not-empty");
    });
    $submit.on("click.form-submit", formSubmitHandler);
  };

  var formSubmitHandler = function (e) {
    e.preventDefault();
    submitForm($(e.currentTarget).attr("type") == "submit" || e.currentTarget.nodeName === 'FORM');
  };

  var checkBoxHandler = function (e) {
    var $input = $(this);
    var name = $input.attr("id");
    var checked = $input.prop("checked");
    var $relation = $('[data-relation="' + name + '"]', $el);

    if ($relation.length) {
      if (checked) {
        $relation.slideDown({
          duration: 500,
          easing: "easeInOutQuart",
          complete: function () {},
        });
      } else {
        $relation.slideUp({
          duration: 500,
          easing: "easeInOutQuart",
          complete: function () {},
        });
      }
    }
  };

  var submitForm = function (trigger) {
    if (formBeingSent) return false;
    formBeingSent = true;


    if (trigger) {
      var $errors = $el.find(
        "input:not(:valid):not([type=hidden]), select:not(:valid):not([type=hidden]), textarea:not(:valid):not([type=hidden])"
      );
      var $captcha = $(".g-recaptcha");
      var captcha_required =
        $captcha.length && grecaptcha.getResponse().length === 0;

      $captcha
        .removeClass("is-required")
        .addClass(captcha_required ? "is-required" : "");

      if ($errors.length || captcha_required) {
        $el.addClass("form--validate");
        /*var $navigation_height = $site_header.outerHeight();
				var top = $errors.eq(0).offset().top;
				if (top - $navigation_height < $win.scrollTop()) {
					app.obj.site.scrollController.scrollTo(top - $navigation_height - 100);
				}*/
        formBeingSent = false;
        return false;
      } else {
        $el.removeClass("form--validate").addClass("form--sending");
      }



      //var formData = $el.serialize();
      var formData = $(":input", $el).serialize();
      var utm = Cookies.get(app.vars.utm.cookie_name);

      // ADD UTM PARAMS
      if (utm) {
        utm = JSON.parse(utm);
        formData += "&" + $.param(utm);
      }

      console.log("submit:");
      console.log(formData);

      var data = {
        formData: formData,
        CRAFT_CSRF_TOKEN: window.csrfTokenValue,
      };

      // SALESFORCE FORM
      if ($el.find("[name=oid]").length) {
        data = formData;
        formSuccess = app.obj["form-steps"][0].formSuccess;
      } else {
        formSuccess = app.obj["info"].showInfo;
      }

      $.ajax({
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          app.obj["preloader"].showPreloader(xhr);
          return xhr;
        },
        url: action,
        type: method,
        data: data,
        dataType: "json",
        cache: false,
        success: function (data) {
          var infoType;
          var dropzone = $el.data("dropzone");
          console.log(infoType);

          if (data.status == "success") {
            infoType = "success, corner";
            $el[0].reset();

            if (dropzone) {
              for (var i = 0; i < dropzone.length; i++) {
                dropzone[i].cleanUp();
              }
            }

            if ($el.data("overlay-close")) {
              $(".button-close", $el.parents(".overlay")).trigger("click");
            }
            // TRACKING
            tracking(action, data);
          } else {
            infoType = "warning, corner";
          }
          var infoSettings = {
            type: infoType,
            autoHide: true,
            title: data["message_title"],
            message: data["message_text"],
          };
          formSuccess(infoSettings);
        },
        error: function (data) {
          formBeingSent = false;
        },
      }).done(function () {
        app.obj["preloader"].hidePreloader();
        formBeingSent = false;
      });
    } else {
      formBeingSent = false;
    }
  };

  var tracking = function (action, data) {
    var linkedin_conversion = $el.data("linkedin-conversion");

    // TRACKING
    /*app.obj.tracking.track({
			'event': 'formSubmit',
			'attributes': {
				'url': action,
				'title': data['message_title'],
				'message': data['message_text']
			}
		});*/

    app.obj.tracking.track({
      event: "forms",
      category: "Forms",
      action: "Submit",
      label: action,
      attributes: {
        url: action,
        title: data["message_title"],
        message: data["message_text"],
      },
    });

    if (linkedin_conversion) {
      $("body").append(
        $(
          '<img height="1" width="1" style="display:none;" alt="" src="' +
            linkedin_conversion +
            '" />'
        )
      );
    }
  };

  init();
  return api;
};

app.ext['fullheight'] = function($el) {
  var api = {};

  var $win  = app.vars.$win;
  var $doc  = app.vars.$doc;
  var $html = app.vars.$html;
  var $body = app.vars.$body;

  var initialized = false;

  var init = function() {
    setHeight();
    addListeners();
  };

  var addListeners = function() {
    if (app.vars.media === 'mobile') {
      $win.on('resize', windowResizeHandler);
    }
  };

  var windowResizeHandler = function() {
    setHeight();
  };

  var setHeight = function() {
    if (app.vars.media === 'mobile') {
      $el.height($win.height());
    }
  };

  init();	return api;
};

app.ext['header-nav-trigger'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var init = function() {
		addListeners();
	};

	var addListeners = function() {
		$el.on('click.header-nav', elClickHandler);
		//$win.on('headerNavLinkClick.header-nav', headerNavLinkClickHandler);
		//$win.on('headerNavCloseClick.header-nav', headerNavCloseClickHandler);
	};

	var elClickHandler = function(event) {
		event.preventDefault();
		var $this = $(this);
		var $target = $('.js-ui-site-header').find($this.data('href'));

		$target.trigger('click');

		if ($target.parent('li').hasClass('open')) {
			$this.addClass(app.states.isActive);
			$el.addClass(app.states.isActive);
		} else {
			$this.removeClass(app.states.isActive);
			$el.removeClass(app.states.isActive);
			app.obj['nav-main'].close();
		}
	};

	var headerNavLinkClickHandler = function(event) {
		$el.removeClass(app.states.isActive);
	};

	var headerNavCloseClickHandler = function(event) {
		$el.removeClass(app.states.isActive);
	};


	init();	return api;
};

app.ext['hotspots'] = function($el) { 
  var api = {};

  var $win = app.vars.$win;
  var margin = 10;
  var $active;

	var classes = {
    trigger: '.js-hotspots-trigger',
    close: '.js-hotspots-close',
    target: '.js-hotspots-target',
  };

  var states = {
    active: 'is-active',
  };

	var init = function() {
    $el.find(classes.trigger).on('click.hotspots-trigger', function(e) {
      $trigger = $(e.currentTarget);
      $target = $trigger.next();
      overlayOpen($target, $trigger);
    });
    $el.find(classes.close).on('click.hotspots-close', function (e) {
      overlayOpen();
    });
  };
  
  var overlayOpen = function ($target, $trigger) {
    if ($active) {
      $active.removeClass(states.active);
    }
    if ($target) {
      $active = $target;
      var pos = $trigger.position();
      var offset = $trigger.offset();
      var h = $active.outerHeight();
      var w_win = $win.innerWidth();
      var h_win = $win.innerHeight();
      var h_header = $('.site-header').height();
      var w_trigger = $trigger.outerWidth();
      var h_trigger = $trigger.outerHeight();
      var y_scroll = $win.scrollTop();
      var x = pos.left + w_trigger + margin;
      var y = pos.top - h / 2 + h_trigger / 2;
      var y_diff = -offset.top + y_scroll + h / 2 - h_trigger / 2 + h_header + margin;

      y += Math.max(0, y_diff) + Math.min(0, y_diff + h_win - h - h_header - margin * 2);

      if (offset.left > w_win / 2) {
        x = pos.left - margin - $active.outerWidth();
      }

      $active.css('top', y);
      $active.css('left', x);
      $active.addClass(states.active);
    }
  };

	init();	return api;
};

app.ext['iframe'] = function($el) { 
	var api = {};

	var done;

	var init = function() {
		scroll();
		$(window).on('scroll.iframe', function() {
			scroll();
		});
	};

	var scroll = function() {
		if (!done && isVisible()) {
			done = true;
			$el.attr('src', $el.data('src')).addClass('iframe--show');
		}
	};

	var isVisible = function() {
		var rect = $el[0].getBoundingClientRect();
		return (
			(rect.height > 0 || rect.width > 0) &&
			rect.bottom >= 0 &&
			rect.right >= 0 &&
			rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.left <= (window.innerWidth || document.documentElement.clientWidth)
		);
	};

	init();	return api;
};

Dropzone.autoDiscover = false;

app.ext['industries'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var init = function() {
		var $wrapper		= $('.industries__wrapper', $el);
		var $items			= $('.industries__items:eq(0)', $el);
		var $items_inner	= $('.industries__items__inner', $items);
		var $subs			= $('.industries__subs', $el);
		var $subs_items		= $('.industries__items', $subs);
		var $subs_inner		= $('.industries__items__inner', $subs);
		var $nav			= $('.industries__nav li', $el);
		var $back			= $('.industries__back', $el);
		var timer;

		$('.industries__item', $items).on('click.industries', function(e) {
			e.preventDefault();
			var $target		= $(e.currentTarget);
			var index		= $('.industries__item', $items).index($target);
			var $sub		= $('.industries__items__inner:eq(' + index + ')', $subs);
			var h			= $items_inner.outerHeight();
			var subs_h		= $subs.prop('scrollHeight');
			var sub_h		= $sub.prop('scrollHeight');
			var delay		= scrollUp();
 
			$items.css('height', $items.outerHeight());
			$wrapper.css('height', $wrapper.outerHeight());

			clearTimeout(timer);
			timer = setTimeout(function() {
				$wrapper.css('height', sub_h + $back.outerHeight());
				$el.addClass('industries--open');
				$items.css('height', 0);
				$items_inner.css('transform', 'translateY(-' + h + 'px)');
				$subs.css('height', subs_h + sub_h);
				$sub.css('height', sub_h);

				timer = setTimeout(function() {
					$subs.css('height', 'auto');
					$sub.css('height', 'auto');

					setTimeout(function() {
						$('*[data-bg]', $sub).lazyLoadXT({checkDuplicates: false});
					}, 500);
				}, 1000);

				$nav.removeClass('open');
				$('.industries__nav li:eq(' + index + ')', $el).addClass('open');
				$('.industries__items__inner', $subs).filter(function(i) {
					//if(i != index) $(this).css('transform', 'translateY('+(i < index ? '-' : '')+'200%)');
					if (i != index) {
						$(this).addClass(i < index ? 'prev' : 'next').removeClass('open');
					} else {
						$(this).addClass('open');
						$sub = $(this);
					}
				});

				$win.on('resize.industries orientationchange.industries', function() {
					$wrapper.css('height', $sub.prop('scrollHeight') + $back.outerHeight());
				});
			}, delay);
		});

		$nav.on('click.subs', function(e) {
			var $target		= $(e.currentTarget);
			var index_old	= $nav.index($nav.filter('.open'));
			var index		= $nav.index($target);
			var $sub_old	= $('.industries__items__inner:eq(' + index_old + ')', $subs);
			var $sub		= $('.industries__items__inner:eq(' + index + ')', $subs);
			var subs_h		= $subs.prop('scrollHeight');
			var sub_h		= $sub.prop('scrollHeight');
			var delay		= scrollUp();

			if ($target.hasClass('open')) return false;

			//$subs_items.addClass('change');
			$nav.removeClass('open');
			$target.addClass('open');

			$subs_items.css('height', $subs_items.prop('scrollHeight'));
			//$subs.css('height', subs_h);
			$sub_old.css('height', $sub_old.prop('scrollHeight'));
			$sub.css('height', 0).addClass(index > index_old ? 'prev' : 'next');

			clearTimeout(timer);
			timer = setTimeout(function() {
				$subs_items.removeClass('change');
				$subs_items.css('height', $sub.prop('scrollHeight'));

				$('.industries__items__inner', $subs).filter(function(i) {
					//if(i != index) $(this).css('transform', 'translateY('+(i < index ? '-' : '')+'200%)').removeClass('open');
					if (i != index) $(this).addClass(i < index ? 'prev' : 'next').removeClass('open');
				});
				$sub_old.css('height', '0px');
				//$subs.css('height', subs_h+sub_h);
				$sub.css('height', sub_h).addClass('open').removeClass('prev next');

				timer = setTimeout(function() {
					$subs_items.css('height', 'auto');
					$sub.css('height', 'auto');

					setTimeout(function() {
						$('*[data-bg]', $sub).lazyLoadXT({checkDuplicates: false});
					}, 500);
				}, 1000);
			}, delay);
		});

		$back.on('click.back', function(e) {
			var delay = scrollUp();

			clearTimeout(timer);
			timer = setTimeout(function() {
				$el.removeClass('industries--open');
				$subs_inner.removeClass('open');
				$nav.removeClass('open');

				$wrapper.css('height', $items.outerHeight());

				setTimeout(function() {
					$win.off('resize.industries orientationchange.industries');
					$wrapper.removeAttr('style');
					$items.removeAttr('style');
					$items_inner.removeAttr('style');
					$subs.removeAttr('style');
					$subs_inner.removeAttr('style').removeClass('prev next');
				}, 1000);
			}, delay);
		});
	};

	var scrollUp = function() {
		var $nav_sub	= $('.site-main .subnav__trigger:eq(0)');
		var y			= $win.scrollTop();
		var y_diff		= $('html.until-desktopEx').length ? app.obj.site.headerHeight : ($nav_sub.length ? $nav_sub.outerHeight() : app.obj.site.headerHeight);

		app.obj.site.scrollController.scrollTo($el.offset().top, {
			callback: function() { if (typeof app.obj.site.scrollController.update !== 'undefined') app.obj.site.scrollController.update(true); }, 
			duration: 0.8,
		});

		return (y == Math.round($el.offset().top) - y_diff ? 0 : 800);
	};

	init();	return api;
};

app.ext["input-tel"] = function ($el) {
  var api = {};

  var input = $el[0];
  var $hidden = $el.parent().find(".js-input-tel-target");
  var placeholder = $el.attr("placeholder");
  var intlTel;

  var init = function () {
    initInput();
    addListeners();
  };

  var addListeners = function () {
    input.addEventListener("countrychange", function (e) {
      $hidden.val($el.val()).trigger("keyup");
    });
    $el
      .on("focus.intl-tel", function () {
        prefix();
      })
      .on("keyup.int-tel, change.int-tel", function () {
        $hidden.val($el.val()).trigger("keyup");
      });
  };

  var initInput = function () {
    /*$.getScript(location.protocol+'//www.geoplugin.net/javascript.gp', function () {
            var country = geoplugin_countryName();
            var zone = geoplugin_region();
            var district = geoplugin_city();
            console.log("Your location is: " + country + ", " + zone + ", " + district);
        });*/
    /*
        $.get("http://ipinfo.io", function(response) {
            console.log(response.city, response.country);
        }, "jsonp");
        */

    intlTel = intlTelInput(input, {
      initialCountry: "auto",
      geoIpLookup: function (success, failure) {
        /*$.get("//ipapi.co/jsonp", function () { }, "jsonp").always(function (json) {
                    var countryCode = (json && json.country) ? json.country : "";
                    success(countryCode.toLowerCase());
                });*/
        $.ajax({
          url: "https://ipinfo.io",
          jsonpCallback: "callback",
          dataType: "jsonp",
          success: function (json) {
            var countryCode = json && json.country ? json.country : "us";
            success(countryCode.toLowerCase());
          },
        });
      },
      //utilsScript: location.protocol + "//cdnjs.com/libraries/intl-tel-input",
      customPlaceholder: function (
        selectedCountryPlaceholder,
        selectedCountryData
      ) {
        //return placeholder + ' (+' + selectedCountryData.dialCode +' '+ selectedCountryPlaceholder + ')';
        return placeholder + " (+" + selectedCountryData.dialCode + "...)";
      },
      autoPlaceholder: "aggressive",
      //hiddenInput: 'mobile',
    });
  };

  var prefix = function () {
    if ($el.val() == "") {
      $el.val("+" + intlTel.selectedCountryData.dialCode + " ");
    }
  };

  init();
  return api;
};

app.ext['load-more'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var vars = {
		url: $el.attr('href'),
		$target: $($el.data('target'), $el.parent().parent()),
		loading: false,
		moduleID : $el.attr('data-module-id'),
		pageID : $el.attr('data-page-id'),
	};

	var init = function() {
		$el.on('click', function(e) {
			e.preventDefault();

			if(vars.url == 'javascript:;'){
				$('.is-hidden', vars.$target).removeClass('is-hidden');
				$el.hide();
				setTimeout(function() {
					$('[data-bg], [data-src]', vars.$target).lazyLoadXT({checkDuplicates: false});
					$win.trigger('scroll');
				}, 100);
			}else if (!vars.loading) {
				vars.loading = true;
				$el.parent().parent().addClass('js-load-more--loading');

				jQuery.ajax({
					context: this,
					url: vars.url,
					//async: false,
					type: 'GET',
					data: {
						offset: vars.$target.children().length,
						'CRAFT_CSRF_TOKEN' : window.csrfTokenValue,
						pageId: vars.pageID,
						moduleId: vars.moduleID,
					},
					dataType: 'json',
					contentType: 'application/json',
					//jsonpCallback: 'result',
					cache: false,
					success: function(data) {
						if (data.status == 'success') {
							var $result = $(data.html);
							vars.$target.append($result);
							$result.hide().fadeIn(500, 'easeOutCubic', function() {
								$(this).removeAttr('style');
								app.parse($result);
								setTimeout(function() {
									$('[data-bg], [data-src]', $result).lazyLoadXT();
									$win.trigger('scroll');
								}, 100);
							});
						}
						if (!data.more) {
							$el.hide();
						}
					},
					error:function(data) {
					},
				}).done(function() {
					vars.loading = false;
					$el.parent().parent().removeClass('js-load-more--loading');
				});
			}
		});
	};

	init();	return api;
};

app.ext['module-name'] = function($el) { 
	var api = {};

	var init = function() {
		
	};

	init();	return api;
};

app.ext["map"] = function ($el) {
  var api = {};

  var $win = app.vars.$win;
  var $doc = app.vars.$doc;
  var $html = app.vars.$html;
  var $body = app.vars.$body;

  var init = function () {
    addListeners();
    inView();

    if (interactive) {
      $html.addClass("share--hidden");
      mapInteractive();
    }
  };

  var initialized;
  var interactive = $el.hasClass("map--interactive");
  var touch;
  var img_w;
  var img_h;
  var img_w_orig = 825;
  var img_h_orig = 430;
  var zoom_max = 20;
  var map_url = $el.data("url");
  var map_xy = app.vars.urlParam["map-xy"];
  var map_id = app.vars.urlParam["map-id"];
  var loc_arr = [];
  var groups = {};
  var group_dist_min = 40;
  var address_scroller;

  var $holder = $el.parents(".map-holder");
  var $section = $el.parents(".section");
  var $map_search = $(".map-search");
  var $filters_form = $(".filters__content form", $map_search);
  var $img = $(".map__img", $el);
  var $src = $(".map__src", $el);
  var $locations = $(".map__locations", $el);
  var $lines = $(".map__lines", $el);
  var $address = $(".map__address", $section);
  var $address_inner = $(".map__address__inner", $address);
  var $filter_items = $(".map__filter__items", $section);
  var $list_button = $(".map__filter__button", $section);
  var $filterChange;
  var $loc;
  var $loc_group;
  var $loc_arr = [];
  var $group =
    '<div class="map__loc map__loc--size-4 map__loc--color-0" data-id=""></div>';

  var teaser = $el.parents(".teaser-map").length;
  var teaser_delay = 3000;
  var teaser_delay_done;
  var teaser_timeout;

  var filter = {
    item: '<div class="map__filter__item  dropdown  dropdown--inline  js-dropdown  js-filters-group">\
					<div class="map__filter__item__header">###filter-title###<span class="map__filter__item__header__selected"></span></div>\
					<div class="map__filter__item__options  dropdown__content--inline  js-dropdown-content">\
						<div class="map__filter__item__options__inner">\
							<form class="dropdown__main  js-dropdown-main">\
								<div>\
									###filter-options###\
								</div>\
							</form>\
						</div>\
					</div>\
				</div>',

    option:
      '<div class="form__row  js-filters-item">\
					<input type="checkbox" id="###filter-option-value###" name="###filter-option-value###" value="###filter-option-title###" class="form__checkbox">\
					<label for="###filter-option-value###" class="form__checkbox-label">###filter-option-title###</label>\
				</div>',
  };

  var overlay =
    '<div class="overlay" data-overlay-no-remove="true">\
								<div class="overlay__outer">\
									<div class="overlay__inner">\
										<section class="section section--overlay space--top-medium downloads">\
											<div class="js-tabs" data-pagination-delimiter="p=" data-object-name="map-list">\
												<div class="section__inner section__inner--wide  filters  js-filters  js-tabs-filters"  data-filters-reload="false"  data-selected-string="selected">\
													<h2 class="h2">Locations - List view</h2>\
													<div class="filters__button  filters__toggle  js-filters-toggle">\
														<div>\
															<div class="filters__toggle__text  filters__toggle__text--show">Show filter options</div>\
															<div class="filters__toggle__text  filters__toggle__text--hide">Hide filter options</div>\
														</div>\
													</div>\
													<div class="filters__buttons  filters__content  js-filters-content">\
														<form></form>\
													</div>\
													<div class="js-tabs-container">\
														<div class="map__list"></div>\
													</div>\
												</div>\
											</div>\
										</section>\
									</div>\
									<div class="button-close"><i></i></div>\
								</div>\
							</div>';

  var address = {
    list: '<div class="map__address__list">\
					<div class="map__address__list__outer">\
						<div class="map__address__list__inner" data-component=\'{ "component": "slider" }\' data-slider-settings=\'{ "pagination": true, "navigation": false, "autoHeight": false, "spaceBetween": 40 }\'>\
							###address###\
						</div>\
					</div>\
					<div class="map__address__close button-close"><i></i></div>\
				</div>',

    item: '<div class="map__address__item">\
					<div class="map__address__item__text map__address__item__text--header">\
						###subheadline###\
						###subheadline-addr###\
						###tpl-desc###\
					</div>\
					<div class="map__address__item__text">\
						<p>###address-body###<br>\
							###telephone###\
							###fax###\
							###email###\
						</p>\
						###directions###\
						###links###\
					</div>\
				</div>',
  };

  // A L G O L I A

  var search_page = $(".search").data("search");
  var client = search_page ? search_page.vars.client : false;
  var prefix = search_page ? search_page.vars.prefix : '';

  var indexList = {};
  var index = prefix + "locations";
  var params = { hitsPerPage: 100, facets: "*", facetFilters: "" };

  var facets_created;

  var mapSearch = function (indexName) {
    var queries = [];
    var query = "";

    params.filters = interactive
      ? '(visible_in_map:"true")'
      : '(visible_in_teaser:"true")';
    queries = [
      {
        indexName: indexName,
        query: query,
        params: params,
      },
    ];

    if(client) {
      client.search(queries, function searchDone(err, content) {
        dataResponse(content.results[0]);
      });
    }
  };

  var mapSearchUpdate = function (content, filters_set) {
    var hits = content.results[0].hits;

    $(".map__loc:not(.map__group)").each(function () {
      var $_l = $(this);
      if ($_l.data("loc_arr"))
        $_l.addClass("map__loc--hidden").data("loc_arr").vis = false;
    });

    for (var h in hits) {
      var hit = hits[h];
      var $_l = $('.map__loc[data-id="' + hit.objectID + '"]', $locations);
      if ($_l.data("loc_arr"))
        $('.map__loc[data-id="' + hit.objectID + '"]', $locations)
          .removeClass("map__loc--hidden")
          .data("loc_arr").vis = true;
    }

    $(".map__loc--color-1-active", $locations).removeClass(
      "map__loc--color-1-active"
    );
    if (filters_set && filters_set["company"]) {
      if (
        filters_set["company"].opt.length == 1 &&
        filters_set["company"].opt[0] == "Borouge"
      ) {
        $(".map__loc--color-0", $locations).addClass(
          "map__loc--color-1-active"
        );
      }
    }

    zoomChanged = true;
    mapGroups();

    if ($filterChange) {
      if (!$("input:checked", $filterChange).length) {
        filterOpen($filterChange, true);
        $(".js-dropdown-main", $filterChange).data("scroller").refresh();
        //$win.trigger('scrollRefresh');
        //$filterChange = false;
      }
    }

    // FILTERS CREATE
    if (!facets_created) {
      facets_created = search_page.categoriesSort(content.results[0].facets);

      for (var i in facets_created) {
        var f = facets_created[i].key;

        if (!search_page.filter_hidden[f]) {
          var $filter_item = $(
            strReplace(
              filter.item,
              "filter-title",
              search_page.filter_titles[f]
            )
          );
          $filter_items.append($filter_item);

          $(".map__filter__item__header", $filter_item).on(
            "click.mapFilter",
            function () {
              var $self = $(this).parent();
              //if(!$self.hasClass('is-open')) filterOpen($('.is-open'), $self.parent());
              filterOpen($self);
            }
          );
        }
      }

      app.parse($filter_items);
    }

    $filter_items.children().each(function (i) {
      filterOpen($(this));
    });
  };
  $el.data("search-result-update", mapSearchUpdate);

  var mapLoad = function () {
    mapSearch(index);
  };

  var mapFull = function () {
    $section.css("height", $win.innerHeight() - app.obj.site.headerHeight);
  };

  var mapInteractive = function () {
    $body.on("mousewheel.smoothZoom", function (e) {
      if (!$(".overlay, .nav-main--open, .search--open").length) return false;
    });

    // PREVENT DOUBLECLICK
    /*$("*").dblclick(function(e){
			$target = $(e.target);
			console.log($target);
			//if($target.hasClass('map__loc') || $('.map__loc__nr', $target).length){
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
			//}
		});*/

    /*var change;
		var timer;
		var zoom;
		var left, top;
		var interval = setInterval(function(){
			if(!change){
				var pos = $locations.position();
				zoom = $img.smoothZoom('getZoomData');
				left = $el.width()*0.5 - pos.left;
				top = $el.height()*0.5 - pos.top;
				//console.log(pos);
			}
		}, 100);*/

    // FULLSCREEN
    mapFull();
    $win.on("resize orientationchange", function () {
      mapFull();
      if (address_scroller) address_scroller.refresh();

      /*if (zoom) {
				change = true;
				clearTimeout(timer);
				timer = setTimeout(function(){
					//if(!changePosition){
						var sc = zoom.scaledHeight / zoom.normHeight;
						console.log('focusTo, left:'+left+', top:'+top);
						$img.smoothZoom('focusTo', {
							x: left / sc,
							y: top / sc,
							zoom: 100 * sc,
							//zoom: 300,
							speed: 5,
						});
						change = false;
					//}
				}, 2000);
			}*/
    });
    /*$win.on({
			orientationchange: function(e) {},
			resize: function(e) {}
		});*/

    address_scroller = new IScroll($address[0], {
      scrollbars: true,
      mouseWheel: true,
      interactiveScrollbars: true,
      click: false,
      preventDefaultException: { label: /.*/ },
    });

    var w = $img.outerWidth();
    var h = $img.outerHeight();
    var z = 100;
    var x = w / 2;
    var y = h / 2;

    if (map_xy) {
      var xy = map_xy.split(",");

      //x = parseFloat(xy[0]) / 100 * w;
      //y = parseFloat(xy[1]) / 100 * h;
    }

    $img.smoothZoom({
      width: "100%",
      height: "100%",
      zoom_MIN: 100,
      zoom_MAX: zoom_max * 100,
      zoom_OUT_TO_FIT: true,
      initial_ZOOM: 100,
      initial_POSITION: x + "," + y,
      image_original_width: img_w_orig,
      image_original_height: img_h_orig,
      animation_SMOOTHNESS: touch ? 1.0 : 5.0,
      animation_SPEED_ZOOM: 5.0,
      animation_SPEED_PAN: 5.0,
      background_COLOR: "transparent",
      border_SIZE: 0,
      border_COLOR: "#ffffff",
      border_TRANSPARENCY: 10,
      //zoom_BUTTONS_SHOW: false,
      pan_BUTTONS_SHOW: false,
      pan_LIMIT_BOUNDARY: false,
      button_HOLDER: $holder,
      button_SIZE: 50,
      button_ICON_IMAGE:
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      responsive: true,
      responsive_maintain_ratio: true,
      //reset_ALIGN_TO: 'center center',
      //image_original_width: 3300,
      //image_original_height: 1720,
      use_3D_Transform: true,
      on_ZOOM_PAN_COMPLETE: zoomComplete,
      on_ZOOM_PAN_UPDATE: zoomUpdate,
    });

    /*$img.smoothZoom('focusTo', {
			x: x,
			y: y,
			zoom: 300,
			speed: 5,
		});*/

    if (map_xy) {
      //$el.css('opacity','0');
      //setTimeout(function(){
      var zoom = $img.smoothZoom("getZoomData");
      var sc = zoom.scaledHeight / zoom.normHeight;

      //console.log('sc:'+sc+', zoom.scaledHeight:'+zoom.scaledHeight+', zoom.normHeight:'+zoom.normHeight+', img_w_orig:'+img_w_orig);
      //$el.css('opacity','1');

      $img.smoothZoom("focusTo", {
        x: (parseFloat(xy[0]) / 100) * w,
        y: (parseFloat(xy[1]) / 100) * h,
        zoom: 100 * sc * 2 * (($win.innerWidth() * 100) / img_w_orig),
        //zoom: 300,
        speed: 5,
      });
      //}, 500);
    }

    mapUpdate();

    $section.addClass("section--map-show");

    // MOUSE LISTENERS
    /*$doc.on('pointerover.map-loc', '.map__loc', function(e) {
			var $target = $(e.currentTarget);
			$target.addClass('map__loc--hover');
			$el.addClass('map--hover');
			//console.log('enter');
		}).on('pointerout.map-loc', '.map__loc', function(e) {
			var $target = $(e.currentTarget);
			$el.removeClass('map--hover');
			$target.removeClass('map__loc--hover');
			//console.log('out');
		}).on('click.map-loc', '.map__loc', function(e) {
			var $target = $(e.currentTarget);
			locClick($target);
		});

		$img.on('touchstart', function(e) {
			$el.removeClass('map--hover');
			$('.map__loc--hover', $el).removeClass('map__loc--hover');
		});*/
  };

  var zoomActive,
    zoomTimer,
    zoomInt = false,
    zoomData,
    zoomScale,
    zoomX,
    zoomY;
  var zoomUpdate = function () {
    zoomActive = true;
    zoomChanged = true;
    zoomData = $img.smoothZoom("getZoomData");

    //console.log('zoomUpdate');

    /*if(!zoomInt){
			zoomInt = setInterval(function(){
				clearTimeout(zoomTimer);
					zoomTimer = setTimeout(function(){
					mapGroups();
				}, 0);
			}, 200);
		}*/
  };
  var zoomComplete = function () {
    zoomActive = false;
    clearInterval(zoomInt);
    zoomInt = false;
    mapGroups();
  };
  var zoomMax = function () {
    return (img_w_orig / $src.width()) * zoom_max;
  };

  var mapUpdate = function () {
    requestAnimationFrame(mapUpdate);

    if (
      zoomData &&
      (zoomScale != zoomData.scaledWidth ||
        zoomX != zoomData.scaledX ||
        zoomY != zoomData.scaledY ||
        img_w != $img.outerWidth())
    ) {
      var trans;
      //var matrix = $img.panzoom('getMatrix');
      var m = $img.css("transform");
      var img_resized = img_w != $img.outerWidth();

      //console.log('img_resized:'+img_resized);

      img_w = $img.outerWidth();

      if (!touch) {
        if (zoomScale != zoomData.scaledWidth || img_resized) {
          /*clearTimeout(zoomTimer);
					zoomTimer = setTimeout(function(){
						mapGroups();
					}, 100);*/
          if ((!zoomInt && zoomActive) || img_resized) {
            console.log("zoomInt");

            if (img_resized) {
              clearTimeout(zoomTimer);
              zoomTimer = setTimeout(function () {
                mapGroups();
              }, 0);
            } else {
              zoomInt = setInterval(function () {
                clearTimeout(zoomTimer);
                zoomTimer = setTimeout(function () {
                  mapGroups();
                }, 0);
              }, 500);
            }
          }
        }
      }

      if (zoomScale != zoomData.scaledWidth) {
        var scale = m.split("(")[1].split(",")[0];
        zoomScale = zoomData.scaledWidth;
        trans = true;

        $locations.css("width", scale * 100 + "%");
        $locations.css("height", scale * 100 + "%");
      }
      if (zoomX != zoomData.scaledX || zoomY != zoomData.scaledY) {
        var pos = $img.position();
        zoomX = zoomData.scaledX;
        zoomY = zoomData.scaledY;
        trans = true;

        $locations.css("left", pos.left + "px");
        $locations.css("top", pos.top + "px");
      }
      if (trans) {
        //$locations.css('transform', 'matrix('+scale+',0,0,'+scale+','+mx.m41+','+mx.m42+')');
        $src.css("transform", m);
      }
    }
  };

  var distance = function (l, lc) {
    var distX = lc.x - l.x;
    var distY = lc.y - l.y;
    var dist = Math.sqrt(distX * distX + distY * distY);
    return dist;
  };

  var mapGroupPos = function (g, l) {
    if (g.x_max < l.x) {
      g.x_max = l.x;
    }
    if (g.x_min > l.x) {
      g.x_min = l.x;
    }
    if (g.y_max < l.y) {
      g.y_max = l.y;
    }
    if (g.y_min > l.y) {
      g.y_min = l.y;
    }
  };

  var mapGroups = function () {
    var min = group_dist_min;

    //console.log('mapGroups');

    if (interactive && $loc && zoomChanged) {
      zoomChanged = false;

      $loc.removeClass("map__loc--group");
      if ($loc_group) $loc_group.removeClass("map__group--show");

      var loc_w = $locations.outerWidth();
      var loc_list = JSON.parse(JSON.stringify(loc_arr));
      var cnt = 0;
      //var g_single	= 0;
      //var g_double	= 0;

      groups = {};

      for (var i = 0; i < loc_arr.length; i++) {
        var l = loc_list.shift();

        if (l.vis == true) {
          for (var c = 0; c < loc_list.length; c++) {
            var lc = loc_list[c];
            var dist = (loc_w / 100) * distance(l, lc);

            if (dist < min && lc.vis == true) {
              //var $l = $('.map__loc:eq('+l.i+')', $locations);
              //var $lc = $('.map__loc:eq('+lc.i+')', $locations);
              //var g = groups['g'+l.i] || groups['g'+lc.i];
              var g = l.group || lc.group;

              //console.log(l);
              //console.log(lc);
              //console.log(g);
              //console.log(l.title+' | '+lc.title);
              //console.log(l.group+' | '+lc.group);

              if (!g) {
                g =
                  l.group =
                  lc.group =
                  groups["g" + l.i] =
                    {
                      i: l.i,
                      group: [l, lc],
                      x_min: 101,
                      y_min: 101,
                      x_max: -1,
                      y_max: -1,
                    };

                mapGroupPos(g, l);
                mapGroupPos(g, lc);

                /*if (!$('.map__group.g' + l.i, $locations).length) {
									var $group = $('<div class="map__loc map__loc--size-4 map__group g' + l.i + '"><div class="map__loc__nr"></div></div>');
									$locations.append($group);
									$loc_group = $('.map__group', $locations);

									mouseOverListener($group);
								}*/

                if (!$(".map__group.g" + l.i, $locations).length) {
                  var $group = $(
                    '<div class="map__loc map__loc--size-4 map__group g' +
                      l.i +
                      '"><div class="map__loc__nr"></div></div>'
                  ).appendTo($locations);
                  mouseOverListener($group);
                }
              } else {
                /*if (l.group && lc.group) {
									//console.log('-- DOUBLE --');
									while (function() { return l.group.group.length; } > 0) {
										lc.group.group.push(l.group.group.shift());
									}
									delete groups['g' + l.i];
								} else {
									g.group.push(l.group ? lc : l);
									l.group = lc.group = (l.group || lc.group);
									mapGroupPos(g, l.group ? lc : l);
								}*/
                if (l.group && lc.group) {
                  //console.log('-- DOUBLE --');
                  //g_double++;
                  while (
                    function () {
                      return l.group.group.length;
                    } > 0
                  ) {
                    //console.log('shift');
                    lc.group.group.push(l.group.group.shift());
                  }
                  delete groups["g" + l.i];
                  //$('.map__group.g'+l.i).remove();
                } else {
                  //g_single++;
                  g.group.push(l.group ? lc : l);
                  l.group = lc.group = l.group || lc.group;
                  mapGroupPos(g, l.group ? lc : l);
                }
              }

              var $g = $(".map__group.g" + g.i, $locations);
              var x = g.x_min + (g.x_max - g.x_min) / 2;
              var y = g.y_min + (g.y_max - g.y_min) / 2;

              $g.data("group", g);

              $g.css("left", x + "%")
                .css("top", y + "%")
                .addClass("map__group--show");
              $(".map__loc__nr", $g).text(g.group.length);
              //$('.map__loc:eq(' + l.i + '), .map__loc:eq(' + lc.i + ')', $locations).addClass('map__loc--group');
              $loc_arr[l.i].addClass("map__loc--group");
              $loc_arr[lc.i].addClass("map__loc--group");
            }

            cnt++;
          }
        } else {
        }
      }

      $loc_group = $(".map__group", $locations);
      //console.log(groups);
      //console.log('loc:'+loc_arr.length+', groups:'+$loc_group.length+', cnt:'+cnt+', single:'+g_single+', double:'+g_double);
    }

    //setTimeout(mapGroups, 250);
  };

  var strReplace = search_page ? search_page.strReplace : false;

  var mapAddress = function ($l, template) {
    var locs = $l.data("loc");
    var loc_arr = $l.data("loc_arr");
    var list = "" + template.list;
    var item = "";

    for (var i = 0; i < locs.length; i++) {
      var loc = locs[i];
      var addr = "" + template.item;
      var postal = loc.postal_address_body && loc.postal_address_body != "";

      addr = strReplace(addr, "tpl-address", search_page.tpl.contacts.address);

      addr = strReplace(
        addr,
        "subheadline",
        !postal ? search_page.tpl.subheadline : ""
      );
      addr = strReplace(
        addr,
        "subheadline-addr",
        postal ? search_page.tpl.subheadline : ""
      );

      addr = search_page.strReplace_CityCountry(addr, loc, " - ");

      addr = strReplace(addr, "tpl-desc", search_page.tpl.contacts.desc);
      addr = search_page.strReplace_Types(addr, loc);

      addr = strReplace(addr, "title", loc.address_title);
      addr = strReplace(addr, "address-title", "");
      addr = strReplace(addr, "address-body", loc.address_body);

      addr = search_page.strReplace_Address_Details(addr, loc);
      addr = search_page.strReplace_Links(addr, loc);
      addr = search_page.strReplace_Directions(addr, loc);

      item += addr;
    }

    list = strReplace(list, "address", item);

    var $list = $(list);
    var $addr = $(".map__address__item", $list);
    var $close = $(".button-close", $list);

    if (!loc_arr.vis) {
      $list.addClass("map__address__list--hidden");
    }

    if ($close.length) {
      $address.addClass("map__address--show");
      setTimeout(function () {
        address_scroller.refresh();
      }, 1000);

      $close.on("click.address_close", function () {
        $list.addClass("is-hidden");
        $address.removeClass("map__address--show");
        setTimeout(function () {
          $list.remove();
          address_scroller.refresh();
        }, 500);
      });
    }

    return $list;
  };

  var mapList = function () {
    var $overlay = $map_search.parents(".overlay");
    if (!$overlay.length) {
      $overlay = $(overlay);
      $(".js-tabs", $overlay).empty().append($map_search);
      $body.append($overlay);
      app.parse($overlay);
    } else {
      $overlay.removeClass("overlay--closed");
    }

    setTimeout(function () {
      /*if (app.obj['sticky-top']) {
				$.each(app.obj['sticky-top'], function(index, object) {
					object.freezeStickyKit();
				});
			}*/
      //var $freeze = !$('html.search--open').length ? $('.site__wrapper') : $('.search');
      //$freeze.data('y', y);
      //$freeze.css('top', -y+$freeze.position().top);
      $html.addClass("overlay--open");
      app.obj.site.overlayOpen = true;
      $win.scrollTop(0);
    }, 100);
  };

  var dataResponse = function (data) {
    console.log(data);
    if (data && data.hits) {
      var locations = data.hits;
      var loc_arr_parent = [];
      var loc_string = JSON.stringify(locations);
      var cnt = 0;

      for (var i = 0; i < locations.length; i++) {
        var loc = locations[i];
        var show =
          (interactive && loc.visible_in_map) ||
          (!interactive && loc.visible_in_teaser);

        if ((!interactive && show) || interactive) {
          //var pos = loc.pos;
          var pos = convertGeoToPixel(loc.coordinates.lat, loc.coordinates.lng);
          var size = 1;
          var color =
            loc.company.length > 1 || loc.company[0] == "Borealis"
              ? 0
              : loc.company[0] == "Borouge"
              ? 1
              : 2;
          var id = loc.objectID;
          var title = loc.group_title;
          var addr = loc.title
            ? '<div class="map__loc__addr"><p>' + title + "</p></div>"
            : "";
          var $l = $(
            '<div class="map__loc map__loc--size-' +
              size +
              " map__loc--color-" +
              color +
              '" data-id="' +
              id +
              '" style="left: ' +
              pos.x +
              "%; top: " +
              pos.y +
              '%;">' +
              addr +
              "</div>"
          );
          var obj = {
            l: $l,
            i: cnt,
            x: parseFloat(pos.x),
            y: parseFloat(pos.y),
            size: size,
            color: color,
            title: title,
            addr: addr,
            loc: loc,
            vis: true,
          };

          $l.data("loc", [loc]).data("loc_arr", obj);

          if (
            loc.parent == false ||
            loc_string.indexOf('"objectID":"' + loc.parent + '"') < 0
          ) {
            loc_arr.push(obj);
            cnt++;

            // APPEND ITEM

            $locations.append($l);
            $loc_arr.push($l);

            if (!interactive && loc.connected_to) {
              if (typeof loc.connected_to === "number")
                loc.connected_to = [loc.connected_to];
              for (var c = 0; c < loc.connected_to.length; c++) {
                $lines.append(
                  '<div class="map__line" data-id="' +
                    loc.objectID +
                    '" data-connected-to="' +
                    loc.connected_to[c] +
                    '"></div>'
                );
              }
            }
          } else {
            loc_arr_parent.push(obj);
          }
        }
      }

      loc_arr_parent.sort(function (a, b) {
        return String(a.loc.position).localeCompare(b.loc.position);
      });

      for (var i = 0; i < loc_arr_parent.length; i++) {
        var obj = loc_arr_parent[i];
        var $parent = $('[data-id="' + obj.loc.parent + '"]', $locations);
        //console.log($parent);
        if ($("p", $parent).text().indexOf(obj.loc.group_title) < 0) {
          $("p", $parent).html(
            $("p", $parent).html() + "<br>" + obj.loc.group_title
          );
        }
        $parent.data("loc").push(obj.loc);
      }

      //console.log(loc_arr);

      // MOUSE EVENTS

      $loc = $(".map__loc", $locations);
      //$el.append('<div class="map__hover"></div>');

      mouseOverListener($loc);

      // MAP LINES

      if (!interactive) {
        drawLines($(".map__line", $lines));
        drawLines($(".map__line", $lines));
      }

      // SHOW

      setTimeout(function () {
        $el.addClass("map--show");
        mapGroups();
      }, 100);

      //addListeners();

      if (interactive && map_id) {
        setTimeout(function () {
          locClick($('.map__loc[data-id="' + map_id + '"]', $locations));
          map_id = false;
        }, 1800);
      }
    }
  };

  var convertGeoToPixel = function (latitude, longitude) {
    var mapWidth = 615.3; // in pixels
    var mapHeight = 394.1; // in pixels
    var mapLngLeft = -171.841723; // in degrees. the longitude of the left side of the map (i.e. the longitude of whatever is depicted on the left-most part of the map image)
    //var mapLngRight	= -169.653160;
    //var mapLngRight		= 190.34684; // in degrees. the longitude of the right side of the map
    var mapLngRight = 189.8;
    //var mapLatBottom	= -55.98; // in degrees.  the latitude of the bottom of the map
    var mapLatBottom = -55.15;

    var mapLatBottomRad = (mapLatBottom * Math.PI) / 180;
    var latitudeRad = (latitude * Math.PI) / 180;
    var mapLngDelta = mapLngRight - mapLngLeft;

    var worldMapWidth = ((mapWidth / mapLngDelta) * 360) / (2 * Math.PI);
    var mapOffsetY =
      (worldMapWidth / 2) *
      Math.log(
        (1 + Math.sin(mapLatBottomRad)) / (1 - Math.sin(mapLatBottomRad))
      );

    var x = (longitude - mapLngLeft) * (mapWidth / mapLngDelta);
    var y =
      mapHeight -
      ((worldMapWidth / 2) *
        Math.log((1 + Math.sin(latitudeRad)) / (1 - Math.sin(latitudeRad))) -
        mapOffsetY);

    var xp = (x * 100) / mapWidth;
    var yp = (y * 100) / mapHeight;

    //console.log(xp+' | '+yp);

    return { x: xp, y: yp };
  };

  var filterOpen = function ($self, reset) {
    if ($self.length) {
      var open = $self.hasClass("is-active");
      var i = $("> *", $self.parent()).index($self);
      var $f = $("> *:eq(" + i + ")", $filters_form);
      var $target;
      var $opt;

      if (!open || reset) {
        $target = $(".js-dropdown-main > *:eq(0)", $self);
        $opt = $(".js-filters-item", $f).parent().clone().html();
        $opt = $opt.split("facet__").join("map__facet__");
        $target.empty();

        if ($opt.length) {
          $target.html($opt);
          $('input[type="checkbox"]', $target).on(
            "change.mapFilter",
            function (e) {
              var $row = $(this).parent();
              var $input_target = $(
                ".form__row:eq(" +
                  $("> *", $row.parent()).index($row) +
                  ') input[type="checkbox"]',
                $f
              );

              $filterChange = $self;

              $input_target.trigger("click");
            }
          );
        }
      } else {
        $filterChange = false;
      }

      var cnt = $("input:checked", $self).length;

      $(".map__filter__item__header", $self).attr("data-selected", cnt);
      $(".map__filter__item__header__selected", $self).text(cnt);
    }
  };

  window.doubleClick = 0;
  var mouseOverListener = function ($item) {
    $item
      .on("pointerover", function (e) {
        var $target = $(e.currentTarget);
        $el.addClass("map--hover");
        $target.addClass("map__loc--hover");
      })
      .on("pointerout", function (e) {
        var $target = $(e.currentTarget);
        $el.removeClass("map--hover");
        $target.removeClass("map__loc--hover");
      });

    $item.on("click", function (e) {
      var $target = $(e.currentTarget);
      locClick($target);
    });
  };

  var locClick = function ($target) {
    if (interactive) {
      window.doubleClick++;

      if (window.doubleClick < 2) {
        var pos = $target.position();
        var is_group = $target.hasClass("map__group");

        $el.removeClass("map--hover");
        $target.removeClass("map__loc--hover");

        var zoom = $img.smoothZoom("getZoomData");
        //var sc = zoom.scaledHeight / zoom.normHeight;
        var sc = zoom.scaledWidth / zoom.normWidth;

        if (is_group) {
          var g = $target.data("group");
          var loc_w = $locations.outerWidth() / 100;
          var dist = 0;
          /*var dist_min	= 0;
					var dist_max	= 0;

					for (var a = 0; a < g.group.length; a++) {
						var _a = g.group[a];

						for (var b = 0; b < g.group.length; b++) {
							var _b = g.group[b];
							var d = loc_w * distance(_a, _b);
							if(a!=b){
								if(d<group_dist_min && d>dist_min){
									dist_min = d;
								}
								if(d>dist_max){
									dist_max = d;
								}
							}
						}
					}

					//dist = dist_max - (dist_max-dist_min);
					dist = dist_max/g.group.length;*/

          var distX = g.x_max - g.x_min;
          var distY = g.y_max - g.y_min;
          dist =
            ((loc_w * Math.sqrt(distX * distX + distY * distY)) /
              g.group.length) *
            1.2;
          var z = (((group_dist_min + 1) * sc) / dist) * 100;
          //console.log(g);
          //console.log('dist:'+dist+', z:'+z+', sc:'+sc);
        }

        $img.smoothZoom("focusTo", {
          x: pos.left / sc,
          y: pos.top / sc,
          zoom: is_group ? z : 100 * sc,
          //zoom: is_group ? 100 * sc * 3 : 100 * sc,
          //zoom_max: zoomMax(),
          //zoom: 300,
          speed: touch ? 0 : 5,
        });

        if (!is_group) {
          var $list = mapAddress($target, address);
          var $outer = $(".map__address__list__outer", $list);
          var $items = $(".map__address__item", $list);
          var $prev = $(".nav-arrow--prev", $list);
          var $next = $(".nav-arrow--next", $list);

          $address_inner.empty().append($list);

          window.parseNewComponents($list[0]);

          // if ($items.length > 1) {
          // 	var $pagination = $('<div class="swiper-pagination swiper-pagination--horizontal"></div>').appendTo($outer);
          // 	$('> *:first-child', $outer).addClass('swiper-wrapper');
          // 	$('> *:first-child > *', $outer).addClass('swiper-slide');

          // 	var swiper = new Swiper($outer[0], {
          // 		pagination: {
          // 			el: $pagination[0],
          // 			type: 'bullets', // fraction
          // 			clickable: true,
          // 		},
          // 		navigation: {
          // 			prevEl: $prev[0],
          // 			nextEl: $next[0],
          // 		},
          // 		paginationClickable: true,
          // 		autoHeight: false,
          // 		spaceBetween: 40,

          // 		on: {
          // 			touchStart: function() {
          // 				$list.addClass('swiper--move');
          // 			},
          // 			touchEnd: function() {
          // 				$list.removeClass('swiper--move');
          // 			},
          // 		},
          // 	});

          // 	setTimeout(function() {
          // 		 $prev.addClass('is-loaded');
          // 		 $next.addClass('is-loaded');
          // 	}, 500);
          // }
        }
        setTimeout(function () {
          window.doubleClick = 0;
        }, 500);
      } else {
        console.log("DOUBLE");
      }
    } else {
      var loc = $target.data("loc")[0];
      var xy = convertGeoToPixel(loc.coordinates.lat, loc.coordinates.lng);
      var url = "?map-xy=" + xy.x + "," + xy.y;
      //console.log(xy);
      if (loc.is_group != true) {
        url += "&map-id=" + loc.objectID;
      }
      window.location = map_url + url;
    }
  };

  var addListeners = function () {
    var w_tmp = $body.width();
    var h_tmp = $body.height();
    //var $lines = $('.map__lines', $el);

    if (interactive) {
      $list_button.on("click.filter_button", mapList);
      $doc.on("mousedown.closeMapAddress", ".section--map", function (e) {
        var $target = $(e.target);
        var $close = $(".map__address .button-close", $section);

        if ($close.length && !$target.parents(".map__address").length)
          $close.trigger("click");
      });
    }

    var redraw = function (force) {
      var w = $body.width();
      var h = $body.height();

      if (w_tmp != w || h_tmp != h || force) {
        drawLines($(".map__line", $lines));
        w_tmp = w;
        h_tmp = h;

        if (!force) redraw(true);
      }
    };

    var redraw_int = setInterval(function () {
      //redraw();
    }, 100);

    $win.on("scroll.map", function () {
      inView();
    });

    $win.on("resize.map orientationchange.map", function () {
      redraw();
    });
  };

  var inView = function (e) {
    var vis = isVisible($el);
    var nav = $html.hasClass("nav-main--open");

    touch = $html.hasClass("screen--is-touch");
    scroll = $html.hasClass("page--scroll");

    if (
      teaser ||
      (vis && ($el.parents(".is-hidden.open").length || interactive))
    ) {
      if (teaser && nav) {
        clearTimeout(teaser_timeout);
        teaser_timeout = setTimeout(function () {
          //console.log('teaser_timeout');
          inView();
        }, teaser_delay);
      } else if (teaser && !teaser_delay_done && !vis) {
        clearTimeout(teaser_timeout);
        teaser_timeout = setTimeout(function () {
          teaser_delay_done = true;
          //console.log('teaser_delay_done');
          inView();
        }, teaser_delay);
      } else if (!initialized) {
        initialized = true;
        mapLoad();
      }
    }
  };

  var drawLines = function ($line) {
    if (
      $el.parents(".teaser-map").length ||
      (isVisible($el) && $el.parents(".is-hidden.open").length)
    ) {
      $line.each(function () {
        $line = $(this);
        $from = $('.map__loc[data-id="' + $line.data("id") + '"]', $el);
        $to = $('.map__loc[data-id="' + $line.data("connected-to") + '"]', $el);

        if (
          $('.map__loc[data-id="' + $line.data("connected-to") + '"]', $el)
            .length
        ) {
          drawLine($from, $to, $line);
        } else {
          $line.remove();
        }
      });
    }
  };

  var drawLine = function (a, b, line) {
    var $a = a,
      $b = b,
      $l = line;
    var x1 = $a.offset().left;
    var x2 = $b.offset().left;
    var y1 = $a.offset().top;
    var y2 = $b.offset().top;

    var hypotenuse = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
    var angle = Math.atan2(y1 - y2, x1 - x2) * (180 / Math.PI);

    if (angle >= 90 && angle < 180) {
      y1 = y1 - (y1 - y2);
    }
    if (angle > 0 && angle < 90) {
      x1 = x1 - (x1 - x2);
      y1 = y1 - (y1 - y2);
    }
    if (angle <= 0 && angle > -90) {
      x1 = x1 - (x1 - x2);
    }

    $l.queue(function () {
      $(this).offset({ top: y1, left: x1 });
      $(this).dequeue();
    })
      .queue(function () {
        $(this).width(hypotenuse);
        $(this).dequeue();
      })
      .queue(function () {
        $(this).css("transform", "rotate(" + angle + "deg) translateZ(0)");
        $(this).dequeue();
      });
  };

  var isVisible = function ($e) {
    var rect = $e[0].getBoundingClientRect();
    return (
      (rect.height > 0 || rect.width > 0) &&
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  init();
  return api;
};

app.ext['more-options'] = function($el) { 
	var api = {};

	var classes = {
		toggle: '.js-more-options-toggle',
		close: '.js-more-options-close',
	};

	// elements
	var $toggle = $el.find(classes.toggle);
	var $close = $el.find(classes.close);

	// vars
	var optionsOpen = false;


	var init = function() {
		addListeners();
	};

	var addListeners = function() {
		$toggle.on('click', toggleClickHandler);
		$close.on('click', closeClickHandler);
	};

	var toggleClickHandler = function(event) {
		if (optionsOpen) {
			hideFilters();
		} else {
			showFilters();
		}
	};

	var closeClickHandler = function(event) {
		if (optionsOpen) {
			hideFilters();
		}
	};

	var showFilters = function() {
		$el.addClass(app.states.isOpen);
		optionsOpen = true;
	};
	
	var hideFilters = function() {
		$el.removeClass(app.states.isOpen);
		optionsOpen = false;
	};

	init();	return api;
};

app.ext['notifications'] = function($el) { 
	var api = {};

	var vars = {
		cookie_key:		'accept-cookies',
	};
	var classes = {
		group:			'.notifications__group',
		item:			'.notifications__item',
		button:			'.button, .button-close',
		hidden:			'is-hidden',
	};

	var $item			= $(classes.item, $el);
	var $button			= $(classes.button, $el);

	var init = function() {
		cookies();
		addListeners();
	};

	var addListeners = function() {
		$button.on('click.notificationsClose', itemCloseHandler);
	};

	var itemCloseHandler = function(e) {
		var $click		= $(e.currentTarget);
		var $target		= $click.parents(classes.item);
		var click_data	= $click.data('click');

		if (!$('a', $click).length) {
			itemClose($target);

			if (click_data) {
				Cookies.set(click_data, '1', { expires: 365 });
			}
		}
	};

	var itemClose = function($target) {
		$target.slideUp({duration: 500, easing: 'easeInOutQuart', complete:function() {
			itemsRemove($target);
		}});
	};

	var itemsRemove = function($target) {
		var $group_parent = $target.parents(classes.group);
		var $group = $(classes.group, $target);
		
		if($group_parent.length && $(classes.item, $group_parent).filter('[style]').length == $(classes.item, $group_parent).length){
			$group_parent.remove();
		} else if($group.length && $group.children().length<1) {
			$group.remove();
		}
		if ($(classes.item, $el).filter('[style]').length == $(classes.item, $el).length) {
			$el.remove();
		}
	};

	var cookies = function() {
		$('[data-click]', $el).each(function() {
			var $click = $(this);

			if (Cookies.get($click.data('click')) === '1') {
				$click.parents(classes.item).remove();
			}
		});
		itemsRemove($el);
	};

	init();	return api;
};

app.ext['overlay-local'] = function($el) {
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var $outer		= $('.overlay__outer', $el);
	var $close		= $('.button-close', $el);
	var remove		= !$el.data('overlay-no-remove');
	var isOverlay	= $el.hasClass('overlay');
	var isButton	= $el.is('a');
	var clicked;

	var init = function() {
		if (isOverlay) {
			$('[data-bg],[data-src]', $el).lazyLoadXT();

			$close.on('click.close', function() {
				api.close();
			});
			$el.on('click', function(e) {
				$target = $(e.target);
				if ($target.hasClass('overlay')) {
					api.close();
				}
			});

		} else if (isButton) {
			$el.on('click.overlay', function(e) {
				e.preventDefault();
				e.stopPropagation();

				if (!clicked) {
					clicked = true;
					jQuery.ajax({
						context: this,
						url: $el.attr('href'),
						//async: false,
						type: 'GET',
						data: {},
						//dataType: 'json',
						//contentType: "application/json",
						//jsonpCallback: 'result',
						cache: false,
						success: function(data) {
							var $overlay = $(data);
							var y = $win.scrollTop();

							$body.append($overlay);
							app.parse($overlay);

							setTimeout(function() {
								if (app.obj['sticky-top']) {
									$.each(app.obj['sticky-top'], function(index, object) {
										object.freezeStickyKit();
									});
								}
								var $freeze = !$('html.search--open').length ? $('.site__wrapper') : $('.search');
								$freeze.data('y', y);
								$freeze.css('top', -y + $freeze.position().top);
								$html.addClass('overlay--open');
								app.obj.site.overlayOpen = true;
								$win.scrollTop(0);
							}, 100);
						},
						error: function(data) {
						},
					}).done(function() {
						clicked = false;
					});
				}
			});
		}
	};

	api.close = function() {
		var s = $win.scrollTop();
		var $freeze = !$('html.search--open').length ? $('.site__wrapper') : $('.search');
		//var y = Math.abs(parseInt($('.site__wrapper').css('top')));
		var y = $freeze.data('y');

		$html.removeClass('overlay--open');
		app.obj.site.overlayOpen = false;
		$win.scrollTop(y);
		$freeze.removeAttr('style');
		$outer.css('top', (y - s + parseInt($outer.css('top'))) + 'px');

		if (remove) $close.off('click.close');
		setTimeout(function() {
			$el.addClass('overlay--closed');
			if (remove) $el.remove();

			if (app.obj['sticky-top']) {
				$.each(app.obj['sticky-top'], function(index, object) {
					object.unfreezeStickyKit();
				});
			}
		}, 500);
	};

	init();	return api;
};

app.ext['parallax'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var init = function() {

		if (('html.screen--no-touch').length) {
			$el.each(function(i, e) {
				var $e = $(e);
				var $bg = $('.section__bg', $e);
				var h = function() { return $win.height() + $e.outerHeight(); };

				var y = function() {
					return Math.floor($bg.outerHeight() - $e.outerHeight());
				};

				var tween_bg = new ScrollMagic.Scene({
					duration: h,
					triggerElement: e,
					triggerHook: 'onEnter',
					offset: 0,
				})
				.setTween(TweenMax.fromTo($bg, 1, {
					css:{'transform':'translateY(' + (y() * -1) + 'px)'},
				}, {
					css:{'transform': 'translateY(' + (y() * 0.25) + 'px)'}, delay: 0, ease: Linear.easeNone,
				}))
				.addTo(app.obj.site.scrollController);
			});
		}
		
	};

	init();	return api;
};

app.ext['print'] = function($el) { 
	var api = {};

	var init = function () {
		addListeners();
	};

	var addListeners = function () {
		$el.on('click.print', clickHandler);
	};

	var clickHandler = function (event) {
		window.print();
	};

	init();	return api;
};

app.ext['quick'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var classes = {
		link: '.js-quick-link',
	};

	var quickOpen;
	var mini;
	var $link		= $(classes.link, $el);

	var init = function() {
		addListeners();
	};

	var addListeners = function() {
		//$el.on('mouseenter', elMouseenterHandler);
		//$el.on('mouseleave', elMouseleaveHandler);
		$link.on('click', linkClickHandler);
		//$win.on('headerNavLinkClick', headerNavLinkClickHandler);
		//$win.on('headerNavCloseClick', headerNavCloseClickHandler);
		//$win.on('scroll', pageScroll);
	};

	var elMouseenterHandler = function(event) {
		showQuick();
	};

	var elMouseleaveHandler = function(event) {
		hideQuick();
	};

	var linkClickHandler = function(event) {
		event.preventDefault();
		var $this = $(this);
		var $target = $('.js-ui-site-header').find($this.data('href'));

		if(!$this.data('target')){
			$target.trigger('click');

			if ($target.parent('li').hasClass('open')) {
				$this.addClass(app.states.isActive);
				$el.addClass(app.states.isActive);
			} else {
				$this.removeClass(app.states.isActive);
				$el.removeClass(app.states.isActive);
				app.obj['nav-main'].close();
			}
		}else{
			location = $($this.data('target')).attr('href');
		}
	};

	var headerNavLinkClickHandler = function(event) {
		$link.removeClass(app.states.isActive);
		$el.removeClass(app.states.isActive);
	};

	var headerNavCloseClickHandler = function(event) {
		$link.removeClass(app.states.isActive);
		$el.removeClass(app.states.isActive);
	};

	var showQuick = function() {
		if (!quickOpen && $('html.from-tabletLandscape').length) {
			quickOpen = true;
			$el.addClass(app.states.isOpen);
		}
	};

	var hideQuick = function() {
		if (quickOpen) {
			quickOpen = false;
			$el.removeClass(app.states.isOpen);
		}
	};

	var pageScroll = function(event) {
		if (!app.obj.site.overlayOpen) {
			var $trigger = $('html.search--open').length ? $('.search__input') : ($('.header').length ? $('.header') : $('.overview__header:eq(0)'));
			var y = $win.scrollTop();
			var h = $trigger.outerHeight() / 2;

			if (h < y) {
				if (!mini) {
					mini = true;
					$el.addClass('quick--mini');
				}
			} else {
				if (mini) {
					mini = false;
					$el.removeClass('quick--mini');	
				}
			}
		}
	};

	init();	return api;
};

app.ext['range-slider'] = function ($el) {
	var api = {};

	var classes = {
		line: '.js-range-slider-line',
		minField: '.js-range-slider-min',
		maxField: '.js-range-slider-max',
	};

	var init = function () {
		initNoUiSlider();
		addListeners();
	};

	// elements
	var $line = $(classes.line, $el);
	var $minField = $(classes.minField, $el);
	var $maxField = $(classes.maxField, $el);
	var $sliderContainer = $el


	// vars
	var slider = $line[0];
	var range = $el.data('range');
	var initial = $el.data('initial');
	var callback = $el.data($el.data('callback'));

	range = range.split(',');



	if (initial !== undefined) {
		initial = initial.split(',');
	} else {
		initial = range;
	}

	var addListeners = function () {
		$minField.on('change', minFieldChangeHandler);
		$maxField.on('change', maxFieldChangeHandler);
	};

	var minFieldChangeHandler = function (event) {

		slider.noUiSlider.set([this.value, null]);
	};

	var maxFieldChangeHandler = function (event) {

		slider.noUiSlider.set([null, this.value]);
	};

	var initNoUiSlider = function () {
		if (!slider.noUiSlider) {
			noUiSlider.create(slider, {
				start: [parseFloat(initial[0]), parseFloat(initial[1])],
				connect: true,
				behaviour: 'drag',
				range: {
					'min': parseFloat(range[0]),
					'max': parseFloat(range[1]),
				},

			});

			if (range[1] == 0) {
				slider.setAttribute('disabled', true);
				$sliderContainer[0].classList.add("disabled")
				$minField[0].setAttribute('disabled', true);
				$maxField[0].setAttribute('disabled', true);
			}



			slider.noUiSlider.on('update', function (values, handle) {



				var value = values[handle];



				if (handle) {

					$maxField[0].value = value;

				} else {

					$minField[0].value = value;
				}

				if (callback) {
					callback($minField.val(), $maxField.val());
				}
			});
		} else {
			//slider.noUiSlider.set([$minField.val(), $maxField.val()]);
			slider.noUiSlider.set([parseFloat(initial[0]), parseFloat(initial[1])]);
		}
		$el.data('slider', slider.noUiSlider);
	};

	init(); return api;
};

app.ext['scroll-nav'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var classes = {
		link: '.js-scroll-nav-link',
	};

	// elements
	var $link = $el.find(classes.link);

	// vars
	var sectionPositions = [];
	var activeSection,
	scrollTimeout,
	resizeTimeout;


	var init = function() {
		getSectionPositions();
		addListener();
	};

	var getSectionPositions = function() {
		sectionPositions = [];
		$link.each(function() {
			var href = $(this).attr('href');
			var $section = $(href);
			sectionPositions.push(parseInt($section.offset().top));
		});
	};

	var addListener = function() {
		$link.on('click', {t: this}, linkClickHandler);
		$win.on('scroll.scrollnav', {t: this}, windowScrollHandler);
		$win.on('resize.scrollnav', {t: this}, windowResizeHandler);
	};

	var linkClickHandler = function(event) {
		var $link = $(this);
		event.preventDefault();
		var href = $(this).attr('href');
		scrollToElement(href, $link);
	};

	var windowScrollHandler = function(event) {
		if (scrollTimeout !== undefined) {
			clearTimeout(scrollTimeout);
		}
		scrollTimeout = setTimeout(function() {
			checkPagePosition();
		}, 100);
	};

	var windowResizeHandler = function(event) {
		if (resizeTimeout !== undefined) {
			clearTimeout(resizeTimeout);
		}
		resizeTimeout = setTimeout(function() {
			getSectionPositions();
		}, 100);
	};

	var scrollToElement = function(href, $link) {
		var $target = $(href);

		$link = $link || '';
		if ($link === '') {
			$link = getLinkByHref(href);
		}

		var currentSectionIndex = getSectionIndex($link);
		markLink(currentSectionIndex);

		var scrollOffset = $target.offset().top;
		if (Gridle.isActive('until-wide')) {
			scrollOffset -= $el.outerHeight();
		}

		app.obj.site.scrollController.scrollTo(scrollOffset, {
			callback: function() { if (typeof app.obj.site.scrollController.update !== 'undefined') app.obj.site.scrollController.update(true); },
		});
	};

	var checkPagePosition = function() {
		var currentSectionIndex;
		var currentScrollPosition = $doc.scrollTop() + 2;

		if (Gridle.isActive('until-wide')) {
			currentScrollPosition += app.obj.site.headerHeight + $el.outerHeight();
		}

		$.each(sectionPositions, function(index, value) {
			if (currentScrollPosition > value) {
				currentSectionIndex = index;
			}
		});
		markLink(currentSectionIndex);

	};

	var markLink = function(currentSectionIndex) {
		if (activeSection !== currentSectionIndex) {
			activeSection = currentSectionIndex;
			$link.filter('.' + app.states.isActive).removeClass(app.states.isActive);
			$link.eq(activeSection).addClass(app.states.isActive);
			if (currentSectionIndex == undefined) {
				$link.eq(0).addClass(app.states.isDefault);
			} else {
				$link.eq(0).removeClass(app.states.isDefault);
			}
		}
	};

	var getSectionIndex = function($element) {
		return $link.index($element[0]);
	};

	var getLinkByHref = function(href) {
		return $link.filter('[href="' + href + '"]');
	};


	init();	return api;
};

app.ext['scrollbar'] = function ($el) {
	var api = {};

	var $win = app.vars.$win;
	var $doc = app.vars.$doc;
	var $html = app.vars.$html;
	var $body = app.vars.$body;

	var scrollbarActive = false;
	var scroller;

	var init = function () {
		//Only init scroll plugin if device is not using safari on tocuh device - else site will crash on ios
		if ($html.hasClass('safari') && $html.hasClass('touch')) {
			useNativeScrollbar()
		} else {
			addListeners();
			initScrollbar();
		}

	};

	//use native scrollbar instead
	var useNativeScrollbar = function () {
		console.log($el)
		$el.addClass('show-native-scrollbar')
	}

	var addListeners = function () {
		Gridle.on('update', gridleUpdateHandler);
	};

	var gridleUpdateHandler = function () {
		if ($el.css('overflow') === 'hidden' && !scrollbarActive) {
			initScrollbar();
		} else if ($el.css('overflow') !== 'hidden' && scrollbarActive) {
			destroyScrollbar();
		}
	};

	var resizer = function () {
		if (scroller && !scroller.enabled) {
			scroller.enable();
		}
		setTimeout(function () {
			checkScrollbar();
		}, 300);
	};

	var initScrollbar = function () {
		if ($el.css('overflow') !== 'hidden') return false;
		scrollbarActive = true;
		scroller = new IScroll($el[0], {
			scrollbars: true,
			mouseWheel: true,
			interactiveScrollbars: true,
			click: false,
			disablePointer: true,
			disableTouch: false,
			disableMouse: false,
		});
		$el.data('scroller', scroller);
		scroller.on('scrollStart', function () {
			if (!$('.iScrollIndicator:visible', $el).length && scroller.enabled) {
				scroller.disable();
			} else if (!scroller.enabled) {
				scroller.enable();
			}
			checkScrollbar();
		});
		scroller.on('refresh', function () {
			console.log('refresh');
			if (!$el.hasClass('scrollbar--enabled')) {
				destroyScrollbar();
				initScrollbar();
			};
		});
		checkScrollbar();
		$win.on('resize.iscroll orientationchange.iscroll', resizer);
	};

	var checkScrollbar = function () {
		if (!$('.iScrollIndicator:visible', $el).length) {
			$el.removeClass('scrollbar--enabled');
		} else {
			$el.addClass('scrollbar--enabled');
		}
		//console.log('checkScrollbar');
	};

	var destroyScrollbar = function () {
		$win.off('resize.iscroll orientationchange.iscroll', resizer);
		scroller.destroy();
		scroller = null;
		scrollbarActive = false;
	};

	init(); return api;
};

app.ext['search-item-filter'] = function($el) { 
  var api = {};

  var vars = {
    filter: $el.data('search-item-filter'),
  };

  var classes = {
    item: '[data-search-item-filter-value]',
    search: {
      obj: '.js-search',
      filters: '.js-filters',
    },
  };

  var addListeners = function () {
    $el.find(classes.item).on('click.search-item-filter', itemClick);
  };

  var itemClick = function (e) {
    var $item = $(event.currentTarget);
    var value = $item.data('search-item-filter-value') || $item.text();
    var $search = $item.closest(classes.search.obj);
    var searchData = $search.length ? $search.data() : false;
    e.preventDefault();

    //if ($search.length) {
      /*
      var search_object = $search.data('search-object') || 'search';
      var $filter = $search.find(classes.search.filters).find('[data-filter="' + vars.filter + '"]').find('[value="' + value + '"]');
      if ($filter.length) {
        $filter.trigger('click');
      }
      */
      var _index = (searchData && searchData.searchIndex) || 'blog';
      var _category = (searchData && searchData.searchCategory) || 'blog';
      var _object = (searchData && searchData.searchObject) || 'blog';
      var loc = location.href.indexOf('.devlocal') >= 0 ? '/blog.php' : '/blog';
      var url_params = '?filter-' + _object + '=' + encodeURIComponent(vars.filter + '[' + value + ']') + '&search-category-' + _category + '&index-' + _object + '=' + _index;
      location.href = loc.split('?').shift() + url_params;
    //}
  };

  var init = function () {
    addListeners();
	};

	init();	return api;
};

app.ext['search-trigger'] = function($el) { 
	var api = {};

	var init = function() {
		addListeners();
	};

	var addListeners = function() {
		$el.on('click', elClickHandler);
	};

	var elClickHandler = function(event) {
		event.preventDefault();
		$('.nav-search a').trigger('click');
	};

	init();	return api;
};

app.ext['share'] = function($el) { 
	var api = {};

	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;

	var classes = {
		'button': '.js-share-button',
	};
	var states = {
		'hover': 'site--share-hover',
	};

	var init = function() {
		addListeners();
	};

	var addListeners = function() {
		$el.find(classes.button).on('click.share-toggle', function(e){
			$html.toggleClass(states.hover);
		});
		$doc.on('click.share, touchstart.share', function(e){
			var $target = $(e.target);
			if(!$target.not('.share').parents('.share').length){
				$html.removeClass(states.hover);
			}
		});

		var $channel = !$el.filter('[data-channel]').length ? $el.find('[data-channel]') : $el;

		console.log($channel);
		if ($channel.length){
			$channel.on('click.share-channel', function(e){
				var url, mailto;
				var $item = $(e.currentTarget);
				var href = $item.attr('href');
				var text = encodeURIComponent(document.title);
				var loc = encodeURIComponent(location.href);
				var channel = $item.data('channel');
				var w = 600;
				var h = 700;

				if (!href || href.length < 1 || href === 'javascript:;'){
					e.preventDefault();

					switch(channel){
						case 'facebook':
							url = 'https://www.facebook.com/sharer/sharer.php?u=';
							break;
						case 'twitter':
							var data_text = $item.data('text');
							if (!data_text) {
								url = 'https://twitter.com/share?text=' + text + '&url=';
							} else {
								url = 'https://twitter.com/intent/tweet?text=' + data_text + '&url=';
							}
							h = 300;
							break;
						case 'linkedin':
							url = 'http://www.linkedin.com/shareArticle?mini=true&url=';
							w = 500;
							break;
						case 'google':
							url = 'https://plus.google.com/share?url=';
							w = 550;
							break;
						case 'whatsapp':
							url = 'whatsapp://send?text=' + text + ' ' + loc;
							w = 550;
							break;
						case 'email':
							var email_subject = $item.data('subject') || 'I want to recommend this article at borealisgroup.com';
							var email_body = $item.data('body') || 'I want to recommend this article at borealisgroup.com';
							email_body += '%0D%0A'+loc;
							mailto = 'mailto:?subject=' + email_subject + '&body=' + email_body;
							break;
						default:
					}
					
					tracking(channel, location.href);

					if(url){
						url += loc;
						var win = window.open(url, 'Share', 'width=' + w + ',height=' + h + ',noopener,noreferrer');
						win.opener = null;
					}else if(mailto){
						location.href = mailto;
					}
				}
			});

		}
	};

	// TRACKING
	var tracking = function(channel, url){
		app.obj.tracking.track({
			'event': 'sharing',
			'category': channel,
			'action': 'Share',
			'label': url,
		});
	};

	init();	return api;
};
app.ext['show-info'] = function($el) { 
	var api = {};

	var init = function() {
		addListeners();
	};

	var data = $el.data();

	var infoSettings = {
		type: data['type'],
		closeButton: data['closeButton'],
		autoHide: data['autoHide'],
		title: data['title'],
		message: data['message'],
	};

	var addListeners = function() {
		$el.on('click', elClickHandler);
	};

	var elClickHandler = function() {
		app.obj['info'].showInfo(infoSettings);
	};

	init();	return api;
};

app.ext['site-footer'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var init = function() {
		var $ul = $('.site-footer__links ul', $el);

		$('a', $ul).on('click.slide', function(e) {
			var $target = $(e.currentTarget).parent().parent();

			if ($(e.target).is('ul') || $(e.target).parent().is('li:first-child')) {
				e.preventDefault();
				$target.siblings().removeAttr('style').removeClass('open');

				if (!$target.attr('style')) {
					$target.css('height', $target.prop('scrollHeight')).addClass('open');
				} else {
					$target.removeAttr('style').removeClass('open');
				}
			}
		});
		$win.on('resize orientationchange', function() {
			if(!$('html.until-tabletLandscape').length){
				$ul.removeAttr('style').removeClass('open');
			}
		});
	};

	init();	return api;
};

app.ext['sitemap'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var $nav		= $('.sitemap__nav');
	var $items		= $('ul li a', $nav);

	var init = function() {
		addListeners();
	};

	var addListeners = function() {
		$doc.on('click.sitemapNav', '.sitemap__nav ul li a', function(e) {
			var $target	= $(e.currentTarget).parent();
			var $sub	= $('.sitemap__nav__sub__sub', $target);
			var $sub2	= $('> .sitemap__nav__sub__sub__sub', $target);
			var subs	= $('> .sitemap__nav__sub .sitemap__nav__sub__sub', $target).length;
			var subs2	= $('> .sitemap__nav__sub__sub .sitemap__nav__sub__sub__sub', $target).length;
			var mobile	= $('html.until-tabletLandscape').length;
			var open;

			if ($('ul', $target).length && mobile) {
				e.preventDefault();
				$target.toggleClass('open');

				if (subs && mobile) {
					$target.addClass('open');
				}
					
				open = $target.hasClass('open');

				if (open) {
					$target.siblings().removeClass('open');
					$('li', $target.parents('.sitemap__nav__sub__sub').parent().siblings()).removeClass('open');
					$('ul li.open', $target).removeClass('open');
					if(subs || $sub.length){
						$('html.until-tabletLandscape .sitemap__nav__sub__sub').slideUp();
					}
					//if(subs2 || $sub2.length){
						$('.sitemap__nav__sub__sub__sub').slideUp();
					//}
				}

				if (!subs || $sub2.length) {
					if (open) {
						$sub.slideDown();
						if($sub2.length){
							$sub2.slideDown();
						}
					} else {
						if($sub2.length){
							$sub2.slideUp();
						}else{
							$sub.slideUp();
						}
					}
				}
			}
		});

		$win.on('resize.sitemapNav orientationchange.sitemapNav', function() {
			if(!$('html.until-tabletLandscape').length){
				$('nav[style]', $nav).removeAttr('style');
				$('.open', $nav).removeClass('open');
			}
		});
	};

	init();	return api;
};
app.ext['slide-up'] = function($el) { 
	var api = {};

	var init = function() {

		$el.each(function(i, e) {
			var o = function() { return 50 + Math.random() * 40; };

			var tween_move = new ScrollMagic.Scene({
				triggerElement: e,
				triggerHook: 'onEnter',
				offset: o(),
			})
			.setClassToggle(e, 'js-slide-up--show')
			.addTo(app.obj.site.scrollController);
		});
		
	};

	init();	return api;
};

app.ext['slideout'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;

	var settings = {
		transDuration: 0.3,
		transDistance: 5,
	};

	var classes = {
		navLink     : '.js-slideout-nav-link',
		navLinks    : '.js-slideout-nav-links',
		prevLink    : '.js-slideout-prev-link',
		nextLink    : '.js-slideout-next-link',
		contentItem : '.js-slideout-content-item',
		container   : '.js-slideout-container',
		navSlide    : '.js-slideout-nav-slide',
	};

	var $navLink                = $(classes.navLink, $el);
	var $navLinks               = $(classes.navLinks, $el);
	var $nextLink               = $(classes.nextLink, $el);
	var $prevLink               = $(classes.prevLink, $el);
	var $contentItem            = $(classes.contentItem, $el);
	var $container              = $(classes.container, $el);
	var $navSlide               = $(classes.navSlide, $el);

	var currentItemNr;
	var isAnimated              = false;
	var slideNavEnabled         = false;
	var slideNavWidth;
	var slideWidth;
	var slideNavDistance;
	var currentSlideNavPosition = 0;

	var init = function() {
		addListeners();
		setupNavSlide();
		getInitialItemNr();
	};

	var getInitialItemNr = function() {
		currentItemNr = getActiveItemNr();
	};

	var addListeners = function() {
		$navLink.on('click', navLinkClickHandler);
		$nextLink.on('click', nextLinkClickHandler);
		$prevLink.on('click', prevLinkClickHandler);
		$navSlide.on('click', navSlideClickHandler);
		Gridle.on('update', function() {
			setupNavSlide();
		});
	};

	var navLinkClickHandler = function(e) {
		e.preventDefault();
		var $this = $(this);
		var itemNr = $this.data('item');
		showContentItem(itemNr);
	};

	var nextLinkClickHandler = function(e) {
		e.preventDefault();
		var itemNr = getNextItemNr();
		showContentItem(itemNr);
	};

	var prevLinkClickHandler = function(e) {
		e.preventDefault();
		var itemNr = getPrevItemNr();
		showContentItem(itemNr);
	};

	var navSlideClickHandler = function(e) {
		e.preventDefault();
		var dir = $(this).data('dir');
		slideNav(dir);
	};

	var setupNavSlide = function() {
		if (Gridle.isActive('until-tablet')) return false;
		slideNavWidth = $navLinks.outerWidth();
		slideWidth = $el.outerWidth();
		slideNavDistance = slideWidth * 0.7;

		if (slideNavWidth > slideWidth) {
			$navSlide.filter('[data-dir="next"]').addClass(app.states.isActive);
			slideNavEnabled = true;
		} else {
			slideNavEnabled = false;
		}

	};

	var showContentItem = function(itemNr) {
		if (isAnimated) return false;

		var $currentItem = getItemByItemNr(currentItemNr);
		var $newItem = getItemByItemNr(itemNr);

		var $currentLink = getLinkByItemNr(currentItemNr);
		var $newLink = getLinkByItemNr(itemNr);

		$currentLink.removeClass(app.states.isActive);
		$newLink.addClass(app.states.isActive);

		$container.css('height', $container.outerHeight());

		isAnimated = true;
		TweenLite.to($currentItem, settings.transDuration, {
			opacity: 0,
			display: 'none',
			onComplete: function() {
				//$currentItem.removeClass(app.states.isSelected).addClass(app.states.isHidden);
				//$newItem.addClass(app.states.isSelected).removeClass(app.states.isHidden);
				TweenLite.fromTo($newItem, settings.transDuration, { opacity: 0, y: settings.transDistance }, {
					opacity: 1,
					y: 0,
					display: 'block',
					ease: app.settings.easeOut,
					onComplete: function() {
						currentItemNr = itemNr;
						$container.css('height', 'auto');
						isAnimated = false;
						// $win.trigger('scroll');
						$win.trigger('load');
						$win.trigger('scrollRefresh');
					},
				});
			},
		});

	};

	var getActiveItemNr = function() {
		return $navLink.filter('.' + app.states.isActive).data('item');
	};

	var getLinkByItemNr = function(itemNr) {
		return $navLink.filter('[data-item="' + itemNr + '"]');
	};

	var getItemByItemNr = function(itemNr) {
		return $contentItem.filter('[data-item="' + itemNr + '"]');
	};

	var getNextItemNr = function() {
		var $currentLink = getLinkByItemNr(currentItemNr);
		var $nextLink = $currentLink.next(classes.navLink);
		if ($nextLink.length === 0) {
			$nextLink = $navLink.first();
		}
		return $nextLink.data('item');
	};

	var getPrevItemNr = function() {
		var $currentLink = getLinkByItemNr(currentItemNr);
		var $nextLink = $currentLink.prev(classes.navLink);
		if ($nextLink.length === 0) {
			$nextLink = $navLink.last();
		}
		return $nextLink.data('item');
	};

	var slideNav = function(dir) {
		var distance = slideNavDistance;

		if (dir === 'next') {
			if (slideNavWidth <= slideWidth + currentSlideNavPosition + distance) {
				distance = slideNavWidth - currentSlideNavPosition - slideWidth;
			}
		} else {
			distance = -distance;
			if (currentSlideNavPosition + distance < 0) {
				distance = -currentSlideNavPosition;
			}

		}

		TweenLite.to($navLinks, 0.7, {
			x: '-=' + distance + 'px',
			ease: Power3.easeInOut,
		});
		currentSlideNavPosition += distance; 


		if (currentSlideNavPosition > 0 && slideNavEnabled) {
			$navSlide.filter('[data-dir="prev"]').addClass(app.states.isActive);
		} else {
			$navSlide.filter('[data-dir="prev"]').removeClass(app.states.isActive);
		}
		if ((currentSlideNavPosition > slideNavWidth - slideWidth - 2) && slideNavEnabled) {
			$navSlide.filter('[data-dir="next"]').removeClass(app.states.isActive);
		} else {
			$navSlide.filter('[data-dir="next"]').addClass(app.states.isActive);
		}
	};

	init();	return api;
};

app.ext["sticky-top"] = function ($el) {
  var api = {};

  var $win = app.vars.$win;

  var stickyOn = false;
  var stickybottom = typeof $el.data("stickybottom") !== "undefined";
  var stickyfrom = $el.data("stickyfrom")
    ? $el.data("stickyfrom")
    : "desktopEx";
  var stickyoffset = $el.data("stickyoffset") ? $el.data("stickyoffset") : 0;
  var resizeTimeout;

  var contentNav = $el.hasClass("content-nav__wrapper");
  var $contentRight = $(".content-right .js-tabs-container");

  var overview_side = $el.parent().hasClass("overview__side");

  if (overview_side) {
    var $overview__inner = $el.closest(".overview__inner");
    var $overview__main = $(".overview__main", $overview__inner);
    var $overview__panel_prev = $el.prev();

    /*if(!$overview__panel_prev.length || !$overview__panel_prev.hasClass('overview__panel')){
      $overview__panel_prev = false;
    }*/
  }

  var init = function () {

    if ($el.closest(".overlay").length || $el.hasClass("subnav__pusher"))
      return false;
    addListeners();
    api.resizeWindow();
  };

  var isPusher = function ($el) {
    if ($el.hasClass("subnav__pusher")) {
      if (
        ($("html.search--open").length && $el.parents(".search").length) ||
        $el.parents(".site-main").length
      ) {
        return true;
      }
    }
  };

  var initStickyKit = function () {
    var offset = 0 + stickyoffset;
    if ($el.hasClass("content-nav__wrapper")) {
      stickyfrom = "desktop";
      offset = 30;
    }

    if (Gridle.isActive(stickyfrom)) {
      stickyOn = true;
      if (stickybottom) {
        offset += app.obj.site.headerHeight;

        if ($el.parent().hasClass("overview__side--spaced")) offset += 30;
      }

      $el.data("top", 0);

      api.unfreezeStickyKit();
      $el
        .stick_in_parent({
          offset_top: offset,
          bottoming: stickybottom,
        })
        .on("sticky_kit:stick", function (e) {
          stickyOn = true;
        })
        .on("sticky_kit:unstick", function (e) {
          stickyOn = false;

          if (isPusher($el)) {
            app.obj["nav-main"].navScroll(true);
          }
        })
        .on("sticky_kit:bottom", function (e) {
          // $(this).parent().css('position', 'static');
        })
        .on("sticky_kit:unbottom", function (e) {
          // $(this).parent().css('position', 'relative');
        });
    } else {
      api.removeStickyKit();
    }
  };

  var addListeners = function () {
    Gridle.on("update", function () {
      api.resizeWindow();
    });

    $win.on("resize.sticky orientationchange.sticky", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        api.resizeWindow();
      }, 200);
    });
  };

  api.resizeWindow = function () {
    initStickyKit();

    if (overview_side) {
      var h =
        $el.prop("scrollHeight") +
        50 +
        ($overview__panel_prev.length
          ? $overview__panel_prev.outerHeight()
          : 0);
      var min_h = $overview__main.css("min-height") || 0;
      // $overview__inner.css('min-height', $overview__side.prop('scrollHeight'));
      if (h != min_h) {
        $overview__main.css("min-height", h);
      }
    } else if (contentNav) {
      $contentRight.css("min-height", $el.prop("scrollHeight") + 50);
    }
  };

  api.removeStickyKit = function () {
    if (stickyOn) {
      api.freezeStickyKit();
      $el.trigger("sticky_kit:detach");
      stickyOn = false;
    }
  };

  api.freezeStickyKit = function () {
    $el.trigger("sticky_kit:freeze");
  };

  api.unfreezeStickyKit = function () {
    $el.trigger("sticky_kit:unfreeze");
  };

  $el.data("sticky-top", api);

  init();
  return api;
};

app.ext['sticky'] = function($el) { 
	var api = {};

	var classes = { 
		stickyTriggerStart: '.js-sticky-trigger-start',
		stickyTriggerStop: '.js-sticky-trigger-stop',
		stickyContent: '.js-sticky-content',
	};

	var $stickyTriggerStart = $el.find(classes.stickyTriggerStart);
	var $stickyContent = $el.find(classes.stickyContent);

	// vars
	var stickyInitiated = false;
	var stickyScene;
 
	var init = function() {
		addListeners();
		if (Gridle.isActive('wide')) {
			initScrollMagicScenes();
		}
	};

	var addListeners = function() {
		Gridle.on('update', function() {
			if (Gridle.isActive('wide')) {
				initScrollMagicScenes();
			} else {
				destroySticky();
			}
		});
	};

	var initScrollMagicScenes = function() {
		if (stickyInitiated) return false;
		stickyInitiated = true;

		var contentTopSpace = $stickyContent.offset().top - $el.offset().top;
		var sceneDuration = $el.outerHeight() - $stickyContent.outerHeight() - contentTopSpace;

		$stickyTriggerStart.css('top', $stickyContent.outerHeight());

		stickyScene = new ScrollMagic.Scene({
			triggerElement: $stickyTriggerStart[0],
			triggerHook: 'onEnter', 
			duration: sceneDuration,
		})
		.setPin($stickyContent[0])
		.addTo(app.obj.site.scrollController); 
	};

	var destroySticky = function() {
		if (!stickyInitiated) return false;
		stickyInitiated = false;
		stickyScene.destroy(true);
	};

	init();	return api;
};

app.ext['subnav'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	var $doc	= app.vars.$doc;
	var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var classes = {
		inner:		'.subnav__inner',
		swiper:		'.subnav__swiper',
		wrapper:	'.subnav__swiper__wrapper',
		arrow:		'.subnav__arrow',
	};

	var swiper;
	var $inner		= $(classes.inner, $el);
	var $move		= $(classes.swiper, $el);
	var $wrapper	= $(classes.wrapper, $el);
	var $arrow		= $(classes.arrow, $el);
	var $right		= $(classes.arrow + '--right', $el);
	var $left		= $(classes.arrow + '--left', $el);
	var $overlay	= $el.parents('.overlay');

	var init = function() {
		// if (!$('.subnav__inner--algolia', $el).length) {
		// 	api.swiper();

		// 	// UPDATE NAVIGATION
		// 	$win.on('resize.subnav orientationchange.subnav', function() {
		// 		api.swiper();
		// 	});
		// }
		if ($overlay.length) {
			var c = app.vars.context;
			var context = app.getParam(c);
			var url = location.href.split('?')[0];

			$('a', $el).each(function() {
				var $self = $(this);
				var href = $self.attr('href');
				var p = href.indexOf('?') >= 0 ? '&' : '?';
				var basePageUrl = context ? (href.indexOf(context)<0 ? context : location.protocol + '//' + location.hostname) : (href.indexOf(url)<0 ? url : location.protocol + '//' + location.hostname);

				console.log('href:'+href);
				console.log(context || 'no context');
				console.log('basePageUrl:'+basePageUrl);

				$self.attr('href', href + p + c + '=' + basePageUrl);
			});
		}
	};

	// api.swiper = function() {
	// 	var sw = $wrapper.prop('scrollWidth');
	// 	var w = $wrapper.width();
	// 	return
	// 	if (sw - 1 > w) {
	// 		if (!$el.data('swiper')) {
	// 			$('> *:first-child', $move).addClass('swiper-wrapper');
	// 			$('> *:first-child > *', $move).addClass('swiper-slide');

	// 			var index	= $('.swiper-slide', $el).index($('.swiper-slide.is-active', $el));
	// 			var moving	= $('.swiper-slide', $el).is('a') ? 0 : false;
	// 			swiper	= new Swiper($move[0], {
	// 				pagination:		false,
	// 				navigation:		{
	// 									prevEl: $left[0],
	// 									nextEl: $right[0],
	// 								},
	// 				initialSlide:	index,
	// 				spaceBetween:	0,
	// 				freeMode:		true,
	// 				freeModeSticky:	true,
	// 				slidesPerView:	'auto',
	// 				preventClicks:	moving != false,

	// 				on: {
	// 					touchMove: function() {
	// 						if (moving >= 0) {
	// 							moving++;
	// 							if (moving == 2) {
	// 								$el.addClass('swiper--moving');
	// 							}
	// 						}
	// 					},
	// 					touchEnd: function() {
	// 						if (moving >= 0) {
	// 							moving = 0;
	// 							$el.removeClass('swiper--moving');
	// 						}
	// 					},
	// 				},
	// 			});

	// 			// NAVIGATION <-|->
	// 			$right.off('click');
	// 			$arrow.off('click').on('click', function(event) {
	// 				var $target	= $(event.currentTarget);

	// 				if ($target.data('dir') == 'right') {
	// 					swiper.slideTo(swiper.slides.length - 1);
	// 				} else {
	// 					swiper.slideTo(0);
	// 				}
	// 			});

	// 			$el.data('swiper', swiper);
	// 		} else if (typeof swiper !== 'undefined' && swiper.update) {
	// 			swiper.update();
	// 		}
	// 	} else {
	// 		if ($el.data('swiper')) {
	// 			swiperDestroy();
	// 		}
	// 	}
	// };

	// var swiperDestroy = function () {
	// 	$el.data('swiper').destroy();
    //     $el.removeClass('swiper-container-vertical swiper-container-horizontal swiper--moving').data('swiper', '');
	// 	$('.swiper-slide, .swiper-wrapper', $el).removeAttr('style');
	// 	$('.swiper-wrapper', $el).removeClass('swiper-wrapper');
	// 	$('.swiper-slide', $el).removeClass('swiper-slide swiper-slide-active swiper-slide-prev swiper-slide-next slide--hidden');
	// 	$('.swiper-pagination, .swiper-button-prev, .swiper-button-next', $el).remove();
	// };

	$el.data('subnav', api);

	init();	return api;
};

app.ext['swiper-trigger'] = function($el) { 
	var api = {};

	var init = function() {
    $el.on('click.swiper-trigger', function (e) {
      var $trigger = $(e.currentTarget);
      var target = $trigger.data('swiper-target');
      var index = $trigger.data('swiper-index') || $trigger.index();

      window.bus.dispatchEvent(new CustomEvent('slider-slide-to', { // would be only dispatch() in new script
        detail: {
          name: target,
          index: parseInt(index)
        },
      }));

      if (target) {
        var swiper = $(target).not('.swiper-pagination--hidden').data('swiper');

        if(swiper){
          e.preventDefault();
          swiper.slideTo(index);

          
        }
      }
    });
	};

	init();	return api;
};
// app.ext['swiper'] = function($el) {
//   var api = {};

//   var $win  = app.vars.$win;
//   var $doc  = app.vars.$doc;
//   var $html = app.vars.$html;
//   var $body = app.vars.$body;

//   var init = function() {
//     var $search_results = $el.find('.js-search-results');

//     if(!$search_results.length){
//       var delay = $el.data('swiper-delay') || 0;
//       setTimeout(function() {
//         initSwiper();
//       }, delay);
//     } else {
//       var $search = $search_results.closest('.js-search');
//       var searchReady = setInterval(function () {
//         var search_total = $search.attr('data-total');
//         if (search_total && search_total != "0"){
//           clearInterval(searchReady);
//           initSwiper();
//         }
//       }, 100);
//     }
//   };

//   var initSwiper = function(){
//     initPlugins();

//     $win.on('resize orientationchange', function() {
//       setTimeout(function() {
//         initPlugins();
//       }, 100);
//     });
//   };
//   var initPlugins = function() {
//     var swiper;
//     var config			= $el.data('swiper-config') ? $el.data('swiper-config') : {'buttons': false, 'cols': false};
//     var mobile			= $el.hasClass('js-swiper--mobile');
//     var until			  = config.until || 'tablet';
//     var direction		= config.direction || 'horizontal';
//     var space			  = config.space || 0;
//     var cols			  = config.cols;
//     var bp				  = {};
//     var slidesPerView = $el.hasClass('gallery__outer') ? 'auto' : (config.slidesPerView || 1);
//     var initialSlide  = $el.data('swiper-slide-initial') || 0;
//     var is_until    = $('html.until-' + until).length;

//     /*var $pagination, $prev, $next;

//     if (config.pagination) {
//       $pagination = $('.swiper-pagination', $el).length ? $('.swiper-pagination', $el) : ($('<div class="swiper-pagination ' + 'swiper-pagination--' + config.pagination + '"></div>'));
//     }*/

//     var $parent = $el.filter('section').length ? $el : $el.parent(), $el_pagination = $('.swiper-pagination', $parent), pagination = false, keyboard = false, navigation = false, fraction = false, $prev, $next;
//     var $fraction = $parent.find('.swiper-pagination-fraction'), $fraction_current, $fraction_total;

//     if($fraction.length){
//       fraction = true;
//       $fraction_current = $fraction.find('.swiper-pagination-fraction__current');
//       $fraction_total = $fraction.find('.swiper-pagination-fraction__total');
//     }

//     if (config.pagination) {
//       pagination = {
//         //el: '.swiper-pagination',
//         type: 'bullets', // fraction
//         clickable: true,
//         //dynamicBullets: true,
//         //dynamicMainBullets: 1,
//       };
//       if (!$el_pagination.length) {
//         $pagination = $('<div class="swiper-pagination"></div>');
//         $pagination.appendTo($el);
//       } else {
//         $pagination = $el_pagination;
//       }
//       $pagination.addClass('swiper-pagination--' + config.pagination);
//       pagination.el = $pagination[0];
//     }

//     if (config.buttons) {
//       if (config.buttons === true) {
//         var $navContainer = $parent;
//         var $el_prev = $('.swiper-button-prev', $navContainer);
//         var $el_next = $('.swiper-button-next', $navContainer);
//         $prev = $el_prev.length ? $el_prev : $('<div class="swiper-button-prev"></div>');
//         $next = $el_next.length ? $el_next : $('<div class="swiper-button-next"></div>');
//       } else {
//         var $navContainer = $(config.buttons);
//         $prev = $('.nav-arrow--prev', $navContainer).length ? $('.nav-arrow--prev', $navContainer) : $('<div class="nav-arrow--prev"></div>');
//         $next = $('.nav-arrow--next', $navContainer).length ? $('.nav-arrow--next', $navContainer) : $('<div class="nav-arrow--next"></div>');
//       }
//       navigation = {
//         prevEl: $prev[0],
//         nextEl: $next[0],
//       };
//     }

//     if (config.keyboard) {
//       keyboard = {
//         enabled: true,
//         onlyInViewport: false,
//       };
//     }
    
//     if (cols) {
//       for (c in cols) {
//         bp[app.obj.site.breakPoints[c]] = {slidesPerView: cols[c]};
//         slidesPerView = cols[c];
//       }
//     }

//     if ((config.until && is_until) || (!config.until && (is_until || !mobile))) {
//       if ($el.data('swiper') && direction != $el.data('swiper').params.direction) {
//         swiperDestroy($el);
//       }
//       if (!$el.data('swiper')) {
//         $('> *:first-child', $el).addClass('swiper-wrapper');
//         $('> *:first-child > *', $el).addClass('swiper-slide');

//         //if (config.pagination && !$('.swiper-pagination', $el).length) $el.append($pagination);
//         //if (config.buttons === true && !$('.swiper-button-prev', $el).length) $el.append($prev);
//         //if (config.buttons === true && !$('.swiper-button-next', $el).length) $el.append($next);
//         if (config.buttons === true && !$('.swiper-button-prev', $parent).length) $el.append($prev);
//         if (config.buttons === true && !$('.swiper-button-next', $parent).length) $el.append($next);

//         var moving = $('.swiper-slide', $el).is('a') ? 0 : false;

//         var delay = config.thumbs ? 100 : 0;

//         setTimeout(function(){

//           swiper = new Swiper($el[0], {
//             pagination: pagination,
//             navigation: navigation,
//             keyboard: keyboard,
//             paginationClickable: true,
//             scrollbar: config.scrollbar || false,
//             initialSlide: initialSlide,
//             autoHeight: config.autoheight || (config.autoHeight ? config.autoHeight : (!!$el.hasClass('js-swiper--autoheight'))),
//             direction: direction,
//             thumbs: config.thumbs || false,
//             //controller: config.controller || false,
//             freeMode: config.freeMode || false,
//             clickable: config.clickable || false,
//             spaceBetween:	space,
//             slidesPerView: slidesPerView,
//             autoplay:	config.autoplay || false,
//             // setWrapperSize:		true,
//             breakpoints:	bp,
//             parallax: config.parallax	|| false,
//             speed: config.speed || 300,
//             preventClicks: moving != false,
//             watchSlidesVisibility: true, //config.watchSlidesVisibility || false,
//             watchSlidesProgress: config.watchSlidesProgress || false,
//             allowTouchMove: typeof config.allowTouchMove !== 'undefined' ? config.allowTouchMove : true,

//             on: {
//               init: function() {
//                 var $container = $(this.wrapperEl);
//                 updateVisibleSlides(this);
//                 if ($prev !== undefined && $next !== undefined) {
//                   markNavButtons($prev, $next);
//                 }
//                 if (fraction) fractionUpdate(this, $fraction_current, $fraction_total);
//                 videoVis($container);
//               },
//               touchStart: function() {
//                 $(this.wrapperEl).addClass('swiper--move');
//               },
//               touchMove: function() {
//                 if (moving >= 0) {
//                   moving++;
//                   if (moving == 2) {
//                     $el.addClass('swiper--moving');
//                   }
//                 }
//               },
//               touchEnd: function() {
//                 $(this.wrapperEl).removeClass('swiper--move');
//                 if (moving >= 0) {
//                   moving = 0;
//                   $el.removeClass('swiper--moving');
//                 }
//               },
//               transitionStart: function() {
//                 updateVisibleSlides(this);
//                 if (fraction) fractionUpdate(this, $fraction_current, $fraction_total);
//               },
//               transitionEnd: function() {
//                 var $container = $(this.wrapperEl);
//                 lazy($container);
//                 videoVis($container);
//                 $('.slide--hidden .video-playing .js-video-player', $container).each(function() {
//                   $(this).data('video-player').videoPause();
//                 });
//               },
//               slideChangeTransitionEnd: function() {
//                 $el.data('swiper-slide-initial', this.activeIndex);
//                 if (fraction) fractionUpdate(this, $fraction_current, $fraction_total);
//               },
//               resize: function() {
//                 swiper.update();
//                 updateVisibleSlides(swiper);
//               },
//             }
//           });

//           $el.data('swiper', swiper);
//           /* $win.on('resize.swiper orientationchange.swiper', function(){
//             updateVisibleSlides($el.data('swiper'));
//           }); */

//           updateVisibleSlides(swiper);

//           if (config.controller && typeof config.controller.control !== 'undefined') {
//             if (typeof config.controller.control === "string") {
//               setTimeout(function () {
//                 swiper.controller.control = $(config.controller.control).data('swiper');
//               }, 100);
//             } else {
//               swiper.controller.control = config.controller.control;
//             }
//           }

//         }, delay);
//       }
//     } else {
//       if ($el.data('swiper')) {
//         swiperDestroy($el);
//       }
//     }
//   };
//   var swiperDestroy = function($el) {
//     $el.data('swiper').destroy();
//     $el.removeClass('swiper-container-vertical swiper-container-horizontal').data('swiper', '');
//     $('.swiper-slide, .swiper-wrapper', $el).removeAttr('style');
//     $('.swiper-wrapper', $el).removeClass('swiper-wrapper');
//     $('.swiper-slide', $el).removeClass('swiper-slide swiper-slide-active swiper-slide-prev swiper-slide-next slide--hidden');
//     if (!$el_pagination.length) {
//       $('.swiper-pagination', $el).remove();
//     }
//     if (!$el_prev.length) {
//       //$('.swiper-button-prev, .swiper-button-next', $el).remove();
//     }
//   };
//   var updateVisibleSlides = function(swiper) {
// 		// console.log(swiper);
//     var $container = $(swiper.wrapperEl);
//     var $items = $('.swiper-slide', $container);
//     var slidesPerView = swiper.params.slidesPerView != 'auto' ? swiper.params.slidesPerView : 1;
//     var visibleItems = $items.filter(function(index) {
//       return index >= swiper.activeIndex && index < swiper.activeIndex + slidesPerView;
//     });

//     $items.not(visibleItems).addClass('slide--hidden');
//     visibleItems.removeClass('slide--hidden');

//     if ($items.length <= slidesPerView) {
//       $el.addClass('swiper-pagination--hidden');
//     } else {
//       $el.removeClass('swiper-pagination--hidden');
//     }
//   };
//   var fractionUpdate = function (swiper, $fraction_current, $fraction_total){
//     $fraction_current.text(swiper.realIndex+1);
//     $fraction_total.text(swiper.slides.length);
//   };
//   var videoVis = function($container) {
//     var $video = $('.swiper-slide-active .js-video-player', $container);
//     if ($video.length && $video[0].videoVis) {
//       $video[0].videoVis();
//     }
//   };
//   var lazy = function($container) {
//     $('.swiper-slide-active [data-bg]:not(.lazy-loaded),[data-src]:not(.lazy-loaded)', $container).lazyLoadXT({checkDuplicates: false});
//   };

//   var markNavButtons = function($prev, $next) {
//     setTimeout(function() {
//       $prev.addClass('is-loaded');
//       $next.addClass('is-loaded');
//     }, 800);
//   };

//   init();	return api;
// };

app.ext['table-scroll'] = function($el) {
	var api = {};

	var $win	= app.vars.$win;
    //var $doc	= app.vars.$doc;
	//var $body	= app.vars.$body;

	var vars = {
		winWidth: $win.innerWidth(),
	};

	var classes = {
		wrapper: '.js-table-scroll__wrapper',
		holder: '.js-table-scroll__holder',
		groupTitle: '.table-scroll__group-title',
		groupHeader: '.js-table-scoll__group__header',
		groupHeaderTrigger: '.js-table-scoll__group__trigger, .table--inline tbody td:empty + td',
		groupDesc: '.js-table-scroll__group-desc',
		// gradient: '.js-table-scroll__gradient',
		filters: '.js-filters',
	};

	var elements = {
		wrapper: $el.find(classes.wrapper),
		holder: $el.find(classes.holder),
		header: $el.find('thead ' + '.table-scroll__group-header'),
		groupTitle: $el.find(classes.groupTitle),
		groupHeader: $el.find(classes.groupHeader),
		groupHeaderTrigger: $el.find(classes.groupHeaderTrigger),
		groupDesc: $el.find(classes.groupDesc),
		table: $el.find('table'),
		// gradient: $el.find(classes.gradient),
		filters: $el.find(classes.filters),
	};

	var init = function() {
		addClasses();
		addListeners();
		setTimeout(function() {
			elements.groupHeaderTrigger.eq(0).trigger('click.table-scroll');
			// holderResize();
		}, 100);
	};

	var addListeners = function() {
		elements.groupHeaderTrigger.on('click.table-scroll', groupHeaderToggle);
		elements.holder.on('scroll.table-scroll', tableScroll);
		elements.filters.on('change.filterInput', 'input[type="checkbox"]', filterChange);
		$win.on('resize.table-scroll orientationchange.table-scroll', winResize);
		dragListener();
	};

	var addClasses = function() {
		$el.find('.table--inline tbody tr td:first-child:empty').parent().addClass(classes.groupHeader.substr(1));
	}

	var winResize = function(e) {
		var w = $win.innerWidth();

		if (vars.winWidth != w) {
			vars.winWidth = w;
			holderResize();
		}
	};

	var scrollDiff = function () {
		elements.wrapper.attr('data-scroll-diff', Math.max(0, elements.table.width() - elements.holder.innerWidth() - elements.holder.scrollLeft()));
	};

	var holderResize = function() {
		// elements.gradient.css('left', elements.header.children(":first").width());
		elements.groupDesc.css('width', elements.wrapper.innerWidth());
		scrollDiff();
	};

	var tableScroll = function(e) {
		elements.holder.attr('data-scroll', elements.holder.scrollLeft());
		scrollDiff();
	};

	var groupHeaderToggle = function(e) {
		var $target = $(e.currentTarget);
		var $header = $target.closest(classes.groupHeader);

		$header.toggleClass(app.states.isActive).nextUntil(classes.groupHeader, "tr").toggleClass(app.states.isActive);
		holderResize();
	};

	var dragListener = function() {
		var isDown = false;
		var startX;
		var scrollLeft;
		var slider = elements.holder;

		slider.on('mousedown', function(e) {
			isDown = true;
			slider.addClass(app.states.isActive);
			startX = e.pageX - slider[0].offsetLeft;
			scrollLeft = slider[0].scrollLeft;
		});
		slider.on('mouseleave mouseup', function(e) {
			isDown = false;
			slider.removeClass(app.states.isActive);
		});
		slider.on('mousemove', function(e) {
			if(!isDown) return;
			e.preventDefault();
			var x = e.pageX - slider[0].offsetLeft;
			var walk = (x - startX) * 1.5; //scroll-fast
			slider[0].scrollLeft = scrollLeft - walk;
		});
	};

	var filterChange = function(e) {
		var $input = $(e.currentTarget);
		var key = $input.attr('name');
		var checked = $input.prop('checked');
		var $items = $el.find('table [data-filter="' + key + '"]');
		
		if (checked) {
			$items.removeClass('is-hidden');
		} else {
			$items.addClass('is-hidden');
		}
		groupTitles();
		holderResize();
		elements.holder[0].scrollTo(0,0);
	};

	var groupTitles = function() {
		var $th = elements.groupTitle.find('th');
		var first = $th.eq(0).filter(':not(.is-hidden)').length;

		$th.each(function(){
			var $self = $(this);
			var hidden = $self.hasClass('is-hidden');
			
			$self.attr('colspan', $self.data('colspan') + (!hidden && !first ? 1 : 0));
			if(!hidden && !first) first = true;
		});
	};


	init();	return api;
};

app.ext['table'] = function($el) { 
	var api			= {};
	var $tr			= $('tbody tr', $el);
	var $tr_head	= $('thead tr:first-child', $el);
	var td_head		= [];

	var init = function() {
		$('th', $tr_head).each(function() {
			td_head.push($(this).text());
		});
		$tr.each(function() {
			$('td', $(this)).each(function(i) {
				var $td = $(this);
				var str = td_head[i];
				if (str != '') $td.attr('data-label', str + ': ');
				if ($td.text() == '') $td.addClass('table__td--hide-mobile');
			});
		});
	};

	init();	return api;
};

app.ext['tabs'] = function($el) {
    var api = {};

    var $win    = app.vars.$win;
    var $doc    = app.vars.$doc;
    var $html   = app.vars.$html;
    var $body   = app.vars.$body;

    var settings = {
        transDuration: 0.3,
        transDistance: 5,
    };

    var classes = {
        category         : '.js-tabs-category',
        container        : '.js-tabs-container',
        main             : '.js-tabs-main',
        filters          : '.js-tabs-filters',
        filtersForm      : '.js-tabs-filters-form',
        filtersNested    : '.js-tabs-filters-nested',
        reload           : '.js-tabs-reload',
        paginationButton : '.js-tabs-pagination-button',
        pageIndex        : '.js-tabs-page-index',
        pageTotal        : '.js-tabs-page-total',
        itemTotal        : '.js-tabs-item-total',
        itemCountField   : '.js-tabs-item-count-field',
        pageCountField   : '.js-tabs-page-count-field',
        pagination       : '.js-tabs-pagination',
        nav              : '.js-tabs-nav',
        stickyTop        : '.overview__side .js-sticky-top',
        contentNavBack   : '.content-nav__back',
        el               : '.js-tabs',
    };

    // vars
    var currentCategoryUrl,
        currentCategoryStaticSide,
        currentCategoryFilters,
        currentCategoryPage,
        categoryPageTotal,
        staticSideLoaded,
        filtersVisible,
        ajaxCall,
        objectName = $el.data('objectName'),
        scrollTarget = $el.data('scrolltarget');
        paginationDelimiter = $el.data('paginationDelimiter');

    // elements
    var $category = $el.find(classes.category).not($el.find(classes.el + ' ' + classes.category));
    var $container = $el.find(classes.container).not($el.find(classes.el + ' ' + classes.container));
    var $filters = $el.find(classes.filters).not($el.find(classes.el + ' ' + classes.filters));
    var $filtersForm = $el.find(classes.filtersForm).not($el.find(classes.el + ' ' + classes.filtersForm));
    var $filtersNested = $el.find(classes.filtersNested).addBack().not($el.find(classes.el + ' ' + classes.filtersNested));
    var $reload = $el.find(classes.reload).not($el.find(classes.el + ' ' + classes.reload));
    var $nav = $el.find(classes.nav).not($el.find(classes.el + ' ' + classes.nav));
    var $stickyTop = $(classes.stickyTop, $el.parent());
    var pageID = parseInt($el.attr('data-page-id'), 10);
    var productID = parseInt($el.attr('data-product-id'), 10);
    var moduleID = parseInt($el.attr('data-module-id'), 10);
    var overlay = $el.parents('.overlay__outer').length;

    // functions
    var init = function() {
        getCurrentCategoryParameters();
        getInitialStatus();
        updatePagination();
        addListeners();
    };

    var addListeners = function() {
        $category.off('click').on('click', categoryClickHandler);
        // $reload.on('click', reloadClickHandler);
        $el.off('click', classes.paginationButton).on('click', classes.paginationButton, paginationButtonClickHandler);
        navBack($container);
        $win.on('popstate.' + objectName, popstateHandler);
    };

    var categoryClickHandler = function(event) {
        event.preventDefault();
        var $button = $(this);
        var displayedUrl = $button.attr('href');
        history.pushState({ type: 'category', displayedUrl: displayedUrl, objectName: objectName }, document.title, displayedUrl);
        $win.trigger('popstate.' + objectName);
        $win.trigger('test');
    };

    var reloadClickHandler = function(event) {
        api.loadTab();
    };

    var paginationButtonClickHandler = function(event) {
        var $button = $(this);
        // check if tabs is not nested in another tabs
        if ($button.closest(classes.el).parent().closest(classes.el).length) return false;
        if ($button.hasClass(app.states.isDisabled)) return false;
        var dir = $button.data('paginate');
        var tempCurrentCategoryPage = currentCategoryPage;

        if (dir === 'prev') {
            if (tempCurrentCategoryPage > 1) {
                tempCurrentCategoryPage--;
            } else {
                return false;
            }
        } else if (dir === 'next') {
            tempCurrentCategoryPage++;
        }

        var displayedUrl = location.href;
        var tempPaginationDelimiter;

        // temporary
        if (displayedUrl.indexOf('?t=') > -1) {
            tempPaginationDelimiter = '&' + paginationDelimiter;
        } else {
            tempPaginationDelimiter = '?' + paginationDelimiter;
        }

        displayedUrl = displayedUrl.split(tempPaginationDelimiter);
        displayedUrl = displayedUrl[0] + tempPaginationDelimiter + tempCurrentCategoryPage;
        history.pushState({ type: 'pagination', dir: dir, categoryIndex: tempCurrentCategoryPage, displayedUrl: displayedUrl }, document.title, displayedUrl);
        $win.trigger('popstate.' + objectName);

    };

    var popstateHandler = function(event) {
        if(history.state){
            var state = history.state;

            if (state.objectName == objectName) {
                if (state && state.type === 'category') {
                    var $button = $category.filter('[href="' + state.displayedUrl + '"]');
                    $button.parent().parent().parent().parent().find('.' + app.states.isActive).removeClass(app.states.isActive);
                    $button.addClass(app.states.isActive);
                    getCurrentCategoryParameters($button);
                    api.loadTab();

                } else if (state && state.type === 'pagination') {
                    currentCategoryPage = state.categoryIndex;
                    api.loadTab('pagination');
                }
                //scrollUp();
            }
        }
    };

    var getCurrentCategoryParameters = function($button) {
        $button = $button || false;

        if ($category.length) {
            if (!$button) {
                $button = $category.parent().parent().find('.' + app.states.isActive);
            }
            if ($button.data('url')) {
                var categoryData = $button.data();
                currentCategoryUrl = categoryData['url'];
                currentCategoryStaticSide = categoryData['staticSide'];
                currentCategoryFilters = categoryData['filters'];
            }
        } else {
            var defaultData = $el.data();
            currentCategoryUrl = defaultData['defaultUrl'];
            currentCategoryStaticSide = defaultData['defaultStaticSide'];
            currentCategoryFilters = defaultData['defaultFilters'];
        }

        currentCategoryPage = $el.find(classes.pageIndex).text();
    };

    var getInitialStatus = function() {
        staticSideLoaded = currentCategoryStaticSide;
        filtersVisible = currentCategoryFilters;

        if (overlay) {
            var displayedUrl = $('.js-tabs-nav a:eq(0)', $el).attr('href');
            if (displayedUrl) {
                displayedUrl = urlDev(displayedUrl);
                history.pushState({ type: 'category', displayedUrl: displayedUrl, objectName: objectName }, document.title, displayedUrl); 
            }
        }
    };

    var urlDev = function(url){
        if (location.href.indexOf('.devlocal') >= 0) {
            url = url.split('https:').join('http:').split('develop.cms.borealisgroup.com').join('borealisgroup.devlocal');
        }
        return url;
    }

    api.loadTab = function(type) {
        type = type || 'general';
        if (type !== 'pagination') currentCategoryPage = 1;

        var mainOnly = (!!(currentCategoryStaticSide && staticSideLoaded));
        //var filters = (currentCategoryFilters ? $filtersForm.serialize() : '');
        $dropdowns = $('.dropdown', $filtersForm);

        var filters = {};
        var filtersSubmitIndex = $filtersNested.length ? $('.dropdown.is-current', $filtersForm).index() + 1 : $dropdowns.length;

        //console.log($filtersNested.length+'filter_get_index: '+filtersSubmitIndex);

        $dropdowns.filter(':lt(' + filtersSubmitIndex + ')').each(function(i) {
            $('input[type=checkbox]:checked', $(this)).each(function(i) {
                var filter = $(this).attr('name');
                if (filters[filter] === undefined) filters[filter] = [];
                filters[filter].push($(this).val());
            });
        });

        var $responseContainer = (mainOnly ? $container.find(classes.main) : $container);

        //console.log($responseContainer);

        staticSideLoaded = currentCategoryStaticSide;

        TweenLite.to($responseContainer, settings.transDuration, { opacity: 0.5 });

        if (ajaxCall !== undefined) {
            ajaxCall.abort();
        }

        // if ($nav.length) {
        //     app.obj['preloader'].hidePreloader($nav, 'fade');
        // } else {
        // }
            app.obj['preloader'].hidePreloader();

        if (type !== 'no-scroll' && !overlay) {
            scrollUp();
        }

        ajaxCall = $.ajax({
                xhr: function() {
                    var xhr = new window.XMLHttpRequest();

                    // if ($nav.length) {
                    //     app.obj['preloader'].showPreloader(xhr, $nav);
                    // } else {
                    // }
                        app.obj['preloader'].showPreloader(xhr);

                    return xhr;
                },
                url: currentCategoryUrl,
                method: 'POST',
                data: {
                    'ajaxCall': true,
                    'mainOnly': mainOnly,
                    'filters': filters,
                    'pagination': currentCategoryPage,
                    'CRAFT_CSRF_TOKEN' : window.csrfTokenValue,
                    'pageId' : pageID,
                    'productId' : productID,
                    'moduleId' : moduleID,
                },
            })
            .done(function(response) {
                setTimeout(function() {
                    api.loadTabDone(response, mainOnly, $responseContainer);
                    (currentCategoryFilters ? showFilters() : hideFilters());
                }, 10);
                ajaxCall = undefined;
            });

    };

    api.loadTabDone = function(response, mainOnly, $responseContainer) {
        var split = response.split('<!-- FILTERS REPLACE END -->');
        if (split.length > 1) {
            replaceFilters(split[0]);
        }
        var $response = $(split.pop());

        // if ($nav.length) {
        //     app.obj['preloader'].hidePreloader($nav, 'fade');
        // } else {
        // }
            app.obj['preloader'].hidePreloader();

        TweenLite.to($responseContainer, settings.transDuration, {
            opacity: 0,
            onComplete: function() {
                $responseContainer.html($response);
                app.parse($response);
                $('[data-bg], [data-src]', $response).lazyLoadXT();
                updatePagination();
                TweenLite.fromTo($responseContainer, settings.transDuration, { opacity: 0, y: settings.transDistance }, {
                    opacity: 1,
                    y: 0,
                    ease: app.settings.easeOut,
                    onComplete: function() {
                        $responseContainer.removeAttr('style');
                        
                        if ($stickyTop.length && $stickyTop.data('sticky-top')) $stickyTop.data('sticky-top').resizeWindow();

                        $el.addClass('js-tabs--loaded-done');
                        navBack($responseContainer);
                    },
                });
            },
        });
    };

    var navBack = function($responseContainer){
        $(classes.contentNavBack, $responseContainer).off().on('click', function(e) {
            e.preventDefault();
            $el.removeClass('js-tabs--loaded-done');
        });
    };

    var updatePagination = function() {
        var $pagination = $el.find(classes.pagination);
        if (!$pagination.length) return false;
        var $pageIndex = $el.find(classes.pageIndex);
        var $pageTotal = $el.find(classes.pageTotal);
        var $itemTotal = $el.find(classes.itemTotal);
        var $prevPageButton = $el.find(classes.paginationButton).filter('[data-paginate="prev"]');
        var $nextPageButton = $el.find(classes.paginationButton).filter('[data-paginate="next"]');
        var $itemCountField = $el.find(classes.itemCountField).last();
        var $pageCountField = $el.find(classes.pageCountField).last();

        var categoryItemTotal = $itemCountField.val();
        categoryPageTotal = $pageCountField.val();

        if (categoryPageTotal > 1) {
            $pagination.removeClass(app.states.isHidden);
        } else {
            $pagination.addClass(app.states.isHidden);
        }

        $pageIndex.text(currentCategoryPage);
        $pageTotal.text(categoryPageTotal);
        $itemTotal.text(categoryItemTotal);

        if (currentCategoryPage > 1) {
            $prevPageButton.removeClass(app.states.isDisabled);
        } else {
            $prevPageButton.addClass(app.states.isDisabled);
        }

        if (currentCategoryPage < categoryPageTotal) {
            $nextPageButton.removeClass(app.states.isDisabled);
        } else {
            $nextPageButton.addClass(app.states.isDisabled);
        }

    };

    var showFilters = function() {
        if (!filtersVisible) {
            $filters.show();
            TweenLite.set($filters, { height: 'auto' });
            $filters.addClass(app.states.isOpen).addClass(app.states.isAnimated);
            TweenLite.from($filters, settings.transDuration, {
                height: 0,
                ease: app.settings.easeInOut,
                onComplete: function() {
                    $filters.removeClass(app.states.isAnimated);
                },
            });
            filtersVisible = true;
        }
    };

    var hideFilters = function() {
        if (filtersVisible) {
            $filters.addClass(app.states.isAnimated);
            TweenLite.to($filters, settings.transDuration, {
                height: 0,
                display: 'none',
                ease: app.settings.easeInOut,
                onComplete: function() {
                    $filters.removeClass(app.states.isAnimated);
                },
            });
            $filters.removeClass(app.states.isOpen);
            filtersVisible = false;
        }
    };

    var replaceFilters = function(response) {
        var $filtersButtons         = $('.filters__buttons', $filtersForm);
        var $filtersButton          = $('.filters__button', $filtersForm);
        var $responseButton         = $('.filters__button', $(response));
        var active_index            = Math.max(0, $filtersButton.filter('.is-current').index());

        var $filtersButtonNew       = $responseButton.filter(':gt(' + active_index + ')');
        var $filtersButtonActive    = $filtersButton.filter(':lt(' + (active_index + 1) + ')');

        $filtersButton.filter(':gt(' + active_index + ')').remove();
        $filtersButtons.prepend($filtersButtonNew);
        $filtersButtons.prepend($filtersButtonActive);

        app.parse($filtersButtonNew);
    };

    var scrollUp = function() {
        var tabsPosition = $nav.length ? $nav.offset().top : $el.offset().top;
        if ($nav.length || scrollTarget) {
            app.obj.site.scrollController.scrollTo(tabsPosition, {
                callback: function() { if (typeof app.obj.site.scrollController.update !== 'undefined') app.obj.site.scrollController.update(true); },
                duration: 1,
                target: !scrollTarget ? false : (scrollTarget == 'subnav' ? $('.site-main .subnav__trigger:eq(0)') : false),
            });
        }
    };


    init();
    return api;
};

app.ext['timeline'] = function($el) {
  var api = {};

  var $html   = app.vars.$html;

  var settings = {
    changeDuration: 0.4,
  };

  var classes = {
    shortcuts     : '.js-timeline-shortcuts',
    shortcutsItem : '.js-timeline-shortcuts-item',
    nav           : '.js-timeline-nav',
    arrows        : '.js-timeline-arrows',
    navItem       : '.js-timeline-nav-item',
    contentItem   : '.js-timeline-content-item',
    year          : '.js-timeline-year',
    scene         : '.js-timeline-scene',
  };

  var $shortcuts = $(classes.shortcuts, $el);
  var $shortcutsItem = $(classes.shortcutsItem, $el);
  var $nav = $(classes.nav, $el);
  var $prev = $(classes.arrows + '> *:first-child', $el);
  var $next = $(classes.arrows + '> *:last-child', $el);
  var $navItem = $(classes.navItem, $el);
  var $contentItem = $(classes.contentItem, $el);
  var $year = $(classes.year, $el);
  var $scene = $(classes.scene, $el);

  var currentItem;
  var currentYear;
  var shortcutYears = [];
  var swiping;

  var init = function() {
    addListeners();
    getInitialParameters();
    $(classes.contentItem, $el).each(function(){
      scrollerRefresh($(this));
    });
    $html.addClass('share--hidden');
  };

  var addListeners = function() {
    $shortcutsItem.on('click', shortcutsItemClickHandler);
    $navItem.on('click', navItemClickHandler);
    $scene.on('swipeleft', sceneSwipeLeftHandler);
    $scene.on('swiperight', sceneSwipeRightHandler);
    $prev.on('click', sceneSwipeRightHandler);
    $next.on('click', sceneSwipeLeftHandler);
  };

  var shortcutsItemClickHandler = function() {
    if ($shortcuts.hasClass(app.states.isOpen)) {
      var shortcutId = $(this).data('id');
      var shortcutYearLink = $(this).data('yearLink');
      selectShortcut(shortcutId);
      moveToYear(shortcutYearLink);
      closeShortcuts();
    } else {
      openShortcuts();
    }
  };

  var navItemClickHandler = function() {
    if ($(this).hasClass(app.states.isSelected)) return false;
    var itemId = $(this).data('id');
    showItem(itemId);
  };

  var sceneSwipeLeftHandler = function() {
    showNextItem();
  };

  var sceneSwipeRightHandler = function() {
    showPrevItem();
  };

  var getInitialParameters = function() {
    var $currentNavItem = $navItem.filter('.' + app.states.isSelected);
    currentItem = $currentNavItem.data('id');
    currentYear = $currentNavItem.data('year');

    $shortcutsItem.each(function() {
      shortcutYears.push($(this).data('yearLink'));
    });
  };

  var openShortcuts = function() {
    $shortcuts.addClass(app.states.isOpen);
  };

  var closeShortcuts = function() {
    $shortcuts.removeClass(app.states.isOpen);
  };

  var selectShortcut = function(shortcutId) {
    var $currentShortcut = $shortcutsItem.filter('.' + app.states.isSelected);
    var $newShortcut = $shortcutsItem.filter('[data-id="' + shortcutId + '"]');
    $currentShortcut.addClass(app.states.isHiding);

    setTimeout(function() {
      $currentShortcut.removeClass(app.states.isSelected).removeClass(app.states.isHiding);
      $newShortcut.addClass(app.states.isSelected);
    }, 400);
  };

  var showItem = function(itemId) {
    if (itemId < 0 || itemId >= $navItem.length || swiping) return false;
    if (itemId === currentItem) return false;
    swiping = true;
    closeShortcuts();
    markNavItems(itemId);
    changeContentItems(itemId);
    changeYear(itemId);
    checkForShortcutChange(itemId);
    setTimeout(function() {
      swiping = false;
    }, settings.changeDuration * 1000);
  };

  var scrollerRefresh = function($item) {
    var $newContentItem = $item || $contentItem.filter('.is-next');
    var scroller = $('.js-scrollbar', $newContentItem).data('scroller');
    if(scroller){
      scroller.refresh();
    }
  }

  var markNavItems = function(itemId) {
    var $oldNavItem = $navItem.filter('.' + app.states.isSelected);
    var $newNavItem = $navItem.filter('[data-id="' + itemId + '"]');
    $oldNavItem.removeClass(app.states.isSelected);
    $newNavItem.addClass(app.states.isSelected);

    currentItem = itemId;

    var $wrapper = $newNavItem.parent();
    var i		= $newNavItem.index();
    var i_old	= $oldNavItem.index();
    var w		= $wrapper.width();
    var w_item	= $('>*:eq(1)', $wrapper).position().left;
    var x		= $wrapper.position().left;
    var x_item	= $newNavItem.position().left;
    var xDiff	= w - x - x_item;
		// console.log(w+', '+xDiff);

    if ((xDiff - w_item / 2 < 0 && i > i_old) || (w < xDiff && i > i_old)) {
      dispatchSlideTo(i);
    } else if (xDiff > w && i < i_old) {
      var i_back = i_old - Math.ceil(w / w_item);
      dispatchSlideTo(i_back + 1);
    }
  };

  var dispatchSlideTo = function(index) {
    window.bus.dispatchEvent(new CustomEvent('slider-slide-to', { // would be only dispatch() in new script
      detail: {
        name: 'timeline-slider',
        index: parseInt(index)
      },
    }));
  }

  var changeContentItems = function(itemId) {
    var $oldContentItem = $contentItem.filter('.' + app.states.isSelected);
    var $newContentItem = $contentItem.filter('[data-id="' + itemId + '"]');
    $oldContentItem.removeClass(app.states.isSelected+' is-next');
    $oldContentItem.addClass(app.states.isHiding);
    $newContentItem.addClass('is-next');
    scrollerRefresh();
    setTimeout(function() {
      $newContentItem.addClass(app.states.isSelected);
      $oldContentItem.removeClass(app.states.isHiding);
    }, settings.changeDuration * 1000);
  };

  var changeYear = function(itemId) {
    var $currentNavItem = $navItem.filter('[data-id="' + itemId + '"]');
    var year = $currentNavItem.data('year');
    if (year !== currentYear) {
      var options = {
          useEasing: true,
          useGrouping: false,
          separator: '',
      };
      if(typeof CountUp != 'undefined') {
        var counter = new CountUp($year[0], currentYear, year, 0, settings.changeDuration * 4, options);
        counter.start();
      } else {
        $year[0].innerHTML = year;
      }
      currentYear = year;
    }
  };

  var moveToYear = function(year) {
    var $firstYearNavItem = $navItem.filter('[data-year="' + year + '"]').eq(0);
    var itemIndex = $firstYearNavItem.index();

    if ($firstYearNavItem.length) {
      var itemId = $firstYearNavItem.data('id');
      showItem(itemId);
      moveNavToItem(itemIndex);
    }
  };

  var moveNavToItem = function(itemIndex) {
    dispatchSlideTo(itemIndex);
  };

  var showNextItem = function() {
    showItem(currentItem + 1);
  };

  var showPrevItem = function() {
    showItem(currentItem - 1);
  };

  var checkForShortcutChange = function() {
    var currentShortcutYear;
    $.each(shortcutYears, function(index, year) {
      if (currentYear >= year) {
        currentShortcutYear = year;
        return false;
      }
    });

    var $currentShortcut = $shortcutsItem.filter('[data-year-link="' + currentShortcutYear + '"]');
    if (!$currentShortcut.hasClass(app.states.isSelected)) {
      var shortcutId = $currentShortcut.data('id');
      selectShortcut(shortcutId);
    }
  };

  init();	return api;
};

app.ext['touch-hover'] = function($el) { 
	var api = {};

	var init = function() {
		addListeners();
	};

	var addListeners = function() {
		// $el.on('mouseenter', elMouseoverHandler);
		$el.on('mouseleave', elMouseleaveHandler);
		$el.on('click', elTouchstartHandler);
	};

	var elMouseoverHandler = function(event) {
		hoverElement();
	};

	var elMouseleaveHandler = function(event) {
		releaseElement();
	};

	var elTouchstartHandler = function(event) {
		if ($el.hasClass(app.states.isHover)) {
			releaseElement();
		} else {
			hoverElement();
		}
		event.preventDefault();
		event.stopPropagation();
	};

	var hoverElement = function() {
		$el.addClass(app.states.isHover);
	};

	var releaseElement = function() {
		$el.removeClass(app.states.isHover);
	};

	init();	return api;
};

app.ext['up'] = function($el) { 
	var api = {};

	var init = function() {
		$el.on('click.scroll', function() {
			app.obj.site.scrollController.scrollTo(0, {
				callback: function() {
 if (typeof app.obj.site.scrollController.update !== 'undefined') app.obj.site.scrollController.update(true);
			}});
		});
	};

	init();	return api;
};

app.ext['video-player'] = function($el) { 
	var api = {};

	var $win	= app.vars.$win;
	//var $doc	= app.vars.$doc;
	//var $html	= app.vars.$html;
	var $body	= app.vars.$body;

	var $holder			= $el.parents('.video-inline');
	var $button			= $('.video-button', $holder);
	var $title			= $('.video-inline__title', $holder.parent());
	var title			= '';
	var $img			= $('.video-inline__img', $holder);
	var $media_item		= $el.parents('.media__item');
	var $list 			= $el.parents('.textvideo__list');
	var list_child		= $el.parents('.textvideo__list__items').length;
	var list_change;
	var $list_items;
	var $list_item		= $('.textvideo__list__item', $list);
	var list_item 		= $el.parents('.textvideo__list__item').length;
    var $duration		= $('.video-inline__duration, .media-list__duration', $holder);
    var $copy           = $('.textvideo__copy', $holder.parent());

	var channel			= $el.data('type');
	var id				= $el.data('video-id');
	var target			= $el.data('target');
	var mobile			= $('html.until-tablet.screen--is-touch, html.from-desktop.screen--is-touch').length;

	var player_support	= !$('html.until-tablet.explorer.explorer-11.windows.media-mobile.screen--is-touch').length;
	var player;
	var playerInt;
	var playing;
	var paused;
	var initialized;
	var ready;
	var apiReady;
	var debug_mobile;
	var tracked			= {};
	var config			= {
							autoplay: $el.data('autoplay') ? $el.data('mute') || 0 : 0,
							loop: $el.data('loop') || 0,
							mute: $el.data('mute') || 0,
							background: $el.data('background') || 0,
							playlist: $el.data('playlist') || false,
							playsinline: !mobile,
						}
	
	//console.log(config);
	
	if(debug_mobile){
		var debug_info	= '';
		var $debug 		= $('<div style="position:fixed; right: 0; bottom: 0; background:black; color: white; padding: 10px;"></div>').appendTo($body);
	}

	var init = function() {

		setVideoId(id);
		setChannel();
		videoData();

		$el.data('video-player', api);

		// VIDEO LIST
		if ($list.length && !list_item){
			var $videos_inline = $('.video-inline', $list);
			if(player_support) {
				$videos_inline.addClass('video-support');
				initList();
			}else{
				$videos_inline.addClass('video-no-support');
			}
		}

		// INLINE VIDEO
		if (target == 'inline'){
			if(player_support) {
				$holder.addClass('video-support');
				$button.on('click.video', function(e) {
					e.preventDefault();
					//debug('video - click');

					if ((!list_item || $el.parents('.swiper-slide-active').length) && isVisible()) {
						$holder.addClass('video-initialized video-player video-paused');
						//debug('video - click - approved: ' + $el.data('video-id'));
						playerInit();
					}
				});

				// VIDEO VISIBILITY
				videoVisInit();
			}else{
				$holder.addClass('video-no-support');
			}
		}

		// pause on new slide change end
		window.bus.addEventListener('slideChangeEnd', function(e) {
			const sliderElement = e.detail.element
			const videoElement = $el.get(0)
			if(sliderElement.contains(videoElement)) {
				api.videoPause()
			}
		})
	};

	var initList = function() {
		$list_items = $('.textvideo__list__items', $list);

		$('.video-button', $list_item).on('click.list', function(e) {
			e.preventDefault();

            var $click = $(e.currentTarget);
            var $item = $click.parents('.textvideo__list__item');

			$el.data('video-id', $click.data('video-id'));

			$list_item.removeClass('is-active');
			$item.addClass('is-active');

			$title.text($('.video-inline__title:eq(0)', $item).text());
            $duration.text($('.video-inline__duration', $item).text());
            $copy.html($('.textvideo__copy', $item).html());
            $img.attr('style', $('.video-inline__img', $item).attr('style')).removeClass('lazy-hidden');

			setTimeout(function() {
				$img.addClass('lazy lazy-hidden');
			}, 500);

			if (!$item.hasClass('swiper-slide')) {
				list_change = true;
				$button.trigger('click.video');
			}
		});

		iScrollUpdate();
		$win.on('resize.videoscroller orientationchange.videoscroller', function() {
			iScrollUpdate();
		});
	};

	var playerInit = function () {
		if(!player){
			clearTimeout(playerInt);
			
			if (apiReady && ((channel == 'vimeo' && typeof Vimeo !== 'undefined') || (typeof YT !== 'undefined'))) {
				var $iframe;
				var delay = initialized ? 0 : 10;

				if(!initialized){
					initialized = true;

					setTimeout(function () {
						switch (channel) {
							case 'youtube':
								//$iframe = iframe('https://www.youtube.com/embed/' + id + '?autoplay=' + config.autoplay + '&mute=' + config.mute + '&loop=' + config.loop + '&playlist=' + id);
								$iframe = $('<div></div>').appendTo($el);

								var playerVars = {
									autohide: 1,
									autoplay: config.autoplay,
									loop: config.loop,
									mute: config.mute,
									wmode: 'opaque',
									enablejsapi: 1,
									//controls: 0,
									color: 'red',
									modestbranding: 1,
									showinfo: 0,
									fs: 1,
									rel: 0,
									iv_load_policy: 3,
									playsinline: 1
								}

								if (config.playlist) {
									if (config.playlist.indexOf(',') < 0) {
										playerVars.listType = 'playlist';
										playerVars.list = config.playlist;
									} else {
										playerVars.playlist = config.playlist;
									}
								}

								player = new YT.Player($iframe[0], {
									height: '100%',
									width: '100%',
									videoId: id,
									playerVars: playerVars,
									events: {
										'onReady': function (event) {
											//console.log('onYouTubePlayerReady');
											ready = true;
											$holder.addClass('video-ready');
											playerLoaded();
										},
										'onStateChange': function (event) {
											//console.log('onYouTubePlayerStateChange: ' + event.data);
											if (event.data == YT.PlayerState.PAUSED && !paused) {
												playerPause();
											}
											if (event.data == YT.PlayerState.PLAYING && ! playing) {
												paused = false;
												playerPlay();
											}
											if (event.data == YT.PlayerState.BUFFERING) {
												debug('video BUFFERING');
												paused = false;
												playerPlay();
											}
											if (event.data == YT.PlayerState.ENDED) {
												debug('video ENDED');
											}
										},
									},
								});

								break;

							case 'vimeo':
								//$iframe = iframe('https://player.vimeo.com/video/' + id + '?autoplay=' + config.autoplay + '&muted=' + config.mute + '&loop=' + config.loop + '&background=' + config.background);
								//$iframe = iframe('https://player.vimeo.com/video/' + id);
								player = new Vimeo.Player($el[0], {
									id: (String(id).indexOf('http') < 0 ? 'https://vimeo.com/' + id : id),
									autoplay: config.autoplay,
									muted: config.mute,
									loop: config.loop,
									background: config.background,
									playsinline: !mobile,
								});
								/*player.on('start', function () {
									debug('start');
								});*/
								player.on('play', function () {
									paused = false;
								});
								player.on('pause', function () {
									playerPause();
								});
								player.on('loaded', function () {
									playerLoaded();
								});
								player.on('timeupdate', function (e) {
									if (!playing && !paused && e.seconds > 0.01) {
										//$holder.addClass('video-playing video-played').removeClass('video-paused');
										//$media_item.addClass('media--playing');
										//playing = true;
										playerTracking();
										playerPlay();
									}
								});
								player.ready().then(function () {
									ready = true;
									$holder.addClass('video-ready');
								});
								/*player.getVideoTitle().then(function(title) {
									console.log('title:', title);
								});*/

								break;
						}

						playerPrepared();

						if (config.mute == 0) videoVolume(0.75);
						
					}, delay);
				}
			} else {
				playerInt = setTimeout(function(){
					playerInit();
				}, 500);
			}
		} else if ($el.data('video-id') != id) {
            var channelTmp = channel;
			debug('loadVideo');
			id = $el.data('video-id');
			$holder.removeClass('video-ready video-played');
            setChannel();
            
            if (channelTmp == channel) {
                if (channel == 'vimeo') {
                    player.loadVideo(id);
                } else if (channel == 'youtube') {
                    player.loadVideoById({videoId: id});
                }
            } else {
                //console.log('change player');
                player.destroy();
                player = false;
                initialized = false;
                playerInit();
            }
		} else if (ready && playing) {
			api.videoPause();
		} else if (ready && !playing) {
			api.videoPlay();
		}
	};

	var playerPrepared = function() {
		$holder[0].player = player;
		$holder[0].videoPause = function () {
			api.videoPause();
		};
		$win.on('scroll.videoPlayer', function () {
			if (!isVisible() && playing) {
				api.videoPause();
			}
		});
	};

	var setVideoId = function(url){
		String(url).match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
		id = RegExp.$6 || url;
		$el.attr('data-video-id', id);
		$button.data('video-id', id);
	};

	var setChannel = function() {
		channel = isNaN(id) ? 'youtube' : 'vimeo';
		videoAPI(channel);
	};

	var playerLoaded = function(){
		debug('loaded');
		$holder.addClass('video-loaded');
		if (list_change) {
			list_change = false;
			api.videoPlay();
		}
		if (config.autoplay) {
			api.videoVis();
			setTimeout(function () {
				api.videoPlay();
			}, 10);
		}
	};
	var playerPause = function(){
		debug('pause');
		$holder.removeClass('video-playing video-play').addClass('video-paused');
		$media_item.removeClass('media--playing');
		playing = false;
		paused = true;
	};
	var playerPlay = function(){
		debug('play');
		$holder.addClass('video-playing video-played').removeClass('video-paused');
		$media_item.addClass('media--playing');
		//paused = false;
		playing = true;

		// PAUSE IF NOT VISIBLE
		api.videoVis();

		// PAUSE OTHER VIDEOS
		if(playing){
			$('.js-video-player').not($el).each(function(){
				var $self = $(this);
				if ($self.data('video-player')) $self.data('video-player').videoPause();
			});
		}
	};
	var playerTracking = function(){
		if (!tracked[id]) {
			tracked[id] = true;
			// TRACKING
			app.obj.tracking.track({
				'event': 'videos',
				'category': 'Videos',
				'action': 'Play',
				'label': id + ' - ' + title,
				//'value': id,
				'attributes': {
					'id': id,
					'title': $title.length ? $title.text() : ''
				}
			});
		}
	};

	var videoVolume = function(val){
		if (player.setVolume) player.setVolume(val);
	};

	api.videoPause = function() {
		debug('videoPause');
		if (player && playing) {
			//playing = false;
			player.pause ? player.pause() : player.pauseVideo();
		}
	};
	api.videoPlay = function() {
		debug('videoPlay');
		if (player && !playing) {
			$holder.addClass('video-play');
			//playing = true;
			player.play ? player.play() : player.playVideo();
		}
	};
	api.videoVis = function() {
		//console.log('videoVis:' + isVisible() + ', initialized:' + initialized + ', $list.length:' + $list.length + ', mobile:' + mobile);
		
		//if ((isVisible() && !initialized) || (!isVisible() && playing)) {
		if ((isVisible() && !initialized)) {
			//console.log('trigger');
			$button.trigger('click.video');
		}
	};

	var videoVisInit = function () {
		$el[0].videoVis = $holder[0].videoVis = function () {
			api.videoVis();
		};
		if ((!list_child || mobile) && !initialized) {
			$win.on('scroll.videoPlayerInit', function () {
				api.videoVis();
			});
			api.videoVis();
		}
	}
	
	var videoData = function() {
		if (channel == 'vimeo') {
			/*$.getJSON('https://noembed.com/embed?url=https://vimeo.com/' + id, function(result) {
				var duration = result.duration;
				var h = Math.floor(duration / 60);
				var m = duration - h * 60;
				var time = ('' + h).slice(-2) + ':' + ('0' + m).slice(-2) + ' min';

				if ($title.length && $title.eq(0).text() == '') $title.text(result.title);
				if ($duration.length) $duration.text(time);
			});*/
			jQuery.ajax({
				context: this,
				url: '/api/vimeo.php',
				type: 'GET',
				data: {'id': id},
				dataType: 'json',
				contentType: 'application/json',
				cache: false,
				success: function (data) {
					if (data.status && data.status == 'success') {
						var ratio = data.height * 100 / data.width;
						var duration = data.duration;
						var h = Math.floor(duration / 60);
						var m = duration - h * 60;
						var time = ('' + h).slice(-2) + ':' + ('0' + m).slice(-2) + ' min';

						$holder.css('padding-bottom', ratio + '%');
						title = data.title || '';
						if ($title.length && $title.eq(0).text() == '' && title != '') $title.text(data.title);
						if ($duration.length) $duration.text(time);
					}
				},
				error:function(data) {
				},
			}).done(function() {
				if(!player_support){
					$button.attr('href', data.video_high).attr('target', '_blank');
				}
				//if (config.autoplay != 0) $button.trigger('click.video');
			});
		} else if (channel == 'youtube') {
			var url = 'https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=' + id + '&key=AIzaSyBQjhEvvhfr9uVJzjYfi1RzYWilYV3pMC8';
			jQuery.ajax({
				context: this,
				url: url,
				//async: false,
				type: 'GET',
				data: {},
				dataType: 'json',
				contentType: 'application/json',
				//jsonpCallback: 'result',
				cache: false,
				success: function(data) {
					//console.log(data.items[0].contentDetails.duration);
					if (data.items[0]) {
						var d = convertYouTubeDuration(data.items[0].contentDetails.duration);
						var h = Math.floor(d / 60);
						var m = d - h * 60;
						var time = ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2);

						if ($duration.length) $duration.text(time);
					}
				},
				error: function () {
					console.log('error yt duration');
				}
			});
		}
	};

	/*var iframe = function (url) {
		var $iframe = $('<iframe id="' + (Math.random().toString(36).substr(2, 9)) + '" src="' + url + '"  width="100%" height="100%" frameborder="0" allow="autoplay" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
		$el.empty().append($iframe);
		return $iframe;
	};*/

	// YOUTUBE
	var videoAPI = function() {
		switch (channel) {
			case 'youtube':
				// var youtubeScriptId = 'youtube-api';
				// var youtubeScript = document.getElementById(youtubeScriptId);

				// if (youtubeScript === null) {
				// 	var tag = document.createElement('script');
				// 	var firstScript = document.getElementsByTagName('script')[0];

				// 	tag.src = 'https://www.youtube.com/iframe_api';
				// 	tag.id = youtubeScriptId;
				// 	firstScript.parentNode.insertBefore(tag, firstScript);
				// }
				// if (typeof window.onYouTubeIframeAPIReady === 'undefined') {
				// 	window.onYouTubeIframeAPIReady = function () {
				// 		//if (!window.youTubeAPIReady) window.youTubeAPIReady = true;
				// 		apiReady = true;
				// 	}
				// }else{
				// 	apiReady = true;
				// }

				break;
			default:
				apiReady = true;
		}
	};

	var iScrollUpdate = function() {
		var scroller = $list.data('scroller');

		if ($('html.until-desktop').length && scroller) {
			scroller.destroy();
			delete scroller;
			$list.data('scroller', '');
			$('.textvideo__list__items__inner', $list).removeAttr('style');
		} else if (!$('html.until-desktop').length && !scroller) {
			scroller = new IScroll($list_items[0], {
				scrollbars: true,
				mouseWheel: true,
				//fadeScrollbars: true,
				interactiveScrollbars: true,
				useTransition: true,
				momentum: true,
				bounce: true,
				click: false,
				preventDefaultException: {'*':/.*/},
			});
			$list.data('scroller', scroller);
			scroller['holder'] = $list_items;
		}
		if(scroller){
			scrollUpdate(scroller);
		}
	};

	var scrollUpdate = function(scroller){
		var $scroller = scroller['holder'];
		if(!$('.iScrollIndicator:visible', $scroller).length){
			$scroller.removeClass('scrollbar--enabled');
		}else{
			$scroller.addClass('scrollbar--enabled');
		}
	};

	var convertYouTubeDuration = function(input) {
		var reptms = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/;
		var hours = 0, minutes = 0, seconds = 0, totalseconds;

		if (reptms.test(input)) {
			var matches = reptms.exec(input);
			if (matches[1]) hours = Number(matches[1]);
			if (matches[2]) minutes = Number(matches[2]);
			if (matches[3]) seconds = Number(matches[3]);
			totalseconds = hours * 3600  + minutes * 60 + seconds;
		}
		return (totalseconds);
	};

	var isVisible = function() {
		if (!$el.is(':visible')) return false;
		var rect = $el[0].getBoundingClientRect();
		return (
			(rect.height > 0 || rect.width > 0) &&
			rect.bottom >= 0 &&
			rect.right >= 0 &&
			rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.left <= (window.innerWidth || document.documentElement.clientWidth)
		);
	};

	var debug = function (val) {
		console.log(val);
		if (debug_mobile) {
			debug_info += val + '<br>';
			$debug.html(debug_info);
		}
	};

	init();	return api;
};